//#region \0rolldown/runtime.js
var e = Object.create, t = Object.defineProperty, n = Object.getOwnPropertyDescriptor, r = Object.getOwnPropertyNames, i = Object.getPrototypeOf, a = Object.prototype.hasOwnProperty, o = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), e = null), t.exports), s = (e, i, o, s) => {
	if (i && typeof i == "object" || typeof i == "function") for (var c = r(i), l = 0, u = c.length, d; l < u; l++) d = c[l], !a.call(e, d) && d !== o && t(e, d, {
		get: ((e) => i[e]).bind(null, d),
		enumerable: !(s = n(i, d)) || s.enumerable
	});
	return e;
}, c = (n, r, o) => (o = n == null ? {} : e(i(n)), s(r || !n || !n.__esModule || !a.call(n, "default") ? t(o, "default", {
	value: n,
	enumerable: !0
}) : o, n)), l = /* @__PURE__ */ o(((e) => {
	var t = Symbol.for("react.transitional.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), o = Symbol.for("react.consumer"), s = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), u = Symbol.for("react.memo"), d = Symbol.for("react.lazy"), f = Symbol.for("react.activity"), p = Symbol.iterator;
	function m(e) {
		return typeof e != "object" || !e ? null : (e = p && e[p] || e["@@iterator"], typeof e == "function" ? e : null);
	}
	var h = {
		isMounted: function() {
			return !1;
		},
		enqueueForceUpdate: function() {},
		enqueueReplaceState: function() {},
		enqueueSetState: function() {}
	}, g = Object.assign, _ = {};
	function v(e, t, n) {
		this.props = e, this.context = t, this.refs = _, this.updater = n || h;
	}
	v.prototype.isReactComponent = {}, v.prototype.setState = function(e, t) {
		if (typeof e != "object" && typeof e != "function" && e != null) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
		this.updater.enqueueSetState(this, e, t, "setState");
	}, v.prototype.forceUpdate = function(e) {
		this.updater.enqueueForceUpdate(this, e, "forceUpdate");
	};
	function y() {}
	y.prototype = v.prototype;
	function b(e, t, n) {
		this.props = e, this.context = t, this.refs = _, this.updater = n || h;
	}
	var x = b.prototype = new y();
	x.constructor = b, g(x, v.prototype), x.isPureReactComponent = !0;
	var ee = Array.isArray;
	function S() {}
	var C = {
		H: null,
		A: null,
		T: null,
		S: null
	}, te = Object.prototype.hasOwnProperty;
	function ne(e, n, r) {
		var i = r.ref;
		return {
			$$typeof: t,
			type: e,
			key: n,
			ref: i === void 0 ? null : i,
			props: r
		};
	}
	function w(e, t) {
		return ne(e.type, t, e.props);
	}
	function re(e) {
		return typeof e == "object" && !!e && e.$$typeof === t;
	}
	function ie(e) {
		var t = {
			"=": "=0",
			":": "=2"
		};
		return "$" + e.replace(/[=:]/g, function(e) {
			return t[e];
		});
	}
	var T = /\/+/g;
	function E(e, t) {
		return typeof e == "object" && e && e.key != null ? ie("" + e.key) : t.toString(36);
	}
	function ae(e) {
		switch (e.status) {
			case "fulfilled": return e.value;
			case "rejected": throw e.reason;
			default: switch (typeof e.status == "string" ? e.then(S, S) : (e.status = "pending", e.then(function(t) {
				e.status === "pending" && (e.status = "fulfilled", e.value = t);
			}, function(t) {
				e.status === "pending" && (e.status = "rejected", e.reason = t);
			})), e.status) {
				case "fulfilled": return e.value;
				case "rejected": throw e.reason;
			}
		}
		throw e;
	}
	function oe(e, r, i, a, o) {
		var s = typeof e;
		(s === "undefined" || s === "boolean") && (e = null);
		var c = !1;
		if (e === null) c = !0;
		else switch (s) {
			case "bigint":
			case "string":
			case "number":
				c = !0;
				break;
			case "object": switch (e.$$typeof) {
				case t:
				case n:
					c = !0;
					break;
				case d: return c = e._init, oe(c(e._payload), r, i, a, o);
			}
		}
		if (c) return o = o(e), c = a === "" ? "." + E(e, 0) : a, ee(o) ? (i = "", c != null && (i = c.replace(T, "$&/") + "/"), oe(o, r, i, "", function(e) {
			return e;
		})) : o != null && (re(o) && (o = w(o, i + (o.key == null || e && e.key === o.key ? "" : ("" + o.key).replace(T, "$&/") + "/") + c)), r.push(o)), 1;
		c = 0;
		var l = a === "" ? "." : a + ":";
		if (ee(e)) for (var u = 0; u < e.length; u++) a = e[u], s = l + E(a, u), c += oe(a, r, i, s, o);
		else if (u = m(e), typeof u == "function") for (e = u.call(e), u = 0; !(a = e.next()).done;) a = a.value, s = l + E(a, u++), c += oe(a, r, i, s, o);
		else if (s === "object") {
			if (typeof e.then == "function") return oe(ae(e), r, i, a, o);
			throw r = String(e), Error("Objects are not valid as a React child (found: " + (r === "[object Object]" ? "object with keys {" + Object.keys(e).join(", ") + "}" : r) + "). If you meant to render a collection of children, use an array instead.");
		}
		return c;
	}
	function se(e, t, n) {
		if (e == null) return e;
		var r = [], i = 0;
		return oe(e, r, "", "", function(e) {
			return t.call(n, e, i++);
		}), r;
	}
	function ce(e) {
		if (e._status === -1) {
			var t = e._result;
			t = t(), t.then(function(t) {
				(e._status === 0 || e._status === -1) && (e._status = 1, e._result = t);
			}, function(t) {
				(e._status === 0 || e._status === -1) && (e._status = 2, e._result = t);
			}), e._status === -1 && (e._status = 0, e._result = t);
		}
		if (e._status === 1) return e._result.default;
		throw e._result;
	}
	var D = typeof reportError == "function" ? reportError : function(e) {
		if (typeof window == "object" && typeof window.ErrorEvent == "function") {
			var t = new window.ErrorEvent("error", {
				bubbles: !0,
				cancelable: !0,
				message: typeof e == "object" && e && typeof e.message == "string" ? String(e.message) : String(e),
				error: e
			});
			if (!window.dispatchEvent(t)) return;
		} else if (typeof process == "object" && typeof process.emit == "function") {
			process.emit("uncaughtException", e);
			return;
		}
		console.error(e);
	}, O = {
		map: se,
		forEach: function(e, t, n) {
			se(e, function() {
				t.apply(this, arguments);
			}, n);
		},
		count: function(e) {
			var t = 0;
			return se(e, function() {
				t++;
			}), t;
		},
		toArray: function(e) {
			return se(e, function(e) {
				return e;
			}) || [];
		},
		only: function(e) {
			if (!re(e)) throw Error("React.Children.only expected to receive a single React element child.");
			return e;
		}
	};
	e.Activity = f, e.Children = O, e.Component = v, e.Fragment = r, e.Profiler = a, e.PureComponent = b, e.StrictMode = i, e.Suspense = l, e.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = C, e.__COMPILER_RUNTIME = {
		__proto__: null,
		c: function(e) {
			return C.H.useMemoCache(e);
		}
	}, e.cache = function(e) {
		return function() {
			return e.apply(null, arguments);
		};
	}, e.cacheSignal = function() {
		return null;
	}, e.cloneElement = function(e, t, n) {
		if (e == null) throw Error("The argument must be a React element, but you passed " + e + ".");
		var r = g({}, e.props), i = e.key;
		if (t != null) for (a in t.key !== void 0 && (i = "" + t.key), t) !te.call(t, a) || a === "key" || a === "__self" || a === "__source" || a === "ref" && t.ref === void 0 || (r[a] = t[a]);
		var a = arguments.length - 2;
		if (a === 1) r.children = n;
		else if (1 < a) {
			for (var o = Array(a), s = 0; s < a; s++) o[s] = arguments[s + 2];
			r.children = o;
		}
		return ne(e.type, i, r);
	}, e.createContext = function(e) {
		return e = {
			$$typeof: s,
			_currentValue: e,
			_currentValue2: e,
			_threadCount: 0,
			Provider: null,
			Consumer: null
		}, e.Provider = e, e.Consumer = {
			$$typeof: o,
			_context: e
		}, e;
	}, e.createElement = function(e, t, n) {
		var r, i = {}, a = null;
		if (t != null) for (r in t.key !== void 0 && (a = "" + t.key), t) te.call(t, r) && r !== "key" && r !== "__self" && r !== "__source" && (i[r] = t[r]);
		var o = arguments.length - 2;
		if (o === 1) i.children = n;
		else if (1 < o) {
			for (var s = Array(o), c = 0; c < o; c++) s[c] = arguments[c + 2];
			i.children = s;
		}
		if (e && e.defaultProps) for (r in o = e.defaultProps, o) i[r] === void 0 && (i[r] = o[r]);
		return ne(e, a, i);
	}, e.createRef = function() {
		return { current: null };
	}, e.forwardRef = function(e) {
		return {
			$$typeof: c,
			render: e
		};
	}, e.isValidElement = re, e.lazy = function(e) {
		return {
			$$typeof: d,
			_payload: {
				_status: -1,
				_result: e
			},
			_init: ce
		};
	}, e.memo = function(e, t) {
		return {
			$$typeof: u,
			type: e,
			compare: t === void 0 ? null : t
		};
	}, e.startTransition = function(e) {
		var t = C.T, n = {};
		C.T = n;
		try {
			var r = e(), i = C.S;
			i !== null && i(n, r), typeof r == "object" && r && typeof r.then == "function" && r.then(S, D);
		} catch (e) {
			D(e);
		} finally {
			t !== null && n.types !== null && (t.types = n.types), C.T = t;
		}
	}, e.unstable_useCacheRefresh = function() {
		return C.H.useCacheRefresh();
	}, e.use = function(e) {
		return C.H.use(e);
	}, e.useActionState = function(e, t, n) {
		return C.H.useActionState(e, t, n);
	}, e.useCallback = function(e, t) {
		return C.H.useCallback(e, t);
	}, e.useContext = function(e) {
		return C.H.useContext(e);
	}, e.useDebugValue = function() {}, e.useDeferredValue = function(e, t) {
		return C.H.useDeferredValue(e, t);
	}, e.useEffect = function(e, t) {
		return C.H.useEffect(e, t);
	}, e.useEffectEvent = function(e) {
		return C.H.useEffectEvent(e);
	}, e.useId = function() {
		return C.H.useId();
	}, e.useImperativeHandle = function(e, t, n) {
		return C.H.useImperativeHandle(e, t, n);
	}, e.useInsertionEffect = function(e, t) {
		return C.H.useInsertionEffect(e, t);
	}, e.useLayoutEffect = function(e, t) {
		return C.H.useLayoutEffect(e, t);
	}, e.useMemo = function(e, t) {
		return C.H.useMemo(e, t);
	}, e.useOptimistic = function(e, t) {
		return C.H.useOptimistic(e, t);
	}, e.useReducer = function(e, t, n) {
		return C.H.useReducer(e, t, n);
	}, e.useRef = function(e) {
		return C.H.useRef(e);
	}, e.useState = function(e) {
		return C.H.useState(e);
	}, e.useSyncExternalStore = function(e, t, n) {
		return C.H.useSyncExternalStore(e, t, n);
	}, e.useTransition = function() {
		return C.H.useTransition();
	}, e.version = "19.2.8";
})), u = /* @__PURE__ */ o(((e, t) => {
	t.exports = l();
})), d = /* @__PURE__ */ o(((e) => {
	function t(e, t) {
		var n = e.length;
		e.push(t);
		a: for (; 0 < n;) {
			var r = n - 1 >>> 1, a = e[r];
			if (0 < i(a, t)) e[r] = t, e[n] = a, n = r;
			else break a;
		}
	}
	function n(e) {
		return e.length === 0 ? null : e[0];
	}
	function r(e) {
		if (e.length === 0) return null;
		var t = e[0], n = e.pop();
		if (n !== t) {
			e[0] = n;
			a: for (var r = 0, a = e.length, o = a >>> 1; r < o;) {
				var s = 2 * (r + 1) - 1, c = e[s], l = s + 1, u = e[l];
				if (0 > i(c, n)) l < a && 0 > i(u, c) ? (e[r] = u, e[l] = n, r = l) : (e[r] = c, e[s] = n, r = s);
				else if (l < a && 0 > i(u, n)) e[r] = u, e[l] = n, r = l;
				else break a;
			}
		}
		return t;
	}
	function i(e, t) {
		var n = e.sortIndex - t.sortIndex;
		return n === 0 ? e.id - t.id : n;
	}
	if (e.unstable_now = void 0, typeof performance == "object" && typeof performance.now == "function") {
		var a = performance;
		e.unstable_now = function() {
			return a.now();
		};
	} else {
		var o = Date, s = o.now();
		e.unstable_now = function() {
			return o.now() - s;
		};
	}
	var c = [], l = [], u = 1, d = null, f = 3, p = !1, m = !1, h = !1, g = !1, _ = typeof setTimeout == "function" ? setTimeout : null, v = typeof clearTimeout == "function" ? clearTimeout : null, y = typeof setImmediate < "u" ? setImmediate : null;
	function b(e) {
		for (var i = n(l); i !== null;) {
			if (i.callback === null) r(l);
			else if (i.startTime <= e) r(l), i.sortIndex = i.expirationTime, t(c, i);
			else break;
			i = n(l);
		}
	}
	function x(e) {
		if (h = !1, b(e), !m) {
			if (n(c) !== null) m = !0, ee || (ee = !0, re());
			else {
				var t = n(l);
				t !== null && E(x, t.startTime - e);
			}
		}
	}
	var ee = !1, S = -1, C = 5, te = -1;
	function ne() {
		return g ? !0 : !(e.unstable_now() - te < C);
	}
	function w() {
		if (g = !1, ee) {
			var t = e.unstable_now();
			te = t;
			var i = !0;
			try {
				a: {
					m = !1, h && (h = !1, v(S), S = -1), p = !0;
					var a = f;
					try {
						b: {
							for (b(t), d = n(c); d !== null && !(d.expirationTime > t && ne());) {
								var o = d.callback;
								if (typeof o == "function") {
									d.callback = null, f = d.priorityLevel;
									var s = o(d.expirationTime <= t);
									if (t = e.unstable_now(), typeof s == "function") {
										d.callback = s, b(t), i = !0;
										break b;
									}
									d === n(c) && r(c), b(t);
								} else r(c);
								d = n(c);
							}
							if (d !== null) i = !0;
							else {
								var u = n(l);
								u !== null && E(x, u.startTime - t), i = !1;
							}
						}
						break a;
					} finally {
						d = null, f = a, p = !1;
					}
				}
			} finally {
				i ? re() : ee = !1;
			}
		}
	}
	var re;
	if (typeof y == "function") re = function() {
		y(w);
	};
	else if (typeof MessageChannel < "u") {
		var ie = new MessageChannel(), T = ie.port2;
		ie.port1.onmessage = w, re = function() {
			T.postMessage(null);
		};
	} else re = function() {
		_(w, 0);
	};
	function E(t, n) {
		S = _(function() {
			t(e.unstable_now());
		}, n);
	}
	e.unstable_IdlePriority = 5, e.unstable_ImmediatePriority = 1, e.unstable_LowPriority = 4, e.unstable_NormalPriority = 3, e.unstable_Profiling = null, e.unstable_UserBlockingPriority = 2, e.unstable_cancelCallback = function(e) {
		e.callback = null;
	}, e.unstable_forceFrameRate = function(e) {
		0 > e || 125 < e ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : C = 0 < e ? Math.floor(1e3 / e) : 5;
	}, e.unstable_getCurrentPriorityLevel = function() {
		return f;
	}, e.unstable_next = function(e) {
		switch (f) {
			case 1:
			case 2:
			case 3:
				var t = 3;
				break;
			default: t = f;
		}
		var n = f;
		f = t;
		try {
			return e();
		} finally {
			f = n;
		}
	}, e.unstable_requestPaint = function() {
		g = !0;
	}, e.unstable_runWithPriority = function(e, t) {
		switch (e) {
			case 1:
			case 2:
			case 3:
			case 4:
			case 5: break;
			default: e = 3;
		}
		var n = f;
		f = e;
		try {
			return t();
		} finally {
			f = n;
		}
	}, e.unstable_scheduleCallback = function(r, i, a) {
		var o = e.unstable_now();
		switch (typeof a == "object" && a ? (a = a.delay, a = typeof a == "number" && 0 < a ? o + a : o) : a = o, r) {
			case 1:
				var s = -1;
				break;
			case 2:
				s = 250;
				break;
			case 5:
				s = 1073741823;
				break;
			case 4:
				s = 1e4;
				break;
			default: s = 5e3;
		}
		return s = a + s, r = {
			id: u++,
			callback: i,
			priorityLevel: r,
			startTime: a,
			expirationTime: s,
			sortIndex: -1
		}, a > o ? (r.sortIndex = a, t(l, r), n(c) === null && r === n(l) && (h ? (v(S), S = -1) : h = !0, E(x, a - o))) : (r.sortIndex = s, t(c, r), m || p || (m = !0, ee || (ee = !0, re()))), r;
	}, e.unstable_shouldYield = ne, e.unstable_wrapCallback = function(e) {
		var t = f;
		return function() {
			var n = f;
			f = t;
			try {
				return e.apply(this, arguments);
			} finally {
				f = n;
			}
		};
	};
})), f = /* @__PURE__ */ o(((e, t) => {
	t.exports = d();
})), p = /* @__PURE__ */ o(((e) => {
	var t = u();
	function n(e) {
		var t = "https://react.dev/errors/" + e;
		if (1 < arguments.length) {
			t += "?args[]=" + encodeURIComponent(arguments[1]);
			for (var n = 2; n < arguments.length; n++) t += "&args[]=" + encodeURIComponent(arguments[n]);
		}
		return "Minified React error #" + e + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
	}
	function r() {}
	var i = {
		d: {
			f: r,
			r: function() {
				throw Error(n(522));
			},
			D: r,
			C: r,
			L: r,
			m: r,
			X: r,
			S: r,
			M: r
		},
		p: 0,
		findDOMNode: null
	}, a = Symbol.for("react.portal");
	function o(e, t, n) {
		var r = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
		return {
			$$typeof: a,
			key: r == null ? null : "" + r,
			children: e,
			containerInfo: t,
			implementation: n
		};
	}
	var s = t.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
	function c(e, t) {
		if (e === "font") return "";
		if (typeof t == "string") return t === "use-credentials" ? t : "";
	}
	e.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = i, e.createPortal = function(e, t) {
		var r = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
		if (!t || t.nodeType !== 1 && t.nodeType !== 9 && t.nodeType !== 11) throw Error(n(299));
		return o(e, t, null, r);
	}, e.flushSync = function(e) {
		var t = s.T, n = i.p;
		try {
			if (s.T = null, i.p = 2, e) return e();
		} finally {
			s.T = t, i.p = n, i.d.f();
		}
	}, e.preconnect = function(e, t) {
		typeof e == "string" && (t ? (t = t.crossOrigin, t = typeof t == "string" ? t === "use-credentials" ? t : "" : void 0) : t = null, i.d.C(e, t));
	}, e.prefetchDNS = function(e) {
		typeof e == "string" && i.d.D(e);
	}, e.preinit = function(e, t) {
		if (typeof e == "string" && t && typeof t.as == "string") {
			var n = t.as, r = c(n, t.crossOrigin), a = typeof t.integrity == "string" ? t.integrity : void 0, o = typeof t.fetchPriority == "string" ? t.fetchPriority : void 0;
			n === "style" ? i.d.S(e, typeof t.precedence == "string" ? t.precedence : void 0, {
				crossOrigin: r,
				integrity: a,
				fetchPriority: o
			}) : n === "script" && i.d.X(e, {
				crossOrigin: r,
				integrity: a,
				fetchPriority: o,
				nonce: typeof t.nonce == "string" ? t.nonce : void 0
			});
		}
	}, e.preinitModule = function(e, t) {
		if (typeof e == "string") {
			if (typeof t == "object" && t) {
				if (t.as == null || t.as === "script") {
					var n = c(t.as, t.crossOrigin);
					i.d.M(e, {
						crossOrigin: n,
						integrity: typeof t.integrity == "string" ? t.integrity : void 0,
						nonce: typeof t.nonce == "string" ? t.nonce : void 0
					});
				}
			} else t ?? i.d.M(e);
		}
	}, e.preload = function(e, t) {
		if (typeof e == "string" && typeof t == "object" && t && typeof t.as == "string") {
			var n = t.as, r = c(n, t.crossOrigin);
			i.d.L(e, n, {
				crossOrigin: r,
				integrity: typeof t.integrity == "string" ? t.integrity : void 0,
				nonce: typeof t.nonce == "string" ? t.nonce : void 0,
				type: typeof t.type == "string" ? t.type : void 0,
				fetchPriority: typeof t.fetchPriority == "string" ? t.fetchPriority : void 0,
				referrerPolicy: typeof t.referrerPolicy == "string" ? t.referrerPolicy : void 0,
				imageSrcSet: typeof t.imageSrcSet == "string" ? t.imageSrcSet : void 0,
				imageSizes: typeof t.imageSizes == "string" ? t.imageSizes : void 0,
				media: typeof t.media == "string" ? t.media : void 0
			});
		}
	}, e.preloadModule = function(e, t) {
		if (typeof e == "string") {
			if (t) {
				var n = c(t.as, t.crossOrigin);
				i.d.m(e, {
					as: typeof t.as == "string" && t.as !== "script" ? t.as : void 0,
					crossOrigin: n,
					integrity: typeof t.integrity == "string" ? t.integrity : void 0
				});
			} else i.d.m(e);
		}
	}, e.requestFormReset = function(e) {
		i.d.r(e);
	}, e.unstable_batchedUpdates = function(e, t) {
		return e(t);
	}, e.useFormState = function(e, t, n) {
		return s.H.useFormState(e, t, n);
	}, e.useFormStatus = function() {
		return s.H.useHostTransitionStatus();
	}, e.version = "19.2.8";
})), m = /* @__PURE__ */ o(((e, t) => {
	function n() {
		if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) try {
			__REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(n);
		} catch (e) {
			console.error(e);
		}
	}
	n(), t.exports = p();
})), h = /* @__PURE__ */ o(((e) => {
	var t = f(), n = u(), r = m();
	function i(e) {
		var t = "https://react.dev/errors/" + e;
		if (1 < arguments.length) {
			t += "?args[]=" + encodeURIComponent(arguments[1]);
			for (var n = 2; n < arguments.length; n++) t += "&args[]=" + encodeURIComponent(arguments[n]);
		}
		return "Minified React error #" + e + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
	}
	function a(e) {
		return !(!e || e.nodeType !== 1 && e.nodeType !== 9 && e.nodeType !== 11);
	}
	function o(e) {
		var t = e, n = e;
		if (e.alternate) for (; t.return;) t = t.return;
		else {
			e = t;
			do
				t = e, t.flags & 4098 && (n = t.return), e = t.return;
			while (e);
		}
		return t.tag === 3 ? n : null;
	}
	function s(e) {
		if (e.tag === 13) {
			var t = e.memoizedState;
			if (t === null && (e = e.alternate, e !== null && (t = e.memoizedState)), t !== null) return t.dehydrated;
		}
		return null;
	}
	function c(e) {
		if (e.tag === 31) {
			var t = e.memoizedState;
			if (t === null && (e = e.alternate, e !== null && (t = e.memoizedState)), t !== null) return t.dehydrated;
		}
		return null;
	}
	function l(e) {
		if (o(e) !== e) throw Error(i(188));
	}
	function d(e) {
		var t = e.alternate;
		if (!t) {
			if (t = o(e), t === null) throw Error(i(188));
			return t === e ? e : null;
		}
		for (var n = e, r = t;;) {
			var a = n.return;
			if (a === null) break;
			var s = a.alternate;
			if (s === null) {
				if (r = a.return, r !== null) {
					n = r;
					continue;
				}
				break;
			}
			if (a.child === s.child) {
				for (s = a.child; s;) {
					if (s === n) return l(a), e;
					if (s === r) return l(a), t;
					s = s.sibling;
				}
				throw Error(i(188));
			}
			if (n.return !== r.return) n = a, r = s;
			else {
				for (var c = !1, u = a.child; u;) {
					if (u === n) {
						c = !0, n = a, r = s;
						break;
					}
					if (u === r) {
						c = !0, r = a, n = s;
						break;
					}
					u = u.sibling;
				}
				if (!c) {
					for (u = s.child; u;) {
						if (u === n) {
							c = !0, n = s, r = a;
							break;
						}
						if (u === r) {
							c = !0, r = s, n = a;
							break;
						}
						u = u.sibling;
					}
					if (!c) throw Error(i(189));
				}
			}
			if (n.alternate !== r) throw Error(i(190));
		}
		if (n.tag !== 3) throw Error(i(188));
		return n.stateNode.current === n ? e : t;
	}
	function p(e) {
		var t = e.tag;
		if (t === 5 || t === 26 || t === 27 || t === 6) return e;
		for (e = e.child; e !== null;) {
			if (t = p(e), t !== null) return t;
			e = e.sibling;
		}
		return null;
	}
	var h = Object.assign, g = Symbol.for("react.element"), _ = Symbol.for("react.transitional.element"), v = Symbol.for("react.portal"), y = Symbol.for("react.fragment"), b = Symbol.for("react.strict_mode"), x = Symbol.for("react.profiler"), ee = Symbol.for("react.consumer"), S = Symbol.for("react.context"), C = Symbol.for("react.forward_ref"), te = Symbol.for("react.suspense"), ne = Symbol.for("react.suspense_list"), w = Symbol.for("react.memo"), re = Symbol.for("react.lazy"), ie = Symbol.for("react.activity"), T = Symbol.for("react.memo_cache_sentinel"), E = Symbol.iterator;
	function ae(e) {
		return typeof e != "object" || !e ? null : (e = E && e[E] || e["@@iterator"], typeof e == "function" ? e : null);
	}
	var oe = Symbol.for("react.client.reference");
	function se(e) {
		if (e == null) return null;
		if (typeof e == "function") return e.$$typeof === oe ? null : e.displayName || e.name || null;
		if (typeof e == "string") return e;
		switch (e) {
			case y: return "Fragment";
			case x: return "Profiler";
			case b: return "StrictMode";
			case te: return "Suspense";
			case ne: return "SuspenseList";
			case ie: return "Activity";
		}
		if (typeof e == "object") switch (e.$$typeof) {
			case v: return "Portal";
			case S: return e.displayName || "Context";
			case ee: return (e._context.displayName || "Context") + ".Consumer";
			case C:
				var t = e.render;
				return e = e.displayName, e ||= (e = t.displayName || t.name || "", e === "" ? "ForwardRef" : "ForwardRef(" + e + ")"), e;
			case w: return t = e.displayName || null, t === null ? se(e.type) || "Memo" : t;
			case re:
				t = e._payload, e = e._init;
				try {
					return se(e(t));
				} catch {}
		}
		return null;
	}
	var ce = Array.isArray, D = n.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, O = r.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, le = {
		pending: !1,
		data: null,
		method: null,
		action: null
	}, ue = [], de = -1;
	function fe(e) {
		return { current: e };
	}
	function pe(e) {
		0 > de || (e.current = ue[de], ue[de] = null, de--);
	}
	function k(e, t) {
		de++, ue[de] = e.current, e.current = t;
	}
	var me = fe(null), he = fe(null), ge = fe(null), _e = fe(null);
	function ve(e, t) {
		switch (k(ge, t), k(he, e), k(me, null), t.nodeType) {
			case 9:
			case 11:
				e = (e = t.documentElement) && (e = e.namespaceURI) ? Vd(e) : 0;
				break;
			default: if (e = t.tagName, t = t.namespaceURI) t = Vd(t), e = Hd(t, e);
			else switch (e) {
				case "svg":
					e = 1;
					break;
				case "math":
					e = 2;
					break;
				default: e = 0;
			}
		}
		pe(me), k(me, e);
	}
	function ye() {
		pe(me), pe(he), pe(ge);
	}
	function be(e) {
		e.memoizedState !== null && k(_e, e);
		var t = me.current, n = Hd(t, e.type);
		t !== n && (k(he, e), k(me, n));
	}
	function xe(e) {
		he.current === e && (pe(me), pe(he)), _e.current === e && (pe(_e), Qf._currentValue = le);
	}
	var Se, Ce;
	function we(e) {
		if (Se === void 0) try {
			throw Error();
		} catch (e) {
			var t = e.stack.trim().match(/\n( *(at )?)/);
			Se = t && t[1] || "", Ce = -1 < e.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < e.stack.indexOf("@") ? "@unknown:0:0" : "";
		}
		return "\n" + Se + e + Ce;
	}
	var Te = !1;
	function Ee(e, t) {
		if (!e || Te) return "";
		Te = !0;
		var n = Error.prepareStackTrace;
		Error.prepareStackTrace = void 0;
		try {
			var r = { DetermineComponentFrameRoot: function() {
				try {
					if (t) {
						var n = function() {
							throw Error();
						};
						if (Object.defineProperty(n.prototype, "props", { set: function() {
							throw Error();
						} }), typeof Reflect == "object" && Reflect.construct) {
							try {
								Reflect.construct(n, []);
							} catch (e) {
								var r = e;
							}
							Reflect.construct(e, [], n);
						} else {
							try {
								n.call();
							} catch (e) {
								r = e;
							}
							e.call(n.prototype);
						}
					} else {
						try {
							throw Error();
						} catch (e) {
							r = e;
						}
						(n = e()) && typeof n.catch == "function" && n.catch(function() {});
					}
				} catch (e) {
					if (e && r && typeof e.stack == "string") return [e.stack, r.stack];
				}
				return [null, null];
			} };
			r.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
			var i = Object.getOwnPropertyDescriptor(r.DetermineComponentFrameRoot, "name");
			i && i.configurable && Object.defineProperty(r.DetermineComponentFrameRoot, "name", { value: "DetermineComponentFrameRoot" });
			var a = r.DetermineComponentFrameRoot(), o = a[0], s = a[1];
			if (o && s) {
				var c = o.split("\n"), l = s.split("\n");
				for (i = r = 0; r < c.length && !c[r].includes("DetermineComponentFrameRoot");) r++;
				for (; i < l.length && !l[i].includes("DetermineComponentFrameRoot");) i++;
				if (r === c.length || i === l.length) for (r = c.length - 1, i = l.length - 1; 1 <= r && 0 <= i && c[r] !== l[i];) i--;
				for (; 1 <= r && 0 <= i; r--, i--) if (c[r] !== l[i]) {
					if (r !== 1 || i !== 1) do
						if (r--, i--, 0 > i || c[r] !== l[i]) {
							var u = "\n" + c[r].replace(" at new ", " at ");
							return e.displayName && u.includes("<anonymous>") && (u = u.replace("<anonymous>", e.displayName)), u;
						}
					while (1 <= r && 0 <= i);
					break;
				}
			}
		} finally {
			Te = !1, Error.prepareStackTrace = n;
		}
		return (n = e ? e.displayName || e.name : "") ? we(n) : "";
	}
	function De(e, t) {
		switch (e.tag) {
			case 26:
			case 27:
			case 5: return we(e.type);
			case 16: return we("Lazy");
			case 13: return e.child !== t && t !== null ? we("Suspense Fallback") : we("Suspense");
			case 19: return we("SuspenseList");
			case 0:
			case 15: return Ee(e.type, !1);
			case 11: return Ee(e.type.render, !1);
			case 1: return Ee(e.type, !0);
			case 31: return we("Activity");
			default: return "";
		}
	}
	function Oe(e) {
		try {
			var t = "", n = null;
			do
				t += De(e, n), n = e, e = e.return;
			while (e);
			return t;
		} catch (e) {
			return "\nError generating stack: " + e.message + "\n" + e.stack;
		}
	}
	var ke = Object.prototype.hasOwnProperty, Ae = t.unstable_scheduleCallback, je = t.unstable_cancelCallback, Me = t.unstable_shouldYield, Ne = t.unstable_requestPaint, Pe = t.unstable_now, Fe = t.unstable_getCurrentPriorityLevel, Ie = t.unstable_ImmediatePriority, Le = t.unstable_UserBlockingPriority, Re = t.unstable_NormalPriority, ze = t.unstable_LowPriority, Be = t.unstable_IdlePriority, Ve = t.log, He = t.unstable_setDisableYieldValue, Ue = null, A = null;
	function We(e) {
		if (typeof Ve == "function" && He(e), A && typeof A.setStrictMode == "function") try {
			A.setStrictMode(Ue, e);
		} catch {}
	}
	var Ge = Math.clz32 ? Math.clz32 : Je, Ke = Math.log, qe = Math.LN2;
	function Je(e) {
		return e >>>= 0, e === 0 ? 32 : 31 - (Ke(e) / qe | 0) | 0;
	}
	var Ye = 256, Xe = 262144, Ze = 4194304;
	function Qe(e) {
		var t = e & 42;
		if (t !== 0) return t;
		switch (e & -e) {
			case 1: return 1;
			case 2: return 2;
			case 4: return 4;
			case 8: return 8;
			case 16: return 16;
			case 32: return 32;
			case 64: return 64;
			case 128: return 128;
			case 256:
			case 512:
			case 1024:
			case 2048:
			case 4096:
			case 8192:
			case 16384:
			case 32768:
			case 65536:
			case 131072: return e & 261888;
			case 262144:
			case 524288:
			case 1048576:
			case 2097152: return e & 3932160;
			case 4194304:
			case 8388608:
			case 16777216:
			case 33554432: return e & 62914560;
			case 67108864: return 67108864;
			case 134217728: return 134217728;
			case 268435456: return 268435456;
			case 536870912: return 536870912;
			case 1073741824: return 0;
			default: return e;
		}
	}
	function $e(e, t, n) {
		var r = e.pendingLanes;
		if (r === 0) return 0;
		var i = 0, a = e.suspendedLanes, o = e.pingedLanes;
		e = e.warmLanes;
		var s = r & 134217727;
		return s === 0 ? (s = r & ~a, s === 0 ? o === 0 ? n || (n = r & ~e, n !== 0 && (i = Qe(n))) : i = Qe(o) : i = Qe(s)) : (r = s & ~a, r === 0 ? (o &= s, o === 0 ? n || (n = s & ~e, n !== 0 && (i = Qe(n))) : i = Qe(o)) : i = Qe(r)), i === 0 ? 0 : t !== 0 && t !== i && (t & a) === 0 && (a = i & -i, n = t & -t, a >= n || a === 32 && n & 4194048) ? t : i;
	}
	function et(e, t) {
		return (e.pendingLanes & ~(e.suspendedLanes & ~e.pingedLanes) & t) === 0;
	}
	function tt(e, t) {
		switch (e) {
			case 1:
			case 2:
			case 4:
			case 8:
			case 64: return t + 250;
			case 16:
			case 32:
			case 128:
			case 256:
			case 512:
			case 1024:
			case 2048:
			case 4096:
			case 8192:
			case 16384:
			case 32768:
			case 65536:
			case 131072:
			case 262144:
			case 524288:
			case 1048576:
			case 2097152: return t + 5e3;
			case 4194304:
			case 8388608:
			case 16777216:
			case 33554432: return -1;
			case 67108864:
			case 134217728:
			case 268435456:
			case 536870912:
			case 1073741824: return -1;
			default: return -1;
		}
	}
	function nt() {
		var e = Ze;
		return Ze <<= 1, !(Ze & 62914560) && (Ze = 4194304), e;
	}
	function rt(e) {
		for (var t = [], n = 0; 31 > n; n++) t.push(e);
		return t;
	}
	function it(e, t) {
		e.pendingLanes |= t, t !== 268435456 && (e.suspendedLanes = 0, e.pingedLanes = 0, e.warmLanes = 0);
	}
	function at(e, t, n, r, i, a) {
		var o = e.pendingLanes;
		e.pendingLanes = n, e.suspendedLanes = 0, e.pingedLanes = 0, e.warmLanes = 0, e.expiredLanes &= n, e.entangledLanes &= n, e.errorRecoveryDisabledLanes &= n, e.shellSuspendCounter = 0;
		var s = e.entanglements, c = e.expirationTimes, l = e.hiddenUpdates;
		for (n = o & ~n; 0 < n;) {
			var u = 31 - Ge(n), d = 1 << u;
			s[u] = 0, c[u] = -1;
			var f = l[u];
			if (f !== null) for (l[u] = null, u = 0; u < f.length; u++) {
				var p = f[u];
				p !== null && (p.lane &= -536870913);
			}
			n &= ~d;
		}
		r !== 0 && ot(e, r, 0), a !== 0 && i === 0 && e.tag !== 0 && (e.suspendedLanes |= a & ~(o & ~t));
	}
	function ot(e, t, n) {
		e.pendingLanes |= t, e.suspendedLanes &= ~t;
		var r = 31 - Ge(t);
		e.entangledLanes |= t, e.entanglements[r] = e.entanglements[r] | 1073741824 | n & 261930;
	}
	function st(e, t) {
		var n = e.entangledLanes |= t;
		for (e = e.entanglements; n;) {
			var r = 31 - Ge(n), i = 1 << r;
			i & t | e[r] & t && (e[r] |= t), n &= ~i;
		}
	}
	function ct(e, t) {
		var n = t & -t;
		return n = n & 42 ? 1 : lt(n), (n & (e.suspendedLanes | t)) === 0 ? n : 0;
	}
	function lt(e) {
		switch (e) {
			case 2:
				e = 1;
				break;
			case 8:
				e = 4;
				break;
			case 32:
				e = 16;
				break;
			case 256:
			case 512:
			case 1024:
			case 2048:
			case 4096:
			case 8192:
			case 16384:
			case 32768:
			case 65536:
			case 131072:
			case 262144:
			case 524288:
			case 1048576:
			case 2097152:
			case 4194304:
			case 8388608:
			case 16777216:
			case 33554432:
				e = 128;
				break;
			case 268435456:
				e = 134217728;
				break;
			default: e = 0;
		}
		return e;
	}
	function ut(e) {
		return e &= -e, 2 < e ? 8 < e ? e & 134217727 ? 32 : 268435456 : 8 : 2;
	}
	function dt() {
		var e = O.p;
		return e === 0 ? (e = window.event, e === void 0 ? 32 : mp(e.type)) : e;
	}
	function ft(e, t) {
		var n = O.p;
		try {
			return O.p = e, t();
		} finally {
			O.p = n;
		}
	}
	var j = Math.random().toString(36).slice(2), M = "__reactFiber$" + j, pt = "__reactProps$" + j, mt = "__reactContainer$" + j, ht = "__reactEvents$" + j, gt = "__reactListeners$" + j, _t = "__reactHandles$" + j, vt = "__reactResources$" + j, yt = "__reactMarker$" + j;
	function bt(e) {
		delete e[M], delete e[pt], delete e[ht], delete e[gt], delete e[_t];
	}
	function xt(e) {
		var t = e[M];
		if (t) return t;
		for (var n = e.parentNode; n;) {
			if (t = n[mt] || n[M]) {
				if (n = t.alternate, t.child !== null || n !== null && n.child !== null) for (e = df(e); e !== null;) {
					if (n = e[M]) return n;
					e = df(e);
				}
				return t;
			}
			e = n, n = e.parentNode;
		}
		return null;
	}
	function St(e) {
		if (e = e[M] || e[mt]) {
			var t = e.tag;
			if (t === 5 || t === 6 || t === 13 || t === 31 || t === 26 || t === 27 || t === 3) return e;
		}
		return null;
	}
	function Ct(e) {
		var t = e.tag;
		if (t === 5 || t === 26 || t === 27 || t === 6) return e.stateNode;
		throw Error(i(33));
	}
	function wt(e) {
		var t = e[vt];
		return t ||= e[vt] = {
			hoistableStyles: /* @__PURE__ */ new Map(),
			hoistableScripts: /* @__PURE__ */ new Map()
		}, t;
	}
	function Tt(e) {
		e[yt] = !0;
	}
	var Et = /* @__PURE__ */ new Set(), Dt = {};
	function Ot(e, t) {
		kt(e, t), kt(e + "Capture", t);
	}
	function kt(e, t) {
		for (Dt[e] = t, e = 0; e < t.length; e++) Et.add(t[e]);
	}
	var At = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), jt = {}, Mt = {};
	function Nt(e) {
		return ke.call(Mt, e) ? !0 : ke.call(jt, e) ? !1 : At.test(e) ? Mt[e] = !0 : (jt[e] = !0, !1);
	}
	function Pt(e, t, n) {
		if (Nt(t)) {
			if (n === null) e.removeAttribute(t);
			else {
				switch (typeof n) {
					case "undefined":
					case "function":
					case "symbol":
						e.removeAttribute(t);
						return;
					case "boolean":
						var r = t.toLowerCase().slice(0, 5);
						if (r !== "data-" && r !== "aria-") {
							e.removeAttribute(t);
							return;
						}
				}
				e.setAttribute(t, "" + n);
			}
		}
	}
	function Ft(e, t, n) {
		if (n === null) e.removeAttribute(t);
		else {
			switch (typeof n) {
				case "undefined":
				case "function":
				case "symbol":
				case "boolean":
					e.removeAttribute(t);
					return;
			}
			e.setAttribute(t, "" + n);
		}
	}
	function It(e, t, n, r) {
		if (r === null) e.removeAttribute(n);
		else {
			switch (typeof r) {
				case "undefined":
				case "function":
				case "symbol":
				case "boolean":
					e.removeAttribute(n);
					return;
			}
			e.setAttributeNS(t, n, "" + r);
		}
	}
	function Lt(e) {
		switch (typeof e) {
			case "bigint":
			case "boolean":
			case "number":
			case "string":
			case "undefined": return e;
			case "object": return e;
			default: return "";
		}
	}
	function Rt(e) {
		var t = e.type;
		return (e = e.nodeName) && e.toLowerCase() === "input" && (t === "checkbox" || t === "radio");
	}
	function zt(e, t, n) {
		var r = Object.getOwnPropertyDescriptor(e.constructor.prototype, t);
		if (!e.hasOwnProperty(t) && r !== void 0 && typeof r.get == "function" && typeof r.set == "function") {
			var i = r.get, a = r.set;
			return Object.defineProperty(e, t, {
				configurable: !0,
				get: function() {
					return i.call(this);
				},
				set: function(e) {
					n = "" + e, a.call(this, e);
				}
			}), Object.defineProperty(e, t, { enumerable: r.enumerable }), {
				getValue: function() {
					return n;
				},
				setValue: function(e) {
					n = "" + e;
				},
				stopTracking: function() {
					e._valueTracker = null, delete e[t];
				}
			};
		}
	}
	function Bt(e) {
		if (!e._valueTracker) {
			var t = Rt(e) ? "checked" : "value";
			e._valueTracker = zt(e, t, "" + e[t]);
		}
	}
	function Vt(e) {
		if (!e) return !1;
		var t = e._valueTracker;
		if (!t) return !0;
		var n = t.getValue(), r = "";
		return e && (r = Rt(e) ? e.checked ? "true" : "false" : e.value), e = r, e !== n && (t.setValue(e), !0);
	}
	function Ht(e) {
		if (e ||= typeof document < "u" ? document : void 0, e === void 0) return null;
		try {
			return e.activeElement || e.body;
		} catch {
			return e.body;
		}
	}
	var Ut = /[\n"\\]/g;
	function Wt(e) {
		return e.replace(Ut, function(e) {
			return "\\" + e.charCodeAt(0).toString(16) + " ";
		});
	}
	function Gt(e, t, n, r, i, a, o, s) {
		e.name = "", o != null && typeof o != "function" && typeof o != "symbol" && typeof o != "boolean" ? e.type = o : e.removeAttribute("type"), t == null ? o !== "submit" && o !== "reset" || e.removeAttribute("value") : o === "number" ? (t === 0 && e.value === "" || e.value != t) && (e.value = "" + Lt(t)) : e.value !== "" + Lt(t) && (e.value = "" + Lt(t)), t == null ? n == null ? r != null && e.removeAttribute("value") : qt(e, o, Lt(n)) : qt(e, o, Lt(t)), i == null && a != null && (e.defaultChecked = !!a), i != null && (e.checked = i && typeof i != "function" && typeof i != "symbol"), s != null && typeof s != "function" && typeof s != "symbol" && typeof s != "boolean" ? e.name = "" + Lt(s) : e.removeAttribute("name");
	}
	function Kt(e, t, n, r, i, a, o, s) {
		if (a != null && typeof a != "function" && typeof a != "symbol" && typeof a != "boolean" && (e.type = a), t != null || n != null) {
			if (!(a !== "submit" && a !== "reset" || t != null)) {
				Bt(e);
				return;
			}
			n = n == null ? "" : "" + Lt(n), t = t == null ? n : "" + Lt(t), s || t === e.value || (e.value = t), e.defaultValue = t;
		}
		r ??= i, r = typeof r != "function" && typeof r != "symbol" && !!r, e.checked = s ? e.checked : !!r, e.defaultChecked = !!r, o != null && typeof o != "function" && typeof o != "symbol" && typeof o != "boolean" && (e.name = o), Bt(e);
	}
	function qt(e, t, n) {
		t === "number" && Ht(e.ownerDocument) === e || e.defaultValue === "" + n || (e.defaultValue = "" + n);
	}
	function Jt(e, t, n, r) {
		if (e = e.options, t) {
			t = {};
			for (var i = 0; i < n.length; i++) t["$" + n[i]] = !0;
			for (n = 0; n < e.length; n++) i = t.hasOwnProperty("$" + e[n].value), e[n].selected !== i && (e[n].selected = i), i && r && (e[n].defaultSelected = !0);
		} else {
			for (n = "" + Lt(n), t = null, i = 0; i < e.length; i++) {
				if (e[i].value === n) {
					e[i].selected = !0, r && (e[i].defaultSelected = !0);
					return;
				}
				t !== null || e[i].disabled || (t = e[i]);
			}
			t !== null && (t.selected = !0);
		}
	}
	function Yt(e, t, n) {
		if (t != null && (t = "" + Lt(t), t !== e.value && (e.value = t), n == null)) {
			e.defaultValue !== t && (e.defaultValue = t);
			return;
		}
		e.defaultValue = n == null ? "" : "" + Lt(n);
	}
	function Xt(e, t, n, r) {
		if (t == null) {
			if (r != null) {
				if (n != null) throw Error(i(92));
				if (ce(r)) {
					if (1 < r.length) throw Error(i(93));
					r = r[0];
				}
				n = r;
			}
			n ??= "", t = n;
		}
		n = Lt(t), e.defaultValue = n, r = e.textContent, r === n && r !== "" && r !== null && (e.value = r), Bt(e);
	}
	function Zt(e, t) {
		if (t) {
			var n = e.firstChild;
			if (n && n === e.lastChild && n.nodeType === 3) {
				n.nodeValue = t;
				return;
			}
		}
		e.textContent = t;
	}
	var Qt = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
	function $t(e, t, n) {
		var r = t.indexOf("--") === 0;
		n == null || typeof n == "boolean" || n === "" ? r ? e.setProperty(t, "") : t === "float" ? e.cssFloat = "" : e[t] = "" : r ? e.setProperty(t, n) : typeof n != "number" || n === 0 || Qt.has(t) ? t === "float" ? e.cssFloat = n : e[t] = ("" + n).trim() : e[t] = n + "px";
	}
	function en(e, t, n) {
		if (t != null && typeof t != "object") throw Error(i(62));
		if (e = e.style, n != null) {
			for (var r in n) !n.hasOwnProperty(r) || t != null && t.hasOwnProperty(r) || (r.indexOf("--") === 0 ? e.setProperty(r, "") : r === "float" ? e.cssFloat = "" : e[r] = "");
			for (var a in t) r = t[a], t.hasOwnProperty(a) && n[a] !== r && $t(e, a, r);
		} else for (var o in t) t.hasOwnProperty(o) && $t(e, o, t[o]);
	}
	function tn(e) {
		if (e.indexOf("-") === -1) return !1;
		switch (e) {
			case "annotation-xml":
			case "color-profile":
			case "font-face":
			case "font-face-src":
			case "font-face-uri":
			case "font-face-format":
			case "font-face-name":
			case "missing-glyph": return !1;
			default: return !0;
		}
	}
	var nn = /* @__PURE__ */ new Map([
		["acceptCharset", "accept-charset"],
		["htmlFor", "for"],
		["httpEquiv", "http-equiv"],
		["crossOrigin", "crossorigin"],
		["accentHeight", "accent-height"],
		["alignmentBaseline", "alignment-baseline"],
		["arabicForm", "arabic-form"],
		["baselineShift", "baseline-shift"],
		["capHeight", "cap-height"],
		["clipPath", "clip-path"],
		["clipRule", "clip-rule"],
		["colorInterpolation", "color-interpolation"],
		["colorInterpolationFilters", "color-interpolation-filters"],
		["colorProfile", "color-profile"],
		["colorRendering", "color-rendering"],
		["dominantBaseline", "dominant-baseline"],
		["enableBackground", "enable-background"],
		["fillOpacity", "fill-opacity"],
		["fillRule", "fill-rule"],
		["floodColor", "flood-color"],
		["floodOpacity", "flood-opacity"],
		["fontFamily", "font-family"],
		["fontSize", "font-size"],
		["fontSizeAdjust", "font-size-adjust"],
		["fontStretch", "font-stretch"],
		["fontStyle", "font-style"],
		["fontVariant", "font-variant"],
		["fontWeight", "font-weight"],
		["glyphName", "glyph-name"],
		["glyphOrientationHorizontal", "glyph-orientation-horizontal"],
		["glyphOrientationVertical", "glyph-orientation-vertical"],
		["horizAdvX", "horiz-adv-x"],
		["horizOriginX", "horiz-origin-x"],
		["imageRendering", "image-rendering"],
		["letterSpacing", "letter-spacing"],
		["lightingColor", "lighting-color"],
		["markerEnd", "marker-end"],
		["markerMid", "marker-mid"],
		["markerStart", "marker-start"],
		["overlinePosition", "overline-position"],
		["overlineThickness", "overline-thickness"],
		["paintOrder", "paint-order"],
		["panose-1", "panose-1"],
		["pointerEvents", "pointer-events"],
		["renderingIntent", "rendering-intent"],
		["shapeRendering", "shape-rendering"],
		["stopColor", "stop-color"],
		["stopOpacity", "stop-opacity"],
		["strikethroughPosition", "strikethrough-position"],
		["strikethroughThickness", "strikethrough-thickness"],
		["strokeDasharray", "stroke-dasharray"],
		["strokeDashoffset", "stroke-dashoffset"],
		["strokeLinecap", "stroke-linecap"],
		["strokeLinejoin", "stroke-linejoin"],
		["strokeMiterlimit", "stroke-miterlimit"],
		["strokeOpacity", "stroke-opacity"],
		["strokeWidth", "stroke-width"],
		["textAnchor", "text-anchor"],
		["textDecoration", "text-decoration"],
		["textRendering", "text-rendering"],
		["transformOrigin", "transform-origin"],
		["underlinePosition", "underline-position"],
		["underlineThickness", "underline-thickness"],
		["unicodeBidi", "unicode-bidi"],
		["unicodeRange", "unicode-range"],
		["unitsPerEm", "units-per-em"],
		["vAlphabetic", "v-alphabetic"],
		["vHanging", "v-hanging"],
		["vIdeographic", "v-ideographic"],
		["vMathematical", "v-mathematical"],
		["vectorEffect", "vector-effect"],
		["vertAdvY", "vert-adv-y"],
		["vertOriginX", "vert-origin-x"],
		["vertOriginY", "vert-origin-y"],
		["wordSpacing", "word-spacing"],
		["writingMode", "writing-mode"],
		["xmlnsXlink", "xmlns:xlink"],
		["xHeight", "x-height"]
	]), rn = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
	function an(e) {
		return rn.test("" + e) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : e;
	}
	function on() {}
	var sn = null;
	function cn(e) {
		return e = e.target || e.srcElement || window, e.correspondingUseElement && (e = e.correspondingUseElement), e.nodeType === 3 ? e.parentNode : e;
	}
	var ln = null, un = null;
	function dn(e) {
		var t = St(e);
		if (t && (e = t.stateNode)) {
			var n = e[pt] || null;
			a: switch (e = t.stateNode, t.type) {
				case "input":
					if (Gt(e, n.value, n.defaultValue, n.defaultValue, n.checked, n.defaultChecked, n.type, n.name), t = n.name, n.type === "radio" && t != null) {
						for (n = e; n.parentNode;) n = n.parentNode;
						for (n = n.querySelectorAll("input[name=\"" + Wt("" + t) + "\"][type=\"radio\"]"), t = 0; t < n.length; t++) {
							var r = n[t];
							if (r !== e && r.form === e.form) {
								var a = r[pt] || null;
								if (!a) throw Error(i(90));
								Gt(r, a.value, a.defaultValue, a.defaultValue, a.checked, a.defaultChecked, a.type, a.name);
							}
						}
						for (t = 0; t < n.length; t++) r = n[t], r.form === e.form && Vt(r);
					}
					break a;
				case "textarea":
					Yt(e, n.value, n.defaultValue);
					break a;
				case "select": t = n.value, t != null && Jt(e, !!n.multiple, t, !1);
			}
		}
	}
	var fn = !1;
	function pn(e, t, n) {
		if (fn) return e(t, n);
		fn = !0;
		try {
			return e(t);
		} finally {
			if (fn = !1, (ln !== null || un !== null) && (bu(), ln && (t = ln, e = un, un = ln = null, dn(t), e))) for (t = 0; t < e.length; t++) dn(e[t]);
		}
	}
	function mn(e, t) {
		var n = e.stateNode;
		if (n === null) return null;
		var r = n[pt] || null;
		if (r === null) return null;
		n = r[t];
		a: switch (t) {
			case "onClick":
			case "onClickCapture":
			case "onDoubleClick":
			case "onDoubleClickCapture":
			case "onMouseDown":
			case "onMouseDownCapture":
			case "onMouseMove":
			case "onMouseMoveCapture":
			case "onMouseUp":
			case "onMouseUpCapture":
			case "onMouseEnter":
				(r = !r.disabled) || (e = e.type, r = e !== "button" && e !== "input" && e !== "select" && e !== "textarea"), e = !r;
				break a;
			default: e = !1;
		}
		if (e) return null;
		if (n && typeof n != "function") throw Error(i(231, t, typeof n));
		return n;
	}
	var hn = !(typeof window > "u" || window.document === void 0 || window.document.createElement === void 0), gn = !1;
	if (hn) try {
		var _n = {};
		Object.defineProperty(_n, "passive", { get: function() {
			gn = !0;
		} }), window.addEventListener("test", _n, _n), window.removeEventListener("test", _n, _n);
	} catch {
		gn = !1;
	}
	var vn = null, yn = null, bn = null;
	function xn() {
		if (bn) return bn;
		var e, t = yn, n = t.length, r, i = "value" in vn ? vn.value : vn.textContent, a = i.length;
		for (e = 0; e < n && t[e] === i[e]; e++);
		var o = n - e;
		for (r = 1; r <= o && t[n - r] === i[a - r]; r++);
		return bn = i.slice(e, 1 < r ? 1 - r : void 0);
	}
	function Sn(e) {
		var t = e.keyCode;
		return "charCode" in e ? (e = e.charCode, e === 0 && t === 13 && (e = 13)) : e = t, e === 10 && (e = 13), 32 <= e || e === 13 ? e : 0;
	}
	function Cn() {
		return !0;
	}
	function wn() {
		return !1;
	}
	function Tn(e) {
		function t(t, n, r, i, a) {
			for (var o in this._reactName = t, this._targetInst = r, this.type = n, this.nativeEvent = i, this.target = a, this.currentTarget = null, e) e.hasOwnProperty(o) && (t = e[o], this[o] = t ? t(i) : i[o]);
			return this.isDefaultPrevented = (i.defaultPrevented == null ? !1 === i.returnValue : i.defaultPrevented) ? Cn : wn, this.isPropagationStopped = wn, this;
		}
		return h(t.prototype, {
			preventDefault: function() {
				this.defaultPrevented = !0;
				var e = this.nativeEvent;
				e && (e.preventDefault ? e.preventDefault() : typeof e.returnValue != "unknown" && (e.returnValue = !1), this.isDefaultPrevented = Cn);
			},
			stopPropagation: function() {
				var e = this.nativeEvent;
				e && (e.stopPropagation ? e.stopPropagation() : typeof e.cancelBubble != "unknown" && (e.cancelBubble = !0), this.isPropagationStopped = Cn);
			},
			persist: function() {},
			isPersistent: Cn
		}), t;
	}
	var En = {
		eventPhase: 0,
		bubbles: 0,
		cancelable: 0,
		timeStamp: function(e) {
			return e.timeStamp || Date.now();
		},
		defaultPrevented: 0,
		isTrusted: 0
	}, Dn = Tn(En), On = h({}, En, {
		view: 0,
		detail: 0
	}), kn = Tn(On), An, jn, Mn, Nn = h({}, On, {
		screenX: 0,
		screenY: 0,
		clientX: 0,
		clientY: 0,
		pageX: 0,
		pageY: 0,
		ctrlKey: 0,
		shiftKey: 0,
		altKey: 0,
		metaKey: 0,
		getModifierState: Wn,
		button: 0,
		buttons: 0,
		relatedTarget: function(e) {
			return e.relatedTarget === void 0 ? e.fromElement === e.srcElement ? e.toElement : e.fromElement : e.relatedTarget;
		},
		movementX: function(e) {
			return "movementX" in e ? e.movementX : (e !== Mn && (Mn && e.type === "mousemove" ? (An = e.screenX - Mn.screenX, jn = e.screenY - Mn.screenY) : jn = An = 0, Mn = e), An);
		},
		movementY: function(e) {
			return "movementY" in e ? e.movementY : jn;
		}
	}), Pn = Tn(Nn), Fn = Tn(h({}, Nn, { dataTransfer: 0 })), In = Tn(h({}, On, { relatedTarget: 0 })), Ln = Tn(h({}, En, {
		animationName: 0,
		elapsedTime: 0,
		pseudoElement: 0
	})), Rn = Tn(h({}, En, { clipboardData: function(e) {
		return "clipboardData" in e ? e.clipboardData : window.clipboardData;
	} })), zn = Tn(h({}, En, { data: 0 })), Bn = {
		Esc: "Escape",
		Spacebar: " ",
		Left: "ArrowLeft",
		Up: "ArrowUp",
		Right: "ArrowRight",
		Down: "ArrowDown",
		Del: "Delete",
		Win: "OS",
		Menu: "ContextMenu",
		Apps: "ContextMenu",
		Scroll: "ScrollLock",
		MozPrintableKey: "Unidentified"
	}, Vn = {
		8: "Backspace",
		9: "Tab",
		12: "Clear",
		13: "Enter",
		16: "Shift",
		17: "Control",
		18: "Alt",
		19: "Pause",
		20: "CapsLock",
		27: "Escape",
		32: " ",
		33: "PageUp",
		34: "PageDown",
		35: "End",
		36: "Home",
		37: "ArrowLeft",
		38: "ArrowUp",
		39: "ArrowRight",
		40: "ArrowDown",
		45: "Insert",
		46: "Delete",
		112: "F1",
		113: "F2",
		114: "F3",
		115: "F4",
		116: "F5",
		117: "F6",
		118: "F7",
		119: "F8",
		120: "F9",
		121: "F10",
		122: "F11",
		123: "F12",
		144: "NumLock",
		145: "ScrollLock",
		224: "Meta"
	}, Hn = {
		Alt: "altKey",
		Control: "ctrlKey",
		Meta: "metaKey",
		Shift: "shiftKey"
	};
	function Un(e) {
		var t = this.nativeEvent;
		return t.getModifierState ? t.getModifierState(e) : (e = Hn[e]) ? !!t[e] : !1;
	}
	function Wn() {
		return Un;
	}
	var Gn = Tn(h({}, On, {
		key: function(e) {
			if (e.key) {
				var t = Bn[e.key] || e.key;
				if (t !== "Unidentified") return t;
			}
			return e.type === "keypress" ? (e = Sn(e), e === 13 ? "Enter" : String.fromCharCode(e)) : e.type === "keydown" || e.type === "keyup" ? Vn[e.keyCode] || "Unidentified" : "";
		},
		code: 0,
		location: 0,
		ctrlKey: 0,
		shiftKey: 0,
		altKey: 0,
		metaKey: 0,
		repeat: 0,
		locale: 0,
		getModifierState: Wn,
		charCode: function(e) {
			return e.type === "keypress" ? Sn(e) : 0;
		},
		keyCode: function(e) {
			return e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
		},
		which: function(e) {
			return e.type === "keypress" ? Sn(e) : e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
		}
	})), Kn = Tn(h({}, Nn, {
		pointerId: 0,
		width: 0,
		height: 0,
		pressure: 0,
		tangentialPressure: 0,
		tiltX: 0,
		tiltY: 0,
		twist: 0,
		pointerType: 0,
		isPrimary: 0
	})), qn = Tn(h({}, On, {
		touches: 0,
		targetTouches: 0,
		changedTouches: 0,
		altKey: 0,
		metaKey: 0,
		ctrlKey: 0,
		shiftKey: 0,
		getModifierState: Wn
	})), Jn = Tn(h({}, En, {
		propertyName: 0,
		elapsedTime: 0,
		pseudoElement: 0
	})), Yn = Tn(h({}, Nn, {
		deltaX: function(e) {
			return "deltaX" in e ? e.deltaX : "wheelDeltaX" in e ? -e.wheelDeltaX : 0;
		},
		deltaY: function(e) {
			return "deltaY" in e ? e.deltaY : "wheelDeltaY" in e ? -e.wheelDeltaY : "wheelDelta" in e ? -e.wheelDelta : 0;
		},
		deltaZ: 0,
		deltaMode: 0
	})), Xn = Tn(h({}, En, {
		newState: 0,
		oldState: 0
	})), Zn = [
		9,
		13,
		27,
		32
	], Qn = hn && "CompositionEvent" in window, $n = null;
	hn && "documentMode" in document && ($n = document.documentMode);
	var er = hn && "TextEvent" in window && !$n, tr = hn && (!Qn || $n && 8 < $n && 11 >= $n), nr = " ", rr = !1;
	function ir(e, t) {
		switch (e) {
			case "keyup": return Zn.indexOf(t.keyCode) !== -1;
			case "keydown": return t.keyCode !== 229;
			case "keypress":
			case "mousedown":
			case "focusout": return !0;
			default: return !1;
		}
	}
	function ar(e) {
		return e = e.detail, typeof e == "object" && "data" in e ? e.data : null;
	}
	var or = !1;
	function sr(e, t) {
		switch (e) {
			case "compositionend": return ar(t);
			case "keypress": return t.which === 32 ? (rr = !0, nr) : null;
			case "textInput": return e = t.data, e === nr && rr ? null : e;
			default: return null;
		}
	}
	function cr(e, t) {
		if (or) return e === "compositionend" || !Qn && ir(e, t) ? (e = xn(), bn = yn = vn = null, or = !1, e) : null;
		switch (e) {
			case "paste": return null;
			case "keypress":
				if (!(t.ctrlKey || t.altKey || t.metaKey) || t.ctrlKey && t.altKey) {
					if (t.char && 1 < t.char.length) return t.char;
					if (t.which) return String.fromCharCode(t.which);
				}
				return null;
			case "compositionend": return tr && t.locale !== "ko" ? null : t.data;
			default: return null;
		}
	}
	var lr = {
		color: !0,
		date: !0,
		datetime: !0,
		"datetime-local": !0,
		email: !0,
		month: !0,
		number: !0,
		password: !0,
		range: !0,
		search: !0,
		tel: !0,
		text: !0,
		time: !0,
		url: !0,
		week: !0
	};
	function ur(e) {
		var t = e && e.nodeName && e.nodeName.toLowerCase();
		return t === "input" ? !!lr[e.type] : t === "textarea";
	}
	function dr(e, t, n, r) {
		ln ? un ? un.push(r) : un = [r] : ln = r, t = Ed(t, "onChange"), 0 < t.length && (n = new Dn("onChange", "change", null, n, r), e.push({
			event: n,
			listeners: t
		}));
	}
	var fr = null, pr = null;
	function mr(e) {
		yd(e, 0);
	}
	function hr(e) {
		if (Vt(Ct(e))) return e;
	}
	function gr(e, t) {
		if (e === "change") return t;
	}
	var _r = !1;
	if (hn) {
		var vr;
		if (hn) {
			var yr = "oninput" in document;
			if (!yr) {
				var br = document.createElement("div");
				br.setAttribute("oninput", "return;"), yr = typeof br.oninput == "function";
			}
			vr = yr;
		} else vr = !1;
		_r = vr && (!document.documentMode || 9 < document.documentMode);
	}
	function xr() {
		fr && (fr.detachEvent("onpropertychange", Sr), pr = fr = null);
	}
	function Sr(e) {
		if (e.propertyName === "value" && hr(pr)) {
			var t = [];
			dr(t, pr, e, cn(e)), pn(mr, t);
		}
	}
	function Cr(e, t, n) {
		e === "focusin" ? (xr(), fr = t, pr = n, fr.attachEvent("onpropertychange", Sr)) : e === "focusout" && xr();
	}
	function wr(e) {
		if (e === "selectionchange" || e === "keyup" || e === "keydown") return hr(pr);
	}
	function Tr(e, t) {
		if (e === "click") return hr(t);
	}
	function Er(e, t) {
		if (e === "input" || e === "change") return hr(t);
	}
	function Dr(e, t) {
		return e === t && (e !== 0 || 1 / e == 1 / t) || e !== e && t !== t;
	}
	var Or = typeof Object.is == "function" ? Object.is : Dr;
	function kr(e, t) {
		if (Or(e, t)) return !0;
		if (typeof e != "object" || !e || typeof t != "object" || !t) return !1;
		var n = Object.keys(e), r = Object.keys(t);
		if (n.length !== r.length) return !1;
		for (r = 0; r < n.length; r++) {
			var i = n[r];
			if (!ke.call(t, i) || !Or(e[i], t[i])) return !1;
		}
		return !0;
	}
	function Ar(e) {
		for (; e && e.firstChild;) e = e.firstChild;
		return e;
	}
	function jr(e, t) {
		var n = Ar(e);
		e = 0;
		for (var r; n;) {
			if (n.nodeType === 3) {
				if (r = e + n.textContent.length, e <= t && r >= t) return {
					node: n,
					offset: t - e
				};
				e = r;
			}
			a: {
				for (; n;) {
					if (n.nextSibling) {
						n = n.nextSibling;
						break a;
					}
					n = n.parentNode;
				}
				n = void 0;
			}
			n = Ar(n);
		}
	}
	function Mr(e, t) {
		return e && t ? e === t ? !0 : e && e.nodeType === 3 ? !1 : t && t.nodeType === 3 ? Mr(e, t.parentNode) : "contains" in e ? e.contains(t) : e.compareDocumentPosition ? !!(e.compareDocumentPosition(t) & 16) : !1 : !1;
	}
	function Nr(e) {
		e = e != null && e.ownerDocument != null && e.ownerDocument.defaultView != null ? e.ownerDocument.defaultView : window;
		for (var t = Ht(e.document); t instanceof e.HTMLIFrameElement;) {
			try {
				var n = typeof t.contentWindow.location.href == "string";
			} catch {
				n = !1;
			}
			if (n) e = t.contentWindow;
			else break;
			t = Ht(e.document);
		}
		return t;
	}
	function Pr(e) {
		var t = e && e.nodeName && e.nodeName.toLowerCase();
		return t && (t === "input" && (e.type === "text" || e.type === "search" || e.type === "tel" || e.type === "url" || e.type === "password") || t === "textarea" || e.contentEditable === "true");
	}
	var Fr = hn && "documentMode" in document && 11 >= document.documentMode, Ir = null, Lr = null, Rr = null, zr = !1;
	function Br(e, t, n) {
		var r = n.window === n ? n.document : n.nodeType === 9 ? n : n.ownerDocument;
		zr || Ir == null || Ir !== Ht(r) || (r = Ir, "selectionStart" in r && Pr(r) ? r = {
			start: r.selectionStart,
			end: r.selectionEnd
		} : (r = (r.ownerDocument && r.ownerDocument.defaultView || window).getSelection(), r = {
			anchorNode: r.anchorNode,
			anchorOffset: r.anchorOffset,
			focusNode: r.focusNode,
			focusOffset: r.focusOffset
		}), Rr && kr(Rr, r) || (Rr = r, r = Ed(Lr, "onSelect"), 0 < r.length && (t = new Dn("onSelect", "select", null, t, n), e.push({
			event: t,
			listeners: r
		}), t.target = Ir)));
	}
	function Vr(e, t) {
		var n = {};
		return n[e.toLowerCase()] = t.toLowerCase(), n["Webkit" + e] = "webkit" + t, n["Moz" + e] = "moz" + t, n;
	}
	var Hr = {
		animationend: Vr("Animation", "AnimationEnd"),
		animationiteration: Vr("Animation", "AnimationIteration"),
		animationstart: Vr("Animation", "AnimationStart"),
		transitionrun: Vr("Transition", "TransitionRun"),
		transitionstart: Vr("Transition", "TransitionStart"),
		transitioncancel: Vr("Transition", "TransitionCancel"),
		transitionend: Vr("Transition", "TransitionEnd")
	}, Ur = {}, Wr = {};
	hn && (Wr = document.createElement("div").style, "AnimationEvent" in window || (delete Hr.animationend.animation, delete Hr.animationiteration.animation, delete Hr.animationstart.animation), "TransitionEvent" in window || delete Hr.transitionend.transition);
	function Gr(e) {
		if (Ur[e]) return Ur[e];
		if (!Hr[e]) return e;
		var t = Hr[e], n;
		for (n in t) if (t.hasOwnProperty(n) && n in Wr) return Ur[e] = t[n];
		return e;
	}
	var Kr = Gr("animationend"), qr = Gr("animationiteration"), Jr = Gr("animationstart"), Yr = Gr("transitionrun"), Xr = Gr("transitionstart"), Zr = Gr("transitioncancel"), Qr = Gr("transitionend"), $r = /* @__PURE__ */ new Map(), ei = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
	ei.push("scrollEnd");
	function ti(e, t) {
		$r.set(e, t), Ot(t, [e]);
	}
	var ni = typeof reportError == "function" ? reportError : function(e) {
		if (typeof window == "object" && typeof window.ErrorEvent == "function") {
			var t = new window.ErrorEvent("error", {
				bubbles: !0,
				cancelable: !0,
				message: typeof e == "object" && e && typeof e.message == "string" ? String(e.message) : String(e),
				error: e
			});
			if (!window.dispatchEvent(t)) return;
		} else if (typeof process == "object" && typeof process.emit == "function") {
			process.emit("uncaughtException", e);
			return;
		}
		console.error(e);
	}, ri = [], ii = 0, ai = 0;
	function oi() {
		for (var e = ii, t = ai = ii = 0; t < e;) {
			var n = ri[t];
			ri[t++] = null;
			var r = ri[t];
			ri[t++] = null;
			var i = ri[t];
			ri[t++] = null;
			var a = ri[t];
			if (ri[t++] = null, r !== null && i !== null) {
				var o = r.pending;
				o === null ? i.next = i : (i.next = o.next, o.next = i), r.pending = i;
			}
			a !== 0 && ui(n, i, a);
		}
	}
	function si(e, t, n, r) {
		ri[ii++] = e, ri[ii++] = t, ri[ii++] = n, ri[ii++] = r, ai |= r, e.lanes |= r, e = e.alternate, e !== null && (e.lanes |= r);
	}
	function ci(e, t, n, r) {
		return si(e, t, n, r), di(e);
	}
	function li(e, t) {
		return si(e, null, null, t), di(e);
	}
	function ui(e, t, n) {
		e.lanes |= n;
		var r = e.alternate;
		r !== null && (r.lanes |= n);
		for (var i = !1, a = e.return; a !== null;) a.childLanes |= n, r = a.alternate, r !== null && (r.childLanes |= n), a.tag === 22 && (e = a.stateNode, e === null || e._visibility & 1 || (i = !0)), e = a, a = a.return;
		return e.tag === 3 ? (a = e.stateNode, i && t !== null && (i = 31 - Ge(n), e = a.hiddenUpdates, r = e[i], r === null ? e[i] = [t] : r.push(t), t.lane = n | 536870912), a) : null;
	}
	function di(e) {
		if (50 < du) throw du = 0, fu = null, Error(i(185));
		for (var t = e.return; t !== null;) e = t, t = e.return;
		return e.tag === 3 ? e.stateNode : null;
	}
	var fi = {};
	function pi(e, t, n, r) {
		this.tag = e, this.key = n, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.refCleanup = this.ref = null, this.pendingProps = t, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = r, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
	}
	function mi(e, t, n, r) {
		return new pi(e, t, n, r);
	}
	function hi(e) {
		return e = e.prototype, !(!e || !e.isReactComponent);
	}
	function gi(e, t) {
		var n = e.alternate;
		return n === null ? (n = mi(e.tag, t, e.key, e.mode), n.elementType = e.elementType, n.type = e.type, n.stateNode = e.stateNode, n.alternate = e, e.alternate = n) : (n.pendingProps = t, n.type = e.type, n.flags = 0, n.subtreeFlags = 0, n.deletions = null), n.flags = e.flags & 65011712, n.childLanes = e.childLanes, n.lanes = e.lanes, n.child = e.child, n.memoizedProps = e.memoizedProps, n.memoizedState = e.memoizedState, n.updateQueue = e.updateQueue, t = e.dependencies, n.dependencies = t === null ? null : {
			lanes: t.lanes,
			firstContext: t.firstContext
		}, n.sibling = e.sibling, n.index = e.index, n.ref = e.ref, n.refCleanup = e.refCleanup, n;
	}
	function _i(e, t) {
		e.flags &= 65011714;
		var n = e.alternate;
		return n === null ? (e.childLanes = 0, e.lanes = t, e.child = null, e.subtreeFlags = 0, e.memoizedProps = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null, e.stateNode = null) : (e.childLanes = n.childLanes, e.lanes = n.lanes, e.child = n.child, e.subtreeFlags = 0, e.deletions = null, e.memoizedProps = n.memoizedProps, e.memoizedState = n.memoizedState, e.updateQueue = n.updateQueue, e.type = n.type, t = n.dependencies, e.dependencies = t === null ? null : {
			lanes: t.lanes,
			firstContext: t.firstContext
		}), e;
	}
	function vi(e, t, n, r, a, o) {
		var s = 0;
		if (r = e, typeof e == "function") hi(e) && (s = 1);
		else if (typeof e == "string") s = Uf(e, n, me.current) ? 26 : e === "html" || e === "head" || e === "body" ? 27 : 5;
		else a: switch (e) {
			case ie: return e = mi(31, n, t, a), e.elementType = ie, e.lanes = o, e;
			case y: return yi(n.children, a, o, t);
			case b:
				s = 8, a |= 24;
				break;
			case x: return e = mi(12, n, t, a | 2), e.elementType = x, e.lanes = o, e;
			case te: return e = mi(13, n, t, a), e.elementType = te, e.lanes = o, e;
			case ne: return e = mi(19, n, t, a), e.elementType = ne, e.lanes = o, e;
			default:
				if (typeof e == "object" && e) switch (e.$$typeof) {
					case S:
						s = 10;
						break a;
					case ee:
						s = 9;
						break a;
					case C:
						s = 11;
						break a;
					case w:
						s = 14;
						break a;
					case re:
						s = 16, r = null;
						break a;
				}
				s = 29, n = Error(i(130, e === null ? "null" : typeof e, "")), r = null;
		}
		return t = mi(s, n, t, a), t.elementType = e, t.type = r, t.lanes = o, t;
	}
	function yi(e, t, n, r) {
		return e = mi(7, e, r, t), e.lanes = n, e;
	}
	function bi(e, t, n) {
		return e = mi(6, e, null, t), e.lanes = n, e;
	}
	function xi(e) {
		var t = mi(18, null, null, 0);
		return t.stateNode = e, t;
	}
	function Si(e, t, n) {
		return t = mi(4, e.children === null ? [] : e.children, e.key, t), t.lanes = n, t.stateNode = {
			containerInfo: e.containerInfo,
			pendingChildren: null,
			implementation: e.implementation
		}, t;
	}
	var Ci = /* @__PURE__ */ new WeakMap();
	function wi(e, t) {
		if (typeof e == "object" && e) {
			var n = Ci.get(e);
			return n === void 0 ? (t = {
				value: e,
				source: t,
				stack: Oe(t)
			}, Ci.set(e, t), t) : n;
		}
		return {
			value: e,
			source: t,
			stack: Oe(t)
		};
	}
	var Ti = [], Ei = 0, Di = null, Oi = 0, ki = [], Ai = 0, ji = null, Mi = 1, Ni = "";
	function Pi(e, t) {
		Ti[Ei++] = Oi, Ti[Ei++] = Di, Di = e, Oi = t;
	}
	function Fi(e, t, n) {
		ki[Ai++] = Mi, ki[Ai++] = Ni, ki[Ai++] = ji, ji = e;
		var r = Mi;
		e = Ni;
		var i = 32 - Ge(r) - 1;
		r &= ~(1 << i), n += 1;
		var a = 32 - Ge(t) + i;
		if (30 < a) {
			var o = i - i % 5;
			a = (r & (1 << o) - 1).toString(32), r >>= o, i -= o, Mi = 1 << 32 - Ge(t) + i | n << i | r, Ni = a + e;
		} else Mi = 1 << a | n << i | r, Ni = e;
	}
	function Ii(e) {
		e.return !== null && (Pi(e, 1), Fi(e, 1, 0));
	}
	function Li(e) {
		for (; e === Di;) Di = Ti[--Ei], Ti[Ei] = null, Oi = Ti[--Ei], Ti[Ei] = null;
		for (; e === ji;) ji = ki[--Ai], ki[Ai] = null, Ni = ki[--Ai], ki[Ai] = null, Mi = ki[--Ai], ki[Ai] = null;
	}
	function Ri(e, t) {
		ki[Ai++] = Mi, ki[Ai++] = Ni, ki[Ai++] = ji, Mi = t.id, Ni = t.overflow, ji = e;
	}
	var zi = null, N = null, P = !1, Bi = null, Vi = !1, Hi = Error(i(519));
	function Ui(e) {
		throw Yi(wi(Error(i(418, 1 < arguments.length && arguments[1] !== void 0 && arguments[1] ? "text" : "HTML", "")), e)), Hi;
	}
	function Wi(e) {
		var t = e.stateNode, n = e.type, r = e.memoizedProps;
		switch (t[M] = e, t[pt] = r, n) {
			case "dialog":
				Q("cancel", t), Q("close", t);
				break;
			case "iframe":
			case "object":
			case "embed":
				Q("load", t);
				break;
			case "video":
			case "audio":
				for (n = 0; n < _d.length; n++) Q(_d[n], t);
				break;
			case "source":
				Q("error", t);
				break;
			case "img":
			case "image":
			case "link":
				Q("error", t), Q("load", t);
				break;
			case "details":
				Q("toggle", t);
				break;
			case "input":
				Q("invalid", t), Kt(t, r.value, r.defaultValue, r.checked, r.defaultChecked, r.type, r.name, !0);
				break;
			case "select":
				Q("invalid", t);
				break;
			case "textarea": Q("invalid", t), Xt(t, r.value, r.defaultValue, r.children);
		}
		n = r.children, typeof n != "string" && typeof n != "number" && typeof n != "bigint" || t.textContent === "" + n || !0 === r.suppressHydrationWarning || Md(t.textContent, n) ? (r.popover != null && (Q("beforetoggle", t), Q("toggle", t)), r.onScroll != null && Q("scroll", t), r.onScrollEnd != null && Q("scrollend", t), r.onClick != null && (t.onclick = on), t = !0) : t = !1, t || Ui(e, !0);
	}
	function Gi(e) {
		for (zi = e.return; zi;) switch (zi.tag) {
			case 5:
			case 31:
			case 13:
				Vi = !1;
				return;
			case 27:
			case 3:
				Vi = !0;
				return;
			default: zi = zi.return;
		}
	}
	function Ki(e) {
		if (e !== zi) return !1;
		if (!P) return Gi(e), P = !0, !1;
		var t = e.tag, n;
		if ((n = t !== 3 && t !== 27) && ((n = t === 5) && (n = e.type, n = n === "form" || n === "button" || Ud(e.type, e.memoizedProps)), n = !n), n && N && Ui(e), Gi(e), t === 13) {
			if (e = e.memoizedState, e = e === null ? null : e.dehydrated, !e) throw Error(i(317));
			N = uf(e);
		} else if (t === 31) {
			if (e = e.memoizedState, e = e === null ? null : e.dehydrated, !e) throw Error(i(317));
			N = uf(e);
		} else t === 27 ? (t = N, Zd(e.type) ? (e = lf, lf = null, N = e) : N = t) : N = zi ? cf(e.stateNode.nextSibling) : null;
		return !0;
	}
	function qi() {
		N = zi = null, P = !1;
	}
	function Ji() {
		var e = Bi;
		return e !== null && (Zl === null ? Zl = e : Zl.push.apply(Zl, e), Bi = null), e;
	}
	function Yi(e) {
		Bi === null ? Bi = [e] : Bi.push(e);
	}
	var Xi = fe(null), Zi = null, Qi = null;
	function $i(e, t, n) {
		k(Xi, t._currentValue), t._currentValue = n;
	}
	function ea(e) {
		e._currentValue = Xi.current, pe(Xi);
	}
	function ta(e, t, n) {
		for (; e !== null;) {
			var r = e.alternate;
			if ((e.childLanes & t) === t ? r !== null && (r.childLanes & t) !== t && (r.childLanes |= t) : (e.childLanes |= t, r !== null && (r.childLanes |= t)), e === n) break;
			e = e.return;
		}
	}
	function na(e, t, n, r) {
		var a = e.child;
		for (a !== null && (a.return = e); a !== null;) {
			var o = a.dependencies;
			if (o !== null) {
				var s = a.child;
				o = o.firstContext;
				a: for (; o !== null;) {
					var c = o;
					o = a;
					for (var l = 0; l < t.length; l++) if (c.context === t[l]) {
						o.lanes |= n, c = o.alternate, c !== null && (c.lanes |= n), ta(o.return, n, e), r || (s = null);
						break a;
					}
					o = c.next;
				}
			} else if (a.tag === 18) {
				if (s = a.return, s === null) throw Error(i(341));
				s.lanes |= n, o = s.alternate, o !== null && (o.lanes |= n), ta(s, n, e), s = null;
			} else s = a.child;
			if (s !== null) s.return = a;
			else for (s = a; s !== null;) {
				if (s === e) {
					s = null;
					break;
				}
				if (a = s.sibling, a !== null) {
					a.return = s.return, s = a;
					break;
				}
				s = s.return;
			}
			a = s;
		}
	}
	function ra(e, t, n, r) {
		e = null;
		for (var a = t, o = !1; a !== null;) {
			if (!o) {
				if (a.flags & 524288) o = !0;
				else if (a.flags & 262144) break;
			}
			if (a.tag === 10) {
				var s = a.alternate;
				if (s === null) throw Error(i(387));
				if (s = s.memoizedProps, s !== null) {
					var c = a.type;
					Or(a.pendingProps.value, s.value) || (e === null ? e = [c] : e.push(c));
				}
			} else if (a === _e.current) {
				if (s = a.alternate, s === null) throw Error(i(387));
				s.memoizedState.memoizedState !== a.memoizedState.memoizedState && (e === null ? e = [Qf] : e.push(Qf));
			}
			a = a.return;
		}
		e !== null && na(t, e, n, r), t.flags |= 262144;
	}
	function ia(e) {
		for (e = e.firstContext; e !== null;) {
			if (!Or(e.context._currentValue, e.memoizedValue)) return !0;
			e = e.next;
		}
		return !1;
	}
	function aa(e) {
		Zi = e, Qi = null, e = e.dependencies, e !== null && (e.firstContext = null);
	}
	function oa(e) {
		return ca(Zi, e);
	}
	function sa(e, t) {
		return Zi === null && aa(e), ca(e, t);
	}
	function ca(e, t) {
		var n = t._currentValue;
		if (t = {
			context: t,
			memoizedValue: n,
			next: null
		}, Qi === null) {
			if (e === null) throw Error(i(308));
			Qi = t, e.dependencies = {
				lanes: 0,
				firstContext: t
			}, e.flags |= 524288;
		} else Qi = Qi.next = t;
		return n;
	}
	var la = typeof AbortController < "u" ? AbortController : function() {
		var e = [], t = this.signal = {
			aborted: !1,
			addEventListener: function(t, n) {
				e.push(n);
			}
		};
		this.abort = function() {
			t.aborted = !0, e.forEach(function(e) {
				return e();
			});
		};
	}, ua = t.unstable_scheduleCallback, da = t.unstable_NormalPriority, F = {
		$$typeof: S,
		Consumer: null,
		Provider: null,
		_currentValue: null,
		_currentValue2: null,
		_threadCount: 0
	};
	function fa() {
		return {
			controller: new la(),
			data: /* @__PURE__ */ new Map(),
			refCount: 0
		};
	}
	function pa(e) {
		e.refCount--, e.refCount === 0 && ua(da, function() {
			e.controller.abort();
		});
	}
	var ma = null, ha = 0, ga = 0, _a = null;
	function va(e, t) {
		if (ma === null) {
			var n = ma = [];
			ha = 0, ga = dd(), _a = {
				status: "pending",
				value: void 0,
				then: function(e) {
					n.push(e);
				}
			};
		}
		return ha++, t.then(ya, ya), t;
	}
	function ya() {
		if (--ha === 0 && ma !== null) {
			_a !== null && (_a.status = "fulfilled");
			var e = ma;
			ma = null, ga = 0, _a = null;
			for (var t = 0; t < e.length; t++) (0, e[t])();
		}
	}
	function ba(e, t) {
		var n = [], r = {
			status: "pending",
			value: null,
			reason: null,
			then: function(e) {
				n.push(e);
			}
		};
		return e.then(function() {
			r.status = "fulfilled", r.value = t;
			for (var e = 0; e < n.length; e++) (0, n[e])(t);
		}, function(e) {
			for (r.status = "rejected", r.reason = e, e = 0; e < n.length; e++) (0, n[e])(void 0);
		}), r;
	}
	var xa = D.S;
	D.S = function(e, t) {
		eu = Pe(), typeof t == "object" && t && typeof t.then == "function" && va(e, t), xa !== null && xa(e, t);
	};
	var Sa = fe(null);
	function Ca() {
		var e = Sa.current;
		return e === null ? K.pooledCache : e;
	}
	function wa(e, t) {
		t === null ? k(Sa, Sa.current) : k(Sa, t.pool);
	}
	function Ta() {
		var e = Ca();
		return e === null ? null : {
			parent: F._currentValue,
			pool: e
		};
	}
	var Ea = Error(i(460)), Da = Error(i(474)), Oa = Error(i(542)), ka = { then: function() {} };
	function Aa(e) {
		return e = e.status, e === "fulfilled" || e === "rejected";
	}
	function ja(e, t, n) {
		switch (n = e[n], n === void 0 ? e.push(t) : n !== t && (t.then(on, on), t = n), t.status) {
			case "fulfilled": return t.value;
			case "rejected": throw e = t.reason, Fa(e), e;
			default:
				if (typeof t.status == "string") t.then(on, on);
				else {
					if (e = K, e !== null && 100 < e.shellSuspendCounter) throw Error(i(482));
					e = t, e.status = "pending", e.then(function(e) {
						if (t.status === "pending") {
							var n = t;
							n.status = "fulfilled", n.value = e;
						}
					}, function(e) {
						if (t.status === "pending") {
							var n = t;
							n.status = "rejected", n.reason = e;
						}
					});
				}
				switch (t.status) {
					case "fulfilled": return t.value;
					case "rejected": throw e = t.reason, Fa(e), e;
				}
				throw Na = t, Ea;
		}
	}
	function Ma(e) {
		try {
			var t = e._init;
			return t(e._payload);
		} catch (e) {
			throw typeof e == "object" && e && typeof e.then == "function" ? (Na = e, Ea) : e;
		}
	}
	var Na = null;
	function Pa() {
		if (Na === null) throw Error(i(459));
		var e = Na;
		return Na = null, e;
	}
	function Fa(e) {
		if (e === Ea || e === Oa) throw Error(i(483));
	}
	var Ia = null, La = 0;
	function Ra(e) {
		var t = La;
		return La += 1, Ia === null && (Ia = []), ja(Ia, e, t);
	}
	function za(e, t) {
		t = t.props.ref, e.ref = t === void 0 ? null : t;
	}
	function Ba(e, t) {
		throw t.$$typeof === g ? Error(i(525)) : (e = Object.prototype.toString.call(t), Error(i(31, e === "[object Object]" ? "object with keys {" + Object.keys(t).join(", ") + "}" : e)));
	}
	function Va(e) {
		function t(t, n) {
			if (e) {
				var r = t.deletions;
				r === null ? (t.deletions = [n], t.flags |= 16) : r.push(n);
			}
		}
		function n(n, r) {
			if (!e) return null;
			for (; r !== null;) t(n, r), r = r.sibling;
			return null;
		}
		function r(e) {
			for (var t = /* @__PURE__ */ new Map(); e !== null;) e.key === null ? t.set(e.index, e) : t.set(e.key, e), e = e.sibling;
			return t;
		}
		function a(e, t) {
			return e = gi(e, t), e.index = 0, e.sibling = null, e;
		}
		function o(t, n, r) {
			return t.index = r, e ? (r = t.alternate, r === null ? (t.flags |= 67108866, n) : (r = r.index, r < n ? (t.flags |= 67108866, n) : r)) : (t.flags |= 1048576, n);
		}
		function s(t) {
			return e && t.alternate === null && (t.flags |= 67108866), t;
		}
		function c(e, t, n, r) {
			return t === null || t.tag !== 6 ? (t = bi(n, e.mode, r), t.return = e, t) : (t = a(t, n), t.return = e, t);
		}
		function l(e, t, n, r) {
			var i = n.type;
			return i === y ? d(e, t, n.props.children, r, n.key) : t !== null && (t.elementType === i || typeof i == "object" && i && i.$$typeof === re && Ma(i) === t.type) ? (t = a(t, n.props), za(t, n), t.return = e, t) : (t = vi(n.type, n.key, n.props, null, e.mode, r), za(t, n), t.return = e, t);
		}
		function u(e, t, n, r) {
			return t === null || t.tag !== 4 || t.stateNode.containerInfo !== n.containerInfo || t.stateNode.implementation !== n.implementation ? (t = Si(n, e.mode, r), t.return = e, t) : (t = a(t, n.children || []), t.return = e, t);
		}
		function d(e, t, n, r, i) {
			return t === null || t.tag !== 7 ? (t = yi(n, e.mode, r, i), t.return = e, t) : (t = a(t, n), t.return = e, t);
		}
		function f(e, t, n) {
			if (typeof t == "string" && t !== "" || typeof t == "number" || typeof t == "bigint") return t = bi("" + t, e.mode, n), t.return = e, t;
			if (typeof t == "object" && t) {
				switch (t.$$typeof) {
					case _: return n = vi(t.type, t.key, t.props, null, e.mode, n), za(n, t), n.return = e, n;
					case v: return t = Si(t, e.mode, n), t.return = e, t;
					case re: return t = Ma(t), f(e, t, n);
				}
				if (ce(t) || ae(t)) return t = yi(t, e.mode, n, null), t.return = e, t;
				if (typeof t.then == "function") return f(e, Ra(t), n);
				if (t.$$typeof === S) return f(e, sa(e, t), n);
				Ba(e, t);
			}
			return null;
		}
		function p(e, t, n, r) {
			var i = t === null ? null : t.key;
			if (typeof n == "string" && n !== "" || typeof n == "number" || typeof n == "bigint") return i === null ? c(e, t, "" + n, r) : null;
			if (typeof n == "object" && n) {
				switch (n.$$typeof) {
					case _: return n.key === i ? l(e, t, n, r) : null;
					case v: return n.key === i ? u(e, t, n, r) : null;
					case re: return n = Ma(n), p(e, t, n, r);
				}
				if (ce(n) || ae(n)) return i === null ? d(e, t, n, r, null) : null;
				if (typeof n.then == "function") return p(e, t, Ra(n), r);
				if (n.$$typeof === S) return p(e, t, sa(e, n), r);
				Ba(e, n);
			}
			return null;
		}
		function m(e, t, n, r, i) {
			if (typeof r == "string" && r !== "" || typeof r == "number" || typeof r == "bigint") return e = e.get(n) || null, c(t, e, "" + r, i);
			if (typeof r == "object" && r) {
				switch (r.$$typeof) {
					case _: return e = e.get(r.key === null ? n : r.key) || null, l(t, e, r, i);
					case v: return e = e.get(r.key === null ? n : r.key) || null, u(t, e, r, i);
					case re: return r = Ma(r), m(e, t, n, r, i);
				}
				if (ce(r) || ae(r)) return e = e.get(n) || null, d(t, e, r, i, null);
				if (typeof r.then == "function") return m(e, t, n, Ra(r), i);
				if (r.$$typeof === S) return m(e, t, n, sa(t, r), i);
				Ba(t, r);
			}
			return null;
		}
		function h(i, a, s, c) {
			for (var l = null, u = null, d = a, h = a = 0, g = null; d !== null && h < s.length; h++) {
				d.index > h ? (g = d, d = null) : g = d.sibling;
				var _ = p(i, d, s[h], c);
				if (_ === null) {
					d === null && (d = g);
					break;
				}
				e && d && _.alternate === null && t(i, d), a = o(_, a, h), u === null ? l = _ : u.sibling = _, u = _, d = g;
			}
			if (h === s.length) return n(i, d), P && Pi(i, h), l;
			if (d === null) {
				for (; h < s.length; h++) d = f(i, s[h], c), d !== null && (a = o(d, a, h), u === null ? l = d : u.sibling = d, u = d);
				return P && Pi(i, h), l;
			}
			for (d = r(d); h < s.length; h++) g = m(d, i, h, s[h], c), g !== null && (e && g.alternate !== null && d.delete(g.key === null ? h : g.key), a = o(g, a, h), u === null ? l = g : u.sibling = g, u = g);
			return e && d.forEach(function(e) {
				return t(i, e);
			}), P && Pi(i, h), l;
		}
		function g(a, s, c, l) {
			if (c == null) throw Error(i(151));
			for (var u = null, d = null, h = s, g = s = 0, _ = null, v = c.next(); h !== null && !v.done; g++, v = c.next()) {
				h.index > g ? (_ = h, h = null) : _ = h.sibling;
				var y = p(a, h, v.value, l);
				if (y === null) {
					h === null && (h = _);
					break;
				}
				e && h && y.alternate === null && t(a, h), s = o(y, s, g), d === null ? u = y : d.sibling = y, d = y, h = _;
			}
			if (v.done) return n(a, h), P && Pi(a, g), u;
			if (h === null) {
				for (; !v.done; g++, v = c.next()) v = f(a, v.value, l), v !== null && (s = o(v, s, g), d === null ? u = v : d.sibling = v, d = v);
				return P && Pi(a, g), u;
			}
			for (h = r(h); !v.done; g++, v = c.next()) v = m(h, a, g, v.value, l), v !== null && (e && v.alternate !== null && h.delete(v.key === null ? g : v.key), s = o(v, s, g), d === null ? u = v : d.sibling = v, d = v);
			return e && h.forEach(function(e) {
				return t(a, e);
			}), P && Pi(a, g), u;
		}
		function b(e, r, o, c) {
			if (typeof o == "object" && o && o.type === y && o.key === null && (o = o.props.children), typeof o == "object" && o) {
				switch (o.$$typeof) {
					case _:
						a: {
							for (var l = o.key; r !== null;) {
								if (r.key === l) {
									if (l = o.type, l === y) {
										if (r.tag === 7) {
											n(e, r.sibling), c = a(r, o.props.children), c.return = e, e = c;
											break a;
										}
									} else if (r.elementType === l || typeof l == "object" && l && l.$$typeof === re && Ma(l) === r.type) {
										n(e, r.sibling), c = a(r, o.props), za(c, o), c.return = e, e = c;
										break a;
									}
									n(e, r);
									break;
								}
								t(e, r), r = r.sibling;
							}
							o.type === y ? (c = yi(o.props.children, e.mode, c, o.key), c.return = e, e = c) : (c = vi(o.type, o.key, o.props, null, e.mode, c), za(c, o), c.return = e, e = c);
						}
						return s(e);
					case v:
						a: {
							for (l = o.key; r !== null;) {
								if (r.key === l) {
									if (r.tag === 4 && r.stateNode.containerInfo === o.containerInfo && r.stateNode.implementation === o.implementation) {
										n(e, r.sibling), c = a(r, o.children || []), c.return = e, e = c;
										break a;
									}
									n(e, r);
									break;
								}
								t(e, r), r = r.sibling;
							}
							c = Si(o, e.mode, c), c.return = e, e = c;
						}
						return s(e);
					case re: return o = Ma(o), b(e, r, o, c);
				}
				if (ce(o)) return h(e, r, o, c);
				if (ae(o)) {
					if (l = ae(o), typeof l != "function") throw Error(i(150));
					return o = l.call(o), g(e, r, o, c);
				}
				if (typeof o.then == "function") return b(e, r, Ra(o), c);
				if (o.$$typeof === S) return b(e, r, sa(e, o), c);
				Ba(e, o);
			}
			return typeof o == "string" && o !== "" || typeof o == "number" || typeof o == "bigint" ? (o = "" + o, r !== null && r.tag === 6 ? (n(e, r.sibling), c = a(r, o), c.return = e, e = c) : (n(e, r), c = bi(o, e.mode, c), c.return = e, e = c), s(e)) : n(e, r);
		}
		return function(e, t, n, r) {
			try {
				La = 0;
				var i = b(e, t, n, r);
				return Ia = null, i;
			} catch (t) {
				if (t === Ea || t === Oa) throw t;
				var a = mi(29, t, null, e.mode);
				return a.lanes = r, a.return = e, a;
			}
		};
	}
	var Ha = Va(!0), Ua = Va(!1), Wa = !1;
	function Ga(e) {
		e.updateQueue = {
			baseState: e.memoizedState,
			firstBaseUpdate: null,
			lastBaseUpdate: null,
			shared: {
				pending: null,
				lanes: 0,
				hiddenCallbacks: null
			},
			callbacks: null
		};
	}
	function Ka(e, t) {
		e = e.updateQueue, t.updateQueue === e && (t.updateQueue = {
			baseState: e.baseState,
			firstBaseUpdate: e.firstBaseUpdate,
			lastBaseUpdate: e.lastBaseUpdate,
			shared: e.shared,
			callbacks: null
		});
	}
	function qa(e) {
		return {
			lane: e,
			tag: 0,
			payload: null,
			callback: null,
			next: null
		};
	}
	function Ja(e, t, n) {
		var r = e.updateQueue;
		if (r === null) return null;
		if (r = r.shared, G & 2) {
			var i = r.pending;
			return i === null ? t.next = t : (t.next = i.next, i.next = t), r.pending = t, t = di(e), ui(e, null, n), t;
		}
		return si(e, r, t, n), di(e);
	}
	function Ya(e, t, n) {
		if (t = t.updateQueue, t !== null && (t = t.shared, n & 4194048)) {
			var r = t.lanes;
			r &= e.pendingLanes, n |= r, t.lanes = n, st(e, n);
		}
	}
	function Xa(e, t) {
		var n = e.updateQueue, r = e.alternate;
		if (r !== null && (r = r.updateQueue, n === r)) {
			var i = null, a = null;
			if (n = n.firstBaseUpdate, n !== null) {
				do {
					var o = {
						lane: n.lane,
						tag: n.tag,
						payload: n.payload,
						callback: null,
						next: null
					};
					a === null ? i = a = o : a = a.next = o, n = n.next;
				} while (n !== null);
				a === null ? i = a = t : a = a.next = t;
			} else i = a = t;
			n = {
				baseState: r.baseState,
				firstBaseUpdate: i,
				lastBaseUpdate: a,
				shared: r.shared,
				callbacks: r.callbacks
			}, e.updateQueue = n;
			return;
		}
		e = n.lastBaseUpdate, e === null ? n.firstBaseUpdate = t : e.next = t, n.lastBaseUpdate = t;
	}
	var Za = !1;
	function Qa() {
		if (Za) {
			var e = _a;
			if (e !== null) throw e;
		}
	}
	function $a(e, t, n, r) {
		Za = !1;
		var i = e.updateQueue;
		Wa = !1;
		var a = i.firstBaseUpdate, o = i.lastBaseUpdate, s = i.shared.pending;
		if (s !== null) {
			i.shared.pending = null;
			var c = s, l = c.next;
			c.next = null, o === null ? a = l : o.next = l, o = c;
			var u = e.alternate;
			u !== null && (u = u.updateQueue, s = u.lastBaseUpdate, s !== o && (s === null ? u.firstBaseUpdate = l : s.next = l, u.lastBaseUpdate = c));
		}
		if (a !== null) {
			var d = i.baseState;
			o = 0, u = l = c = null, s = a;
			do {
				var f = s.lane & -536870913, p = f !== s.lane;
				if (p ? (J & f) === f : (r & f) === f) {
					f !== 0 && f === ga && (Za = !0), u !== null && (u = u.next = {
						lane: 0,
						tag: s.tag,
						payload: s.payload,
						callback: null,
						next: null
					});
					a: {
						var m = e, g = s;
						f = t;
						var _ = n;
						switch (g.tag) {
							case 1:
								if (m = g.payload, typeof m == "function") {
									d = m.call(_, d, f);
									break a;
								}
								d = m;
								break a;
							case 3: m.flags = m.flags & -65537 | 128;
							case 0:
								if (m = g.payload, f = typeof m == "function" ? m.call(_, d, f) : m, f == null) break a;
								d = h({}, d, f);
								break a;
							case 2: Wa = !0;
						}
					}
					f = s.callback, f !== null && (e.flags |= 64, p && (e.flags |= 8192), p = i.callbacks, p === null ? i.callbacks = [f] : p.push(f));
				} else p = {
					lane: f,
					tag: s.tag,
					payload: s.payload,
					callback: s.callback,
					next: null
				}, u === null ? (l = u = p, c = d) : u = u.next = p, o |= f;
				if (s = s.next, s === null) {
					if (s = i.shared.pending, s === null) break;
					p = s, s = p.next, p.next = null, i.lastBaseUpdate = p, i.shared.pending = null;
				}
			} while (1);
			u === null && (c = d), i.baseState = c, i.firstBaseUpdate = l, i.lastBaseUpdate = u, a === null && (i.shared.lanes = 0), Gl |= o, e.lanes = o, e.memoizedState = d;
		}
	}
	function eo(e, t) {
		if (typeof e != "function") throw Error(i(191, e));
		e.call(t);
	}
	function to(e, t) {
		var n = e.callbacks;
		if (n !== null) for (e.callbacks = null, e = 0; e < n.length; e++) eo(n[e], t);
	}
	var no = fe(null), ro = fe(0);
	function io(e, t) {
		e = Wl, k(ro, e), k(no, t), Wl = e | t.baseLanes;
	}
	function ao() {
		k(ro, Wl), k(no, no.current);
	}
	function oo() {
		Wl = ro.current, pe(no), pe(ro);
	}
	var so = fe(null), co = null;
	function lo(e) {
		var t = e.alternate;
		k(I, I.current & 1), k(so, e), co === null && (t === null || no.current !== null || t.memoizedState !== null) && (co = e);
	}
	function uo(e) {
		k(I, I.current), k(so, e), co === null && (co = e);
	}
	function fo(e) {
		e.tag === 22 ? (k(I, I.current), k(so, e), co === null && (co = e)) : po(e);
	}
	function po() {
		k(I, I.current), k(so, so.current);
	}
	function mo(e) {
		pe(so), co === e && (co = null), pe(I);
	}
	var I = fe(0);
	function ho(e) {
		for (var t = e; t !== null;) {
			if (t.tag === 13) {
				var n = t.memoizedState;
				if (n !== null && (n = n.dehydrated, n === null || af(n) || of(n))) return t;
			} else if (t.tag === 19 && (t.memoizedProps.revealOrder === "forwards" || t.memoizedProps.revealOrder === "backwards" || t.memoizedProps.revealOrder === "unstable_legacy-backwards" || t.memoizedProps.revealOrder === "together")) {
				if (t.flags & 128) return t;
			} else if (t.child !== null) {
				t.child.return = t, t = t.child;
				continue;
			}
			if (t === e) break;
			for (; t.sibling === null;) {
				if (t.return === null || t.return === e) return null;
				t = t.return;
			}
			t.sibling.return = t.return, t = t.sibling;
		}
		return null;
	}
	var go = 0, L = null, R = null, z = null, _o = !1, vo = !1, yo = !1, bo = 0, xo = 0, So = null, Co = 0;
	function B() {
		throw Error(i(321));
	}
	function wo(e, t) {
		if (t === null) return !1;
		for (var n = 0; n < t.length && n < e.length; n++) if (!Or(e[n], t[n])) return !1;
		return !0;
	}
	function To(e, t, n, r, i, a) {
		return go = a, L = t, t.memoizedState = null, t.updateQueue = null, t.lanes = 0, D.H = e === null || e.memoizedState === null ? Vs : Hs, yo = !1, a = n(r, i), yo = !1, vo && (a = Do(t, n, r, i)), Eo(e), a;
	}
	function Eo(e) {
		D.H = Bs;
		var t = R !== null && R.next !== null;
		if (go = 0, z = R = L = null, _o = !1, xo = 0, So = null, t) throw Error(i(300));
		e === null || H || (e = e.dependencies, e !== null && ia(e) && (H = !0));
	}
	function Do(e, t, n, r) {
		L = e;
		var a = 0;
		do {
			if (vo && (So = null), xo = 0, vo = !1, 25 <= a) throw Error(i(301));
			if (a += 1, z = R = null, e.updateQueue != null) {
				var o = e.updateQueue;
				o.lastEffect = null, o.events = null, o.stores = null, o.memoCache != null && (o.memoCache.index = 0);
			}
			D.H = Us, o = t(n, r);
		} while (vo);
		return o;
	}
	function Oo() {
		var e = D.H, t = e.useState()[0];
		return t = typeof t.then == "function" ? Po(t) : t, e = e.useState()[0], (R === null ? null : R.memoizedState) !== e && (L.flags |= 1024), t;
	}
	function ko() {
		var e = bo !== 0;
		return bo = 0, e;
	}
	function Ao(e, t, n) {
		t.updateQueue = e.updateQueue, t.flags &= -2053, e.lanes &= ~n;
	}
	function jo(e) {
		if (_o) {
			for (e = e.memoizedState; e !== null;) {
				var t = e.queue;
				t !== null && (t.pending = null), e = e.next;
			}
			_o = !1;
		}
		go = 0, z = R = L = null, vo = !1, xo = bo = 0, So = null;
	}
	function Mo() {
		var e = {
			memoizedState: null,
			baseState: null,
			baseQueue: null,
			queue: null,
			next: null
		};
		return z === null ? L.memoizedState = z = e : z = z.next = e, z;
	}
	function V() {
		if (R === null) {
			var e = L.alternate;
			e = e === null ? null : e.memoizedState;
		} else e = R.next;
		var t = z === null ? L.memoizedState : z.next;
		if (t !== null) z = t, R = e;
		else {
			if (e === null) throw L.alternate === null ? Error(i(467)) : Error(i(310));
			R = e, e = {
				memoizedState: R.memoizedState,
				baseState: R.baseState,
				baseQueue: R.baseQueue,
				queue: R.queue,
				next: null
			}, z === null ? L.memoizedState = z = e : z = z.next = e;
		}
		return z;
	}
	function No() {
		return {
			lastEffect: null,
			events: null,
			stores: null,
			memoCache: null
		};
	}
	function Po(e) {
		var t = xo;
		return xo += 1, So === null && (So = []), e = ja(So, e, t), t = L, (z === null ? t.memoizedState : z.next) === null && (t = t.alternate, D.H = t === null || t.memoizedState === null ? Vs : Hs), e;
	}
	function Fo(e) {
		if (typeof e == "object" && e) {
			if (typeof e.then == "function") return Po(e);
			if (e.$$typeof === S) return oa(e);
		}
		throw Error(i(438, String(e)));
	}
	function Io(e) {
		var t = null, n = L.updateQueue;
		if (n !== null && (t = n.memoCache), t == null) {
			var r = L.alternate;
			r !== null && (r = r.updateQueue, r !== null && (r = r.memoCache, r != null && (t = {
				data: r.data.map(function(e) {
					return e.slice();
				}),
				index: 0
			})));
		}
		if (t ??= {
			data: [],
			index: 0
		}, n === null && (n = No(), L.updateQueue = n), n.memoCache = t, n = t.data[t.index], n === void 0) for (n = t.data[t.index] = Array(e), r = 0; r < e; r++) n[r] = T;
		return t.index++, n;
	}
	function Lo(e, t) {
		return typeof t == "function" ? t(e) : t;
	}
	function Ro(e) {
		return zo(V(), R, e);
	}
	function zo(e, t, n) {
		var r = e.queue;
		if (r === null) throw Error(i(311));
		r.lastRenderedReducer = n;
		var a = e.baseQueue, o = r.pending;
		if (o !== null) {
			if (a !== null) {
				var s = a.next;
				a.next = o.next, o.next = s;
			}
			t.baseQueue = a = o, r.pending = null;
		}
		if (o = e.baseState, a === null) e.memoizedState = o;
		else {
			t = a.next;
			var c = s = null, l = null, u = t, d = !1;
			do {
				var f = u.lane & -536870913;
				if (f === u.lane ? (go & f) === f : (J & f) === f) {
					var p = u.revertLane;
					if (p === 0) l !== null && (l = l.next = {
						lane: 0,
						revertLane: 0,
						gesture: null,
						action: u.action,
						hasEagerState: u.hasEagerState,
						eagerState: u.eagerState,
						next: null
					}), f === ga && (d = !0);
					else if ((go & p) === p) {
						u = u.next, p === ga && (d = !0);
						continue;
					} else f = {
						lane: 0,
						revertLane: u.revertLane,
						gesture: null,
						action: u.action,
						hasEagerState: u.hasEagerState,
						eagerState: u.eagerState,
						next: null
					}, l === null ? (c = l = f, s = o) : l = l.next = f, L.lanes |= p, Gl |= p;
					f = u.action, yo && n(o, f), o = u.hasEagerState ? u.eagerState : n(o, f);
				} else p = {
					lane: f,
					revertLane: u.revertLane,
					gesture: u.gesture,
					action: u.action,
					hasEagerState: u.hasEagerState,
					eagerState: u.eagerState,
					next: null
				}, l === null ? (c = l = p, s = o) : l = l.next = p, L.lanes |= f, Gl |= f;
				u = u.next;
			} while (u !== null && u !== t);
			if (l === null ? s = o : l.next = c, !Or(o, e.memoizedState) && (H = !0, d && (n = _a, n !== null))) throw n;
			e.memoizedState = o, e.baseState = s, e.baseQueue = l, r.lastRenderedState = o;
		}
		return a === null && (r.lanes = 0), [e.memoizedState, r.dispatch];
	}
	function Bo(e) {
		var t = V(), n = t.queue;
		if (n === null) throw Error(i(311));
		n.lastRenderedReducer = e;
		var r = n.dispatch, a = n.pending, o = t.memoizedState;
		if (a !== null) {
			n.pending = null;
			var s = a = a.next;
			do
				o = e(o, s.action), s = s.next;
			while (s !== a);
			Or(o, t.memoizedState) || (H = !0), t.memoizedState = o, t.baseQueue === null && (t.baseState = o), n.lastRenderedState = o;
		}
		return [o, r];
	}
	function Vo(e, t, n) {
		var r = L, a = V(), o = P;
		if (o) {
			if (n === void 0) throw Error(i(407));
			n = n();
		} else n = t();
		var s = !Or((R || a).memoizedState, n);
		if (s && (a.memoizedState = n, H = !0), a = a.queue, fs(Wo.bind(null, r, a, e), [e]), a.getSnapshot !== t || s || z !== null && z.memoizedState.tag & 1) {
			if (r.flags |= 2048, ss(9, { destroy: void 0 }, Uo.bind(null, r, a, n, t), null), K === null) throw Error(i(349));
			o || go & 127 || Ho(r, t, n);
		}
		return n;
	}
	function Ho(e, t, n) {
		e.flags |= 16384, e = {
			getSnapshot: t,
			value: n
		}, t = L.updateQueue, t === null ? (t = No(), L.updateQueue = t, t.stores = [e]) : (n = t.stores, n === null ? t.stores = [e] : n.push(e));
	}
	function Uo(e, t, n, r) {
		t.value = n, t.getSnapshot = r, Go(t) && Ko(e);
	}
	function Wo(e, t, n) {
		return n(function() {
			Go(t) && Ko(e);
		});
	}
	function Go(e) {
		var t = e.getSnapshot;
		e = e.value;
		try {
			var n = t();
			return !Or(e, n);
		} catch {
			return !0;
		}
	}
	function Ko(e) {
		var t = li(e, 2);
		t !== null && hu(t, e, 2);
	}
	function qo(e) {
		var t = Mo();
		if (typeof e == "function") {
			var n = e;
			if (e = n(), yo) {
				We(!0);
				try {
					n();
				} finally {
					We(!1);
				}
			}
		}
		return t.memoizedState = t.baseState = e, t.queue = {
			pending: null,
			lanes: 0,
			dispatch: null,
			lastRenderedReducer: Lo,
			lastRenderedState: e
		}, t;
	}
	function Jo(e, t, n, r) {
		return e.baseState = n, zo(e, R, typeof r == "function" ? r : Lo);
	}
	function Yo(e, t, n, r, a) {
		if (Ls(e)) throw Error(i(485));
		if (e = t.action, e !== null) {
			var o = {
				payload: a,
				action: e,
				next: null,
				isTransition: !0,
				status: "pending",
				value: null,
				reason: null,
				listeners: [],
				then: function(e) {
					o.listeners.push(e);
				}
			};
			D.T === null ? o.isTransition = !1 : n(!0), r(o), n = t.pending, n === null ? (o.next = t.pending = o, Xo(t, o)) : (o.next = n.next, t.pending = n.next = o);
		}
	}
	function Xo(e, t) {
		var n = t.action, r = t.payload, i = e.state;
		if (t.isTransition) {
			var a = D.T, o = {};
			D.T = o;
			try {
				var s = n(i, r), c = D.S;
				c !== null && c(o, s), Zo(e, t, s);
			} catch (n) {
				$o(e, t, n);
			} finally {
				a !== null && o.types !== null && (a.types = o.types), D.T = a;
			}
		} else try {
			a = n(i, r), Zo(e, t, a);
		} catch (n) {
			$o(e, t, n);
		}
	}
	function Zo(e, t, n) {
		typeof n == "object" && n && typeof n.then == "function" ? n.then(function(n) {
			Qo(e, t, n);
		}, function(n) {
			return $o(e, t, n);
		}) : Qo(e, t, n);
	}
	function Qo(e, t, n) {
		t.status = "fulfilled", t.value = n, es(t), e.state = n, t = e.pending, t !== null && (n = t.next, n === t ? e.pending = null : (n = n.next, t.next = n, Xo(e, n)));
	}
	function $o(e, t, n) {
		var r = e.pending;
		if (e.pending = null, r !== null) {
			r = r.next;
			do
				t.status = "rejected", t.reason = n, es(t), t = t.next;
			while (t !== r);
		}
		e.action = null;
	}
	function es(e) {
		e = e.listeners;
		for (var t = 0; t < e.length; t++) (0, e[t])();
	}
	function ts(e, t) {
		return t;
	}
	function ns(e, t) {
		if (P) {
			var n = K.formState;
			if (n !== null) {
				a: {
					var r = L;
					if (P) {
						if (N) {
							b: {
								for (var i = N, a = Vi; i.nodeType !== 8;) {
									if (!a) {
										i = null;
										break b;
									}
									if (i = cf(i.nextSibling), i === null) {
										i = null;
										break b;
									}
								}
								a = i.data, i = a === "F!" || a === "F" ? i : null;
							}
							if (i) {
								N = cf(i.nextSibling), r = i.data === "F!";
								break a;
							}
						}
						Ui(r);
					}
					r = !1;
				}
				r && (t = n[0]);
			}
		}
		return n = Mo(), n.memoizedState = n.baseState = t, r = {
			pending: null,
			lanes: 0,
			dispatch: null,
			lastRenderedReducer: ts,
			lastRenderedState: t
		}, n.queue = r, n = Ps.bind(null, L, r), r.dispatch = n, r = qo(!1), a = Is.bind(null, L, !1, r.queue), r = Mo(), i = {
			state: t,
			dispatch: null,
			action: e,
			pending: null
		}, r.queue = i, n = Yo.bind(null, L, i, a, n), i.dispatch = n, r.memoizedState = e, [
			t,
			n,
			!1
		];
	}
	function rs(e) {
		return is(V(), R, e);
	}
	function is(e, t, n) {
		if (t = zo(e, t, ts)[0], e = Ro(Lo)[0], typeof t == "object" && t && typeof t.then == "function") try {
			var r = Po(t);
		} catch (e) {
			throw e === Ea ? Oa : e;
		}
		else r = t;
		t = V();
		var i = t.queue, a = i.dispatch;
		return n !== t.memoizedState && (L.flags |= 2048, ss(9, { destroy: void 0 }, as.bind(null, i, n), null)), [
			r,
			a,
			e
		];
	}
	function as(e, t) {
		e.action = t;
	}
	function os(e) {
		var t = V(), n = R;
		if (n !== null) return is(t, n, e);
		V(), t = t.memoizedState, n = V();
		var r = n.queue.dispatch;
		return n.memoizedState = e, [
			t,
			r,
			!1
		];
	}
	function ss(e, t, n, r) {
		return e = {
			tag: e,
			create: n,
			deps: r,
			inst: t,
			next: null
		}, t = L.updateQueue, t === null && (t = No(), L.updateQueue = t), n = t.lastEffect, n === null ? t.lastEffect = e.next = e : (r = n.next, n.next = e, e.next = r, t.lastEffect = e), e;
	}
	function cs() {
		return V().memoizedState;
	}
	function ls(e, t, n, r) {
		var i = Mo();
		L.flags |= e, i.memoizedState = ss(1 | t, { destroy: void 0 }, n, r === void 0 ? null : r);
	}
	function us(e, t, n, r) {
		var i = V();
		r = r === void 0 ? null : r;
		var a = i.memoizedState.inst;
		R !== null && r !== null && wo(r, R.memoizedState.deps) ? i.memoizedState = ss(t, a, n, r) : (L.flags |= e, i.memoizedState = ss(1 | t, a, n, r));
	}
	function ds(e, t) {
		ls(8390656, 8, e, t);
	}
	function fs(e, t) {
		us(2048, 8, e, t);
	}
	function ps(e) {
		L.flags |= 4;
		var t = L.updateQueue;
		if (t === null) t = No(), L.updateQueue = t, t.events = [e];
		else {
			var n = t.events;
			n === null ? t.events = [e] : n.push(e);
		}
	}
	function ms(e) {
		var t = V().memoizedState;
		return ps({
			ref: t,
			nextImpl: e
		}), function() {
			if (G & 2) throw Error(i(440));
			return t.impl.apply(void 0, arguments);
		};
	}
	function hs(e, t) {
		return us(4, 2, e, t);
	}
	function gs(e, t) {
		return us(4, 4, e, t);
	}
	function _s(e, t) {
		if (typeof t == "function") {
			e = e();
			var n = t(e);
			return function() {
				typeof n == "function" ? n() : t(null);
			};
		}
		if (t != null) return e = e(), t.current = e, function() {
			t.current = null;
		};
	}
	function vs(e, t, n) {
		n = n == null ? null : n.concat([e]), us(4, 4, _s.bind(null, t, e), n);
	}
	function ys() {}
	function bs(e, t) {
		var n = V();
		t = t === void 0 ? null : t;
		var r = n.memoizedState;
		return t !== null && wo(t, r[1]) ? r[0] : (n.memoizedState = [e, t], e);
	}
	function xs(e, t) {
		var n = V();
		t = t === void 0 ? null : t;
		var r = n.memoizedState;
		if (t !== null && wo(t, r[1])) return r[0];
		if (r = e(), yo) {
			We(!0);
			try {
				e();
			} finally {
				We(!1);
			}
		}
		return n.memoizedState = [r, t], r;
	}
	function Ss(e, t, n) {
		return n === void 0 || go & 1073741824 && !(J & 261930) ? e.memoizedState = t : (e.memoizedState = n, e = mu(), L.lanes |= e, Gl |= e, n);
	}
	function Cs(e, t, n, r) {
		return Or(n, t) ? n : no.current === null ? !(go & 42) || go & 1073741824 && !(J & 261930) ? (H = !0, e.memoizedState = n) : (e = mu(), L.lanes |= e, Gl |= e, t) : (e = Ss(e, n, r), Or(e, t) || (H = !0), e);
	}
	function ws(e, t, n, r, i) {
		var a = O.p;
		O.p = a !== 0 && 8 > a ? a : 8;
		var o = D.T, s = {};
		D.T = s, Is(e, !1, t, n);
		try {
			var c = i(), l = D.S;
			l !== null && l(s, c), typeof c == "object" && c && typeof c.then == "function" ? Fs(e, t, ba(c, r), pu(e)) : Fs(e, t, r, pu(e));
		} catch (n) {
			Fs(e, t, {
				then: function() {},
				status: "rejected",
				reason: n
			}, pu());
		} finally {
			O.p = a, o !== null && s.types !== null && (o.types = s.types), D.T = o;
		}
	}
	function Ts() {}
	function Es(e, t, n, r) {
		if (e.tag !== 5) throw Error(i(476));
		var a = Ds(e).queue;
		ws(e, a, t, le, n === null ? Ts : function() {
			return Os(e), n(r);
		});
	}
	function Ds(e) {
		var t = e.memoizedState;
		if (t !== null) return t;
		t = {
			memoizedState: le,
			baseState: le,
			baseQueue: null,
			queue: {
				pending: null,
				lanes: 0,
				dispatch: null,
				lastRenderedReducer: Lo,
				lastRenderedState: le
			},
			next: null
		};
		var n = {};
		return t.next = {
			memoizedState: n,
			baseState: n,
			baseQueue: null,
			queue: {
				pending: null,
				lanes: 0,
				dispatch: null,
				lastRenderedReducer: Lo,
				lastRenderedState: n
			},
			next: null
		}, e.memoizedState = t, e = e.alternate, e !== null && (e.memoizedState = t), t;
	}
	function Os(e) {
		var t = Ds(e);
		t.next === null && (t = e.alternate.memoizedState), Fs(e, t.next.queue, {}, pu());
	}
	function ks() {
		return oa(Qf);
	}
	function As() {
		return V().memoizedState;
	}
	function js() {
		return V().memoizedState;
	}
	function Ms(e) {
		for (var t = e.return; t !== null;) {
			switch (t.tag) {
				case 24:
				case 3:
					var n = pu();
					e = qa(n);
					var r = Ja(t, e, n);
					r !== null && (hu(r, t, n), Ya(r, t, n)), t = { cache: fa() }, e.payload = t;
					return;
			}
			t = t.return;
		}
	}
	function Ns(e, t, n) {
		var r = pu();
		n = {
			lane: r,
			revertLane: 0,
			gesture: null,
			action: n,
			hasEagerState: !1,
			eagerState: null,
			next: null
		}, Ls(e) ? Rs(t, n) : (n = ci(e, t, n, r), n !== null && (hu(n, e, r), zs(n, t, r)));
	}
	function Ps(e, t, n) {
		Fs(e, t, n, pu());
	}
	function Fs(e, t, n, r) {
		var i = {
			lane: r,
			revertLane: 0,
			gesture: null,
			action: n,
			hasEagerState: !1,
			eagerState: null,
			next: null
		};
		if (Ls(e)) Rs(t, i);
		else {
			var a = e.alternate;
			if (e.lanes === 0 && (a === null || a.lanes === 0) && (a = t.lastRenderedReducer, a !== null)) try {
				var o = t.lastRenderedState, s = a(o, n);
				if (i.hasEagerState = !0, i.eagerState = s, Or(s, o)) return si(e, t, i, 0), K === null && oi(), !1;
			} catch {}
			if (n = ci(e, t, i, r), n !== null) return hu(n, e, r), zs(n, t, r), !0;
		}
		return !1;
	}
	function Is(e, t, n, r) {
		if (r = {
			lane: 2,
			revertLane: dd(),
			gesture: null,
			action: r,
			hasEagerState: !1,
			eagerState: null,
			next: null
		}, Ls(e)) {
			if (t) throw Error(i(479));
		} else t = ci(e, n, r, 2), t !== null && hu(t, e, 2);
	}
	function Ls(e) {
		var t = e.alternate;
		return e === L || t !== null && t === L;
	}
	function Rs(e, t) {
		vo = _o = !0;
		var n = e.pending;
		n === null ? t.next = t : (t.next = n.next, n.next = t), e.pending = t;
	}
	function zs(e, t, n) {
		if (n & 4194048) {
			var r = t.lanes;
			r &= e.pendingLanes, n |= r, t.lanes = n, st(e, n);
		}
	}
	var Bs = {
		readContext: oa,
		use: Fo,
		useCallback: B,
		useContext: B,
		useEffect: B,
		useImperativeHandle: B,
		useLayoutEffect: B,
		useInsertionEffect: B,
		useMemo: B,
		useReducer: B,
		useRef: B,
		useState: B,
		useDebugValue: B,
		useDeferredValue: B,
		useTransition: B,
		useSyncExternalStore: B,
		useId: B,
		useHostTransitionStatus: B,
		useFormState: B,
		useActionState: B,
		useOptimistic: B,
		useMemoCache: B,
		useCacheRefresh: B
	};
	Bs.useEffectEvent = B;
	var Vs = {
		readContext: oa,
		use: Fo,
		useCallback: function(e, t) {
			return Mo().memoizedState = [e, t === void 0 ? null : t], e;
		},
		useContext: oa,
		useEffect: ds,
		useImperativeHandle: function(e, t, n) {
			n = n == null ? null : n.concat([e]), ls(4194308, 4, _s.bind(null, t, e), n);
		},
		useLayoutEffect: function(e, t) {
			return ls(4194308, 4, e, t);
		},
		useInsertionEffect: function(e, t) {
			ls(4, 2, e, t);
		},
		useMemo: function(e, t) {
			var n = Mo();
			t = t === void 0 ? null : t;
			var r = e();
			if (yo) {
				We(!0);
				try {
					e();
				} finally {
					We(!1);
				}
			}
			return n.memoizedState = [r, t], r;
		},
		useReducer: function(e, t, n) {
			var r = Mo();
			if (n !== void 0) {
				var i = n(t);
				if (yo) {
					We(!0);
					try {
						n(t);
					} finally {
						We(!1);
					}
				}
			} else i = t;
			return r.memoizedState = r.baseState = i, e = {
				pending: null,
				lanes: 0,
				dispatch: null,
				lastRenderedReducer: e,
				lastRenderedState: i
			}, r.queue = e, e = e.dispatch = Ns.bind(null, L, e), [r.memoizedState, e];
		},
		useRef: function(e) {
			var t = Mo();
			return e = { current: e }, t.memoizedState = e;
		},
		useState: function(e) {
			e = qo(e);
			var t = e.queue, n = Ps.bind(null, L, t);
			return t.dispatch = n, [e.memoizedState, n];
		},
		useDebugValue: ys,
		useDeferredValue: function(e, t) {
			return Ss(Mo(), e, t);
		},
		useTransition: function() {
			var e = qo(!1);
			return e = ws.bind(null, L, e.queue, !0, !1), Mo().memoizedState = e, [!1, e];
		},
		useSyncExternalStore: function(e, t, n) {
			var r = L, a = Mo();
			if (P) {
				if (n === void 0) throw Error(i(407));
				n = n();
			} else {
				if (n = t(), K === null) throw Error(i(349));
				J & 127 || Ho(r, t, n);
			}
			a.memoizedState = n;
			var o = {
				value: n,
				getSnapshot: t
			};
			return a.queue = o, ds(Wo.bind(null, r, o, e), [e]), r.flags |= 2048, ss(9, { destroy: void 0 }, Uo.bind(null, r, o, n, t), null), n;
		},
		useId: function() {
			var e = Mo(), t = K.identifierPrefix;
			if (P) {
				var n = Ni, r = Mi;
				n = (r & ~(1 << 32 - Ge(r) - 1)).toString(32) + n, t = "_" + t + "R_" + n, n = bo++, 0 < n && (t += "H" + n.toString(32)), t += "_";
			} else n = Co++, t = "_" + t + "r_" + n.toString(32) + "_";
			return e.memoizedState = t;
		},
		useHostTransitionStatus: ks,
		useFormState: ns,
		useActionState: ns,
		useOptimistic: function(e) {
			var t = Mo();
			t.memoizedState = t.baseState = e;
			var n = {
				pending: null,
				lanes: 0,
				dispatch: null,
				lastRenderedReducer: null,
				lastRenderedState: null
			};
			return t.queue = n, t = Is.bind(null, L, !0, n), n.dispatch = t, [e, t];
		},
		useMemoCache: Io,
		useCacheRefresh: function() {
			return Mo().memoizedState = Ms.bind(null, L);
		},
		useEffectEvent: function(e) {
			var t = Mo(), n = { impl: e };
			return t.memoizedState = n, function() {
				if (G & 2) throw Error(i(440));
				return n.impl.apply(void 0, arguments);
			};
		}
	}, Hs = {
		readContext: oa,
		use: Fo,
		useCallback: bs,
		useContext: oa,
		useEffect: fs,
		useImperativeHandle: vs,
		useInsertionEffect: hs,
		useLayoutEffect: gs,
		useMemo: xs,
		useReducer: Ro,
		useRef: cs,
		useState: function() {
			return Ro(Lo);
		},
		useDebugValue: ys,
		useDeferredValue: function(e, t) {
			return Cs(V(), R.memoizedState, e, t);
		},
		useTransition: function() {
			var e = Ro(Lo)[0], t = V().memoizedState;
			return [typeof e == "boolean" ? e : Po(e), t];
		},
		useSyncExternalStore: Vo,
		useId: As,
		useHostTransitionStatus: ks,
		useFormState: rs,
		useActionState: rs,
		useOptimistic: function(e, t) {
			return Jo(V(), R, e, t);
		},
		useMemoCache: Io,
		useCacheRefresh: js
	};
	Hs.useEffectEvent = ms;
	var Us = {
		readContext: oa,
		use: Fo,
		useCallback: bs,
		useContext: oa,
		useEffect: fs,
		useImperativeHandle: vs,
		useInsertionEffect: hs,
		useLayoutEffect: gs,
		useMemo: xs,
		useReducer: Bo,
		useRef: cs,
		useState: function() {
			return Bo(Lo);
		},
		useDebugValue: ys,
		useDeferredValue: function(e, t) {
			var n = V();
			return R === null ? Ss(n, e, t) : Cs(n, R.memoizedState, e, t);
		},
		useTransition: function() {
			var e = Bo(Lo)[0], t = V().memoizedState;
			return [typeof e == "boolean" ? e : Po(e), t];
		},
		useSyncExternalStore: Vo,
		useId: As,
		useHostTransitionStatus: ks,
		useFormState: os,
		useActionState: os,
		useOptimistic: function(e, t) {
			var n = V();
			return R === null ? (n.baseState = e, [e, n.queue.dispatch]) : Jo(n, R, e, t);
		},
		useMemoCache: Io,
		useCacheRefresh: js
	};
	Us.useEffectEvent = ms;
	function Ws(e, t, n, r) {
		t = e.memoizedState, n = n(r, t), n = n == null ? t : h({}, t, n), e.memoizedState = n, e.lanes === 0 && (e.updateQueue.baseState = n);
	}
	var Gs = {
		enqueueSetState: function(e, t, n) {
			e = e._reactInternals;
			var r = pu(), i = qa(r);
			i.payload = t, n != null && (i.callback = n), t = Ja(e, i, r), t !== null && (hu(t, e, r), Ya(t, e, r));
		},
		enqueueReplaceState: function(e, t, n) {
			e = e._reactInternals;
			var r = pu(), i = qa(r);
			i.tag = 1, i.payload = t, n != null && (i.callback = n), t = Ja(e, i, r), t !== null && (hu(t, e, r), Ya(t, e, r));
		},
		enqueueForceUpdate: function(e, t) {
			e = e._reactInternals;
			var n = pu(), r = qa(n);
			r.tag = 2, t != null && (r.callback = t), t = Ja(e, r, n), t !== null && (hu(t, e, n), Ya(t, e, n));
		}
	};
	function Ks(e, t, n, r, i, a, o) {
		return e = e.stateNode, typeof e.shouldComponentUpdate == "function" ? e.shouldComponentUpdate(r, a, o) : t.prototype && t.prototype.isPureReactComponent ? !kr(n, r) || !kr(i, a) : !0;
	}
	function qs(e, t, n, r) {
		e = t.state, typeof t.componentWillReceiveProps == "function" && t.componentWillReceiveProps(n, r), typeof t.UNSAFE_componentWillReceiveProps == "function" && t.UNSAFE_componentWillReceiveProps(n, r), t.state !== e && Gs.enqueueReplaceState(t, t.state, null);
	}
	function Js(e, t) {
		var n = t;
		if ("ref" in t) for (var r in n = {}, t) r !== "ref" && (n[r] = t[r]);
		if (e = e.defaultProps) for (var i in n === t && (n = h({}, n)), e) n[i] === void 0 && (n[i] = e[i]);
		return n;
	}
	function Ys(e) {
		ni(e);
	}
	function Xs(e) {
		console.error(e);
	}
	function Zs(e) {
		ni(e);
	}
	function Qs(e, t) {
		try {
			var n = e.onUncaughtError;
			n(t.value, { componentStack: t.stack });
		} catch (e) {
			setTimeout(function() {
				throw e;
			});
		}
	}
	function $s(e, t, n) {
		try {
			var r = e.onCaughtError;
			r(n.value, {
				componentStack: n.stack,
				errorBoundary: t.tag === 1 ? t.stateNode : null
			});
		} catch (e) {
			setTimeout(function() {
				throw e;
			});
		}
	}
	function ec(e, t, n) {
		return n = qa(n), n.tag = 3, n.payload = { element: null }, n.callback = function() {
			Qs(e, t);
		}, n;
	}
	function tc(e) {
		return e = qa(e), e.tag = 3, e;
	}
	function nc(e, t, n, r) {
		var i = n.type.getDerivedStateFromError;
		if (typeof i == "function") {
			var a = r.value;
			e.payload = function() {
				return i(a);
			}, e.callback = function() {
				$s(t, n, r);
			};
		}
		var o = n.stateNode;
		o !== null && typeof o.componentDidCatch == "function" && (e.callback = function() {
			$s(t, n, r), typeof i != "function" && (ru === null ? ru = /* @__PURE__ */ new Set([this]) : ru.add(this));
			var e = r.stack;
			this.componentDidCatch(r.value, { componentStack: e === null ? "" : e });
		});
	}
	function rc(e, t, n, r, a) {
		if (n.flags |= 32768, typeof r == "object" && r && typeof r.then == "function") {
			if (t = n.alternate, t !== null && ra(t, n, a, !0), n = so.current, n !== null) {
				switch (n.tag) {
					case 31:
					case 13: return co === null ? Du() : n.alternate === null && X === 0 && (X = 3), n.flags &= -257, n.flags |= 65536, n.lanes = a, r === ka ? n.flags |= 16384 : (t = n.updateQueue, t === null ? n.updateQueue = /* @__PURE__ */ new Set([r]) : t.add(r), Gu(e, r, a)), !1;
					case 22: return n.flags |= 65536, r === ka ? n.flags |= 16384 : (t = n.updateQueue, t === null ? (t = {
						transitions: null,
						markerInstances: null,
						retryQueue: /* @__PURE__ */ new Set([r])
					}, n.updateQueue = t) : (n = t.retryQueue, n === null ? t.retryQueue = /* @__PURE__ */ new Set([r]) : n.add(r)), Gu(e, r, a)), !1;
				}
				throw Error(i(435, n.tag));
			}
			return Gu(e, r, a), Du(), !1;
		}
		if (P) return t = so.current, t === null ? (r !== Hi && (t = Error(i(423), { cause: r }), Yi(wi(t, n))), e = e.current.alternate, e.flags |= 65536, a &= -a, e.lanes |= a, r = wi(r, n), a = ec(e.stateNode, r, a), Xa(e, a), X !== 4 && (X = 2)) : (!(t.flags & 65536) && (t.flags |= 256), t.flags |= 65536, t.lanes = a, r !== Hi && (e = Error(i(422), { cause: r }), Yi(wi(e, n)))), !1;
		var o = Error(i(520), { cause: r });
		if (o = wi(o, n), Xl === null ? Xl = [o] : Xl.push(o), X !== 4 && (X = 2), t === null) return !0;
		r = wi(r, n), n = t;
		do {
			switch (n.tag) {
				case 3: return n.flags |= 65536, e = a & -a, n.lanes |= e, e = ec(n.stateNode, r, e), Xa(n, e), !1;
				case 1: if (t = n.type, o = n.stateNode, !(n.flags & 128) && (typeof t.getDerivedStateFromError == "function" || o !== null && typeof o.componentDidCatch == "function" && (ru === null || !ru.has(o)))) return n.flags |= 65536, a &= -a, n.lanes |= a, a = tc(a), nc(a, e, n, r), Xa(n, a), !1;
			}
			n = n.return;
		} while (n !== null);
		return !1;
	}
	var ic = Error(i(461)), H = !1;
	function ac(e, t, n, r) {
		t.child = e === null ? Ua(t, null, n, r) : Ha(t, e.child, n, r);
	}
	function oc(e, t, n, r, i) {
		n = n.render;
		var a = t.ref;
		if ("ref" in r) {
			var o = {};
			for (var s in r) s !== "ref" && (o[s] = r[s]);
		} else o = r;
		return aa(t), r = To(e, t, n, o, a, i), s = ko(), e !== null && !H ? (Ao(e, t, i), Ac(e, t, i)) : (P && s && Ii(t), t.flags |= 1, ac(e, t, r, i), t.child);
	}
	function sc(e, t, n, r, i) {
		if (e === null) {
			var a = n.type;
			return typeof a == "function" && !hi(a) && a.defaultProps === void 0 && n.compare === null ? (t.tag = 15, t.type = a, cc(e, t, a, r, i)) : (e = vi(n.type, null, r, t, t.mode, i), e.ref = t.ref, e.return = t, t.child = e);
		}
		if (a = e.child, !jc(e, i)) {
			var o = a.memoizedProps;
			if (n = n.compare, n = n === null ? kr : n, n(o, r) && e.ref === t.ref) return Ac(e, t, i);
		}
		return t.flags |= 1, e = gi(a, r), e.ref = t.ref, e.return = t, t.child = e;
	}
	function cc(e, t, n, r, i) {
		if (e !== null) {
			var a = e.memoizedProps;
			if (kr(a, r) && e.ref === t.ref) {
				if (H = !1, t.pendingProps = r = a, jc(e, i)) e.flags & 131072 && (H = !0);
				else return t.lanes = e.lanes, Ac(e, t, i);
			}
		}
		return gc(e, t, n, r, i);
	}
	function lc(e, t, n, r) {
		var i = r.children, a = e === null ? null : e.memoizedState;
		if (e === null && t.stateNode === null && (t.stateNode = {
			_visibility: 1,
			_pendingMarkers: null,
			_retryCache: null,
			_transitions: null
		}), r.mode === "hidden") {
			if (t.flags & 128) {
				if (a = a === null ? n : a.baseLanes | n, e !== null) {
					for (r = t.child = e.child, i = 0; r !== null;) i = i | r.lanes | r.childLanes, r = r.sibling;
					r = i & ~a;
				} else r = 0, t.child = null;
				return dc(e, t, a, n, r);
			}
			if (n & 536870912) t.memoizedState = {
				baseLanes: 0,
				cachePool: null
			}, e !== null && wa(t, a === null ? null : a.cachePool), a === null ? ao() : io(t, a), fo(t);
			else return r = t.lanes = 536870912, dc(e, t, a === null ? n : a.baseLanes | n, n, r);
		} else a === null ? (e !== null && wa(t, null), ao(), po(t)) : (wa(t, a.cachePool), io(t, a), po(t), t.memoizedState = null);
		return ac(e, t, i, n), t.child;
	}
	function uc(e, t) {
		return e !== null && e.tag === 22 || t.stateNode !== null || (t.stateNode = {
			_visibility: 1,
			_pendingMarkers: null,
			_retryCache: null,
			_transitions: null
		}), t.sibling;
	}
	function dc(e, t, n, r, i) {
		var a = Ca();
		return a = a === null ? null : {
			parent: F._currentValue,
			pool: a
		}, t.memoizedState = {
			baseLanes: n,
			cachePool: a
		}, e !== null && wa(t, null), ao(), fo(t), e !== null && ra(e, t, r, !0), t.childLanes = i, null;
	}
	function fc(e, t) {
		return t = Tc({
			mode: t.mode,
			children: t.children
		}, e.mode), t.ref = e.ref, e.child = t, t.return = e, t;
	}
	function pc(e, t, n) {
		return Ha(t, e.child, null, n), e = fc(t, t.pendingProps), e.flags |= 2, mo(t), t.memoizedState = null, e;
	}
	function mc(e, t, n) {
		var r = t.pendingProps, a = !!(t.flags & 128);
		if (t.flags &= -129, e === null) {
			if (P) {
				if (r.mode === "hidden") return e = fc(t, r), t.lanes = 536870912, uc(null, e);
				if (uo(t), (e = N) ? (e = rf(e, Vi), e = e !== null && e.data === "&" ? e : null, e !== null && (t.memoizedState = {
					dehydrated: e,
					treeContext: ji === null ? null : {
						id: Mi,
						overflow: Ni
					},
					retryLane: 536870912,
					hydrationErrors: null
				}, n = xi(e), n.return = t, t.child = n, zi = t, N = null)) : e = null, e === null) throw Ui(t);
				return t.lanes = 536870912, null;
			}
			return fc(t, r);
		}
		var o = e.memoizedState;
		if (o !== null) {
			var s = o.dehydrated;
			if (uo(t), a) {
				if (t.flags & 256) t.flags &= -257, t = pc(e, t, n);
				else if (t.memoizedState !== null) t.child = e.child, t.flags |= 128, t = null;
				else throw Error(i(558));
			} else if (H || ra(e, t, n, !1), a = (n & e.childLanes) !== 0, H || a) {
				if (r = K, r !== null && (s = ct(r, n), s !== 0 && s !== o.retryLane)) throw o.retryLane = s, li(e, s), hu(r, e, s), ic;
				Du(), t = pc(e, t, n);
			} else e = o.treeContext, N = cf(s.nextSibling), zi = t, P = !0, Bi = null, Vi = !1, e !== null && Ri(t, e), t = fc(t, r), t.flags |= 4096;
			return t;
		}
		return e = gi(e.child, {
			mode: r.mode,
			children: r.children
		}), e.ref = t.ref, t.child = e, e.return = t, e;
	}
	function hc(e, t) {
		var n = t.ref;
		if (n === null) e !== null && e.ref !== null && (t.flags |= 4194816);
		else {
			if (typeof n != "function" && typeof n != "object") throw Error(i(284));
			(e === null || e.ref !== n) && (t.flags |= 4194816);
		}
	}
	function gc(e, t, n, r, i) {
		return aa(t), n = To(e, t, n, r, void 0, i), r = ko(), e !== null && !H ? (Ao(e, t, i), Ac(e, t, i)) : (P && r && Ii(t), t.flags |= 1, ac(e, t, n, i), t.child);
	}
	function _c(e, t, n, r, i, a) {
		return aa(t), t.updateQueue = null, n = Do(t, r, n, i), Eo(e), r = ko(), e !== null && !H ? (Ao(e, t, a), Ac(e, t, a)) : (P && r && Ii(t), t.flags |= 1, ac(e, t, n, a), t.child);
	}
	function vc(e, t, n, r, i) {
		if (aa(t), t.stateNode === null) {
			var a = fi, o = n.contextType;
			typeof o == "object" && o && (a = oa(o)), a = new n(r, a), t.memoizedState = a.state !== null && a.state !== void 0 ? a.state : null, a.updater = Gs, t.stateNode = a, a._reactInternals = t, a = t.stateNode, a.props = r, a.state = t.memoizedState, a.refs = {}, Ga(t), o = n.contextType, a.context = typeof o == "object" && o ? oa(o) : fi, a.state = t.memoizedState, o = n.getDerivedStateFromProps, typeof o == "function" && (Ws(t, n, o, r), a.state = t.memoizedState), typeof n.getDerivedStateFromProps == "function" || typeof a.getSnapshotBeforeUpdate == "function" || typeof a.UNSAFE_componentWillMount != "function" && typeof a.componentWillMount != "function" || (o = a.state, typeof a.componentWillMount == "function" && a.componentWillMount(), typeof a.UNSAFE_componentWillMount == "function" && a.UNSAFE_componentWillMount(), o !== a.state && Gs.enqueueReplaceState(a, a.state, null), $a(t, r, a, i), Qa(), a.state = t.memoizedState), typeof a.componentDidMount == "function" && (t.flags |= 4194308), r = !0;
		} else if (e === null) {
			a = t.stateNode;
			var s = t.memoizedProps, c = Js(n, s);
			a.props = c;
			var l = a.context, u = n.contextType;
			o = fi, typeof u == "object" && u && (o = oa(u));
			var d = n.getDerivedStateFromProps;
			u = typeof d == "function" || typeof a.getSnapshotBeforeUpdate == "function", s = t.pendingProps !== s, u || typeof a.UNSAFE_componentWillReceiveProps != "function" && typeof a.componentWillReceiveProps != "function" || (s || l !== o) && qs(t, a, r, o), Wa = !1;
			var f = t.memoizedState;
			a.state = f, $a(t, r, a, i), Qa(), l = t.memoizedState, s || f !== l || Wa ? (typeof d == "function" && (Ws(t, n, d, r), l = t.memoizedState), (c = Wa || Ks(t, n, c, r, f, l, o)) ? (u || typeof a.UNSAFE_componentWillMount != "function" && typeof a.componentWillMount != "function" || (typeof a.componentWillMount == "function" && a.componentWillMount(), typeof a.UNSAFE_componentWillMount == "function" && a.UNSAFE_componentWillMount()), typeof a.componentDidMount == "function" && (t.flags |= 4194308)) : (typeof a.componentDidMount == "function" && (t.flags |= 4194308), t.memoizedProps = r, t.memoizedState = l), a.props = r, a.state = l, a.context = o, r = c) : (typeof a.componentDidMount == "function" && (t.flags |= 4194308), r = !1);
		} else {
			a = t.stateNode, Ka(e, t), o = t.memoizedProps, u = Js(n, o), a.props = u, d = t.pendingProps, f = a.context, l = n.contextType, c = fi, typeof l == "object" && l && (c = oa(l)), s = n.getDerivedStateFromProps, (l = typeof s == "function" || typeof a.getSnapshotBeforeUpdate == "function") || typeof a.UNSAFE_componentWillReceiveProps != "function" && typeof a.componentWillReceiveProps != "function" || (o !== d || f !== c) && qs(t, a, r, c), Wa = !1, f = t.memoizedState, a.state = f, $a(t, r, a, i), Qa();
			var p = t.memoizedState;
			o !== d || f !== p || Wa || e !== null && e.dependencies !== null && ia(e.dependencies) ? (typeof s == "function" && (Ws(t, n, s, r), p = t.memoizedState), (u = Wa || Ks(t, n, u, r, f, p, c) || e !== null && e.dependencies !== null && ia(e.dependencies)) ? (l || typeof a.UNSAFE_componentWillUpdate != "function" && typeof a.componentWillUpdate != "function" || (typeof a.componentWillUpdate == "function" && a.componentWillUpdate(r, p, c), typeof a.UNSAFE_componentWillUpdate == "function" && a.UNSAFE_componentWillUpdate(r, p, c)), typeof a.componentDidUpdate == "function" && (t.flags |= 4), typeof a.getSnapshotBeforeUpdate == "function" && (t.flags |= 1024)) : (typeof a.componentDidUpdate != "function" || o === e.memoizedProps && f === e.memoizedState || (t.flags |= 4), typeof a.getSnapshotBeforeUpdate != "function" || o === e.memoizedProps && f === e.memoizedState || (t.flags |= 1024), t.memoizedProps = r, t.memoizedState = p), a.props = r, a.state = p, a.context = c, r = u) : (typeof a.componentDidUpdate != "function" || o === e.memoizedProps && f === e.memoizedState || (t.flags |= 4), typeof a.getSnapshotBeforeUpdate != "function" || o === e.memoizedProps && f === e.memoizedState || (t.flags |= 1024), r = !1);
		}
		return a = r, hc(e, t), r = !!(t.flags & 128), a || r ? (a = t.stateNode, n = r && typeof n.getDerivedStateFromError != "function" ? null : a.render(), t.flags |= 1, e !== null && r ? (t.child = Ha(t, e.child, null, i), t.child = Ha(t, null, n, i)) : ac(e, t, n, i), t.memoizedState = a.state, e = t.child) : e = Ac(e, t, i), e;
	}
	function yc(e, t, n, r) {
		return qi(), t.flags |= 256, ac(e, t, n, r), t.child;
	}
	var bc = {
		dehydrated: null,
		treeContext: null,
		retryLane: 0,
		hydrationErrors: null
	};
	function xc(e) {
		return {
			baseLanes: e,
			cachePool: Ta()
		};
	}
	function Sc(e, t, n) {
		return e = e === null ? 0 : e.childLanes & ~n, t && (e |= Jl), e;
	}
	function Cc(e, t, n) {
		var r = t.pendingProps, a = !1, o = !!(t.flags & 128), s;
		if ((s = o) || (s = e !== null && e.memoizedState === null ? !1 : !!(I.current & 2)), s && (a = !0, t.flags &= -129), s = !!(t.flags & 32), t.flags &= -33, e === null) {
			if (P) {
				if (a ? lo(t) : po(t), (e = N) ? (e = rf(e, Vi), e = e !== null && e.data !== "&" ? e : null, e !== null && (t.memoizedState = {
					dehydrated: e,
					treeContext: ji === null ? null : {
						id: Mi,
						overflow: Ni
					},
					retryLane: 536870912,
					hydrationErrors: null
				}, n = xi(e), n.return = t, t.child = n, zi = t, N = null)) : e = null, e === null) throw Ui(t);
				return of(e) ? t.lanes = 32 : t.lanes = 536870912, null;
			}
			var c = r.children;
			return r = r.fallback, a ? (po(t), a = t.mode, c = Tc({
				mode: "hidden",
				children: c
			}, a), r = yi(r, a, n, null), c.return = t, r.return = t, c.sibling = r, t.child = c, r = t.child, r.memoizedState = xc(n), r.childLanes = Sc(e, s, n), t.memoizedState = bc, uc(null, r)) : (lo(t), wc(t, c));
		}
		var l = e.memoizedState;
		if (l !== null && (c = l.dehydrated, c !== null)) {
			if (o) t.flags & 256 ? (lo(t), t.flags &= -257, t = Ec(e, t, n)) : t.memoizedState === null ? (po(t), c = r.fallback, a = t.mode, r = Tc({
				mode: "visible",
				children: r.children
			}, a), c = yi(c, a, n, null), c.flags |= 2, r.return = t, c.return = t, r.sibling = c, t.child = r, Ha(t, e.child, null, n), r = t.child, r.memoizedState = xc(n), r.childLanes = Sc(e, s, n), t.memoizedState = bc, t = uc(null, r)) : (po(t), t.child = e.child, t.flags |= 128, t = null);
			else if (lo(t), of(c)) {
				if (s = c.nextSibling && c.nextSibling.dataset, s) var u = s.dgst;
				s = u, r = Error(i(419)), r.stack = "", r.digest = s, Yi({
					value: r,
					source: null,
					stack: null
				}), t = Ec(e, t, n);
			} else if (H || ra(e, t, n, !1), s = (n & e.childLanes) !== 0, H || s) {
				if (s = K, s !== null && (r = ct(s, n), r !== 0 && r !== l.retryLane)) throw l.retryLane = r, li(e, r), hu(s, e, r), ic;
				af(c) || Du(), t = Ec(e, t, n);
			} else af(c) ? (t.flags |= 192, t.child = e.child, t = null) : (e = l.treeContext, N = cf(c.nextSibling), zi = t, P = !0, Bi = null, Vi = !1, e !== null && Ri(t, e), t = wc(t, r.children), t.flags |= 4096);
			return t;
		}
		return a ? (po(t), c = r.fallback, a = t.mode, l = e.child, u = l.sibling, r = gi(l, {
			mode: "hidden",
			children: r.children
		}), r.subtreeFlags = l.subtreeFlags & 65011712, u === null ? (c = yi(c, a, n, null), c.flags |= 2) : c = gi(u, c), c.return = t, r.return = t, r.sibling = c, t.child = r, uc(null, r), r = t.child, c = e.child.memoizedState, c === null ? c = xc(n) : (a = c.cachePool, a === null ? a = Ta() : (l = F._currentValue, a = a.parent === l ? a : {
			parent: l,
			pool: l
		}), c = {
			baseLanes: c.baseLanes | n,
			cachePool: a
		}), r.memoizedState = c, r.childLanes = Sc(e, s, n), t.memoizedState = bc, uc(e.child, r)) : (lo(t), n = e.child, e = n.sibling, n = gi(n, {
			mode: "visible",
			children: r.children
		}), n.return = t, n.sibling = null, e !== null && (s = t.deletions, s === null ? (t.deletions = [e], t.flags |= 16) : s.push(e)), t.child = n, t.memoizedState = null, n);
	}
	function wc(e, t) {
		return t = Tc({
			mode: "visible",
			children: t
		}, e.mode), t.return = e, e.child = t;
	}
	function Tc(e, t) {
		return e = mi(22, e, null, t), e.lanes = 0, e;
	}
	function Ec(e, t, n) {
		return Ha(t, e.child, null, n), e = wc(t, t.pendingProps.children), e.flags |= 2, t.memoizedState = null, e;
	}
	function Dc(e, t, n) {
		e.lanes |= t;
		var r = e.alternate;
		r !== null && (r.lanes |= t), ta(e.return, t, n);
	}
	function Oc(e, t, n, r, i, a) {
		var o = e.memoizedState;
		o === null ? e.memoizedState = {
			isBackwards: t,
			rendering: null,
			renderingStartTime: 0,
			last: r,
			tail: n,
			tailMode: i,
			treeForkCount: a
		} : (o.isBackwards = t, o.rendering = null, o.renderingStartTime = 0, o.last = r, o.tail = n, o.tailMode = i, o.treeForkCount = a);
	}
	function kc(e, t, n) {
		var r = t.pendingProps, i = r.revealOrder, a = r.tail;
		r = r.children;
		var o = I.current, s = !!(o & 2);
		if (s ? (o = o & 1 | 2, t.flags |= 128) : o &= 1, k(I, o), ac(e, t, r, n), r = P ? Oi : 0, !s && e !== null && e.flags & 128) a: for (e = t.child; e !== null;) {
			if (e.tag === 13) e.memoizedState !== null && Dc(e, n, t);
			else if (e.tag === 19) Dc(e, n, t);
			else if (e.child !== null) {
				e.child.return = e, e = e.child;
				continue;
			}
			if (e === t) break a;
			for (; e.sibling === null;) {
				if (e.return === null || e.return === t) break a;
				e = e.return;
			}
			e.sibling.return = e.return, e = e.sibling;
		}
		switch (i) {
			case "forwards":
				for (n = t.child, i = null; n !== null;) e = n.alternate, e !== null && ho(e) === null && (i = n), n = n.sibling;
				n = i, n === null ? (i = t.child, t.child = null) : (i = n.sibling, n.sibling = null), Oc(t, !1, i, n, a, r);
				break;
			case "backwards":
			case "unstable_legacy-backwards":
				for (n = null, i = t.child, t.child = null; i !== null;) {
					if (e = i.alternate, e !== null && ho(e) === null) {
						t.child = i;
						break;
					}
					e = i.sibling, i.sibling = n, n = i, i = e;
				}
				Oc(t, !0, n, null, a, r);
				break;
			case "together":
				Oc(t, !1, null, null, void 0, r);
				break;
			default: t.memoizedState = null;
		}
		return t.child;
	}
	function Ac(e, t, n) {
		if (e !== null && (t.dependencies = e.dependencies), Gl |= t.lanes, (n & t.childLanes) === 0) {
			if (e !== null) {
				if (ra(e, t, n, !1), (n & t.childLanes) === 0) return null;
			} else return null;
		}
		if (e !== null && t.child !== e.child) throw Error(i(153));
		if (t.child !== null) {
			for (e = t.child, n = gi(e, e.pendingProps), t.child = n, n.return = t; e.sibling !== null;) e = e.sibling, n = n.sibling = gi(e, e.pendingProps), n.return = t;
			n.sibling = null;
		}
		return t.child;
	}
	function jc(e, t) {
		return (e.lanes & t) !== 0 || (e = e.dependencies, !!(e !== null && ia(e)));
	}
	function Mc(e, t, n) {
		switch (t.tag) {
			case 3:
				ve(t, t.stateNode.containerInfo), $i(t, F, e.memoizedState.cache), qi();
				break;
			case 27:
			case 5:
				be(t);
				break;
			case 4:
				ve(t, t.stateNode.containerInfo);
				break;
			case 10:
				$i(t, t.type, t.memoizedProps.value);
				break;
			case 31:
				if (t.memoizedState !== null) return t.flags |= 128, uo(t), null;
				break;
			case 13:
				var r = t.memoizedState;
				if (r !== null) return r.dehydrated === null ? (n & t.child.childLanes) === 0 ? (lo(t), e = Ac(e, t, n), e === null ? null : e.sibling) : Cc(e, t, n) : (lo(t), t.flags |= 128, null);
				lo(t);
				break;
			case 19:
				var i = !!(e.flags & 128);
				if (r = (n & t.childLanes) !== 0, r ||= (ra(e, t, n, !1), (n & t.childLanes) !== 0), i) {
					if (r) return kc(e, t, n);
					t.flags |= 128;
				}
				if (i = t.memoizedState, i !== null && (i.rendering = null, i.tail = null, i.lastEffect = null), k(I, I.current), r) break;
				return null;
			case 22: return t.lanes = 0, lc(e, t, n, t.pendingProps);
			case 24: $i(t, F, e.memoizedState.cache);
		}
		return Ac(e, t, n);
	}
	function Nc(e, t, n) {
		if (e !== null) {
			if (e.memoizedProps !== t.pendingProps) H = !0;
			else {
				if (!jc(e, n) && !(t.flags & 128)) return H = !1, Mc(e, t, n);
				H = !!(e.flags & 131072);
			}
		} else H = !1, P && t.flags & 1048576 && Fi(t, Oi, t.index);
		switch (t.lanes = 0, t.tag) {
			case 16:
				a: {
					var r = t.pendingProps;
					if (e = Ma(t.elementType), t.type = e, typeof e == "function") hi(e) ? (r = Js(e, r), t.tag = 1, t = vc(null, t, e, r, n)) : (t.tag = 0, t = gc(null, t, e, r, n));
					else {
						if (e != null) {
							var a = e.$$typeof;
							if (a === C) {
								t.tag = 11, t = oc(null, t, e, r, n);
								break a;
							}
							if (a === w) {
								t.tag = 14, t = sc(null, t, e, r, n);
								break a;
							}
						}
						throw t = se(e) || e, Error(i(306, t, ""));
					}
				}
				return t;
			case 0: return gc(e, t, t.type, t.pendingProps, n);
			case 1: return r = t.type, a = Js(r, t.pendingProps), vc(e, t, r, a, n);
			case 3:
				a: {
					if (ve(t, t.stateNode.containerInfo), e === null) throw Error(i(387));
					r = t.pendingProps;
					var o = t.memoizedState;
					a = o.element, Ka(e, t), $a(t, r, null, n);
					var s = t.memoizedState;
					if (r = s.cache, $i(t, F, r), r !== o.cache && na(t, [F], n, !0), Qa(), r = s.element, o.isDehydrated) {
						if (o = {
							element: r,
							isDehydrated: !1,
							cache: s.cache
						}, t.updateQueue.baseState = o, t.memoizedState = o, t.flags & 256) {
							t = yc(e, t, r, n);
							break a;
						}
						if (r !== a) {
							a = wi(Error(i(424)), t), Yi(a), t = yc(e, t, r, n);
							break a;
						}
						switch (e = t.stateNode.containerInfo, e.nodeType) {
							case 9:
								e = e.body;
								break;
							default: e = e.nodeName === "HTML" ? e.ownerDocument.body : e;
						}
						for (N = cf(e.firstChild), zi = t, P = !0, Bi = null, Vi = !0, n = Ua(t, null, r, n), t.child = n; n;) n.flags = n.flags & -3 | 4096, n = n.sibling;
					} else {
						if (qi(), r === a) {
							t = Ac(e, t, n);
							break a;
						}
						ac(e, t, r, n);
					}
					t = t.child;
				}
				return t;
			case 26: return hc(e, t), e === null ? (n = kf(t.type, null, t.pendingProps, null)) ? t.memoizedState = n : P || (n = t.type, e = t.pendingProps, r = Bd(ge.current).createElement(n), r[M] = t, r[pt] = e, Pd(r, n, e), Tt(r), t.stateNode = r) : t.memoizedState = kf(t.type, e.memoizedProps, t.pendingProps, e.memoizedState), null;
			case 27: return be(t), e === null && P && (r = t.stateNode = ff(t.type, t.pendingProps, ge.current), zi = t, Vi = !0, a = N, Zd(t.type) ? (lf = a, N = cf(r.firstChild)) : N = a), ac(e, t, t.pendingProps.children, n), hc(e, t), e === null && (t.flags |= 4194304), t.child;
			case 5: return e === null && P && ((a = r = N) && (r = tf(r, t.type, t.pendingProps, Vi), r === null ? a = !1 : (t.stateNode = r, zi = t, N = cf(r.firstChild), Vi = !1, a = !0)), a || Ui(t)), be(t), a = t.type, o = t.pendingProps, s = e === null ? null : e.memoizedProps, r = o.children, Ud(a, o) ? r = null : s !== null && Ud(a, s) && (t.flags |= 32), t.memoizedState !== null && (a = To(e, t, Oo, null, null, n), Qf._currentValue = a), hc(e, t), ac(e, t, r, n), t.child;
			case 6: return e === null && P && ((e = n = N) && (n = nf(n, t.pendingProps, Vi), n === null ? e = !1 : (t.stateNode = n, zi = t, N = null, e = !0)), e || Ui(t)), null;
			case 13: return Cc(e, t, n);
			case 4: return ve(t, t.stateNode.containerInfo), r = t.pendingProps, e === null ? t.child = Ha(t, null, r, n) : ac(e, t, r, n), t.child;
			case 11: return oc(e, t, t.type, t.pendingProps, n);
			case 7: return ac(e, t, t.pendingProps, n), t.child;
			case 8: return ac(e, t, t.pendingProps.children, n), t.child;
			case 12: return ac(e, t, t.pendingProps.children, n), t.child;
			case 10: return r = t.pendingProps, $i(t, t.type, r.value), ac(e, t, r.children, n), t.child;
			case 9: return a = t.type._context, r = t.pendingProps.children, aa(t), a = oa(a), r = r(a), t.flags |= 1, ac(e, t, r, n), t.child;
			case 14: return sc(e, t, t.type, t.pendingProps, n);
			case 15: return cc(e, t, t.type, t.pendingProps, n);
			case 19: return kc(e, t, n);
			case 31: return mc(e, t, n);
			case 22: return lc(e, t, n, t.pendingProps);
			case 24: return aa(t), r = oa(F), e === null ? (a = Ca(), a === null && (a = K, o = fa(), a.pooledCache = o, o.refCount++, o !== null && (a.pooledCacheLanes |= n), a = o), t.memoizedState = {
				parent: r,
				cache: a
			}, Ga(t), $i(t, F, a)) : ((e.lanes & n) !== 0 && (Ka(e, t), $a(t, null, null, n), Qa()), a = e.memoizedState, o = t.memoizedState, a.parent === r ? (r = o.cache, $i(t, F, r), r !== a.cache && na(t, [F], n, !0)) : (a = {
				parent: r,
				cache: r
			}, t.memoizedState = a, t.lanes === 0 && (t.memoizedState = t.updateQueue.baseState = a), $i(t, F, r))), ac(e, t, t.pendingProps.children, n), t.child;
			case 29: throw t.pendingProps;
		}
		throw Error(i(156, t.tag));
	}
	function Pc(e) {
		e.flags |= 4;
	}
	function Fc(e, t, n, r, i) {
		if ((t = !!(e.mode & 32)) && (t = !1), t) {
			if (e.flags |= 16777216, (i & 335544128) === i) {
				if (e.stateNode.complete) e.flags |= 8192;
				else if (wu()) e.flags |= 8192;
				else throw Na = ka, Da;
			}
		} else e.flags &= -16777217;
	}
	function Ic(e, t) {
		if (t.type !== "stylesheet" || t.state.loading & 4) e.flags &= -16777217;
		else if (e.flags |= 16777216, !Wf(t)) {
			if (wu()) e.flags |= 8192;
			else throw Na = ka, Da;
		}
	}
	function Lc(e, t) {
		t !== null && (e.flags |= 4), e.flags & 16384 && (t = e.tag === 22 ? 536870912 : nt(), e.lanes |= t, Yl |= t);
	}
	function Rc(e, t) {
		if (!P) switch (e.tailMode) {
			case "hidden":
				t = e.tail;
				for (var n = null; t !== null;) t.alternate !== null && (n = t), t = t.sibling;
				n === null ? e.tail = null : n.sibling = null;
				break;
			case "collapsed":
				n = e.tail;
				for (var r = null; n !== null;) n.alternate !== null && (r = n), n = n.sibling;
				r === null ? t || e.tail === null ? e.tail = null : e.tail.sibling = null : r.sibling = null;
		}
	}
	function U(e) {
		var t = e.alternate !== null && e.alternate.child === e.child, n = 0, r = 0;
		if (t) for (var i = e.child; i !== null;) n |= i.lanes | i.childLanes, r |= i.subtreeFlags & 65011712, r |= i.flags & 65011712, i.return = e, i = i.sibling;
		else for (i = e.child; i !== null;) n |= i.lanes | i.childLanes, r |= i.subtreeFlags, r |= i.flags, i.return = e, i = i.sibling;
		return e.subtreeFlags |= r, e.childLanes = n, t;
	}
	function zc(e, t, n) {
		var r = t.pendingProps;
		switch (Li(t), t.tag) {
			case 16:
			case 15:
			case 0:
			case 11:
			case 7:
			case 8:
			case 12:
			case 9:
			case 14: return U(t), null;
			case 1: return U(t), null;
			case 3: return n = t.stateNode, r = null, e !== null && (r = e.memoizedState.cache), t.memoizedState.cache !== r && (t.flags |= 2048), ea(F), ye(), n.pendingContext && (n.context = n.pendingContext, n.pendingContext = null), (e === null || e.child === null) && (Ki(t) ? Pc(t) : e === null || e.memoizedState.isDehydrated && !(t.flags & 256) || (t.flags |= 1024, Ji())), U(t), null;
			case 26:
				var a = t.type, o = t.memoizedState;
				return e === null ? (Pc(t), o === null ? (U(t), Fc(t, a, null, r, n)) : (U(t), Ic(t, o))) : o ? o === e.memoizedState ? (U(t), t.flags &= -16777217) : (Pc(t), U(t), Ic(t, o)) : (e = e.memoizedProps, e !== r && Pc(t), U(t), Fc(t, a, e, r, n)), null;
			case 27:
				if (xe(t), n = ge.current, a = t.type, e !== null && t.stateNode != null) e.memoizedProps !== r && Pc(t);
				else {
					if (!r) {
						if (t.stateNode === null) throw Error(i(166));
						return U(t), null;
					}
					e = me.current, Ki(t) ? Wi(t, e) : (e = ff(a, r, n), t.stateNode = e, Pc(t));
				}
				return U(t), null;
			case 5:
				if (xe(t), a = t.type, e !== null && t.stateNode != null) e.memoizedProps !== r && Pc(t);
				else {
					if (!r) {
						if (t.stateNode === null) throw Error(i(166));
						return U(t), null;
					}
					if (o = me.current, Ki(t)) Wi(t, o);
					else {
						var s = Bd(ge.current);
						switch (o) {
							case 1:
								o = s.createElementNS("http://www.w3.org/2000/svg", a);
								break;
							case 2:
								o = s.createElementNS("http://www.w3.org/1998/Math/MathML", a);
								break;
							default: switch (a) {
								case "svg":
									o = s.createElementNS("http://www.w3.org/2000/svg", a);
									break;
								case "math":
									o = s.createElementNS("http://www.w3.org/1998/Math/MathML", a);
									break;
								case "script":
									o = s.createElement("div"), o.innerHTML = "<script><\/script>", o = o.removeChild(o.firstChild);
									break;
								case "select":
									o = typeof r.is == "string" ? s.createElement("select", { is: r.is }) : s.createElement("select"), r.multiple ? o.multiple = !0 : r.size && (o.size = r.size);
									break;
								default: o = typeof r.is == "string" ? s.createElement(a, { is: r.is }) : s.createElement(a);
							}
						}
						o[M] = t, o[pt] = r;
						a: for (s = t.child; s !== null;) {
							if (s.tag === 5 || s.tag === 6) o.appendChild(s.stateNode);
							else if (s.tag !== 4 && s.tag !== 27 && s.child !== null) {
								s.child.return = s, s = s.child;
								continue;
							}
							if (s === t) break a;
							for (; s.sibling === null;) {
								if (s.return === null || s.return === t) break a;
								s = s.return;
							}
							s.sibling.return = s.return, s = s.sibling;
						}
						t.stateNode = o;
						a: switch (Pd(o, a, r), a) {
							case "button":
							case "input":
							case "select":
							case "textarea":
								r = !!r.autoFocus;
								break a;
							case "img":
								r = !0;
								break a;
							default: r = !1;
						}
						r && Pc(t);
					}
				}
				return U(t), Fc(t, t.type, e === null ? null : e.memoizedProps, t.pendingProps, n), null;
			case 6:
				if (e && t.stateNode != null) e.memoizedProps !== r && Pc(t);
				else {
					if (typeof r != "string" && t.stateNode === null) throw Error(i(166));
					if (e = ge.current, Ki(t)) {
						if (e = t.stateNode, n = t.memoizedProps, r = null, a = zi, a !== null) switch (a.tag) {
							case 27:
							case 5: r = a.memoizedProps;
						}
						e[M] = t, e = !!(e.nodeValue === n || r !== null && !0 === r.suppressHydrationWarning || Md(e.nodeValue, n)), e || Ui(t, !0);
					} else e = Bd(e).createTextNode(r), e[M] = t, t.stateNode = e;
				}
				return U(t), null;
			case 31:
				if (n = t.memoizedState, e === null || e.memoizedState !== null) {
					if (r = Ki(t), n !== null) {
						if (e === null) {
							if (!r) throw Error(i(318));
							if (e = t.memoizedState, e = e === null ? null : e.dehydrated, !e) throw Error(i(557));
							e[M] = t;
						} else qi(), !(t.flags & 128) && (t.memoizedState = null), t.flags |= 4;
						U(t), e = !1;
					} else n = Ji(), e !== null && e.memoizedState !== null && (e.memoizedState.hydrationErrors = n), e = !0;
					if (!e) return t.flags & 256 ? (mo(t), t) : (mo(t), null);
					if (t.flags & 128) throw Error(i(558));
				}
				return U(t), null;
			case 13:
				if (r = t.memoizedState, e === null || e.memoizedState !== null && e.memoizedState.dehydrated !== null) {
					if (a = Ki(t), r !== null && r.dehydrated !== null) {
						if (e === null) {
							if (!a) throw Error(i(318));
							if (a = t.memoizedState, a = a === null ? null : a.dehydrated, !a) throw Error(i(317));
							a[M] = t;
						} else qi(), !(t.flags & 128) && (t.memoizedState = null), t.flags |= 4;
						U(t), a = !1;
					} else a = Ji(), e !== null && e.memoizedState !== null && (e.memoizedState.hydrationErrors = a), a = !0;
					if (!a) return t.flags & 256 ? (mo(t), t) : (mo(t), null);
				}
				return mo(t), t.flags & 128 ? (t.lanes = n, t) : (n = r !== null, e = e !== null && e.memoizedState !== null, n && (r = t.child, a = null, r.alternate !== null && r.alternate.memoizedState !== null && r.alternate.memoizedState.cachePool !== null && (a = r.alternate.memoizedState.cachePool.pool), o = null, r.memoizedState !== null && r.memoizedState.cachePool !== null && (o = r.memoizedState.cachePool.pool), o !== a && (r.flags |= 2048)), n !== e && n && (t.child.flags |= 8192), Lc(t, t.updateQueue), U(t), null);
			case 4: return ye(), e === null && Sd(t.stateNode.containerInfo), U(t), null;
			case 10: return ea(t.type), U(t), null;
			case 19:
				if (pe(I), r = t.memoizedState, r === null) return U(t), null;
				if (a = !!(t.flags & 128), o = r.rendering, o === null) {
					if (a) Rc(r, !1);
					else {
						if (X !== 0 || e !== null && e.flags & 128) for (e = t.child; e !== null;) {
							if (o = ho(e), o !== null) {
								for (t.flags |= 128, Rc(r, !1), e = o.updateQueue, t.updateQueue = e, Lc(t, e), t.subtreeFlags = 0, e = n, n = t.child; n !== null;) _i(n, e), n = n.sibling;
								return k(I, I.current & 1 | 2), P && Pi(t, r.treeForkCount), t.child;
							}
							e = e.sibling;
						}
						r.tail !== null && Pe() > tu && (t.flags |= 128, a = !0, Rc(r, !1), t.lanes = 4194304);
					}
				} else {
					if (!a) {
						if (e = ho(o), e !== null) {
							if (t.flags |= 128, a = !0, e = e.updateQueue, t.updateQueue = e, Lc(t, e), Rc(r, !0), r.tail === null && r.tailMode === "hidden" && !o.alternate && !P) return U(t), null;
						} else 2 * Pe() - r.renderingStartTime > tu && n !== 536870912 && (t.flags |= 128, a = !0, Rc(r, !1), t.lanes = 4194304);
					}
					r.isBackwards ? (o.sibling = t.child, t.child = o) : (e = r.last, e === null ? t.child = o : e.sibling = o, r.last = o);
				}
				return r.tail === null ? (U(t), null) : (e = r.tail, r.rendering = e, r.tail = e.sibling, r.renderingStartTime = Pe(), e.sibling = null, n = I.current, k(I, a ? n & 1 | 2 : n & 1), P && Pi(t, r.treeForkCount), e);
			case 22:
			case 23: return mo(t), oo(), r = t.memoizedState !== null, e === null ? r && (t.flags |= 8192) : e.memoizedState !== null !== r && (t.flags |= 8192), r ? n & 536870912 && !(t.flags & 128) && (U(t), t.subtreeFlags & 6 && (t.flags |= 8192)) : U(t), n = t.updateQueue, n !== null && Lc(t, n.retryQueue), n = null, e !== null && e.memoizedState !== null && e.memoizedState.cachePool !== null && (n = e.memoizedState.cachePool.pool), r = null, t.memoizedState !== null && t.memoizedState.cachePool !== null && (r = t.memoizedState.cachePool.pool), r !== n && (t.flags |= 2048), e !== null && pe(Sa), null;
			case 24: return n = null, e !== null && (n = e.memoizedState.cache), t.memoizedState.cache !== n && (t.flags |= 2048), ea(F), U(t), null;
			case 25: return null;
			case 30: return null;
		}
		throw Error(i(156, t.tag));
	}
	function Bc(e, t) {
		switch (Li(t), t.tag) {
			case 1: return e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
			case 3: return ea(F), ye(), e = t.flags, e & 65536 && !(e & 128) ? (t.flags = e & -65537 | 128, t) : null;
			case 26:
			case 27:
			case 5: return xe(t), null;
			case 31:
				if (t.memoizedState !== null) {
					if (mo(t), t.alternate === null) throw Error(i(340));
					qi();
				}
				return e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
			case 13:
				if (mo(t), e = t.memoizedState, e !== null && e.dehydrated !== null) {
					if (t.alternate === null) throw Error(i(340));
					qi();
				}
				return e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
			case 19: return pe(I), null;
			case 4: return ye(), null;
			case 10: return ea(t.type), null;
			case 22:
			case 23: return mo(t), oo(), e !== null && pe(Sa), e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
			case 24: return ea(F), null;
			case 25: return null;
			default: return null;
		}
	}
	function Vc(e, t) {
		switch (Li(t), t.tag) {
			case 3:
				ea(F), ye();
				break;
			case 26:
			case 27:
			case 5:
				xe(t);
				break;
			case 4:
				ye();
				break;
			case 31:
				t.memoizedState !== null && mo(t);
				break;
			case 13:
				mo(t);
				break;
			case 19:
				pe(I);
				break;
			case 10:
				ea(t.type);
				break;
			case 22:
			case 23:
				mo(t), oo(), e !== null && pe(Sa);
				break;
			case 24: ea(F);
		}
	}
	function Hc(e, t) {
		try {
			var n = t.updateQueue, r = n === null ? null : n.lastEffect;
			if (r !== null) {
				var i = r.next;
				n = i;
				do {
					if ((n.tag & e) === e) {
						r = void 0;
						var a = n.create, o = n.inst;
						r = a(), o.destroy = r;
					}
					n = n.next;
				} while (n !== i);
			}
		} catch (e) {
			Z(t, t.return, e);
		}
	}
	function Uc(e, t, n) {
		try {
			var r = t.updateQueue, i = r === null ? null : r.lastEffect;
			if (i !== null) {
				var a = i.next;
				r = a;
				do {
					if ((r.tag & e) === e) {
						var o = r.inst, s = o.destroy;
						if (s !== void 0) {
							o.destroy = void 0, i = t;
							var c = n, l = s;
							try {
								l();
							} catch (e) {
								Z(i, c, e);
							}
						}
					}
					r = r.next;
				} while (r !== a);
			}
		} catch (e) {
			Z(t, t.return, e);
		}
	}
	function Wc(e) {
		var t = e.updateQueue;
		if (t !== null) {
			var n = e.stateNode;
			try {
				to(t, n);
			} catch (t) {
				Z(e, e.return, t);
			}
		}
	}
	function Gc(e, t, n) {
		n.props = Js(e.type, e.memoizedProps), n.state = e.memoizedState;
		try {
			n.componentWillUnmount();
		} catch (n) {
			Z(e, t, n);
		}
	}
	function Kc(e, t) {
		try {
			var n = e.ref;
			if (n !== null) {
				switch (e.tag) {
					case 26:
					case 27:
					case 5:
						var r = e.stateNode;
						break;
					case 30:
						r = e.stateNode;
						break;
					default: r = e.stateNode;
				}
				typeof n == "function" ? e.refCleanup = n(r) : n.current = r;
			}
		} catch (n) {
			Z(e, t, n);
		}
	}
	function qc(e, t) {
		var n = e.ref, r = e.refCleanup;
		if (n !== null) {
			if (typeof r == "function") try {
				r();
			} catch (n) {
				Z(e, t, n);
			} finally {
				e.refCleanup = null, e = e.alternate, e != null && (e.refCleanup = null);
			}
			else if (typeof n == "function") try {
				n(null);
			} catch (n) {
				Z(e, t, n);
			}
			else n.current = null;
		}
	}
	function Jc(e) {
		var t = e.type, n = e.memoizedProps, r = e.stateNode;
		try {
			a: switch (t) {
				case "button":
				case "input":
				case "select":
				case "textarea":
					n.autoFocus && r.focus();
					break a;
				case "img": n.src ? r.src = n.src : n.srcSet && (r.srcset = n.srcSet);
			}
		} catch (t) {
			Z(e, e.return, t);
		}
	}
	function Yc(e, t, n) {
		try {
			var r = e.stateNode;
			Fd(r, e.type, n, t), r[pt] = t;
		} catch (t) {
			Z(e, e.return, t);
		}
	}
	function Xc(e) {
		return e.tag === 5 || e.tag === 3 || e.tag === 26 || e.tag === 27 && Zd(e.type) || e.tag === 4;
	}
	function Zc(e) {
		a: for (;;) {
			for (; e.sibling === null;) {
				if (e.return === null || Xc(e.return)) return null;
				e = e.return;
			}
			for (e.sibling.return = e.return, e = e.sibling; e.tag !== 5 && e.tag !== 6 && e.tag !== 18;) {
				if (e.tag === 27 && Zd(e.type) || e.flags & 2 || e.child === null || e.tag === 4) continue a;
				e.child.return = e, e = e.child;
			}
			if (!(e.flags & 2)) return e.stateNode;
		}
	}
	function Qc(e, t, n) {
		var r = e.tag;
		if (r === 5 || r === 6) e = e.stateNode, t ? (n.nodeType === 9 ? n.body : n.nodeName === "HTML" ? n.ownerDocument.body : n).insertBefore(e, t) : (t = n.nodeType === 9 ? n.body : n.nodeName === "HTML" ? n.ownerDocument.body : n, t.appendChild(e), n = n._reactRootContainer, n != null || t.onclick !== null || (t.onclick = on));
		else if (r !== 4 && (r === 27 && Zd(e.type) && (n = e.stateNode, t = null), e = e.child, e !== null)) for (Qc(e, t, n), e = e.sibling; e !== null;) Qc(e, t, n), e = e.sibling;
	}
	function $c(e, t, n) {
		var r = e.tag;
		if (r === 5 || r === 6) e = e.stateNode, t ? n.insertBefore(e, t) : n.appendChild(e);
		else if (r !== 4 && (r === 27 && Zd(e.type) && (n = e.stateNode), e = e.child, e !== null)) for ($c(e, t, n), e = e.sibling; e !== null;) $c(e, t, n), e = e.sibling;
	}
	function el(e) {
		var t = e.stateNode, n = e.memoizedProps;
		try {
			for (var r = e.type, i = t.attributes; i.length;) t.removeAttributeNode(i[0]);
			Pd(t, r, n), t[M] = e, t[pt] = n;
		} catch (t) {
			Z(e, e.return, t);
		}
	}
	var tl = !1, nl = !1, rl = !1, il = typeof WeakSet == "function" ? WeakSet : Set, al = null;
	function ol(e, t) {
		if (e = e.containerInfo, Rd = sp, e = Nr(e), Pr(e)) {
			if ("selectionStart" in e) var n = {
				start: e.selectionStart,
				end: e.selectionEnd
			};
			else a: {
				n = (n = e.ownerDocument) && n.defaultView || window;
				var r = n.getSelection && n.getSelection();
				if (r && r.rangeCount !== 0) {
					n = r.anchorNode;
					var a = r.anchorOffset, o = r.focusNode;
					r = r.focusOffset;
					try {
						n.nodeType, o.nodeType;
					} catch {
						n = null;
						break a;
					}
					var s = 0, c = -1, l = -1, u = 0, d = 0, f = e, p = null;
					b: for (;;) {
						for (var m; f !== n || a !== 0 && f.nodeType !== 3 || (c = s + a), f !== o || r !== 0 && f.nodeType !== 3 || (l = s + r), f.nodeType === 3 && (s += f.nodeValue.length), (m = f.firstChild) !== null;) p = f, f = m;
						for (;;) {
							if (f === e) break b;
							if (p === n && ++u === a && (c = s), p === o && ++d === r && (l = s), (m = f.nextSibling) !== null) break;
							f = p, p = f.parentNode;
						}
						f = m;
					}
					n = c === -1 || l === -1 ? null : {
						start: c,
						end: l
					};
				} else n = null;
			}
			n ||= {
				start: 0,
				end: 0
			};
		} else n = null;
		for (zd = {
			focusedElem: e,
			selectionRange: n
		}, sp = !1, al = t; al !== null;) if (t = al, e = t.child, t.subtreeFlags & 1028 && e !== null) e.return = t, al = e;
		else for (; al !== null;) {
			switch (t = al, o = t.alternate, e = t.flags, t.tag) {
				case 0:
					if (e & 4 && (e = t.updateQueue, e = e === null ? null : e.events, e !== null)) for (n = 0; n < e.length; n++) a = e[n], a.ref.impl = a.nextImpl;
					break;
				case 11:
				case 15: break;
				case 1:
					if (e & 1024 && o !== null) {
						e = void 0, n = t, a = o.memoizedProps, o = o.memoizedState, r = n.stateNode;
						try {
							var h = Js(n.type, a);
							e = r.getSnapshotBeforeUpdate(h, o), r.__reactInternalSnapshotBeforeUpdate = e;
						} catch (e) {
							Z(n, n.return, e);
						}
					}
					break;
				case 3:
					if (e & 1024) {
						if (e = t.stateNode.containerInfo, n = e.nodeType, n === 9) ef(e);
						else if (n === 1) switch (e.nodeName) {
							case "HEAD":
							case "HTML":
							case "BODY":
								ef(e);
								break;
							default: e.textContent = "";
						}
					}
					break;
				case 5:
				case 26:
				case 27:
				case 6:
				case 4:
				case 17: break;
				default: if (e & 1024) throw Error(i(163));
			}
			if (e = t.sibling, e !== null) {
				e.return = t.return, al = e;
				break;
			}
			al = t.return;
		}
	}
	function sl(e, t, n) {
		var r = n.flags;
		switch (n.tag) {
			case 0:
			case 11:
			case 15:
				xl(e, n), r & 4 && Hc(5, n);
				break;
			case 1:
				if (xl(e, n), r & 4) {
					if (e = n.stateNode, t === null) try {
						e.componentDidMount();
					} catch (e) {
						Z(n, n.return, e);
					}
					else {
						var i = Js(n.type, t.memoizedProps);
						t = t.memoizedState;
						try {
							e.componentDidUpdate(i, t, e.__reactInternalSnapshotBeforeUpdate);
						} catch (e) {
							Z(n, n.return, e);
						}
					}
				}
				r & 64 && Wc(n), r & 512 && Kc(n, n.return);
				break;
			case 3:
				if (xl(e, n), r & 64 && (e = n.updateQueue, e !== null)) {
					if (t = null, n.child !== null) switch (n.child.tag) {
						case 27:
						case 5:
							t = n.child.stateNode;
							break;
						case 1: t = n.child.stateNode;
					}
					try {
						to(e, t);
					} catch (e) {
						Z(n, n.return, e);
					}
				}
				break;
			case 27: t === null && r & 4 && el(n);
			case 26:
			case 5:
				xl(e, n), t === null && r & 4 && Jc(n), r & 512 && Kc(n, n.return);
				break;
			case 12:
				xl(e, n);
				break;
			case 31:
				xl(e, n), r & 4 && fl(e, n);
				break;
			case 13:
				xl(e, n), r & 4 && pl(e, n), r & 64 && (e = n.memoizedState, e !== null && (e = e.dehydrated, e !== null && (n = Ju.bind(null, n), sf(e, n))));
				break;
			case 22:
				if (r = n.memoizedState !== null || tl, !r) {
					t = t !== null && t.memoizedState !== null || nl, i = tl;
					var a = nl;
					tl = r, (nl = t) && !a ? Cl(e, n, !!(n.subtreeFlags & 8772)) : xl(e, n), tl = i, nl = a;
				}
				break;
			case 30: break;
			default: xl(e, n);
		}
	}
	function cl(e) {
		var t = e.alternate;
		t !== null && (e.alternate = null, cl(t)), e.child = null, e.deletions = null, e.sibling = null, e.tag === 5 && (t = e.stateNode, t !== null && bt(t)), e.stateNode = null, e.return = null, e.dependencies = null, e.memoizedProps = null, e.memoizedState = null, e.pendingProps = null, e.stateNode = null, e.updateQueue = null;
	}
	var W = null, ll = !1;
	function ul(e, t, n) {
		for (n = n.child; n !== null;) dl(e, t, n), n = n.sibling;
	}
	function dl(e, t, n) {
		if (A && typeof A.onCommitFiberUnmount == "function") try {
			A.onCommitFiberUnmount(Ue, n);
		} catch {}
		switch (n.tag) {
			case 26:
				nl || qc(n, t), ul(e, t, n), n.memoizedState ? n.memoizedState.count-- : n.stateNode && (n = n.stateNode, n.parentNode.removeChild(n));
				break;
			case 27:
				nl || qc(n, t);
				var r = W, i = ll;
				Zd(n.type) && (W = n.stateNode, ll = !1), ul(e, t, n), pf(n.stateNode), W = r, ll = i;
				break;
			case 5: nl || qc(n, t);
			case 6:
				if (r = W, i = ll, W = null, ul(e, t, n), W = r, ll = i, W !== null) {
					if (ll) try {
						(W.nodeType === 9 ? W.body : W.nodeName === "HTML" ? W.ownerDocument.body : W).removeChild(n.stateNode);
					} catch (e) {
						Z(n, t, e);
					}
					else try {
						W.removeChild(n.stateNode);
					} catch (e) {
						Z(n, t, e);
					}
				}
				break;
			case 18:
				W !== null && (ll ? (e = W, Qd(e.nodeType === 9 ? e.body : e.nodeName === "HTML" ? e.ownerDocument.body : e, n.stateNode), Np(e)) : Qd(W, n.stateNode));
				break;
			case 4:
				r = W, i = ll, W = n.stateNode.containerInfo, ll = !0, ul(e, t, n), W = r, ll = i;
				break;
			case 0:
			case 11:
			case 14:
			case 15:
				Uc(2, n, t), nl || Uc(4, n, t), ul(e, t, n);
				break;
			case 1:
				nl || (qc(n, t), r = n.stateNode, typeof r.componentWillUnmount == "function" && Gc(n, t, r)), ul(e, t, n);
				break;
			case 21:
				ul(e, t, n);
				break;
			case 22:
				nl = (r = nl) || n.memoizedState !== null, ul(e, t, n), nl = r;
				break;
			default: ul(e, t, n);
		}
	}
	function fl(e, t) {
		if (t.memoizedState === null && (e = t.alternate, e !== null && (e = e.memoizedState, e !== null))) {
			e = e.dehydrated;
			try {
				Np(e);
			} catch (e) {
				Z(t, t.return, e);
			}
		}
	}
	function pl(e, t) {
		if (t.memoizedState === null && (e = t.alternate, e !== null && (e = e.memoizedState, e !== null && (e = e.dehydrated, e !== null)))) try {
			Np(e);
		} catch (e) {
			Z(t, t.return, e);
		}
	}
	function ml(e) {
		switch (e.tag) {
			case 31:
			case 13:
			case 19:
				var t = e.stateNode;
				return t === null && (t = e.stateNode = new il()), t;
			case 22: return e = e.stateNode, t = e._retryCache, t === null && (t = e._retryCache = new il()), t;
			default: throw Error(i(435, e.tag));
		}
	}
	function hl(e, t) {
		var n = ml(e);
		t.forEach(function(t) {
			if (!n.has(t)) {
				n.add(t);
				var r = Yu.bind(null, e, t);
				t.then(r, r);
			}
		});
	}
	function gl(e, t) {
		var n = t.deletions;
		if (n !== null) for (var r = 0; r < n.length; r++) {
			var a = n[r], o = e, s = t, c = s;
			a: for (; c !== null;) {
				switch (c.tag) {
					case 27:
						if (Zd(c.type)) {
							W = c.stateNode, ll = !1;
							break a;
						}
						break;
					case 5:
						W = c.stateNode, ll = !1;
						break a;
					case 3:
					case 4:
						W = c.stateNode.containerInfo, ll = !0;
						break a;
				}
				c = c.return;
			}
			if (W === null) throw Error(i(160));
			dl(o, s, a), W = null, ll = !1, o = a.alternate, o !== null && (o.return = null), a.return = null;
		}
		if (t.subtreeFlags & 13886) for (t = t.child; t !== null;) vl(t, e), t = t.sibling;
	}
	var _l = null;
	function vl(e, t) {
		var n = e.alternate, r = e.flags;
		switch (e.tag) {
			case 0:
			case 11:
			case 14:
			case 15:
				gl(t, e), yl(e), r & 4 && (Uc(3, e, e.return), Hc(3, e), Uc(5, e, e.return));
				break;
			case 1:
				gl(t, e), yl(e), r & 512 && (nl || n === null || qc(n, n.return)), r & 64 && tl && (e = e.updateQueue, e !== null && (r = e.callbacks, r !== null && (n = e.shared.hiddenCallbacks, e.shared.hiddenCallbacks = n === null ? r : n.concat(r))));
				break;
			case 26:
				var a = _l;
				if (gl(t, e), yl(e), r & 512 && (nl || n === null || qc(n, n.return)), r & 4) {
					var o = n === null ? null : n.memoizedState;
					if (r = e.memoizedState, n === null) {
						if (r === null) {
							if (e.stateNode === null) {
								a: {
									r = e.type, n = e.memoizedProps, a = a.ownerDocument || a;
									b: switch (r) {
										case "title":
											o = a.getElementsByTagName("title")[0], (!o || o[yt] || o[M] || o.namespaceURI === "http://www.w3.org/2000/svg" || o.hasAttribute("itemprop")) && (o = a.createElement(r), a.head.insertBefore(o, a.querySelector("head > title"))), Pd(o, r, n), o[M] = e, Tt(o), r = o;
											break a;
										case "link":
											var s = Vf("link", "href", a).get(r + (n.href || ""));
											if (s) {
												for (var c = 0; c < s.length; c++) if (o = s[c], o.getAttribute("href") === (n.href == null || n.href === "" ? null : n.href) && o.getAttribute("rel") === (n.rel == null ? null : n.rel) && o.getAttribute("title") === (n.title == null ? null : n.title) && o.getAttribute("crossorigin") === (n.crossOrigin == null ? null : n.crossOrigin)) {
													s.splice(c, 1);
													break b;
												}
											}
											o = a.createElement(r), Pd(o, r, n), a.head.appendChild(o);
											break;
										case "meta":
											if (s = Vf("meta", "content", a).get(r + (n.content || ""))) {
												for (c = 0; c < s.length; c++) if (o = s[c], o.getAttribute("content") === (n.content == null ? null : "" + n.content) && o.getAttribute("name") === (n.name == null ? null : n.name) && o.getAttribute("property") === (n.property == null ? null : n.property) && o.getAttribute("http-equiv") === (n.httpEquiv == null ? null : n.httpEquiv) && o.getAttribute("charset") === (n.charSet == null ? null : n.charSet)) {
													s.splice(c, 1);
													break b;
												}
											}
											o = a.createElement(r), Pd(o, r, n), a.head.appendChild(o);
											break;
										default: throw Error(i(468, r));
									}
									o[M] = e, Tt(o), r = o;
								}
								e.stateNode = r;
							} else Hf(a, e.type, e.stateNode);
						} else e.stateNode = If(a, r, e.memoizedProps);
					} else o === r ? r === null && e.stateNode !== null && Yc(e, e.memoizedProps, n.memoizedProps) : (o === null ? n.stateNode !== null && (n = n.stateNode, n.parentNode.removeChild(n)) : o.count--, r === null ? Hf(a, e.type, e.stateNode) : If(a, r, e.memoizedProps));
				}
				break;
			case 27:
				gl(t, e), yl(e), r & 512 && (nl || n === null || qc(n, n.return)), n !== null && r & 4 && Yc(e, e.memoizedProps, n.memoizedProps);
				break;
			case 5:
				if (gl(t, e), yl(e), r & 512 && (nl || n === null || qc(n, n.return)), e.flags & 32) {
					a = e.stateNode;
					try {
						Zt(a, "");
					} catch (t) {
						Z(e, e.return, t);
					}
				}
				r & 4 && e.stateNode != null && (a = e.memoizedProps, Yc(e, a, n === null ? a : n.memoizedProps)), r & 1024 && (rl = !0);
				break;
			case 6:
				if (gl(t, e), yl(e), r & 4) {
					if (e.stateNode === null) throw Error(i(162));
					r = e.memoizedProps, n = e.stateNode;
					try {
						n.nodeValue = r;
					} catch (t) {
						Z(e, e.return, t);
					}
				}
				break;
			case 3:
				if (Bf = null, a = _l, _l = gf(t.containerInfo), gl(t, e), _l = a, yl(e), r & 4 && n !== null && n.memoizedState.isDehydrated) try {
					Np(t.containerInfo);
				} catch (t) {
					Z(e, e.return, t);
				}
				rl && (rl = !1, bl(e));
				break;
			case 4:
				r = _l, _l = gf(e.stateNode.containerInfo), gl(t, e), yl(e), _l = r;
				break;
			case 12:
				gl(t, e), yl(e);
				break;
			case 31:
				gl(t, e), yl(e), r & 4 && (r = e.updateQueue, r !== null && (e.updateQueue = null, hl(e, r)));
				break;
			case 13:
				gl(t, e), yl(e), e.child.flags & 8192 && e.memoizedState !== null != (n !== null && n.memoizedState !== null) && ($l = Pe()), r & 4 && (r = e.updateQueue, r !== null && (e.updateQueue = null, hl(e, r)));
				break;
			case 22:
				a = e.memoizedState !== null;
				var l = n !== null && n.memoizedState !== null, u = tl, d = nl;
				if (tl = u || a, nl = d || l, gl(t, e), nl = d, tl = u, yl(e), r & 8192) a: for (t = e.stateNode, t._visibility = a ? t._visibility & -2 : t._visibility | 1, a && (n === null || l || tl || nl || Sl(e)), n = null, t = e;;) {
					if (t.tag === 5 || t.tag === 26) {
						if (n === null) {
							l = n = t;
							try {
								if (o = l.stateNode, a) s = o.style, typeof s.setProperty == "function" ? s.setProperty("display", "none", "important") : s.display = "none";
								else {
									c = l.stateNode;
									var f = l.memoizedProps.style, p = f != null && f.hasOwnProperty("display") ? f.display : null;
									c.style.display = p == null || typeof p == "boolean" ? "" : ("" + p).trim();
								}
							} catch (e) {
								Z(l, l.return, e);
							}
						}
					} else if (t.tag === 6) {
						if (n === null) {
							l = t;
							try {
								l.stateNode.nodeValue = a ? "" : l.memoizedProps;
							} catch (e) {
								Z(l, l.return, e);
							}
						}
					} else if (t.tag === 18) {
						if (n === null) {
							l = t;
							try {
								var m = l.stateNode;
								a ? $d(m, !0) : $d(l.stateNode, !1);
							} catch (e) {
								Z(l, l.return, e);
							}
						}
					} else if ((t.tag !== 22 && t.tag !== 23 || t.memoizedState === null || t === e) && t.child !== null) {
						t.child.return = t, t = t.child;
						continue;
					}
					if (t === e) break a;
					for (; t.sibling === null;) {
						if (t.return === null || t.return === e) break a;
						n === t && (n = null), t = t.return;
					}
					n === t && (n = null), t.sibling.return = t.return, t = t.sibling;
				}
				r & 4 && (r = e.updateQueue, r !== null && (n = r.retryQueue, n !== null && (r.retryQueue = null, hl(e, n))));
				break;
			case 19:
				gl(t, e), yl(e), r & 4 && (r = e.updateQueue, r !== null && (e.updateQueue = null, hl(e, r)));
				break;
			case 30: break;
			case 21: break;
			default: gl(t, e), yl(e);
		}
	}
	function yl(e) {
		var t = e.flags;
		if (t & 2) {
			try {
				for (var n, r = e.return; r !== null;) {
					if (Xc(r)) {
						n = r;
						break;
					}
					r = r.return;
				}
				if (n == null) throw Error(i(160));
				switch (n.tag) {
					case 27:
						var a = n.stateNode;
						$c(e, Zc(e), a);
						break;
					case 5:
						var o = n.stateNode;
						n.flags & 32 && (Zt(o, ""), n.flags &= -33), $c(e, Zc(e), o);
						break;
					case 3:
					case 4:
						var s = n.stateNode.containerInfo;
						Qc(e, Zc(e), s);
						break;
					default: throw Error(i(161));
				}
			} catch (t) {
				Z(e, e.return, t);
			}
			e.flags &= -3;
		}
		t & 4096 && (e.flags &= -4097);
	}
	function bl(e) {
		if (e.subtreeFlags & 1024) for (e = e.child; e !== null;) {
			var t = e;
			bl(t), t.tag === 5 && t.flags & 1024 && t.stateNode.reset(), e = e.sibling;
		}
	}
	function xl(e, t) {
		if (t.subtreeFlags & 8772) for (t = t.child; t !== null;) sl(e, t.alternate, t), t = t.sibling;
	}
	function Sl(e) {
		for (e = e.child; e !== null;) {
			var t = e;
			switch (t.tag) {
				case 0:
				case 11:
				case 14:
				case 15:
					Uc(4, t, t.return), Sl(t);
					break;
				case 1:
					qc(t, t.return);
					var n = t.stateNode;
					typeof n.componentWillUnmount == "function" && Gc(t, t.return, n), Sl(t);
					break;
				case 27: pf(t.stateNode);
				case 26:
				case 5:
					qc(t, t.return), Sl(t);
					break;
				case 22:
					t.memoizedState === null && Sl(t);
					break;
				case 30:
					Sl(t);
					break;
				default: Sl(t);
			}
			e = e.sibling;
		}
	}
	function Cl(e, t, n) {
		for (n &&= !!(t.subtreeFlags & 8772), t = t.child; t !== null;) {
			var r = t.alternate, i = e, a = t, o = a.flags;
			switch (a.tag) {
				case 0:
				case 11:
				case 15:
					Cl(i, a, n), Hc(4, a);
					break;
				case 1:
					if (Cl(i, a, n), r = a, i = r.stateNode, typeof i.componentDidMount == "function") try {
						i.componentDidMount();
					} catch (e) {
						Z(r, r.return, e);
					}
					if (r = a, i = r.updateQueue, i !== null) {
						var s = r.stateNode;
						try {
							var c = i.shared.hiddenCallbacks;
							if (c !== null) for (i.shared.hiddenCallbacks = null, i = 0; i < c.length; i++) eo(c[i], s);
						} catch (e) {
							Z(r, r.return, e);
						}
					}
					n && o & 64 && Wc(a), Kc(a, a.return);
					break;
				case 27: el(a);
				case 26:
				case 5:
					Cl(i, a, n), n && r === null && o & 4 && Jc(a), Kc(a, a.return);
					break;
				case 12:
					Cl(i, a, n);
					break;
				case 31:
					Cl(i, a, n), n && o & 4 && fl(i, a);
					break;
				case 13:
					Cl(i, a, n), n && o & 4 && pl(i, a);
					break;
				case 22:
					a.memoizedState === null && Cl(i, a, n), Kc(a, a.return);
					break;
				case 30: break;
				default: Cl(i, a, n);
			}
			t = t.sibling;
		}
	}
	function wl(e, t) {
		var n = null;
		e !== null && e.memoizedState !== null && e.memoizedState.cachePool !== null && (n = e.memoizedState.cachePool.pool), e = null, t.memoizedState !== null && t.memoizedState.cachePool !== null && (e = t.memoizedState.cachePool.pool), e !== n && (e != null && e.refCount++, n != null && pa(n));
	}
	function Tl(e, t) {
		e = null, t.alternate !== null && (e = t.alternate.memoizedState.cache), t = t.memoizedState.cache, t !== e && (t.refCount++, e != null && pa(e));
	}
	function El(e, t, n, r) {
		if (t.subtreeFlags & 10256) for (t = t.child; t !== null;) Dl(e, t, n, r), t = t.sibling;
	}
	function Dl(e, t, n, r) {
		var i = t.flags;
		switch (t.tag) {
			case 0:
			case 11:
			case 15:
				El(e, t, n, r), i & 2048 && Hc(9, t);
				break;
			case 1:
				El(e, t, n, r);
				break;
			case 3:
				El(e, t, n, r), i & 2048 && (e = null, t.alternate !== null && (e = t.alternate.memoizedState.cache), t = t.memoizedState.cache, t !== e && (t.refCount++, e != null && pa(e)));
				break;
			case 12:
				if (i & 2048) {
					El(e, t, n, r), e = t.stateNode;
					try {
						var a = t.memoizedProps, o = a.id, s = a.onPostCommit;
						typeof s == "function" && s(o, t.alternate === null ? "mount" : "update", e.passiveEffectDuration, -0);
					} catch (e) {
						Z(t, t.return, e);
					}
				} else El(e, t, n, r);
				break;
			case 31:
				El(e, t, n, r);
				break;
			case 13:
				El(e, t, n, r);
				break;
			case 23: break;
			case 22:
				a = t.stateNode, o = t.alternate, t.memoizedState === null ? a._visibility & 2 ? El(e, t, n, r) : (a._visibility |= 2, Ol(e, t, n, r, !!(t.subtreeFlags & 10256) || !1)) : a._visibility & 2 ? El(e, t, n, r) : kl(e, t), i & 2048 && wl(o, t);
				break;
			case 24:
				El(e, t, n, r), i & 2048 && Tl(t.alternate, t);
				break;
			default: El(e, t, n, r);
		}
	}
	function Ol(e, t, n, r, i) {
		for (i &&= !!(t.subtreeFlags & 10256) || !1, t = t.child; t !== null;) {
			var a = e, o = t, s = n, c = r, l = o.flags;
			switch (o.tag) {
				case 0:
				case 11:
				case 15:
					Ol(a, o, s, c, i), Hc(8, o);
					break;
				case 23: break;
				case 22:
					var u = o.stateNode;
					o.memoizedState === null ? (u._visibility |= 2, Ol(a, o, s, c, i)) : u._visibility & 2 ? Ol(a, o, s, c, i) : kl(a, o), i && l & 2048 && wl(o.alternate, o);
					break;
				case 24:
					Ol(a, o, s, c, i), i && l & 2048 && Tl(o.alternate, o);
					break;
				default: Ol(a, o, s, c, i);
			}
			t = t.sibling;
		}
	}
	function kl(e, t) {
		if (t.subtreeFlags & 10256) for (t = t.child; t !== null;) {
			var n = e, r = t, i = r.flags;
			switch (r.tag) {
				case 22:
					kl(n, r), i & 2048 && wl(r.alternate, r);
					break;
				case 24:
					kl(n, r), i & 2048 && Tl(r.alternate, r);
					break;
				default: kl(n, r);
			}
			t = t.sibling;
		}
	}
	var Al = 8192;
	function jl(e, t, n) {
		if (e.subtreeFlags & Al) for (e = e.child; e !== null;) Ml(e, t, n), e = e.sibling;
	}
	function Ml(e, t, n) {
		switch (e.tag) {
			case 26:
				jl(e, t, n), e.flags & Al && e.memoizedState !== null && Gf(n, _l, e.memoizedState, e.memoizedProps);
				break;
			case 5:
				jl(e, t, n);
				break;
			case 3:
			case 4:
				var r = _l;
				_l = gf(e.stateNode.containerInfo), jl(e, t, n), _l = r;
				break;
			case 22:
				e.memoizedState === null && (r = e.alternate, r !== null && r.memoizedState !== null ? (r = Al, Al = 16777216, jl(e, t, n), Al = r) : jl(e, t, n));
				break;
			default: jl(e, t, n);
		}
	}
	function Nl(e) {
		var t = e.alternate;
		if (t !== null && (e = t.child, e !== null)) {
			t.child = null;
			do
				t = e.sibling, e.sibling = null, e = t;
			while (e !== null);
		}
	}
	function Pl(e) {
		var t = e.deletions;
		if (e.flags & 16) {
			if (t !== null) for (var n = 0; n < t.length; n++) {
				var r = t[n];
				al = r, Ll(r, e);
			}
			Nl(e);
		}
		if (e.subtreeFlags & 10256) for (e = e.child; e !== null;) Fl(e), e = e.sibling;
	}
	function Fl(e) {
		switch (e.tag) {
			case 0:
			case 11:
			case 15:
				Pl(e), e.flags & 2048 && Uc(9, e, e.return);
				break;
			case 3:
				Pl(e);
				break;
			case 12:
				Pl(e);
				break;
			case 22:
				var t = e.stateNode;
				e.memoizedState !== null && t._visibility & 2 && (e.return === null || e.return.tag !== 13) ? (t._visibility &= -3, Il(e)) : Pl(e);
				break;
			default: Pl(e);
		}
	}
	function Il(e) {
		var t = e.deletions;
		if (e.flags & 16) {
			if (t !== null) for (var n = 0; n < t.length; n++) {
				var r = t[n];
				al = r, Ll(r, e);
			}
			Nl(e);
		}
		for (e = e.child; e !== null;) {
			switch (t = e, t.tag) {
				case 0:
				case 11:
				case 15:
					Uc(8, t, t.return), Il(t);
					break;
				case 22:
					n = t.stateNode, n._visibility & 2 && (n._visibility &= -3, Il(t));
					break;
				default: Il(t);
			}
			e = e.sibling;
		}
	}
	function Ll(e, t) {
		for (; al !== null;) {
			var n = al;
			switch (n.tag) {
				case 0:
				case 11:
				case 15:
					Uc(8, n, t);
					break;
				case 23:
				case 22:
					if (n.memoizedState !== null && n.memoizedState.cachePool !== null) {
						var r = n.memoizedState.cachePool.pool;
						r != null && r.refCount++;
					}
					break;
				case 24: pa(n.memoizedState.cache);
			}
			if (r = n.child, r !== null) r.return = n, al = r;
			else a: for (n = e; al !== null;) {
				r = al;
				var i = r.sibling, a = r.return;
				if (cl(r), r === n) {
					al = null;
					break a;
				}
				if (i !== null) {
					i.return = a, al = i;
					break a;
				}
				al = a;
			}
		}
	}
	var Rl = {
		getCacheForType: function(e) {
			var t = oa(F), n = t.data.get(e);
			return n === void 0 && (n = e(), t.data.set(e, n)), n;
		},
		cacheSignal: function() {
			return oa(F).controller.signal;
		}
	}, zl = typeof WeakMap == "function" ? WeakMap : Map, G = 0, K = null, q = null, J = 0, Y = 0, Bl = null, Vl = !1, Hl = !1, Ul = !1, Wl = 0, X = 0, Gl = 0, Kl = 0, ql = 0, Jl = 0, Yl = 0, Xl = null, Zl = null, Ql = !1, $l = 0, eu = 0, tu = Infinity, nu = null, ru = null, iu = 0, au = null, ou = null, su = 0, cu = 0, lu = null, uu = null, du = 0, fu = null;
	function pu() {
		return G & 2 && J !== 0 ? J & -J : D.T === null ? dt() : dd();
	}
	function mu() {
		if (Jl === 0) {
			if (!(J & 536870912) || P) {
				var e = Xe;
				Xe <<= 1, !(Xe & 3932160) && (Xe = 262144), Jl = e;
			} else Jl = 536870912;
		}
		return e = so.current, e !== null && (e.flags |= 32), Jl;
	}
	function hu(e, t, n) {
		(e === K && (Y === 2 || Y === 9) || e.cancelPendingCommit !== null) && (Su(e, 0), yu(e, J, Jl, !1)), it(e, n), (!(G & 2) || e !== K) && (e === K && (!(G & 2) && (Kl |= n), X === 4 && yu(e, J, Jl, !1)), rd(e));
	}
	function gu(e, t, n) {
		if (G & 6) throw Error(i(327));
		var r = !n && !(t & 127) && (t & e.expiredLanes) === 0 || et(e, t), a = r ? Au(e, t) : Ou(e, t, !0), o = r;
		do {
			if (a === 0) {
				Hl && !r && yu(e, t, 0, !1);
				break;
			}
			if (n = e.current.alternate, o && !vu(n)) {
				a = Ou(e, t, !1), o = !1;
				continue;
			}
			if (a === 2) {
				if (o = t, e.errorRecoveryDisabledLanes & o) var s = 0;
				else s = e.pendingLanes & -536870913, s = s === 0 ? s & 536870912 ? 536870912 : 0 : s;
				if (s !== 0) {
					t = s;
					a: {
						var c = e;
						a = Xl;
						var l = c.current.memoizedState.isDehydrated;
						if (l && (Su(c, s).flags |= 256), s = Ou(c, s, !1), s !== 2) {
							if (Ul && !l) {
								c.errorRecoveryDisabledLanes |= o, Kl |= o, a = 4;
								break a;
							}
							o = Zl, Zl = a, o !== null && (Zl === null ? Zl = o : Zl.push.apply(Zl, o));
						}
						a = s;
					}
					if (o = !1, a !== 2) continue;
				}
			}
			if (a === 1) {
				Su(e, 0), yu(e, t, 0, !0);
				break;
			}
			a: {
				switch (r = e, o = a, o) {
					case 0:
					case 1: throw Error(i(345));
					case 4: if ((t & 4194048) !== t) break;
					case 6:
						yu(r, t, Jl, !Vl);
						break a;
					case 2:
						Zl = null;
						break;
					case 3:
					case 5: break;
					default: throw Error(i(329));
				}
				if ((t & 62914560) === t && (a = $l + 300 - Pe(), 10 < a)) {
					if (yu(r, t, Jl, !Vl), $e(r, 0, !0) !== 0) break a;
					su = t, r.timeoutHandle = Kd(_u.bind(null, r, n, Zl, nu, Ql, t, Jl, Kl, Yl, Vl, o, "Throttled", -0, 0), a);
					break a;
				}
				_u(r, n, Zl, nu, Ql, t, Jl, Kl, Yl, Vl, o, null, -0, 0);
			}
			break;
		} while (1);
		rd(e);
	}
	function _u(e, t, n, r, i, a, o, s, c, l, u, d, f, p) {
		if (e.timeoutHandle = -1, d = t.subtreeFlags, d & 8192 || (d & 16785408) == 16785408) {
			d = {
				stylesheets: null,
				count: 0,
				imgCount: 0,
				imgBytes: 0,
				suspenseyImages: [],
				waitingForImages: !0,
				waitingForViewTransition: !1,
				unsuspend: on
			}, Ml(t, a, d);
			var m = (a & 62914560) === a ? $l - Pe() : (a & 4194048) === a ? eu - Pe() : 0;
			if (m = qf(d, m), m !== null) {
				su = a, e.cancelPendingCommit = m(Lu.bind(null, e, t, a, n, r, i, o, s, c, u, d, null, f, p)), yu(e, a, o, !l);
				return;
			}
		}
		Lu(e, t, a, n, r, i, o, s, c);
	}
	function vu(e) {
		for (var t = e;;) {
			var n = t.tag;
			if ((n === 0 || n === 11 || n === 15) && t.flags & 16384 && (n = t.updateQueue, n !== null && (n = n.stores, n !== null))) for (var r = 0; r < n.length; r++) {
				var i = n[r], a = i.getSnapshot;
				i = i.value;
				try {
					if (!Or(a(), i)) return !1;
				} catch {
					return !1;
				}
			}
			if (n = t.child, t.subtreeFlags & 16384 && n !== null) n.return = t, t = n;
			else {
				if (t === e) break;
				for (; t.sibling === null;) {
					if (t.return === null || t.return === e) return !0;
					t = t.return;
				}
				t.sibling.return = t.return, t = t.sibling;
			}
		}
		return !0;
	}
	function yu(e, t, n, r) {
		t &= ~ql, t &= ~Kl, e.suspendedLanes |= t, e.pingedLanes &= ~t, r && (e.warmLanes |= t), r = e.expirationTimes;
		for (var i = t; 0 < i;) {
			var a = 31 - Ge(i), o = 1 << a;
			r[a] = -1, i &= ~o;
		}
		n !== 0 && ot(e, n, t);
	}
	function bu() {
		return G & 6 ? !0 : (id(0, !1), !1);
	}
	function xu() {
		if (q !== null) {
			if (Y === 0) var e = q.return;
			else e = q, Qi = Zi = null, jo(e), Ia = null, La = 0, e = q;
			for (; e !== null;) Vc(e.alternate, e), e = e.return;
			q = null;
		}
	}
	function Su(e, t) {
		var n = e.timeoutHandle;
		n !== -1 && (e.timeoutHandle = -1, qd(n)), n = e.cancelPendingCommit, n !== null && (e.cancelPendingCommit = null, n()), su = 0, xu(), K = e, q = n = gi(e.current, null), J = t, Y = 0, Bl = null, Vl = !1, Hl = et(e, t), Ul = !1, Yl = Jl = ql = Kl = Gl = X = 0, Zl = Xl = null, Ql = !1, t & 8 && (t |= t & 32);
		var r = e.entangledLanes;
		if (r !== 0) for (e = e.entanglements, r &= t; 0 < r;) {
			var i = 31 - Ge(r), a = 1 << i;
			t |= e[i], r &= ~a;
		}
		return Wl = t, oi(), n;
	}
	function Cu(e, t) {
		L = null, D.H = Bs, t === Ea || t === Oa ? (t = Pa(), Y = 3) : t === Da ? (t = Pa(), Y = 4) : Y = t === ic ? 8 : typeof t == "object" && t && typeof t.then == "function" ? 6 : 1, Bl = t, q === null && (X = 1, Qs(e, wi(t, e.current)));
	}
	function wu() {
		var e = so.current;
		return e === null ? !0 : (J & 4194048) === J ? co === null : (J & 62914560) === J || J & 536870912 ? e === co : !1;
	}
	function Tu() {
		var e = D.H;
		return D.H = Bs, e === null ? Bs : e;
	}
	function Eu() {
		var e = D.A;
		return D.A = Rl, e;
	}
	function Du() {
		X = 4, Vl || (J & 4194048) !== J && so.current !== null || (Hl = !0), !(Gl & 134217727) && !(Kl & 134217727) || K === null || yu(K, J, Jl, !1);
	}
	function Ou(e, t, n) {
		var r = G;
		G |= 2;
		var i = Tu(), a = Eu();
		(K !== e || J !== t) && (nu = null, Su(e, t)), t = !1;
		var o = X;
		a: do
			try {
				if (Y !== 0 && q !== null) {
					var s = q, c = Bl;
					switch (Y) {
						case 8:
							xu(), o = 6;
							break a;
						case 3:
						case 2:
						case 9:
						case 6:
							so.current === null && (t = !0);
							var l = Y;
							if (Y = 0, Bl = null, Pu(e, s, c, l), n && Hl) {
								o = 0;
								break a;
							}
							break;
						default: l = Y, Y = 0, Bl = null, Pu(e, s, c, l);
					}
				}
				ku(), o = X;
				break;
			} catch (t) {
				Cu(e, t);
			}
		while (1);
		return t && e.shellSuspendCounter++, Qi = Zi = null, G = r, D.H = i, D.A = a, q === null && (K = null, J = 0, oi()), o;
	}
	function ku() {
		for (; q !== null;) Mu(q);
	}
	function Au(e, t) {
		var n = G;
		G |= 2;
		var r = Tu(), a = Eu();
		K !== e || J !== t ? (nu = null, tu = Pe() + 500, Su(e, t)) : Hl = et(e, t);
		a: do
			try {
				if (Y !== 0 && q !== null) {
					t = q;
					var o = Bl;
					b: switch (Y) {
						case 1:
							Y = 0, Bl = null, Pu(e, t, o, 1);
							break;
						case 2:
						case 9:
							if (Aa(o)) {
								Y = 0, Bl = null, Nu(t);
								break;
							}
							t = function() {
								Y !== 2 && Y !== 9 || K !== e || (Y = 7), rd(e);
							}, o.then(t, t);
							break a;
						case 3:
							Y = 7;
							break a;
						case 4:
							Y = 5;
							break a;
						case 7:
							Aa(o) ? (Y = 0, Bl = null, Nu(t)) : (Y = 0, Bl = null, Pu(e, t, o, 7));
							break;
						case 5:
							var s = null;
							switch (q.tag) {
								case 26: s = q.memoizedState;
								case 5:
								case 27:
									var c = q;
									if (s ? Wf(s) : c.stateNode.complete) {
										Y = 0, Bl = null;
										var l = c.sibling;
										if (l !== null) q = l;
										else {
											var u = c.return;
											u === null ? q = null : (q = u, Fu(u));
										}
										break b;
									}
							}
							Y = 0, Bl = null, Pu(e, t, o, 5);
							break;
						case 6:
							Y = 0, Bl = null, Pu(e, t, o, 6);
							break;
						case 8:
							xu(), X = 6;
							break a;
						default: throw Error(i(462));
					}
				}
				ju();
				break;
			} catch (t) {
				Cu(e, t);
			}
		while (1);
		return Qi = Zi = null, D.H = r, D.A = a, G = n, q === null ? (K = null, J = 0, oi(), X) : 0;
	}
	function ju() {
		for (; q !== null && !Me();) Mu(q);
	}
	function Mu(e) {
		var t = Nc(e.alternate, e, Wl);
		e.memoizedProps = e.pendingProps, t === null ? Fu(e) : q = t;
	}
	function Nu(e) {
		var t = e, n = t.alternate;
		switch (t.tag) {
			case 15:
			case 0:
				t = _c(n, t, t.pendingProps, t.type, void 0, J);
				break;
			case 11:
				t = _c(n, t, t.pendingProps, t.type.render, t.ref, J);
				break;
			case 5: jo(t);
			default: Vc(n, t), t = q = _i(t, Wl), t = Nc(n, t, Wl);
		}
		e.memoizedProps = e.pendingProps, t === null ? Fu(e) : q = t;
	}
	function Pu(e, t, n, r) {
		Qi = Zi = null, jo(t), Ia = null, La = 0;
		var i = t.return;
		try {
			if (rc(e, i, t, n, J)) {
				X = 1, Qs(e, wi(n, e.current)), q = null;
				return;
			}
		} catch (t) {
			if (i !== null) throw q = i, t;
			X = 1, Qs(e, wi(n, e.current)), q = null;
			return;
		}
		t.flags & 32768 ? (P || r === 1 ? e = !0 : Hl || J & 536870912 ? e = !1 : (Vl = e = !0, (r === 2 || r === 9 || r === 3 || r === 6) && (r = so.current, r !== null && r.tag === 13 && (r.flags |= 16384))), Iu(t, e)) : Fu(t);
	}
	function Fu(e) {
		var t = e;
		do {
			if (t.flags & 32768) {
				Iu(t, Vl);
				return;
			}
			e = t.return;
			var n = zc(t.alternate, t, Wl);
			if (n !== null) {
				q = n;
				return;
			}
			if (t = t.sibling, t !== null) {
				q = t;
				return;
			}
			q = t = e;
		} while (t !== null);
		X === 0 && (X = 5);
	}
	function Iu(e, t) {
		do {
			var n = Bc(e.alternate, e);
			if (n !== null) {
				n.flags &= 32767, q = n;
				return;
			}
			if (n = e.return, n !== null && (n.flags |= 32768, n.subtreeFlags = 0, n.deletions = null), !t && (e = e.sibling, e !== null)) {
				q = e;
				return;
			}
			q = e = n;
		} while (e !== null);
		X = 6, q = null;
	}
	function Lu(e, t, n, r, a, o, s, c, l) {
		e.cancelPendingCommit = null;
		do
			Hu();
		while (iu !== 0);
		if (G & 6) throw Error(i(327));
		if (t !== null) {
			if (t === e.current) throw Error(i(177));
			if (o = t.lanes | t.childLanes, o |= ai, at(e, n, o, s, c, l), e === K && (q = K = null, J = 0), ou = t, au = e, su = n, cu = o, lu = a, uu = r, t.subtreeFlags & 10256 || t.flags & 10256 ? (e.callbackNode = null, e.callbackPriority = 0, Xu(Re, function() {
				return Uu(), null;
			})) : (e.callbackNode = null, e.callbackPriority = 0), r = !!(t.flags & 13878), t.subtreeFlags & 13878 || r) {
				r = D.T, D.T = null, a = O.p, O.p = 2, s = G, G |= 4;
				try {
					ol(e, t, n);
				} finally {
					G = s, O.p = a, D.T = r;
				}
			}
			iu = 1, Ru(), zu(), Bu();
		}
	}
	function Ru() {
		if (iu === 1) {
			iu = 0;
			var e = au, t = ou, n = !!(t.flags & 13878);
			if (t.subtreeFlags & 13878 || n) {
				n = D.T, D.T = null;
				var r = O.p;
				O.p = 2;
				var i = G;
				G |= 4;
				try {
					vl(t, e);
					var a = zd, o = Nr(e.containerInfo), s = a.focusedElem, c = a.selectionRange;
					if (o !== s && s && s.ownerDocument && Mr(s.ownerDocument.documentElement, s)) {
						if (c !== null && Pr(s)) {
							var l = c.start, u = c.end;
							if (u === void 0 && (u = l), "selectionStart" in s) s.selectionStart = l, s.selectionEnd = Math.min(u, s.value.length);
							else {
								var d = s.ownerDocument || document, f = d && d.defaultView || window;
								if (f.getSelection) {
									var p = f.getSelection(), m = s.textContent.length, h = Math.min(c.start, m), g = c.end === void 0 ? h : Math.min(c.end, m);
									!p.extend && h > g && (o = g, g = h, h = o);
									var _ = jr(s, h), v = jr(s, g);
									if (_ && v && (p.rangeCount !== 1 || p.anchorNode !== _.node || p.anchorOffset !== _.offset || p.focusNode !== v.node || p.focusOffset !== v.offset)) {
										var y = d.createRange();
										y.setStart(_.node, _.offset), p.removeAllRanges(), h > g ? (p.addRange(y), p.extend(v.node, v.offset)) : (y.setEnd(v.node, v.offset), p.addRange(y));
									}
								}
							}
						}
						for (d = [], p = s; p = p.parentNode;) p.nodeType === 1 && d.push({
							element: p,
							left: p.scrollLeft,
							top: p.scrollTop
						});
						for (typeof s.focus == "function" && s.focus(), s = 0; s < d.length; s++) {
							var b = d[s];
							b.element.scrollLeft = b.left, b.element.scrollTop = b.top;
						}
					}
					sp = !!Rd, zd = Rd = null;
				} finally {
					G = i, O.p = r, D.T = n;
				}
			}
			e.current = t, iu = 2;
		}
	}
	function zu() {
		if (iu === 2) {
			iu = 0;
			var e = au, t = ou, n = !!(t.flags & 8772);
			if (t.subtreeFlags & 8772 || n) {
				n = D.T, D.T = null;
				var r = O.p;
				O.p = 2;
				var i = G;
				G |= 4;
				try {
					sl(e, t.alternate, t);
				} finally {
					G = i, O.p = r, D.T = n;
				}
			}
			iu = 3;
		}
	}
	function Bu() {
		if (iu === 4 || iu === 3) {
			iu = 0, Ne();
			var e = au, t = ou, n = su, r = uu;
			t.subtreeFlags & 10256 || t.flags & 10256 ? iu = 5 : (iu = 0, ou = au = null, Vu(e, e.pendingLanes));
			var i = e.pendingLanes;
			if (i === 0 && (ru = null), ut(n), t = t.stateNode, A && typeof A.onCommitFiberRoot == "function") try {
				A.onCommitFiberRoot(Ue, t, void 0, (t.current.flags & 128) == 128);
			} catch {}
			if (r !== null) {
				t = D.T, i = O.p, O.p = 2, D.T = null;
				try {
					for (var a = e.onRecoverableError, o = 0; o < r.length; o++) {
						var s = r[o];
						a(s.value, { componentStack: s.stack });
					}
				} finally {
					D.T = t, O.p = i;
				}
			}
			su & 3 && Hu(), rd(e), i = e.pendingLanes, n & 261930 && i & 42 ? e === fu ? du++ : (du = 0, fu = e) : du = 0, id(0, !1);
		}
	}
	function Vu(e, t) {
		(e.pooledCacheLanes &= t) === 0 && (t = e.pooledCache, t != null && (e.pooledCache = null, pa(t)));
	}
	function Hu() {
		return Ru(), zu(), Bu(), Uu();
	}
	function Uu() {
		if (iu !== 5) return !1;
		var e = au, t = cu;
		cu = 0;
		var n = ut(su), r = D.T, a = O.p;
		try {
			O.p = 32 > n ? 32 : n, D.T = null, n = lu, lu = null;
			var o = au, s = su;
			if (iu = 0, ou = au = null, su = 0, G & 6) throw Error(i(331));
			var c = G;
			if (G |= 4, Fl(o.current), Dl(o, o.current, s, n), G = c, id(0, !1), A && typeof A.onPostCommitFiberRoot == "function") try {
				A.onPostCommitFiberRoot(Ue, o);
			} catch {}
			return !0;
		} finally {
			O.p = a, D.T = r, Vu(e, t);
		}
	}
	function Wu(e, t, n) {
		t = wi(n, t), t = ec(e.stateNode, t, 2), e = Ja(e, t, 2), e !== null && (it(e, 2), rd(e));
	}
	function Z(e, t, n) {
		if (e.tag === 3) Wu(e, e, n);
		else for (; t !== null;) {
			if (t.tag === 3) {
				Wu(t, e, n);
				break;
			}
			if (t.tag === 1) {
				var r = t.stateNode;
				if (typeof t.type.getDerivedStateFromError == "function" || typeof r.componentDidCatch == "function" && (ru === null || !ru.has(r))) {
					e = wi(n, e), n = tc(2), r = Ja(t, n, 2), r !== null && (nc(n, r, t, e), it(r, 2), rd(r));
					break;
				}
			}
			t = t.return;
		}
	}
	function Gu(e, t, n) {
		var r = e.pingCache;
		if (r === null) {
			r = e.pingCache = new zl();
			var i = /* @__PURE__ */ new Set();
			r.set(t, i);
		} else i = r.get(t), i === void 0 && (i = /* @__PURE__ */ new Set(), r.set(t, i));
		i.has(n) || (Ul = !0, i.add(n), e = Ku.bind(null, e, t, n), t.then(e, e));
	}
	function Ku(e, t, n) {
		var r = e.pingCache;
		r !== null && r.delete(t), e.pingedLanes |= e.suspendedLanes & n, e.warmLanes &= ~n, K === e && (J & n) === n && (X === 4 || X === 3 && (J & 62914560) === J && 300 > Pe() - $l ? !(G & 2) && Su(e, 0) : ql |= n, Yl === J && (Yl = 0)), rd(e);
	}
	function qu(e, t) {
		t === 0 && (t = nt()), e = li(e, t), e !== null && (it(e, t), rd(e));
	}
	function Ju(e) {
		var t = e.memoizedState, n = 0;
		t !== null && (n = t.retryLane), qu(e, n);
	}
	function Yu(e, t) {
		var n = 0;
		switch (e.tag) {
			case 31:
			case 13:
				var r = e.stateNode, a = e.memoizedState;
				a !== null && (n = a.retryLane);
				break;
			case 19:
				r = e.stateNode;
				break;
			case 22:
				r = e.stateNode._retryCache;
				break;
			default: throw Error(i(314));
		}
		r !== null && r.delete(t), qu(e, n);
	}
	function Xu(e, t) {
		return Ae(e, t);
	}
	var Zu = null, Qu = null, $u = !1, ed = !1, td = !1, nd = 0;
	function rd(e) {
		e !== Qu && e.next === null && (Qu === null ? Zu = Qu = e : Qu = Qu.next = e), ed = !0, $u || ($u = !0, ud());
	}
	function id(e, t) {
		if (!td && ed) {
			td = !0;
			do
				for (var n = !1, r = Zu; r !== null;) {
					if (!t) {
						if (e !== 0) {
							var i = r.pendingLanes;
							if (i === 0) var a = 0;
							else {
								var o = r.suspendedLanes, s = r.pingedLanes;
								a = (1 << 31 - Ge(42 | e) + 1) - 1, a &= i & ~(o & ~s), a = a & 201326741 ? a & 201326741 | 1 : a ? a | 2 : 0;
							}
							a !== 0 && (n = !0, ld(r, a));
						} else a = J, a = $e(r, r === K ? a : 0, r.cancelPendingCommit !== null || r.timeoutHandle !== -1), !(a & 3) || et(r, a) || (n = !0, ld(r, a));
					}
					r = r.next;
				}
			while (n);
			td = !1;
		}
	}
	function ad() {
		od();
	}
	function od() {
		ed = $u = !1;
		var e = 0;
		nd !== 0 && Gd() && (e = nd);
		for (var t = Pe(), n = null, r = Zu; r !== null;) {
			var i = r.next, a = sd(r, t);
			a === 0 ? (r.next = null, n === null ? Zu = i : n.next = i, i === null && (Qu = n)) : (n = r, (e !== 0 || a & 3) && (ed = !0)), r = i;
		}
		iu !== 0 && iu !== 5 || id(e, !1), nd !== 0 && (nd = 0);
	}
	function sd(e, t) {
		for (var n = e.suspendedLanes, r = e.pingedLanes, i = e.expirationTimes, a = e.pendingLanes & -62914561; 0 < a;) {
			var o = 31 - Ge(a), s = 1 << o, c = i[o];
			c === -1 ? ((s & n) === 0 || (s & r) !== 0) && (i[o] = tt(s, t)) : c <= t && (e.expiredLanes |= s), a &= ~s;
		}
		if (t = K, n = J, n = $e(e, e === t ? n : 0, e.cancelPendingCommit !== null || e.timeoutHandle !== -1), r = e.callbackNode, n === 0 || e === t && (Y === 2 || Y === 9) || e.cancelPendingCommit !== null) return r !== null && r !== null && je(r), e.callbackNode = null, e.callbackPriority = 0;
		if (!(n & 3) || et(e, n)) {
			if (t = n & -n, t === e.callbackPriority) return t;
			switch (r !== null && je(r), ut(n)) {
				case 2:
				case 8:
					n = Le;
					break;
				case 32:
					n = Re;
					break;
				case 268435456:
					n = Be;
					break;
				default: n = Re;
			}
			return r = cd.bind(null, e), n = Ae(n, r), e.callbackPriority = t, e.callbackNode = n, t;
		}
		return r !== null && r !== null && je(r), e.callbackPriority = 2, e.callbackNode = null, 2;
	}
	function cd(e, t) {
		if (iu !== 0 && iu !== 5) return e.callbackNode = null, e.callbackPriority = 0, null;
		var n = e.callbackNode;
		if (Hu() && e.callbackNode !== n) return null;
		var r = J;
		return r = $e(e, e === K ? r : 0, e.cancelPendingCommit !== null || e.timeoutHandle !== -1), r === 0 ? null : (gu(e, r, t), sd(e, Pe()), e.callbackNode != null && e.callbackNode === n ? cd.bind(null, e) : null);
	}
	function ld(e, t) {
		if (Hu()) return null;
		gu(e, t, !0);
	}
	function ud() {
		Yd(function() {
			G & 6 ? Ae(Ie, ad) : od();
		});
	}
	function dd() {
		if (nd === 0) {
			var e = ga;
			e === 0 && (e = Ye, Ye <<= 1, !(Ye & 261888) && (Ye = 256)), nd = e;
		}
		return nd;
	}
	function fd(e) {
		return e == null || typeof e == "symbol" || typeof e == "boolean" ? null : typeof e == "function" ? e : an("" + e);
	}
	function pd(e, t) {
		var n = t.ownerDocument.createElement("input");
		return n.name = t.name, n.value = t.value, e.id && n.setAttribute("form", e.id), t.parentNode.insertBefore(n, t), e = new FormData(e), n.parentNode.removeChild(n), e;
	}
	function md(e, t, n, r, i) {
		if (t === "submit" && n && n.stateNode === i) {
			var a = fd((i[pt] || null).action), o = r.submitter;
			o && (t = (t = o[pt] || null) ? fd(t.formAction) : o.getAttribute("formAction"), t !== null && (a = t, o = null));
			var s = new Dn("action", "action", null, r, i);
			e.push({
				event: s,
				listeners: [{
					instance: null,
					listener: function() {
						if (r.defaultPrevented) {
							if (nd !== 0) {
								var e = o ? pd(i, o) : new FormData(i);
								Es(n, {
									pending: !0,
									data: e,
									method: i.method,
									action: a
								}, null, e);
							}
						} else typeof a == "function" && (s.preventDefault(), e = o ? pd(i, o) : new FormData(i), Es(n, {
							pending: !0,
							data: e,
							method: i.method,
							action: a
						}, a, e));
					},
					currentTarget: i
				}]
			});
		}
	}
	for (var hd = 0; hd < ei.length; hd++) {
		var gd = ei[hd];
		ti(gd.toLowerCase(), "on" + (gd[0].toUpperCase() + gd.slice(1)));
	}
	ti(Kr, "onAnimationEnd"), ti(qr, "onAnimationIteration"), ti(Jr, "onAnimationStart"), ti("dblclick", "onDoubleClick"), ti("focusin", "onFocus"), ti("focusout", "onBlur"), ti(Yr, "onTransitionRun"), ti(Xr, "onTransitionStart"), ti(Zr, "onTransitionCancel"), ti(Qr, "onTransitionEnd"), kt("onMouseEnter", ["mouseout", "mouseover"]), kt("onMouseLeave", ["mouseout", "mouseover"]), kt("onPointerEnter", ["pointerout", "pointerover"]), kt("onPointerLeave", ["pointerout", "pointerover"]), Ot("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" ")), Ot("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")), Ot("onBeforeInput", [
		"compositionend",
		"keypress",
		"textInput",
		"paste"
	]), Ot("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" ")), Ot("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" ")), Ot("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
	var _d = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), vd = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat(_d));
	function yd(e, t) {
		t = !!(t & 4);
		for (var n = 0; n < e.length; n++) {
			var r = e[n], i = r.event;
			r = r.listeners;
			a: {
				var a = void 0;
				if (t) for (var o = r.length - 1; 0 <= o; o--) {
					var s = r[o], c = s.instance, l = s.currentTarget;
					if (s = s.listener, c !== a && i.isPropagationStopped()) break a;
					a = s, i.currentTarget = l;
					try {
						a(i);
					} catch (e) {
						ni(e);
					}
					i.currentTarget = null, a = c;
				}
				else for (o = 0; o < r.length; o++) {
					if (s = r[o], c = s.instance, l = s.currentTarget, s = s.listener, c !== a && i.isPropagationStopped()) break a;
					a = s, i.currentTarget = l;
					try {
						a(i);
					} catch (e) {
						ni(e);
					}
					i.currentTarget = null, a = c;
				}
			}
		}
	}
	function Q(e, t) {
		var n = t[ht];
		n === void 0 && (n = t[ht] = /* @__PURE__ */ new Set());
		var r = e + "__bubble";
		n.has(r) || (Cd(t, e, 2, !1), n.add(r));
	}
	function bd(e, t, n) {
		var r = 0;
		t && (r |= 4), Cd(n, e, r, t);
	}
	var xd = "_reactListening" + Math.random().toString(36).slice(2);
	function Sd(e) {
		if (!e[xd]) {
			e[xd] = !0, Et.forEach(function(t) {
				t !== "selectionchange" && (vd.has(t) || bd(t, !1, e), bd(t, !0, e));
			});
			var t = e.nodeType === 9 ? e : e.ownerDocument;
			t === null || t[xd] || (t[xd] = !0, bd("selectionchange", !1, t));
		}
	}
	function Cd(e, t, n, r) {
		switch (mp(t)) {
			case 2:
				var i = cp;
				break;
			case 8:
				i = lp;
				break;
			default: i = up;
		}
		n = i.bind(null, t, n, e), i = void 0, !gn || t !== "touchstart" && t !== "touchmove" && t !== "wheel" || (i = !0), r ? i === void 0 ? e.addEventListener(t, n, !0) : e.addEventListener(t, n, {
			capture: !0,
			passive: i
		}) : i === void 0 ? e.addEventListener(t, n, !1) : e.addEventListener(t, n, { passive: i });
	}
	function wd(e, t, n, r, i) {
		var a = r;
		if (!(t & 1) && !(t & 2) && r !== null) a: for (;;) {
			if (r === null) return;
			var s = r.tag;
			if (s === 3 || s === 4) {
				var c = r.stateNode.containerInfo;
				if (c === i) break;
				if (s === 4) for (s = r.return; s !== null;) {
					var l = s.tag;
					if ((l === 3 || l === 4) && s.stateNode.containerInfo === i) return;
					s = s.return;
				}
				for (; c !== null;) {
					if (s = xt(c), s === null) return;
					if (l = s.tag, l === 5 || l === 6 || l === 26 || l === 27) {
						r = a = s;
						continue a;
					}
					c = c.parentNode;
				}
			}
			r = r.return;
		}
		pn(function() {
			var r = a, i = cn(n), s = [];
			a: {
				var c = $r.get(e);
				if (c !== void 0) {
					var l = Dn, u = e;
					switch (e) {
						case "keypress": if (Sn(n) === 0) break a;
						case "keydown":
						case "keyup":
							l = Gn;
							break;
						case "focusin":
							u = "focus", l = In;
							break;
						case "focusout":
							u = "blur", l = In;
							break;
						case "beforeblur":
						case "afterblur":
							l = In;
							break;
						case "click": if (n.button === 2) break a;
						case "auxclick":
						case "dblclick":
						case "mousedown":
						case "mousemove":
						case "mouseup":
						case "mouseout":
						case "mouseover":
						case "contextmenu":
							l = Pn;
							break;
						case "drag":
						case "dragend":
						case "dragenter":
						case "dragexit":
						case "dragleave":
						case "dragover":
						case "dragstart":
						case "drop":
							l = Fn;
							break;
						case "touchcancel":
						case "touchend":
						case "touchmove":
						case "touchstart":
							l = qn;
							break;
						case Kr:
						case qr:
						case Jr:
							l = Ln;
							break;
						case Qr:
							l = Jn;
							break;
						case "scroll":
						case "scrollend":
							l = kn;
							break;
						case "wheel":
							l = Yn;
							break;
						case "copy":
						case "cut":
						case "paste":
							l = Rn;
							break;
						case "gotpointercapture":
						case "lostpointercapture":
						case "pointercancel":
						case "pointerdown":
						case "pointermove":
						case "pointerout":
						case "pointerover":
						case "pointerup":
							l = Kn;
							break;
						case "toggle":
						case "beforetoggle": l = Xn;
					}
					var d = !!(t & 4), f = !d && (e === "scroll" || e === "scrollend"), p = d ? c === null ? null : c + "Capture" : c;
					d = [];
					for (var m = r, h; m !== null;) {
						var g = m;
						if (h = g.stateNode, g = g.tag, g !== 5 && g !== 26 && g !== 27 || h === null || p === null || (g = mn(m, p), g != null && d.push(Td(m, g, h))), f) break;
						m = m.return;
					}
					0 < d.length && (c = new l(c, u, null, n, i), s.push({
						event: c,
						listeners: d
					}));
				}
			}
			if (!(t & 7)) {
				a: {
					if (c = e === "mouseover" || e === "pointerover", l = e === "mouseout" || e === "pointerout", c && n !== sn && (u = n.relatedTarget || n.fromElement) && (xt(u) || u[mt])) break a;
					if ((l || c) && (c = i.window === i ? i : (c = i.ownerDocument) ? c.defaultView || c.parentWindow : window, l ? (u = n.relatedTarget || n.toElement, l = r, u = u ? xt(u) : null, u !== null && (f = o(u), d = u.tag, u !== f || d !== 5 && d !== 27 && d !== 6) && (u = null)) : (l = null, u = r), l !== u)) {
						if (d = Pn, g = "onMouseLeave", p = "onMouseEnter", m = "mouse", (e === "pointerout" || e === "pointerover") && (d = Kn, g = "onPointerLeave", p = "onPointerEnter", m = "pointer"), f = l == null ? c : Ct(l), h = u == null ? c : Ct(u), c = new d(g, m + "leave", l, n, i), c.target = f, c.relatedTarget = h, g = null, xt(i) === r && (d = new d(p, m + "enter", u, n, i), d.target = h, d.relatedTarget = f, g = d), f = g, l && u) b: {
							for (d = Dd, p = l, m = u, h = 0, g = p; g; g = d(g)) h++;
							g = 0;
							for (var _ = m; _; _ = d(_)) g++;
							for (; 0 < h - g;) p = d(p), h--;
							for (; 0 < g - h;) m = d(m), g--;
							for (; h--;) {
								if (p === m || m !== null && p === m.alternate) {
									d = p;
									break b;
								}
								p = d(p), m = d(m);
							}
							d = null;
						}
						else d = null;
						l !== null && Od(s, c, l, d, !1), u !== null && f !== null && Od(s, f, u, d, !0);
					}
				}
				a: {
					if (c = r ? Ct(r) : window, l = c.nodeName && c.nodeName.toLowerCase(), l === "select" || l === "input" && c.type === "file") var v = gr;
					else if (ur(c)) {
						if (_r) v = Er;
						else {
							v = wr;
							var y = Cr;
						}
					} else l = c.nodeName, !l || l.toLowerCase() !== "input" || c.type !== "checkbox" && c.type !== "radio" ? r && tn(r.elementType) && (v = gr) : v = Tr;
					if (v &&= v(e, r)) {
						dr(s, v, n, i);
						break a;
					}
					y && y(e, c, r), e === "focusout" && r && c.type === "number" && r.memoizedProps.value != null && qt(c, "number", c.value);
				}
				switch (y = r ? Ct(r) : window, e) {
					case "focusin":
						(ur(y) || y.contentEditable === "true") && (Ir = y, Lr = r, Rr = null);
						break;
					case "focusout":
						Rr = Lr = Ir = null;
						break;
					case "mousedown":
						zr = !0;
						break;
					case "contextmenu":
					case "mouseup":
					case "dragend":
						zr = !1, Br(s, n, i);
						break;
					case "selectionchange": if (Fr) break;
					case "keydown":
					case "keyup": Br(s, n, i);
				}
				var b;
				if (Qn) b: {
					switch (e) {
						case "compositionstart":
							var x = "onCompositionStart";
							break b;
						case "compositionend":
							x = "onCompositionEnd";
							break b;
						case "compositionupdate":
							x = "onCompositionUpdate";
							break b;
					}
					x = void 0;
				}
				else or ? ir(e, n) && (x = "onCompositionEnd") : e === "keydown" && n.keyCode === 229 && (x = "onCompositionStart");
				x && (tr && n.locale !== "ko" && (or || x !== "onCompositionStart" ? x === "onCompositionEnd" && or && (b = xn()) : (vn = i, yn = "value" in vn ? vn.value : vn.textContent, or = !0)), y = Ed(r, x), 0 < y.length && (x = new zn(x, e, null, n, i), s.push({
					event: x,
					listeners: y
				}), b ? x.data = b : (b = ar(n), b !== null && (x.data = b)))), (b = er ? sr(e, n) : cr(e, n)) && (x = Ed(r, "onBeforeInput"), 0 < x.length && (y = new zn("onBeforeInput", "beforeinput", null, n, i), s.push({
					event: y,
					listeners: x
				}), y.data = b)), md(s, e, r, n, i);
			}
			yd(s, t);
		});
	}
	function Td(e, t, n) {
		return {
			instance: e,
			listener: t,
			currentTarget: n
		};
	}
	function Ed(e, t) {
		for (var n = t + "Capture", r = []; e !== null;) {
			var i = e, a = i.stateNode;
			if (i = i.tag, i !== 5 && i !== 26 && i !== 27 || a === null || (i = mn(e, n), i != null && r.unshift(Td(e, i, a)), i = mn(e, t), i != null && r.push(Td(e, i, a))), e.tag === 3) return r;
			e = e.return;
		}
		return [];
	}
	function Dd(e) {
		if (e === null) return null;
		do
			e = e.return;
		while (e && e.tag !== 5 && e.tag !== 27);
		return e || null;
	}
	function Od(e, t, n, r, i) {
		for (var a = t._reactName, o = []; n !== null && n !== r;) {
			var s = n, c = s.alternate, l = s.stateNode;
			if (s = s.tag, c !== null && c === r) break;
			s !== 5 && s !== 26 && s !== 27 || l === null || (c = l, i ? (l = mn(n, a), l != null && o.unshift(Td(n, l, c))) : i || (l = mn(n, a), l != null && o.push(Td(n, l, c)))), n = n.return;
		}
		o.length !== 0 && e.push({
			event: t,
			listeners: o
		});
	}
	var kd = /\r\n?/g, Ad = /\u0000|\uFFFD/g;
	function jd(e) {
		return (typeof e == "string" ? e : "" + e).replace(kd, "\n").replace(Ad, "");
	}
	function Md(e, t) {
		return t = jd(t), jd(e) === t;
	}
	function $(e, t, n, r, a, o) {
		switch (n) {
			case "children":
				typeof r == "string" ? t === "body" || t === "textarea" && r === "" || Zt(e, r) : (typeof r == "number" || typeof r == "bigint") && t !== "body" && Zt(e, "" + r);
				break;
			case "className":
				Ft(e, "class", r);
				break;
			case "tabIndex":
				Ft(e, "tabindex", r);
				break;
			case "dir":
			case "role":
			case "viewBox":
			case "width":
			case "height":
				Ft(e, n, r);
				break;
			case "style":
				en(e, r, o);
				break;
			case "data": if (t !== "object") {
				Ft(e, "data", r);
				break;
			}
			case "src":
			case "href":
				if (r === "" && (t !== "a" || n !== "href")) {
					e.removeAttribute(n);
					break;
				}
				if (r == null || typeof r == "function" || typeof r == "symbol" || typeof r == "boolean") {
					e.removeAttribute(n);
					break;
				}
				r = an("" + r), e.setAttribute(n, r);
				break;
			case "action":
			case "formAction":
				if (typeof r == "function") {
					e.setAttribute(n, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
					break;
				}
				if (typeof o == "function" && (n === "formAction" ? (t !== "input" && $(e, t, "name", a.name, a, null), $(e, t, "formEncType", a.formEncType, a, null), $(e, t, "formMethod", a.formMethod, a, null), $(e, t, "formTarget", a.formTarget, a, null)) : ($(e, t, "encType", a.encType, a, null), $(e, t, "method", a.method, a, null), $(e, t, "target", a.target, a, null))), r == null || typeof r == "symbol" || typeof r == "boolean") {
					e.removeAttribute(n);
					break;
				}
				r = an("" + r), e.setAttribute(n, r);
				break;
			case "onClick":
				r != null && (e.onclick = on);
				break;
			case "onScroll":
				r != null && Q("scroll", e);
				break;
			case "onScrollEnd":
				r != null && Q("scrollend", e);
				break;
			case "dangerouslySetInnerHTML":
				if (r != null) {
					if (typeof r != "object" || !("__html" in r)) throw Error(i(61));
					if (n = r.__html, n != null) {
						if (a.children != null) throw Error(i(60));
						e.innerHTML = n;
					}
				}
				break;
			case "multiple":
				e.multiple = r && typeof r != "function" && typeof r != "symbol";
				break;
			case "muted":
				e.muted = r && typeof r != "function" && typeof r != "symbol";
				break;
			case "suppressContentEditableWarning":
			case "suppressHydrationWarning":
			case "defaultValue":
			case "defaultChecked":
			case "innerHTML":
			case "ref": break;
			case "autoFocus": break;
			case "xlinkHref":
				if (r == null || typeof r == "function" || typeof r == "boolean" || typeof r == "symbol") {
					e.removeAttribute("xlink:href");
					break;
				}
				n = an("" + r), e.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", n);
				break;
			case "contentEditable":
			case "spellCheck":
			case "draggable":
			case "value":
			case "autoReverse":
			case "externalResourcesRequired":
			case "focusable":
			case "preserveAlpha":
				r != null && typeof r != "function" && typeof r != "symbol" ? e.setAttribute(n, "" + r) : e.removeAttribute(n);
				break;
			case "inert":
			case "allowFullScreen":
			case "async":
			case "autoPlay":
			case "controls":
			case "default":
			case "defer":
			case "disabled":
			case "disablePictureInPicture":
			case "disableRemotePlayback":
			case "formNoValidate":
			case "hidden":
			case "loop":
			case "noModule":
			case "noValidate":
			case "open":
			case "playsInline":
			case "readOnly":
			case "required":
			case "reversed":
			case "scoped":
			case "seamless":
			case "itemScope":
				r && typeof r != "function" && typeof r != "symbol" ? e.setAttribute(n, "") : e.removeAttribute(n);
				break;
			case "capture":
			case "download":
				!0 === r ? e.setAttribute(n, "") : !1 !== r && r != null && typeof r != "function" && typeof r != "symbol" ? e.setAttribute(n, r) : e.removeAttribute(n);
				break;
			case "cols":
			case "rows":
			case "size":
			case "span":
				r != null && typeof r != "function" && typeof r != "symbol" && !isNaN(r) && 1 <= r ? e.setAttribute(n, r) : e.removeAttribute(n);
				break;
			case "rowSpan":
			case "start":
				r == null || typeof r == "function" || typeof r == "symbol" || isNaN(r) ? e.removeAttribute(n) : e.setAttribute(n, r);
				break;
			case "popover":
				Q("beforetoggle", e), Q("toggle", e), Pt(e, "popover", r);
				break;
			case "xlinkActuate":
				It(e, "http://www.w3.org/1999/xlink", "xlink:actuate", r);
				break;
			case "xlinkArcrole":
				It(e, "http://www.w3.org/1999/xlink", "xlink:arcrole", r);
				break;
			case "xlinkRole":
				It(e, "http://www.w3.org/1999/xlink", "xlink:role", r);
				break;
			case "xlinkShow":
				It(e, "http://www.w3.org/1999/xlink", "xlink:show", r);
				break;
			case "xlinkTitle":
				It(e, "http://www.w3.org/1999/xlink", "xlink:title", r);
				break;
			case "xlinkType":
				It(e, "http://www.w3.org/1999/xlink", "xlink:type", r);
				break;
			case "xmlBase":
				It(e, "http://www.w3.org/XML/1998/namespace", "xml:base", r);
				break;
			case "xmlLang":
				It(e, "http://www.w3.org/XML/1998/namespace", "xml:lang", r);
				break;
			case "xmlSpace":
				It(e, "http://www.w3.org/XML/1998/namespace", "xml:space", r);
				break;
			case "is":
				Pt(e, "is", r);
				break;
			case "innerText":
			case "textContent": break;
			default: (!(2 < n.length) || n[0] !== "o" && n[0] !== "O" || n[1] !== "n" && n[1] !== "N") && (n = nn.get(n) || n, Pt(e, n, r));
		}
	}
	function Nd(e, t, n, r, a, o) {
		switch (n) {
			case "style":
				en(e, r, o);
				break;
			case "dangerouslySetInnerHTML":
				if (r != null) {
					if (typeof r != "object" || !("__html" in r)) throw Error(i(61));
					if (n = r.__html, n != null) {
						if (a.children != null) throw Error(i(60));
						e.innerHTML = n;
					}
				}
				break;
			case "children":
				typeof r == "string" ? Zt(e, r) : (typeof r == "number" || typeof r == "bigint") && Zt(e, "" + r);
				break;
			case "onScroll":
				r != null && Q("scroll", e);
				break;
			case "onScrollEnd":
				r != null && Q("scrollend", e);
				break;
			case "onClick":
				r != null && (e.onclick = on);
				break;
			case "suppressContentEditableWarning":
			case "suppressHydrationWarning":
			case "innerHTML":
			case "ref": break;
			case "innerText":
			case "textContent": break;
			default: if (!Dt.hasOwnProperty(n)) a: {
				if (n[0] === "o" && n[1] === "n" && (a = n.endsWith("Capture"), t = n.slice(2, a ? n.length - 7 : void 0), o = e[pt] || null, o = o == null ? null : o[n], typeof o == "function" && e.removeEventListener(t, o, a), typeof r == "function")) {
					typeof o != "function" && o !== null && (n in e ? e[n] = null : e.hasAttribute(n) && e.removeAttribute(n)), e.addEventListener(t, r, a);
					break a;
				}
				n in e ? e[n] = r : !0 === r ? e.setAttribute(n, "") : Pt(e, n, r);
			}
		}
	}
	function Pd(e, t, n) {
		switch (t) {
			case "div":
			case "span":
			case "svg":
			case "path":
			case "a":
			case "g":
			case "p":
			case "li": break;
			case "img":
				Q("error", e), Q("load", e);
				var r = !1, a = !1, o;
				for (o in n) if (n.hasOwnProperty(o)) {
					var s = n[o];
					if (s != null) switch (o) {
						case "src":
							r = !0;
							break;
						case "srcSet":
							a = !0;
							break;
						case "children":
						case "dangerouslySetInnerHTML": throw Error(i(137, t));
						default: $(e, t, o, s, n, null);
					}
				}
				a && $(e, t, "srcSet", n.srcSet, n, null), r && $(e, t, "src", n.src, n, null);
				return;
			case "input":
				Q("invalid", e);
				var c = o = s = a = null, l = null, u = null;
				for (r in n) if (n.hasOwnProperty(r)) {
					var d = n[r];
					if (d != null) switch (r) {
						case "name":
							a = d;
							break;
						case "type":
							s = d;
							break;
						case "checked":
							l = d;
							break;
						case "defaultChecked":
							u = d;
							break;
						case "value":
							o = d;
							break;
						case "defaultValue":
							c = d;
							break;
						case "children":
						case "dangerouslySetInnerHTML":
							if (d != null) throw Error(i(137, t));
							break;
						default: $(e, t, r, d, n, null);
					}
				}
				Kt(e, o, c, l, u, s, a, !1);
				return;
			case "select":
				for (a in Q("invalid", e), r = s = o = null, n) if (n.hasOwnProperty(a) && (c = n[a], c != null)) switch (a) {
					case "value":
						o = c;
						break;
					case "defaultValue":
						s = c;
						break;
					case "multiple": r = c;
					default: $(e, t, a, c, n, null);
				}
				t = o, n = s, e.multiple = !!r, t == null ? n != null && Jt(e, !!r, n, !0) : Jt(e, !!r, t, !1);
				return;
			case "textarea":
				for (s in Q("invalid", e), o = a = r = null, n) if (n.hasOwnProperty(s) && (c = n[s], c != null)) switch (s) {
					case "value":
						r = c;
						break;
					case "defaultValue":
						a = c;
						break;
					case "children":
						o = c;
						break;
					case "dangerouslySetInnerHTML":
						if (c != null) throw Error(i(91));
						break;
					default: $(e, t, s, c, n, null);
				}
				Xt(e, r, a, o);
				return;
			case "option":
				for (l in n) if (n.hasOwnProperty(l) && (r = n[l], r != null)) switch (l) {
					case "selected":
						e.selected = r && typeof r != "function" && typeof r != "symbol";
						break;
					default: $(e, t, l, r, n, null);
				}
				return;
			case "dialog":
				Q("beforetoggle", e), Q("toggle", e), Q("cancel", e), Q("close", e);
				break;
			case "iframe":
			case "object":
				Q("load", e);
				break;
			case "video":
			case "audio":
				for (r = 0; r < _d.length; r++) Q(_d[r], e);
				break;
			case "image":
				Q("error", e), Q("load", e);
				break;
			case "details":
				Q("toggle", e);
				break;
			case "embed":
			case "source":
			case "link": Q("error", e), Q("load", e);
			case "area":
			case "base":
			case "br":
			case "col":
			case "hr":
			case "keygen":
			case "meta":
			case "param":
			case "track":
			case "wbr":
			case "menuitem":
				for (u in n) if (n.hasOwnProperty(u) && (r = n[u], r != null)) switch (u) {
					case "children":
					case "dangerouslySetInnerHTML": throw Error(i(137, t));
					default: $(e, t, u, r, n, null);
				}
				return;
			default: if (tn(t)) {
				for (d in n) n.hasOwnProperty(d) && (r = n[d], r !== void 0 && Nd(e, t, d, r, n, void 0));
				return;
			}
		}
		for (c in n) n.hasOwnProperty(c) && (r = n[c], r != null && $(e, t, c, r, n, null));
	}
	function Fd(e, t, n, r) {
		switch (t) {
			case "div":
			case "span":
			case "svg":
			case "path":
			case "a":
			case "g":
			case "p":
			case "li": break;
			case "input":
				var a = null, o = null, s = null, c = null, l = null, u = null, d = null;
				for (m in n) {
					var f = n[m];
					if (n.hasOwnProperty(m) && f != null) switch (m) {
						case "checked": break;
						case "value": break;
						case "defaultValue": l = f;
						default: r.hasOwnProperty(m) || $(e, t, m, null, r, f);
					}
				}
				for (var p in r) {
					var m = r[p];
					if (f = n[p], r.hasOwnProperty(p) && (m != null || f != null)) switch (p) {
						case "type":
							o = m;
							break;
						case "name":
							a = m;
							break;
						case "checked":
							u = m;
							break;
						case "defaultChecked":
							d = m;
							break;
						case "value":
							s = m;
							break;
						case "defaultValue":
							c = m;
							break;
						case "children":
						case "dangerouslySetInnerHTML":
							if (m != null) throw Error(i(137, t));
							break;
						default: m !== f && $(e, t, p, m, r, f);
					}
				}
				Gt(e, s, c, l, u, d, o, a);
				return;
			case "select":
				for (o in m = s = c = p = null, n) if (l = n[o], n.hasOwnProperty(o) && l != null) switch (o) {
					case "value": break;
					case "multiple": m = l;
					default: r.hasOwnProperty(o) || $(e, t, o, null, r, l);
				}
				for (a in r) if (o = r[a], l = n[a], r.hasOwnProperty(a) && (o != null || l != null)) switch (a) {
					case "value":
						p = o;
						break;
					case "defaultValue":
						c = o;
						break;
					case "multiple": s = o;
					default: o !== l && $(e, t, a, o, r, l);
				}
				t = c, n = s, r = m, p == null ? !!r != !!n && (t == null ? Jt(e, !!n, n ? [] : "", !1) : Jt(e, !!n, t, !0)) : Jt(e, !!n, p, !1);
				return;
			case "textarea":
				for (c in m = p = null, n) if (a = n[c], n.hasOwnProperty(c) && a != null && !r.hasOwnProperty(c)) switch (c) {
					case "value": break;
					case "children": break;
					default: $(e, t, c, null, r, a);
				}
				for (s in r) if (a = r[s], o = n[s], r.hasOwnProperty(s) && (a != null || o != null)) switch (s) {
					case "value":
						p = a;
						break;
					case "defaultValue":
						m = a;
						break;
					case "children": break;
					case "dangerouslySetInnerHTML":
						if (a != null) throw Error(i(91));
						break;
					default: a !== o && $(e, t, s, a, r, o);
				}
				Yt(e, p, m);
				return;
			case "option":
				for (var h in n) if (p = n[h], n.hasOwnProperty(h) && p != null && !r.hasOwnProperty(h)) switch (h) {
					case "selected":
						e.selected = !1;
						break;
					default: $(e, t, h, null, r, p);
				}
				for (l in r) if (p = r[l], m = n[l], r.hasOwnProperty(l) && p !== m && (p != null || m != null)) switch (l) {
					case "selected":
						e.selected = p && typeof p != "function" && typeof p != "symbol";
						break;
					default: $(e, t, l, p, r, m);
				}
				return;
			case "img":
			case "link":
			case "area":
			case "base":
			case "br":
			case "col":
			case "embed":
			case "hr":
			case "keygen":
			case "meta":
			case "param":
			case "source":
			case "track":
			case "wbr":
			case "menuitem":
				for (var g in n) p = n[g], n.hasOwnProperty(g) && p != null && !r.hasOwnProperty(g) && $(e, t, g, null, r, p);
				for (u in r) if (p = r[u], m = n[u], r.hasOwnProperty(u) && p !== m && (p != null || m != null)) switch (u) {
					case "children":
					case "dangerouslySetInnerHTML":
						if (p != null) throw Error(i(137, t));
						break;
					default: $(e, t, u, p, r, m);
				}
				return;
			default: if (tn(t)) {
				for (var _ in n) p = n[_], n.hasOwnProperty(_) && p !== void 0 && !r.hasOwnProperty(_) && Nd(e, t, _, void 0, r, p);
				for (d in r) p = r[d], m = n[d], !r.hasOwnProperty(d) || p === m || p === void 0 && m === void 0 || Nd(e, t, d, p, r, m);
				return;
			}
		}
		for (var v in n) p = n[v], n.hasOwnProperty(v) && p != null && !r.hasOwnProperty(v) && $(e, t, v, null, r, p);
		for (f in r) p = r[f], m = n[f], !r.hasOwnProperty(f) || p === m || p == null && m == null || $(e, t, f, p, r, m);
	}
	function Id(e) {
		switch (e) {
			case "css":
			case "script":
			case "font":
			case "img":
			case "image":
			case "input":
			case "link": return !0;
			default: return !1;
		}
	}
	function Ld() {
		if (typeof performance.getEntriesByType == "function") {
			for (var e = 0, t = 0, n = performance.getEntriesByType("resource"), r = 0; r < n.length; r++) {
				var i = n[r], a = i.transferSize, o = i.initiatorType, s = i.duration;
				if (a && s && Id(o)) {
					for (o = 0, s = i.responseEnd, r += 1; r < n.length; r++) {
						var c = n[r], l = c.startTime;
						if (l > s) break;
						var u = c.transferSize, d = c.initiatorType;
						u && Id(d) && (c = c.responseEnd, o += u * (c < s ? 1 : (s - l) / (c - l)));
					}
					if (--r, t += 8 * (a + o) / (i.duration / 1e3), e++, 10 < e) break;
				}
			}
			if (0 < e) return t / e / 1e6;
		}
		return navigator.connection && (e = navigator.connection.downlink, typeof e == "number") ? e : 5;
	}
	var Rd = null, zd = null;
	function Bd(e) {
		return e.nodeType === 9 ? e : e.ownerDocument;
	}
	function Vd(e) {
		switch (e) {
			case "http://www.w3.org/2000/svg": return 1;
			case "http://www.w3.org/1998/Math/MathML": return 2;
			default: return 0;
		}
	}
	function Hd(e, t) {
		if (e === 0) switch (t) {
			case "svg": return 1;
			case "math": return 2;
			default: return 0;
		}
		return e === 1 && t === "foreignObject" ? 0 : e;
	}
	function Ud(e, t) {
		return e === "textarea" || e === "noscript" || typeof t.children == "string" || typeof t.children == "number" || typeof t.children == "bigint" || typeof t.dangerouslySetInnerHTML == "object" && t.dangerouslySetInnerHTML !== null && t.dangerouslySetInnerHTML.__html != null;
	}
	var Wd = null;
	function Gd() {
		var e = window.event;
		return e && e.type === "popstate" ? e !== Wd && (Wd = e, !0) : (Wd = null, !1);
	}
	var Kd = typeof setTimeout == "function" ? setTimeout : void 0, qd = typeof clearTimeout == "function" ? clearTimeout : void 0, Jd = typeof Promise == "function" ? Promise : void 0, Yd = typeof queueMicrotask == "function" ? queueMicrotask : Jd === void 0 ? Kd : function(e) {
		return Jd.resolve(null).then(e).catch(Xd);
	};
	function Xd(e) {
		setTimeout(function() {
			throw e;
		});
	}
	function Zd(e) {
		return e === "head";
	}
	function Qd(e, t) {
		var n = t, r = 0;
		do {
			var i = n.nextSibling;
			if (e.removeChild(n), i && i.nodeType === 8) {
				if (n = i.data, n === "/$" || n === "/&") {
					if (r === 0) {
						e.removeChild(i), Np(t);
						return;
					}
					r--;
				} else if (n === "$" || n === "$?" || n === "$~" || n === "$!" || n === "&") r++;
				else if (n === "html") pf(e.ownerDocument.documentElement);
				else if (n === "head") {
					n = e.ownerDocument.head, pf(n);
					for (var a = n.firstChild; a;) {
						var o = a.nextSibling, s = a.nodeName;
						a[yt] || s === "SCRIPT" || s === "STYLE" || s === "LINK" && a.rel.toLowerCase() === "stylesheet" || n.removeChild(a), a = o;
					}
				} else n === "body" && pf(e.ownerDocument.body);
			}
			n = i;
		} while (n);
		Np(t);
	}
	function $d(e, t) {
		var n = e;
		e = 0;
		do {
			var r = n.nextSibling;
			if (n.nodeType === 1 ? t ? (n._stashedDisplay = n.style.display, n.style.display = "none") : (n.style.display = n._stashedDisplay || "", n.getAttribute("style") === "" && n.removeAttribute("style")) : n.nodeType === 3 && (t ? (n._stashedText = n.nodeValue, n.nodeValue = "") : n.nodeValue = n._stashedText || ""), r && r.nodeType === 8) {
				if (n = r.data, n === "/$") {
					if (e === 0) break;
					e--;
				} else n !== "$" && n !== "$?" && n !== "$~" && n !== "$!" || e++;
			}
			n = r;
		} while (n);
	}
	function ef(e) {
		var t = e.firstChild;
		for (t && t.nodeType === 10 && (t = t.nextSibling); t;) {
			var n = t;
			switch (t = t.nextSibling, n.nodeName) {
				case "HTML":
				case "HEAD":
				case "BODY":
					ef(n), bt(n);
					continue;
				case "SCRIPT":
				case "STYLE": continue;
				case "LINK": if (n.rel.toLowerCase() === "stylesheet") continue;
			}
			e.removeChild(n);
		}
	}
	function tf(e, t, n, r) {
		for (; e.nodeType === 1;) {
			var i = n;
			if (e.nodeName.toLowerCase() !== t.toLowerCase()) {
				if (!r && (e.nodeName !== "INPUT" || e.type !== "hidden")) break;
			} else if (!r) {
				if (t === "input" && e.type === "hidden") {
					var a = i.name == null ? null : "" + i.name;
					if (i.type === "hidden" && e.getAttribute("name") === a) return e;
				} else return e;
			} else if (!e[yt]) switch (t) {
				case "meta":
					if (!e.hasAttribute("itemprop")) break;
					return e;
				case "link":
					if (a = e.getAttribute("rel"), a === "stylesheet" && e.hasAttribute("data-precedence") || a !== i.rel || e.getAttribute("href") !== (i.href == null || i.href === "" ? null : i.href) || e.getAttribute("crossorigin") !== (i.crossOrigin == null ? null : i.crossOrigin) || e.getAttribute("title") !== (i.title == null ? null : i.title)) break;
					return e;
				case "style":
					if (e.hasAttribute("data-precedence")) break;
					return e;
				case "script":
					if (a = e.getAttribute("src"), (a !== (i.src == null ? null : i.src) || e.getAttribute("type") !== (i.type == null ? null : i.type) || e.getAttribute("crossorigin") !== (i.crossOrigin == null ? null : i.crossOrigin)) && a && e.hasAttribute("async") && !e.hasAttribute("itemprop")) break;
					return e;
				default: return e;
			}
			if (e = cf(e.nextSibling), e === null) break;
		}
		return null;
	}
	function nf(e, t, n) {
		if (t === "") return null;
		for (; e.nodeType !== 3;) if ((e.nodeType !== 1 || e.nodeName !== "INPUT" || e.type !== "hidden") && !n || (e = cf(e.nextSibling), e === null)) return null;
		return e;
	}
	function rf(e, t) {
		for (; e.nodeType !== 8;) if ((e.nodeType !== 1 || e.nodeName !== "INPUT" || e.type !== "hidden") && !t || (e = cf(e.nextSibling), e === null)) return null;
		return e;
	}
	function af(e) {
		return e.data === "$?" || e.data === "$~";
	}
	function of(e) {
		return e.data === "$!" || e.data === "$?" && e.ownerDocument.readyState !== "loading";
	}
	function sf(e, t) {
		var n = e.ownerDocument;
		if (e.data === "$~") e._reactRetry = t;
		else if (e.data !== "$?" || n.readyState !== "loading") t();
		else {
			var r = function() {
				t(), n.removeEventListener("DOMContentLoaded", r);
			};
			n.addEventListener("DOMContentLoaded", r), e._reactRetry = r;
		}
	}
	function cf(e) {
		for (; e != null; e = e.nextSibling) {
			var t = e.nodeType;
			if (t === 1 || t === 3) break;
			if (t === 8) {
				if (t = e.data, t === "$" || t === "$!" || t === "$?" || t === "$~" || t === "&" || t === "F!" || t === "F") break;
				if (t === "/$" || t === "/&") return null;
			}
		}
		return e;
	}
	var lf = null;
	function uf(e) {
		e = e.nextSibling;
		for (var t = 0; e;) {
			if (e.nodeType === 8) {
				var n = e.data;
				if (n === "/$" || n === "/&") {
					if (t === 0) return cf(e.nextSibling);
					t--;
				} else n !== "$" && n !== "$!" && n !== "$?" && n !== "$~" && n !== "&" || t++;
			}
			e = e.nextSibling;
		}
		return null;
	}
	function df(e) {
		e = e.previousSibling;
		for (var t = 0; e;) {
			if (e.nodeType === 8) {
				var n = e.data;
				if (n === "$" || n === "$!" || n === "$?" || n === "$~" || n === "&") {
					if (t === 0) return e;
					t--;
				} else n !== "/$" && n !== "/&" || t++;
			}
			e = e.previousSibling;
		}
		return null;
	}
	function ff(e, t, n) {
		switch (t = Bd(n), e) {
			case "html":
				if (e = t.documentElement, !e) throw Error(i(452));
				return e;
			case "head":
				if (e = t.head, !e) throw Error(i(453));
				return e;
			case "body":
				if (e = t.body, !e) throw Error(i(454));
				return e;
			default: throw Error(i(451));
		}
	}
	function pf(e) {
		for (var t = e.attributes; t.length;) e.removeAttributeNode(t[0]);
		bt(e);
	}
	var mf = /* @__PURE__ */ new Map(), hf = /* @__PURE__ */ new Set();
	function gf(e) {
		return typeof e.getRootNode == "function" ? e.getRootNode() : e.nodeType === 9 ? e : e.ownerDocument;
	}
	var _f = O.d;
	O.d = {
		f: vf,
		r: yf,
		D: Sf,
		C: Cf,
		L: wf,
		m: Tf,
		X: Df,
		S: Ef,
		M: Of
	};
	function vf() {
		var e = _f.f(), t = bu();
		return e || t;
	}
	function yf(e) {
		var t = St(e);
		t !== null && t.tag === 5 && t.type === "form" ? Os(t) : _f.r(e);
	}
	var bf = typeof document > "u" ? null : document;
	function xf(e, t, n) {
		var r = bf;
		if (r && typeof t == "string" && t) {
			var i = Wt(t);
			i = "link[rel=\"" + e + "\"][href=\"" + i + "\"]", typeof n == "string" && (i += "[crossorigin=\"" + n + "\"]"), hf.has(i) || (hf.add(i), e = {
				rel: e,
				crossOrigin: n,
				href: t
			}, r.querySelector(i) === null && (t = r.createElement("link"), Pd(t, "link", e), Tt(t), r.head.appendChild(t)));
		}
	}
	function Sf(e) {
		_f.D(e), xf("dns-prefetch", e, null);
	}
	function Cf(e, t) {
		_f.C(e, t), xf("preconnect", e, t);
	}
	function wf(e, t, n) {
		_f.L(e, t, n);
		var r = bf;
		if (r && e && t) {
			var i = "link[rel=\"preload\"][as=\"" + Wt(t) + "\"]";
			t === "image" && n && n.imageSrcSet ? (i += "[imagesrcset=\"" + Wt(n.imageSrcSet) + "\"]", typeof n.imageSizes == "string" && (i += "[imagesizes=\"" + Wt(n.imageSizes) + "\"]")) : i += "[href=\"" + Wt(e) + "\"]";
			var a = i;
			switch (t) {
				case "style":
					a = Af(e);
					break;
				case "script": a = Pf(e);
			}
			mf.has(a) || (e = h({
				rel: "preload",
				href: t === "image" && n && n.imageSrcSet ? void 0 : e,
				as: t
			}, n), mf.set(a, e), r.querySelector(i) !== null || t === "style" && r.querySelector(jf(a)) || t === "script" && r.querySelector(Ff(a)) || (t = r.createElement("link"), Pd(t, "link", e), Tt(t), r.head.appendChild(t)));
		}
	}
	function Tf(e, t) {
		_f.m(e, t);
		var n = bf;
		if (n && e) {
			var r = t && typeof t.as == "string" ? t.as : "script", i = "link[rel=\"modulepreload\"][as=\"" + Wt(r) + "\"][href=\"" + Wt(e) + "\"]", a = i;
			switch (r) {
				case "audioworklet":
				case "paintworklet":
				case "serviceworker":
				case "sharedworker":
				case "worker":
				case "script": a = Pf(e);
			}
			if (!mf.has(a) && (e = h({
				rel: "modulepreload",
				href: e
			}, t), mf.set(a, e), n.querySelector(i) === null)) {
				switch (r) {
					case "audioworklet":
					case "paintworklet":
					case "serviceworker":
					case "sharedworker":
					case "worker":
					case "script": if (n.querySelector(Ff(a))) return;
				}
				r = n.createElement("link"), Pd(r, "link", e), Tt(r), n.head.appendChild(r);
			}
		}
	}
	function Ef(e, t, n) {
		_f.S(e, t, n);
		var r = bf;
		if (r && e) {
			var i = wt(r).hoistableStyles, a = Af(e);
			t ||= "default";
			var o = i.get(a);
			if (!o) {
				var s = {
					loading: 0,
					preload: null
				};
				if (o = r.querySelector(jf(a))) s.loading = 5;
				else {
					e = h({
						rel: "stylesheet",
						href: e,
						"data-precedence": t
					}, n), (n = mf.get(a)) && Rf(e, n);
					var c = o = r.createElement("link");
					Tt(c), Pd(c, "link", e), c._p = new Promise(function(e, t) {
						c.onload = e, c.onerror = t;
					}), c.addEventListener("load", function() {
						s.loading |= 1;
					}), c.addEventListener("error", function() {
						s.loading |= 2;
					}), s.loading |= 4, Lf(o, t, r);
				}
				o = {
					type: "stylesheet",
					instance: o,
					count: 1,
					state: s
				}, i.set(a, o);
			}
		}
	}
	function Df(e, t) {
		_f.X(e, t);
		var n = bf;
		if (n && e) {
			var r = wt(n).hoistableScripts, i = Pf(e), a = r.get(i);
			a || (a = n.querySelector(Ff(i)), a || (e = h({
				src: e,
				async: !0
			}, t), (t = mf.get(i)) && zf(e, t), a = n.createElement("script"), Tt(a), Pd(a, "link", e), n.head.appendChild(a)), a = {
				type: "script",
				instance: a,
				count: 1,
				state: null
			}, r.set(i, a));
		}
	}
	function Of(e, t) {
		_f.M(e, t);
		var n = bf;
		if (n && e) {
			var r = wt(n).hoistableScripts, i = Pf(e), a = r.get(i);
			a || (a = n.querySelector(Ff(i)), a || (e = h({
				src: e,
				async: !0,
				type: "module"
			}, t), (t = mf.get(i)) && zf(e, t), a = n.createElement("script"), Tt(a), Pd(a, "link", e), n.head.appendChild(a)), a = {
				type: "script",
				instance: a,
				count: 1,
				state: null
			}, r.set(i, a));
		}
	}
	function kf(e, t, n, r) {
		var a = (a = ge.current) ? gf(a) : null;
		if (!a) throw Error(i(446));
		switch (e) {
			case "meta":
			case "title": return null;
			case "style": return typeof n.precedence == "string" && typeof n.href == "string" ? (t = Af(n.href), n = wt(a).hoistableStyles, r = n.get(t), r || (r = {
				type: "style",
				instance: null,
				count: 0,
				state: null
			}, n.set(t, r)), r) : {
				type: "void",
				instance: null,
				count: 0,
				state: null
			};
			case "link":
				if (n.rel === "stylesheet" && typeof n.href == "string" && typeof n.precedence == "string") {
					e = Af(n.href);
					var o = wt(a).hoistableStyles, s = o.get(e);
					if (s || (a = a.ownerDocument || a, s = {
						type: "stylesheet",
						instance: null,
						count: 0,
						state: {
							loading: 0,
							preload: null
						}
					}, o.set(e, s), (o = a.querySelector(jf(e))) && !o._p && (s.instance = o, s.state.loading = 5), mf.has(e) || (n = {
						rel: "preload",
						as: "style",
						href: n.href,
						crossOrigin: n.crossOrigin,
						integrity: n.integrity,
						media: n.media,
						hrefLang: n.hrefLang,
						referrerPolicy: n.referrerPolicy
					}, mf.set(e, n), o || Nf(a, e, n, s.state))), t && r === null) throw Error(i(528, ""));
					return s;
				}
				if (t && r !== null) throw Error(i(529, ""));
				return null;
			case "script": return t = n.async, n = n.src, typeof n == "string" && t && typeof t != "function" && typeof t != "symbol" ? (t = Pf(n), n = wt(a).hoistableScripts, r = n.get(t), r || (r = {
				type: "script",
				instance: null,
				count: 0,
				state: null
			}, n.set(t, r)), r) : {
				type: "void",
				instance: null,
				count: 0,
				state: null
			};
			default: throw Error(i(444, e));
		}
	}
	function Af(e) {
		return "href=\"" + Wt(e) + "\"";
	}
	function jf(e) {
		return "link[rel=\"stylesheet\"][" + e + "]";
	}
	function Mf(e) {
		return h({}, e, {
			"data-precedence": e.precedence,
			precedence: null
		});
	}
	function Nf(e, t, n, r) {
		e.querySelector("link[rel=\"preload\"][as=\"style\"][" + t + "]") ? r.loading = 1 : (t = e.createElement("link"), r.preload = t, t.addEventListener("load", function() {
			return r.loading |= 1;
		}), t.addEventListener("error", function() {
			return r.loading |= 2;
		}), Pd(t, "link", n), Tt(t), e.head.appendChild(t));
	}
	function Pf(e) {
		return "[src=\"" + Wt(e) + "\"]";
	}
	function Ff(e) {
		return "script[async]" + e;
	}
	function If(e, t, n) {
		if (t.count++, t.instance === null) switch (t.type) {
			case "style":
				var r = e.querySelector("style[data-href~=\"" + Wt(n.href) + "\"]");
				if (r) return t.instance = r, Tt(r), r;
				var a = h({}, n, {
					"data-href": n.href,
					"data-precedence": n.precedence,
					href: null,
					precedence: null
				});
				return r = (e.ownerDocument || e).createElement("style"), Tt(r), Pd(r, "style", a), Lf(r, n.precedence, e), t.instance = r;
			case "stylesheet":
				a = Af(n.href);
				var o = e.querySelector(jf(a));
				if (o) return t.state.loading |= 4, t.instance = o, Tt(o), o;
				r = Mf(n), (a = mf.get(a)) && Rf(r, a), o = (e.ownerDocument || e).createElement("link"), Tt(o);
				var s = o;
				return s._p = new Promise(function(e, t) {
					s.onload = e, s.onerror = t;
				}), Pd(o, "link", r), t.state.loading |= 4, Lf(o, n.precedence, e), t.instance = o;
			case "script": return o = Pf(n.src), (a = e.querySelector(Ff(o))) ? (t.instance = a, Tt(a), a) : (r = n, (a = mf.get(o)) && (r = h({}, n), zf(r, a)), e = e.ownerDocument || e, a = e.createElement("script"), Tt(a), Pd(a, "link", r), e.head.appendChild(a), t.instance = a);
			case "void": return null;
			default: throw Error(i(443, t.type));
		}
		else t.type === "stylesheet" && !(t.state.loading & 4) && (r = t.instance, t.state.loading |= 4, Lf(r, n.precedence, e));
		return t.instance;
	}
	function Lf(e, t, n) {
		for (var r = n.querySelectorAll("link[rel=\"stylesheet\"][data-precedence],style[data-precedence]"), i = r.length ? r[r.length - 1] : null, a = i, o = 0; o < r.length; o++) {
			var s = r[o];
			if (s.dataset.precedence === t) a = s;
			else if (a !== i) break;
		}
		a ? a.parentNode.insertBefore(e, a.nextSibling) : (t = n.nodeType === 9 ? n.head : n, t.insertBefore(e, t.firstChild));
	}
	function Rf(e, t) {
		e.crossOrigin ??= t.crossOrigin, e.referrerPolicy ??= t.referrerPolicy, e.title ??= t.title;
	}
	function zf(e, t) {
		e.crossOrigin ??= t.crossOrigin, e.referrerPolicy ??= t.referrerPolicy, e.integrity ??= t.integrity;
	}
	var Bf = null;
	function Vf(e, t, n) {
		if (Bf === null) {
			var r = /* @__PURE__ */ new Map(), i = Bf = /* @__PURE__ */ new Map();
			i.set(n, r);
		} else i = Bf, r = i.get(n), r || (r = /* @__PURE__ */ new Map(), i.set(n, r));
		if (r.has(e)) return r;
		for (r.set(e, null), n = n.getElementsByTagName(e), i = 0; i < n.length; i++) {
			var a = n[i];
			if (!(a[yt] || a[M] || e === "link" && a.getAttribute("rel") === "stylesheet") && a.namespaceURI !== "http://www.w3.org/2000/svg") {
				var o = a.getAttribute(t) || "";
				o = e + o;
				var s = r.get(o);
				s ? s.push(a) : r.set(o, [a]);
			}
		}
		return r;
	}
	function Hf(e, t, n) {
		e = e.ownerDocument || e, e.head.insertBefore(n, t === "title" ? e.querySelector("head > title") : null);
	}
	function Uf(e, t, n) {
		if (n === 1 || t.itemProp != null) return !1;
		switch (e) {
			case "meta":
			case "title": return !0;
			case "style":
				if (typeof t.precedence != "string" || typeof t.href != "string" || t.href === "") break;
				return !0;
			case "link":
				if (typeof t.rel != "string" || typeof t.href != "string" || t.href === "" || t.onLoad || t.onError) break;
				switch (t.rel) {
					case "stylesheet": return e = t.disabled, typeof t.precedence == "string" && e == null;
					default: return !0;
				}
			case "script": if (t.async && typeof t.async != "function" && typeof t.async != "symbol" && !t.onLoad && !t.onError && t.src && typeof t.src == "string") return !0;
		}
		return !1;
	}
	function Wf(e) {
		return !(e.type === "stylesheet" && !(e.state.loading & 3));
	}
	function Gf(e, t, n, r) {
		if (n.type === "stylesheet" && (typeof r.media != "string" || !1 !== matchMedia(r.media).matches) && !(n.state.loading & 4)) {
			if (n.instance === null) {
				var i = Af(r.href), a = t.querySelector(jf(i));
				if (a) {
					t = a._p, typeof t == "object" && t && typeof t.then == "function" && (e.count++, e = Jf.bind(e), t.then(e, e)), n.state.loading |= 4, n.instance = a, Tt(a);
					return;
				}
				a = t.ownerDocument || t, r = Mf(r), (i = mf.get(i)) && Rf(r, i), a = a.createElement("link"), Tt(a);
				var o = a;
				o._p = new Promise(function(e, t) {
					o.onload = e, o.onerror = t;
				}), Pd(a, "link", r), n.instance = a;
			}
			e.stylesheets === null && (e.stylesheets = /* @__PURE__ */ new Map()), e.stylesheets.set(n, t), (t = n.state.preload) && !(n.state.loading & 3) && (e.count++, n = Jf.bind(e), t.addEventListener("load", n), t.addEventListener("error", n));
		}
	}
	var Kf = 0;
	function qf(e, t) {
		return e.stylesheets && e.count === 0 && Xf(e, e.stylesheets), 0 < e.count || 0 < e.imgCount ? function(n) {
			var r = setTimeout(function() {
				if (e.stylesheets && Xf(e, e.stylesheets), e.unsuspend) {
					var t = e.unsuspend;
					e.unsuspend = null, t();
				}
			}, 6e4 + t);
			0 < e.imgBytes && Kf === 0 && (Kf = 62500 * Ld());
			var i = setTimeout(function() {
				if (e.waitingForImages = !1, e.count === 0 && (e.stylesheets && Xf(e, e.stylesheets), e.unsuspend)) {
					var t = e.unsuspend;
					e.unsuspend = null, t();
				}
			}, (e.imgBytes > Kf ? 50 : 800) + t);
			return e.unsuspend = n, function() {
				e.unsuspend = null, clearTimeout(r), clearTimeout(i);
			};
		} : null;
	}
	function Jf() {
		if (this.count--, this.count === 0 && (this.imgCount === 0 || !this.waitingForImages)) {
			if (this.stylesheets) Xf(this, this.stylesheets);
			else if (this.unsuspend) {
				var e = this.unsuspend;
				this.unsuspend = null, e();
			}
		}
	}
	var Yf = null;
	function Xf(e, t) {
		e.stylesheets = null, e.unsuspend !== null && (e.count++, Yf = /* @__PURE__ */ new Map(), t.forEach(Zf, e), Yf = null, Jf.call(e));
	}
	function Zf(e, t) {
		if (!(t.state.loading & 4)) {
			var n = Yf.get(e);
			if (n) var r = n.get(null);
			else {
				n = /* @__PURE__ */ new Map(), Yf.set(e, n);
				for (var i = e.querySelectorAll("link[data-precedence],style[data-precedence]"), a = 0; a < i.length; a++) {
					var o = i[a];
					(o.nodeName === "LINK" || o.getAttribute("media") !== "not all") && (n.set(o.dataset.precedence, o), r = o);
				}
				r && n.set(null, r);
			}
			i = t.instance, o = i.getAttribute("data-precedence"), a = n.get(o) || r, a === r && n.set(null, i), n.set(o, i), this.count++, r = Jf.bind(this), i.addEventListener("load", r), i.addEventListener("error", r), a ? a.parentNode.insertBefore(i, a.nextSibling) : (e = e.nodeType === 9 ? e.head : e, e.insertBefore(i, e.firstChild)), t.state.loading |= 4;
		}
	}
	var Qf = {
		$$typeof: S,
		Provider: null,
		Consumer: null,
		_currentValue: le,
		_currentValue2: le,
		_threadCount: 0
	};
	function $f(e, t, n, r, i, a, o, s, c) {
		this.tag = 1, this.containerInfo = e, this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null, this.callbackPriority = 0, this.expirationTimes = rt(-1), this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = rt(0), this.hiddenUpdates = rt(null), this.identifierPrefix = r, this.onUncaughtError = i, this.onCaughtError = a, this.onRecoverableError = o, this.pooledCache = null, this.pooledCacheLanes = 0, this.formState = c, this.incompleteTransitions = /* @__PURE__ */ new Map();
	}
	function ep(e, t, n, r, i, a, o, s, c, l, u, d) {
		return e = new $f(e, t, n, o, c, l, u, d, s), t = 1, !0 === a && (t |= 24), a = mi(3, null, null, t), e.current = a, a.stateNode = e, t = fa(), t.refCount++, e.pooledCache = t, t.refCount++, a.memoizedState = {
			element: r,
			isDehydrated: n,
			cache: t
		}, Ga(a), e;
	}
	function tp(e) {
		return e ? (e = fi, e) : fi;
	}
	function np(e, t, n, r, i, a) {
		i = tp(i), r.context === null ? r.context = i : r.pendingContext = i, r = qa(t), r.payload = { element: n }, a = a === void 0 ? null : a, a !== null && (r.callback = a), n = Ja(e, r, t), n !== null && (hu(n, e, t), Ya(n, e, t));
	}
	function rp(e, t) {
		if (e = e.memoizedState, e !== null && e.dehydrated !== null) {
			var n = e.retryLane;
			e.retryLane = n !== 0 && n < t ? n : t;
		}
	}
	function ip(e, t) {
		rp(e, t), (e = e.alternate) && rp(e, t);
	}
	function ap(e) {
		if (e.tag === 13 || e.tag === 31) {
			var t = li(e, 67108864);
			t !== null && hu(t, e, 67108864), ip(e, 67108864);
		}
	}
	function op(e) {
		if (e.tag === 13 || e.tag === 31) {
			var t = pu();
			t = lt(t);
			var n = li(e, t);
			n !== null && hu(n, e, t), ip(e, t);
		}
	}
	var sp = !0;
	function cp(e, t, n, r) {
		var i = D.T;
		D.T = null;
		var a = O.p;
		try {
			O.p = 2, up(e, t, n, r);
		} finally {
			O.p = a, D.T = i;
		}
	}
	function lp(e, t, n, r) {
		var i = D.T;
		D.T = null;
		var a = O.p;
		try {
			O.p = 8, up(e, t, n, r);
		} finally {
			O.p = a, D.T = i;
		}
	}
	function up(e, t, n, r) {
		if (sp) {
			var i = dp(r);
			if (i === null) wd(e, t, r, fp, n), Cp(e, r);
			else if (Tp(i, e, t, n, r)) r.stopPropagation();
			else if (Cp(e, r), t & 4 && -1 < Sp.indexOf(e)) {
				for (; i !== null;) {
					var a = St(i);
					if (a !== null) switch (a.tag) {
						case 3:
							if (a = a.stateNode, a.current.memoizedState.isDehydrated) {
								var o = Qe(a.pendingLanes);
								if (o !== 0) {
									var s = a;
									for (s.pendingLanes |= 2, s.entangledLanes |= 2; o;) {
										var c = 1 << 31 - Ge(o);
										s.entanglements[1] |= c, o &= ~c;
									}
									rd(a), !(G & 6) && (tu = Pe() + 500, id(0, !1));
								}
							}
							break;
						case 31:
						case 13: s = li(a, 2), s !== null && hu(s, a, 2), bu(), ip(a, 2);
					}
					if (a = dp(r), a === null && wd(e, t, r, fp, n), a === i) break;
					i = a;
				}
				i !== null && r.stopPropagation();
			} else wd(e, t, r, null, n);
		}
	}
	function dp(e) {
		return e = cn(e), pp(e);
	}
	var fp = null;
	function pp(e) {
		if (fp = null, e = xt(e), e !== null) {
			var t = o(e);
			if (t === null) e = null;
			else {
				var n = t.tag;
				if (n === 13) {
					if (e = s(t), e !== null) return e;
					e = null;
				} else if (n === 31) {
					if (e = c(t), e !== null) return e;
					e = null;
				} else if (n === 3) {
					if (t.stateNode.current.memoizedState.isDehydrated) return t.tag === 3 ? t.stateNode.containerInfo : null;
					e = null;
				} else t !== e && (e = null);
			}
		}
		return fp = e, null;
	}
	function mp(e) {
		switch (e) {
			case "beforetoggle":
			case "cancel":
			case "click":
			case "close":
			case "contextmenu":
			case "copy":
			case "cut":
			case "auxclick":
			case "dblclick":
			case "dragend":
			case "dragstart":
			case "drop":
			case "focusin":
			case "focusout":
			case "input":
			case "invalid":
			case "keydown":
			case "keypress":
			case "keyup":
			case "mousedown":
			case "mouseup":
			case "paste":
			case "pause":
			case "play":
			case "pointercancel":
			case "pointerdown":
			case "pointerup":
			case "ratechange":
			case "reset":
			case "resize":
			case "seeked":
			case "submit":
			case "toggle":
			case "touchcancel":
			case "touchend":
			case "touchstart":
			case "volumechange":
			case "change":
			case "selectionchange":
			case "textInput":
			case "compositionstart":
			case "compositionend":
			case "compositionupdate":
			case "beforeblur":
			case "afterblur":
			case "beforeinput":
			case "blur":
			case "fullscreenchange":
			case "focus":
			case "hashchange":
			case "popstate":
			case "select":
			case "selectstart": return 2;
			case "drag":
			case "dragenter":
			case "dragexit":
			case "dragleave":
			case "dragover":
			case "mousemove":
			case "mouseout":
			case "mouseover":
			case "pointermove":
			case "pointerout":
			case "pointerover":
			case "scroll":
			case "touchmove":
			case "wheel":
			case "mouseenter":
			case "mouseleave":
			case "pointerenter":
			case "pointerleave": return 8;
			case "message": switch (Fe()) {
				case Ie: return 2;
				case Le: return 8;
				case Re:
				case ze: return 32;
				case Be: return 268435456;
				default: return 32;
			}
			default: return 32;
		}
	}
	var hp = !1, gp = null, _p = null, vp = null, yp = /* @__PURE__ */ new Map(), bp = /* @__PURE__ */ new Map(), xp = [], Sp = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
	function Cp(e, t) {
		switch (e) {
			case "focusin":
			case "focusout":
				gp = null;
				break;
			case "dragenter":
			case "dragleave":
				_p = null;
				break;
			case "mouseover":
			case "mouseout":
				vp = null;
				break;
			case "pointerover":
			case "pointerout":
				yp.delete(t.pointerId);
				break;
			case "gotpointercapture":
			case "lostpointercapture": bp.delete(t.pointerId);
		}
	}
	function wp(e, t, n, r, i, a) {
		return e === null || e.nativeEvent !== a ? (e = {
			blockedOn: t,
			domEventName: n,
			eventSystemFlags: r,
			nativeEvent: a,
			targetContainers: [i]
		}, t !== null && (t = St(t), t !== null && ap(t)), e) : (e.eventSystemFlags |= r, t = e.targetContainers, i !== null && t.indexOf(i) === -1 && t.push(i), e);
	}
	function Tp(e, t, n, r, i) {
		switch (t) {
			case "focusin": return gp = wp(gp, e, t, n, r, i), !0;
			case "dragenter": return _p = wp(_p, e, t, n, r, i), !0;
			case "mouseover": return vp = wp(vp, e, t, n, r, i), !0;
			case "pointerover":
				var a = i.pointerId;
				return yp.set(a, wp(yp.get(a) || null, e, t, n, r, i)), !0;
			case "gotpointercapture": return a = i.pointerId, bp.set(a, wp(bp.get(a) || null, e, t, n, r, i)), !0;
		}
		return !1;
	}
	function Ep(e) {
		var t = xt(e.target);
		if (t !== null) {
			var n = o(t);
			if (n !== null) {
				if (t = n.tag, t === 13) {
					if (t = s(n), t !== null) {
						e.blockedOn = t, ft(e.priority, function() {
							op(n);
						});
						return;
					}
				} else if (t === 31) {
					if (t = c(n), t !== null) {
						e.blockedOn = t, ft(e.priority, function() {
							op(n);
						});
						return;
					}
				} else if (t === 3 && n.stateNode.current.memoizedState.isDehydrated) {
					e.blockedOn = n.tag === 3 ? n.stateNode.containerInfo : null;
					return;
				}
			}
		}
		e.blockedOn = null;
	}
	function Dp(e) {
		if (e.blockedOn !== null) return !1;
		for (var t = e.targetContainers; 0 < t.length;) {
			var n = dp(e.nativeEvent);
			if (n === null) {
				n = e.nativeEvent;
				var r = new n.constructor(n.type, n);
				sn = r, n.target.dispatchEvent(r), sn = null;
			} else return t = St(n), t !== null && ap(t), e.blockedOn = n, !1;
			t.shift();
		}
		return !0;
	}
	function Op(e, t, n) {
		Dp(e) && n.delete(t);
	}
	function kp() {
		hp = !1, gp !== null && Dp(gp) && (gp = null), _p !== null && Dp(_p) && (_p = null), vp !== null && Dp(vp) && (vp = null), yp.forEach(Op), bp.forEach(Op);
	}
	function Ap(e, n) {
		e.blockedOn === n && (e.blockedOn = null, hp || (hp = !0, t.unstable_scheduleCallback(t.unstable_NormalPriority, kp)));
	}
	var jp = null;
	function Mp(e) {
		jp !== e && (jp = e, t.unstable_scheduleCallback(t.unstable_NormalPriority, function() {
			jp === e && (jp = null);
			for (var t = 0; t < e.length; t += 3) {
				var n = e[t], r = e[t + 1], i = e[t + 2];
				if (typeof r != "function") {
					if (pp(r || n) === null) continue;
					break;
				}
				var a = St(n);
				a !== null && (e.splice(t, 3), t -= 3, Es(a, {
					pending: !0,
					data: i,
					method: n.method,
					action: r
				}, r, i));
			}
		}));
	}
	function Np(e) {
		function t(t) {
			return Ap(t, e);
		}
		gp !== null && Ap(gp, e), _p !== null && Ap(_p, e), vp !== null && Ap(vp, e), yp.forEach(t), bp.forEach(t);
		for (var n = 0; n < xp.length; n++) {
			var r = xp[n];
			r.blockedOn === e && (r.blockedOn = null);
		}
		for (; 0 < xp.length && (n = xp[0], n.blockedOn === null);) Ep(n), n.blockedOn === null && xp.shift();
		if (n = (e.ownerDocument || e).$$reactFormReplay, n != null) for (r = 0; r < n.length; r += 3) {
			var i = n[r], a = n[r + 1], o = i[pt] || null;
			if (typeof a == "function") o || Mp(n);
			else if (o) {
				var s = null;
				if (a && a.hasAttribute("formAction")) {
					if (i = a, o = a[pt] || null) s = o.formAction;
					else if (pp(i) !== null) continue;
				} else s = o.action;
				typeof s == "function" ? n[r + 1] = s : (n.splice(r, 3), r -= 3), Mp(n);
			}
		}
	}
	function Pp() {
		function e(e) {
			e.canIntercept && e.info === "react-transition" && e.intercept({
				handler: function() {
					return new Promise(function(e) {
						return i = e;
					});
				},
				focusReset: "manual",
				scroll: "manual"
			});
		}
		function t() {
			i !== null && (i(), i = null), r || setTimeout(n, 20);
		}
		function n() {
			if (!r && !navigation.transition) {
				var e = navigation.currentEntry;
				e && e.url != null && navigation.navigate(e.url, {
					state: e.getState(),
					info: "react-transition",
					history: "replace"
				});
			}
		}
		if (typeof navigation == "object") {
			var r = !1, i = null;
			return navigation.addEventListener("navigate", e), navigation.addEventListener("navigatesuccess", t), navigation.addEventListener("navigateerror", t), setTimeout(n, 100), function() {
				r = !0, navigation.removeEventListener("navigate", e), navigation.removeEventListener("navigatesuccess", t), navigation.removeEventListener("navigateerror", t), i !== null && (i(), i = null);
			};
		}
	}
	function Fp(e) {
		this._internalRoot = e;
	}
	Ip.prototype.render = Fp.prototype.render = function(e) {
		var t = this._internalRoot;
		if (t === null) throw Error(i(409));
		var n = t.current;
		np(n, pu(), e, t, null, null);
	}, Ip.prototype.unmount = Fp.prototype.unmount = function() {
		var e = this._internalRoot;
		if (e !== null) {
			this._internalRoot = null;
			var t = e.containerInfo;
			np(e.current, 2, null, e, null, null), bu(), t[mt] = null;
		}
	};
	function Ip(e) {
		this._internalRoot = e;
	}
	Ip.prototype.unstable_scheduleHydration = function(e) {
		if (e) {
			var t = dt();
			e = {
				blockedOn: null,
				target: e,
				priority: t
			};
			for (var n = 0; n < xp.length && t !== 0 && t < xp[n].priority; n++);
			xp.splice(n, 0, e), n === 0 && Ep(e);
		}
	};
	var Lp = n.version;
	if (Lp !== "19.2.8") throw Error(i(527, Lp, "19.2.8"));
	O.findDOMNode = function(e) {
		var t = e._reactInternals;
		if (t === void 0) throw typeof e.render == "function" ? Error(i(188)) : (e = Object.keys(e).join(","), Error(i(268, e)));
		return e = d(t), e = e === null ? null : p(e), e = e === null ? null : e.stateNode, e;
	};
	var Rp = {
		bundleType: 0,
		version: "19.2.8",
		rendererPackageName: "react-dom",
		currentDispatcherRef: D,
		reconcilerVersion: "19.2.8"
	};
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
		var zp = __REACT_DEVTOOLS_GLOBAL_HOOK__;
		if (!zp.isDisabled && zp.supportsFiber) try {
			Ue = zp.inject(Rp), A = zp;
		} catch {}
	}
	e.createRoot = function(e, t) {
		if (!a(e)) throw Error(i(299));
		var n = !1, r = "", o = Ys, s = Xs, c = Zs;
		return t != null && (!0 === t.unstable_strictMode && (n = !0), t.identifierPrefix !== void 0 && (r = t.identifierPrefix), t.onUncaughtError !== void 0 && (o = t.onUncaughtError), t.onCaughtError !== void 0 && (s = t.onCaughtError), t.onRecoverableError !== void 0 && (c = t.onRecoverableError)), t = ep(e, 1, !1, null, null, n, r, null, o, s, c, Pp), e[mt] = t.current, Sd(e), new Fp(t);
	}, e.hydrateRoot = function(e, t, n) {
		if (!a(e)) throw Error(i(299));
		var r = !1, o = "", s = Ys, c = Xs, l = Zs, u = null;
		return n != null && (!0 === n.unstable_strictMode && (r = !0), n.identifierPrefix !== void 0 && (o = n.identifierPrefix), n.onUncaughtError !== void 0 && (s = n.onUncaughtError), n.onCaughtError !== void 0 && (c = n.onCaughtError), n.onRecoverableError !== void 0 && (l = n.onRecoverableError), n.formState !== void 0 && (u = n.formState)), t = ep(e, 1, !0, t, n ?? null, r, o, u, s, c, l, Pp), t.context = tp(null), n = t.current, r = pu(), r = lt(r), o = qa(r), o.callback = null, Ja(n, o, r), n = r, t.current.lanes = n, it(t, n), rd(t), e[mt] = t.current, Sd(e), new Ip(t);
	};
})), g = /* @__PURE__ */ o(((e, t) => {
	function n() {
		if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) try {
			__REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(n);
		} catch (e) {
			console.error(e);
		}
	}
	n(), t.exports = h();
})), _ = (...e) => e.filter((e, t, n) => !!e && e.trim() !== "" && n.indexOf(e) === t).join(" ").trim(), v = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), y = (e) => e.replace(/^([A-Z])|[\s-_]+(\w)/g, (e, t, n) => n ? n.toUpperCase() : t.toLowerCase()), b = (e) => {
	let t = y(e);
	return t.charAt(0).toUpperCase() + t.slice(1);
}, x = {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}, ee = (e) => {
	for (let t in e) if (t.startsWith("aria-") || t === "role" || t === "title") return !0;
	return !1;
}, S = /* @__PURE__ */ c(u(), 1), C = (0, S.createContext)({}), te = () => (0, S.useContext)(C), ne = (0, S.forwardRef)(({ color: e, size: t, strokeWidth: n, absoluteStrokeWidth: r, className: i = "", children: a, iconNode: o, ...s }, c) => {
	let { size: l = 24, strokeWidth: u = 2, absoluteStrokeWidth: d = !1, color: f = "currentColor", className: p = "" } = te() ?? {}, m = r ?? d ? Number(n ?? u) * 24 / Number(t ?? l) : n ?? u;
	return (0, S.createElement)("svg", {
		ref: c,
		...x,
		width: t ?? l ?? x.width,
		height: t ?? l ?? x.height,
		stroke: e ?? f,
		strokeWidth: m,
		className: _("lucide", p, i),
		...!a && !ee(s) && { "aria-hidden": "true" },
		...s
	}, [...o.map(([e, t]) => (0, S.createElement)(e, t)), ...Array.isArray(a) ? a : [a]]);
}), w = (e, t) => {
	let n = (0, S.forwardRef)(({ className: n, ...r }, i) => (0, S.createElement)(ne, {
		ref: i,
		iconNode: t,
		className: _(`lucide-${v(b(e))}`, `lucide-${e}`, n),
		...r
	}));
	return n.displayName = b(e), n;
}, re = w("activity", [["path", {
	d: "M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2",
	key: "169zse"
}]]), ie = w("arrow-left", [["path", {
	d: "m12 19-7-7 7-7",
	key: "1l729n"
}], ["path", {
	d: "M19 12H5",
	key: "x3x0zl"
}]]), T = w("arrow-right", [["path", {
	d: "M5 12h14",
	key: "1ays0h"
}], ["path", {
	d: "m12 5 7 7-7 7",
	key: "xquz4c"
}]]), E = w("arrow-up-right", [["path", {
	d: "M7 7h10v10",
	key: "1tivn9"
}], ["path", {
	d: "M7 17 17 7",
	key: "1vkiza"
}]]), ae = w("audio-lines", [
	["path", {
		d: "M2 10v3",
		key: "1fnikh"
	}],
	["path", {
		d: "M6 6v11",
		key: "11sgs0"
	}],
	["path", {
		d: "M10 3v18",
		key: "yhl04a"
	}],
	["path", {
		d: "M14 8v7",
		key: "3a1oy3"
	}],
	["path", {
		d: "M18 5v13",
		key: "123xd1"
	}],
	["path", {
		d: "M22 10v3",
		key: "154ddg"
	}]
]), oe = w("badge-check", [["path", {
	d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
	key: "3c2336"
}], ["path", {
	d: "m9 12 2 2 4-4",
	key: "dzmm74"
}]]), se = w("battery-charging", [
	["path", {
		d: "m11 7-3 5h4l-3 5",
		key: "b4a64w"
	}],
	["path", {
		d: "M14.856 6H16a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.935",
		key: "lre1cr"
	}],
	["path", {
		d: "M22 14v-4",
		key: "14q9d5"
	}],
	["path", {
		d: "M5.14 18H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h2.936",
		key: "13q5k0"
	}]
]), ce = w("bike", [
	["circle", {
		cx: "18.5",
		cy: "17.5",
		r: "3.5",
		key: "15x4ox"
	}],
	["circle", {
		cx: "5.5",
		cy: "17.5",
		r: "3.5",
		key: "1noe27"
	}],
	["circle", {
		cx: "15",
		cy: "5",
		r: "1",
		key: "19l28e"
	}],
	["path", {
		d: "M12 17.5V14l-3-3 4-3 2 3h2",
		key: "1npguv"
	}]
]), D = w("bluetooth", [["path", {
	d: "m7 7 10 10-5 5V2l5 5L7 17",
	key: "1q5490"
}]]), O = w("cable", [
	["path", {
		d: "M17 19a1 1 0 0 1-1-1v-2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a1 1 0 0 1-1 1z",
		key: "trhst0"
	}],
	["path", {
		d: "M17 21v-2",
		key: "ds4u3f"
	}],
	["path", {
		d: "M19 14V6.5a1 1 0 0 0-7 0v11a1 1 0 0 1-7 0V10",
		key: "1mo9zo"
	}],
	["path", {
		d: "M21 21v-2",
		key: "eo0ou"
	}],
	["path", {
		d: "M3 5V3",
		key: "1k5hjh"
	}],
	["path", {
		d: "M4 10a2 2 0 0 1-2-2V6a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2a2 2 0 0 1-2 2z",
		key: "1dd30t"
	}],
	["path", {
		d: "M7 5V3",
		key: "1t1388"
	}]
]), le = w("check", [["path", {
	d: "M20 6 9 17l-5-5",
	key: "1gmf2c"
}]]), ue = w("chevron-down", [["path", {
	d: "m6 9 6 6 6-6",
	key: "qrunsl"
}]]), de = w("chevron-left", [["path", {
	d: "m15 18-6-6 6-6",
	key: "1wnfg3"
}]]), fe = w("chevron-right", [["path", {
	d: "m9 18 6-6-6-6",
	key: "mthhwq"
}]]), pe = w("circle-check", [["circle", {
	cx: "12",
	cy: "12",
	r: "10",
	key: "1mglay"
}], ["path", {
	d: "m9 12 2 2 4-4",
	key: "dzmm74"
}]]), k = w("dumbbell", [
	["path", {
		d: "M17.596 12.768a2 2 0 1 0 2.829-2.829l-1.768-1.767a2 2 0 0 0 2.828-2.829l-2.828-2.828a2 2 0 0 0-2.829 2.828l-1.767-1.768a2 2 0 1 0-2.829 2.829z",
		key: "9m4mmf"
	}],
	["path", {
		d: "m2.5 21.5 1.4-1.4",
		key: "17g3f0"
	}],
	["path", {
		d: "m20.1 3.9 1.4-1.4",
		key: "1qn309"
	}],
	["path", {
		d: "M5.343 21.485a2 2 0 1 0 2.829-2.828l1.767 1.768a2 2 0 1 0 2.829-2.829l-6.364-6.364a2 2 0 1 0-2.829 2.829l1.768 1.767a2 2 0 0 0-2.828 2.829z",
		key: "1t2c92"
	}],
	["path", {
		d: "m9.6 14.4 4.8-4.8",
		key: "6umqxw"
	}]
]), me = w("ear", [["path", {
	d: "M6 8.5a6.5 6.5 0 1 1 13 0c0 6-6 6-6 10a3.5 3.5 0 1 1-7 0",
	key: "1dfaln"
}], ["path", {
	d: "M15 8.5a2.5 2.5 0 0 0-5 0v1a2 2 0 1 1 0 4",
	key: "1qnva7"
}]]), he = w("footprints", [
	["path", {
		d: "M4 16v-2.38C4 11.5 2.97 10.5 3 8c.03-2.72 1.49-6 4.5-6C9.37 2 10 3.8 10 5.5c0 3.11-2 5.66-2 8.68V16a2 2 0 1 1-4 0Z",
		key: "1dudjm"
	}],
	["path", {
		d: "M20 20v-2.38c0-2.12 1.03-3.12 1-5.62-.03-2.72-1.49-6-4.5-6C14.63 6 14 7.8 14 9.5c0 3.11 2 5.66 2 8.68V20a2 2 0 1 0 4 0Z",
		key: "l2t8xc"
	}],
	["path", {
		d: "M16 17h4",
		key: "1dejxt"
	}],
	["path", {
		d: "M4 13h4",
		key: "1bwh8b"
	}]
]), ge = w("gift", [
	["path", {
		d: "M12 7v14",
		key: "1akyts"
	}],
	["path", {
		d: "M20 11v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-8",
		key: "1sqzm4"
	}],
	["path", {
		d: "M7.5 7a1 1 0 0 1 0-5A4.8 8 0 0 1 12 7a4.8 8 0 0 1 4.5-5 1 1 0 0 1 0 5",
		key: "kc0143"
	}],
	["rect", {
		x: "3",
		y: "7",
		width: "18",
		height: "4",
		rx: "1",
		key: "1hberx"
	}]
]), _e = w("headphones", [["path", {
	d: "M3 14h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a9 9 0 0 1 18 0v7a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3",
	key: "1xhozi"
}]]), ve = w("loader-circle", [["path", {
	d: "M21 12a9 9 0 1 1-6.219-8.56",
	key: "13zald"
}]]), ye = w("lock-keyhole", [
	["circle", {
		cx: "12",
		cy: "16",
		r: "1",
		key: "1au0dj"
	}],
	["rect", {
		x: "3",
		y: "10",
		width: "18",
		height: "12",
		rx: "2",
		key: "6s8ecr"
	}],
	["path", {
		d: "M7 10V7a5 5 0 0 1 10 0v3",
		key: "1pqi11"
	}]
]), be = w("medal", [
	["path", {
		d: "M7.21 15 2.66 7.14a2 2 0 0 1 .13-2.2L4.4 2.8A2 2 0 0 1 6 2h12a2 2 0 0 1 1.6.8l1.6 2.14a2 2 0 0 1 .14 2.2L16.79 15",
		key: "143lza"
	}],
	["path", {
		d: "M11 12 5.12 2.2",
		key: "qhuxz6"
	}],
	["path", {
		d: "m13 12 5.88-9.8",
		key: "hbye0f"
	}],
	["path", {
		d: "M8 7h8",
		key: "i86dvs"
	}],
	["circle", {
		cx: "12",
		cy: "17",
		r: "5",
		key: "qbz8iq"
	}],
	["path", {
		d: "M12 18v-2h-.5",
		key: "fawc4q"
	}]
]), xe = w("menu", [
	["path", {
		d: "M4 5h16",
		key: "1tepv9"
	}],
	["path", {
		d: "M4 12h16",
		key: "1lakjw"
	}],
	["path", {
		d: "M4 19h16",
		key: "1djgab"
	}]
]), Se = w("minus", [["path", {
	d: "M5 12h14",
	key: "1ays0h"
}]]), Ce = w("mountain", [["path", {
	d: "m8 3 4 8 5-5 5 15H2L8 3z",
	key: "otkl63"
}]]), we = w("move-up-right", [["path", {
	d: "M13 5H19V11",
	key: "1n1gyv"
}], ["path", {
	d: "M19 5L5 19",
	key: "72u4yj"
}]]), Te = w("package-open", [
	["path", {
		d: "M12 22v-9",
		key: "x3hkom"
	}],
	["path", {
		d: "M15.17 2.21a1.67 1.67 0 0 1 1.63 0L21 4.57a1.93 1.93 0 0 1 0 3.36L8.82 14.79a1.655 1.655 0 0 1-1.64 0L3 12.43a1.93 1.93 0 0 1 0-3.36z",
		key: "2ntwy6"
	}],
	["path", {
		d: "M20 13v3.87a2.06 2.06 0 0 1-1.11 1.83l-6 3.08a1.93 1.93 0 0 1-1.78 0l-6-3.08A2.06 2.06 0 0 1 4 16.87V13",
		key: "1pmm1c"
	}],
	["path", {
		d: "M21 12.43a1.93 1.93 0 0 0 0-3.36L8.83 2.2a1.64 1.64 0 0 0-1.63 0L3 4.57a1.93 1.93 0 0 0 0 3.36l12.18 6.86a1.636 1.636 0 0 0 1.63 0z",
		key: "12ttoo"
	}]
]), Ee = w("package", [
	["path", {
		d: "M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z",
		key: "1a0edw"
	}],
	["path", {
		d: "M12 22V12",
		key: "d0xqtd"
	}],
	["polyline", {
		points: "3.29 7 12 12 20.71 7",
		key: "ousv84"
	}],
	["path", {
		d: "m7.5 4.27 9 5.15",
		key: "1c824w"
	}]
]), De = w("plus", [["path", {
	d: "M5 12h14",
	key: "1ays0h"
}], ["path", {
	d: "M12 5v14",
	key: "s699le"
}]]), Oe = w("rotate-cw", [["path", {
	d: "M21 12a9 9 0 1 1-9-9c2.52 0 4.93 1 6.74 2.74L21 8",
	key: "1p45f6"
}], ["path", {
	d: "M21 3v5h-5",
	key: "1q7to0"
}]]), ke = w("scan-eye", [
	["path", {
		d: "M3 7V5a2 2 0 0 1 2-2h2",
		key: "aa7l1z"
	}],
	["path", {
		d: "M17 3h2a2 2 0 0 1 2 2v2",
		key: "4qcy5o"
	}],
	["path", {
		d: "M21 17v2a2 2 0 0 1-2 2h-2",
		key: "6vwrx8"
	}],
	["path", {
		d: "M7 21H5a2 2 0 0 1-2-2v-2",
		key: "ioqczr"
	}],
	["circle", {
		cx: "12",
		cy: "12",
		r: "1",
		key: "41hilf"
	}],
	["path", {
		d: "M18.944 12.33a1 1 0 0 0 0-.66 7.5 7.5 0 0 0-13.888 0 1 1 0 0 0 0 .66 7.5 7.5 0 0 0 13.888 0",
		key: "11ak4c"
	}]
]), Ae = w("scan-line", [
	["path", {
		d: "M3 7V5a2 2 0 0 1 2-2h2",
		key: "aa7l1z"
	}],
	["path", {
		d: "M17 3h2a2 2 0 0 1 2 2v2",
		key: "4qcy5o"
	}],
	["path", {
		d: "M21 17v2a2 2 0 0 1-2 2h-2",
		key: "6vwrx8"
	}],
	["path", {
		d: "M7 21H5a2 2 0 0 1-2-2v-2",
		key: "ioqczr"
	}],
	["path", {
		d: "M7 12h10",
		key: "b7w52i"
	}]
]), je = w("search", [["path", {
	d: "m21 21-4.34-4.34",
	key: "14j7rj"
}], ["circle", {
	cx: "11",
	cy: "11",
	r: "8",
	key: "4ej97u"
}]]), Me = w("shield-check", [["path", {
	d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
	key: "oel41y"
}], ["path", {
	d: "m9 12 2 2 4-4",
	key: "dzmm74"
}]]), Ne = w("shopping-bag", [
	["path", {
		d: "M16 10a4 4 0 0 1-8 0",
		key: "1ltviw"
	}],
	["path", {
		d: "M3.103 6.034h17.794",
		key: "awc11p"
	}],
	["path", {
		d: "M3.4 5.467a2 2 0 0 0-.4 1.2V20a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6.667a2 2 0 0 0-.4-1.2l-2-2.667A2 2 0 0 0 17 2H7a2 2 0 0 0-1.6.8z",
		key: "o988cm"
	}]
]), Pe = w("sliders-horizontal", [
	["path", {
		d: "M10 5H3",
		key: "1qgfaw"
	}],
	["path", {
		d: "M12 19H3",
		key: "yhmn1j"
	}],
	["path", {
		d: "M14 3v4",
		key: "1sua03"
	}],
	["path", {
		d: "M16 17v4",
		key: "1q0r14"
	}],
	["path", {
		d: "M21 12h-9",
		key: "1o4lsq"
	}],
	["path", {
		d: "M21 19h-5",
		key: "1rlt1p"
	}],
	["path", {
		d: "M21 5h-7",
		key: "1oszz2"
	}],
	["path", {
		d: "M8 10v4",
		key: "tgpxqk"
	}],
	["path", {
		d: "M8 12H3",
		key: "a7s4jb"
	}]
]), Fe = w("smartphone", [["rect", {
	width: "14",
	height: "20",
	x: "5",
	y: "2",
	rx: "2",
	ry: "2",
	key: "1yt0o3"
}], ["path", {
	d: "M12 18h.01",
	key: "mhygvu"
}]]), Ie = w("star", [["path", {
	d: "M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z",
	key: "r04s7s"
}]]), Le = w("truck", [
	["path", {
		d: "M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2",
		key: "wrbu53"
	}],
	["path", {
		d: "M15 18H9",
		key: "1lyqi6"
	}],
	["path", {
		d: "M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14",
		key: "lysw3i"
	}],
	["circle", {
		cx: "17",
		cy: "18",
		r: "2",
		key: "332jqn"
	}],
	["circle", {
		cx: "7",
		cy: "18",
		r: "2",
		key: "19iecd"
	}]
]), Re = w("volume-x", [
	["path", {
		d: "M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z",
		key: "uqj9uw"
	}],
	["line", {
		x1: "22",
		x2: "16",
		y1: "9",
		y2: "15",
		key: "1ewh16"
	}],
	["line", {
		x1: "16",
		x2: "22",
		y1: "9",
		y2: "15",
		key: "5ykzw1"
	}]
]), ze = w("x", [["path", {
	d: "M18 6 6 18",
	key: "1bl5f8"
}], ["path", {
	d: "m6 6 12 12",
	key: "d8bk6v"
}]]), Be = w("zap", [["path", {
	d: "M15.914 4a1.5 1.5 0 00-2.474-1.561l-9 9A1.5 1.5 0 005.5 14h4.002a.5.5 0 01.471.666L8.086 20a1.5 1.5 0 002.475 1.56l9-9A1.5 1.5 0 0018.5 10h-3.997a.5.5 0 01-.472-.667z",
	key: "1v7up4"
}]]), Ve = g(), He = 19999, Ue = [
	{
		id: "graphite",
		name: "Graphite",
		hex: "#777a7c",
		variantId: 54543513616597
	},
	{
		id: "matte-black",
		name: "Matte black",
		hex: "#202221",
		variantId: 54543513649365
	},
	{
		id: "rose-gold",
		name: "Rose gold",
		hex: "#d7aa96",
		variantId: 54543513682133
	}
], A = (e) => new Intl.NumberFormat("en-NZ", {
	style: "currency",
	currency: "NZD"
}).format(e / 100), We = (e) => Array.isArray(e) ? Ue.flatMap((t) => {
	let n = e.filter((e) => e?.colour === t.id).reduce((e, t) => e + (Number.isFinite(t.quantity) ? Math.max(0, Math.trunc(t.quantity)) : 0), 0);
	return n > 0 ? [{
		colour: t.id,
		quantity: Math.min(10, n)
	}] : [];
}) : [], Ge = (e, t, n) => We([...e, {
	colour: t,
	quantity: n
}]), Ke = (e, t, n) => We(e.map((e) => e.colour === t ? {
	...e,
	quantity: n
} : e)), qe = (e, t, n) => We(e.map((e) => e.colour === t ? {
	...e,
	colour: n
} : e)), Je = (e) => {
	let t = We(e).reduce((e, t) => e + t.quantity, 0);
	return {
		quantity: t,
		freeCases: t,
		subtotal: t * He
	};
}, Ye = [
	"gclid",
	"gbraid",
	"wbraid",
	"utm_source",
	"utm_medium",
	"utm_campaign",
	"utm_content",
	"utm_term",
	"tbid",
	"tbsig"
];
function Xe(e, { href: t }) {
	let n = new URL(t);
	return Object.fromEntries(Ye.filter((e) => n.searchParams.has(e)).map((e) => [e, n.searchParams.get(e).slice(0, 250)]));
}
function Ze(e = {}) {
	return [
		{
			key: "storefront",
			value: "mifo.co.nz"
		},
		{
			key: "mifo_storefront__",
			value: "mifo.co.nz"
		},
		...Object.entries(e).filter(([e]) => Ye.includes(e)).map(([e, t]) => ({
			key: e + "__",
			value: t
		}))
	];
}
async function Qe(e = globalThis.window) {
	let t = e?.Shopify?.customerPrivacy;
	if (t?.analyticsProcessingAllowed && !t.analyticsProcessingAllowed()) return { attributes: Ze() };
	let n = {};
	try {
		n = JSON.parse(e.sessionStorage.getItem("mifo-nz-campaign") || "{}");
	} catch {}
	let r = Xe(null, { href: e.location.href }), i = Object.keys(r).length ? r : n;
	try {
		e.sessionStorage.setItem("mifo-nz-campaign", JSON.stringify(i));
	} catch {}
	return { attributes: Ze(i) };
}
async function $e() {
	return !1;
}
function et(e, t, n) {
	if (typeof window > "u" || !window.gtag) return;
	let r = window.Shopify?.customerPrivacy;
	r?.analyticsProcessingAllowed && !r.analyticsProcessingAllowed() || window.gtag("event", e, {
		currency: "NZD",
		value: n,
		items: t,
		storefront: "mifo.co.nz"
	});
}
//#endregion
//#region outputs/regional-reviews-nz-20261018/nz/athletics-src/shopify.mjs
var tt = "https://mifo-new-zealand.myshopify.com/api/2026-10/graphql.json", nt = "gid://shopify/ProductVariant/42472913404117", rt = (e) => `gid://shopify/ProductVariant/${Ue.find((t) => t.id === e).variantId}`, it = "query @inContext(country: NZ) {\n  product(handle: \"mifo-gen-4-wireless-earbuds\") {\n    id title availableForSale variants(first: 10) {\n      nodes { id title sku availableForSale price { amount currencyCode } }\n    }\n  }\n  gift: product(handle: \"mifo-o5-case\") {\n    variants(first: 10) { nodes { id sku availableForSale } }\n  }\n}", at = "mutation CreateAthleticsCart($input: CartInput!) @inContext(country: NZ) {\n  cartCreate(input: $input) {\n    cart {\n      id attributes { key value }\n      checkoutUrl cost { totalAmount { amount currencyCode } }\n      lines(first: 100) {\n        nodes {\n          quantity merchandise { ... on ProductVariant { id sku } }\n          cost { totalAmount { amount currencyCode } }\n        }\n      }\n    }\n    userErrors { field message code }\n    warnings { code message }\n  }\n}";
async function ot(e, t = {}, n = fetch) {
	try {
		let r = await n(tt, {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				query: e,
				variables: t
			}),
			signal: AbortSignal.timeout(2e4)
		});
		if (!r.ok) throw Error("http");
		let i = await r.json();
		if (i.errors?.length || !i.data) throw Error("graphql");
		return i.data;
	} catch {
		throw Error("We couldn't reach checkout. Your bag is saved. Please try again.");
	}
}
function st(e, t) {
	let n = e.product?.variants.nodes || [];
	for (let e of t) {
		let t = n.find((t) => t.id === rt(e.colour));
		if (!t?.availableForSale) throw Error(`${Ue.find((t) => t.id === e.colour).name} is currently unavailable. Please choose another colour.`);
		if (t.price.currencyCode !== "NZD" || Math.round(Number(t.price.amount) * 100) !== 19999) throw Error("Pricing has changed. Please check the latest price at mifo.co.nz before ordering.");
	}
	if (!e.gift?.variants.nodes.some((e) => e.id === "gid://shopify/ProductVariant/42472913404117" && e.sku === "mifo-o5-case" && e.availableForSale)) throw Error("The free case is currently unavailable. Your bag is saved. Please try again later.");
}
function ct(e, t) {
	let n = new Map(t.map((e) => [rt(e.colour), e.quantity])), r = Je(t).quantity;
	n.set(nt, r);
	let i = /* @__PURE__ */ new Map();
	for (let t of e?.lines.nodes || []) {
		let e = t.merchandise.id;
		if (i.set(e, (i.get(e) || 0) + t.quantity), e === "gid://shopify/ProductVariant/42472913404117" && (t.cost.totalAmount.currencyCode !== "NZD" || Number(t.cost.totalAmount.amount) !== 0)) throw Error("We couldn't apply your free case. You haven't been charged. Please try again.");
	}
	if (i.size !== n.size || [...n].some(([e, t]) => i.get(e) !== t)) throw Error("Availability changed while preparing your bag. Please review your quantities and try again.");
	let a = Number(e.cost.totalAmount.amount);
	if (e.cost.totalAmount.currencyCode !== "NZD" || !Number.isFinite(a) || a <= 0 || Math.round(a * 100) > 19999 * r) throw Error("We couldn't confirm your total. You haven't been charged. Please try again.");
	let o = new URL(e.checkoutUrl);
	if (o.protocol !== "https:" || !["mifo.co.nz", "mifo-new-zealand.myshopify.com"].includes(o.hostname) || !/^\/(checkouts\/|cart\/c\/)/.test(o.pathname) || o.username || o.password) throw Error("We couldn't open secure checkout. Please try again.");
	return {
		checkoutUrl: o.href,
		quantity: r,
		total: a
	};
}
async function lt(e, { search: t = "", fetcher: n = fetch, attribution: r } = {}) {
	let i = We(e);
	if (!i.length) throw Error("Add a pair to your bag first.");
	st(await ot(it, {}, n), i);
	let a = r?.attributes || Ze(Xe(null, { href: `https://mifo.co.nz/${t}` })), o = await ot(at, { input: {
		buyerIdentity: { countryCode: "NZ" },
		attributes: a,
		lines: [...i.map((e) => ({
			merchandiseId: rt(e.colour),
			quantity: e.quantity
		})), {
			merchandiseId: nt,
			quantity: Je(i).quantity
		}]
	} }, n);
	if (o.cartCreate.userErrors?.length || o.cartCreate.warnings?.length) throw Error("Shopify couldn't confirm every item in your bag. Please review quantities and try again.");
	let s = ct(o.cartCreate.cart, i);
	if (r) {
		let e = new Map((o.cartCreate.cart.attributes || []).map((e) => [e.key, e.value]));
		if (a.some((t) => e.get(t.key) !== t.value)) throw Error("We couldn't confirm your bag details. Please try again.");
		await $e(o.cartCreate.cart.id, r);
		let t = new URL(s.checkoutUrl);
		for (let n of [
			"gclid",
			"gbraid",
			"wbraid",
			"utm_source",
			"utm_medium",
			"utm_campaign",
			"utm_content",
			"utm_term"
		]) {
			let r = e.get(`${n}__`);
			r && t.searchParams.set(n, r);
		}
		s.checkoutUrl = t.href;
	}
	return s;
}
//#endregion
//#region outputs/regional-reviews-nz-20261018/nz/athletics-src/support.mjs
var ut = [
	{
		slug: "shipping",
		label: "Shipping",
		url: "/pages/mifo-new-zealand-shipping-policy"
	},
	{
		slug: "privacy_policy",
		label: "Privacy policy",
		url: "https://checkout.shopify.com/62358421717/policies/40993980629.html?locale=en"
	},
	{
		slug: "terms_of_service",
		label: "Terms of service",
		url: "https://checkout.shopify.com/62358421717/policies/40994046165.html?locale=en"
	},
	{
		slug: "contact",
		label: "Contact",
		url: "/pages/contact"
	}
], dt = {
	"https://mifogen4.com.au/assets/case-closed.webp": {
		width: 1600,
		height: 900,
		avif: "https://mifogen4.com.au/assets/responsive/case-closed-96.avif 96w, https://mifogen4.com.au/assets/responsive/case-closed-240.avif 240w, https://mifogen4.com.au/assets/responsive/case-closed-480.avif 480w, https://mifogen4.com.au/assets/responsive/case-closed-768.avif 768w, https://mifogen4.com.au/assets/responsive/case-closed-1280.avif 1280w, https://mifogen4.com.au/assets/responsive/case-closed-1600.avif 1600w",
		webp: "https://mifogen4.com.au/assets/responsive/case-closed-96.webp 96w, https://mifogen4.com.au/assets/responsive/case-closed-240.webp 240w, https://mifogen4.com.au/assets/responsive/case-closed-480.webp 480w, https://mifogen4.com.au/assets/responsive/case-closed-768.webp 768w, https://mifogen4.com.au/assets/responsive/case-closed-1280.webp 1280w, https://mifogen4.com.au/assets/responsive/case-closed-1600.webp 1600w"
	},
	"https://mifogen4.com.au/assets/case-gym.webp": {
		width: 1536,
		height: 1024,
		avif: "https://mifogen4.com.au/assets/responsive/case-gym-96.avif 96w, https://mifogen4.com.au/assets/responsive/case-gym-240.avif 240w, https://mifogen4.com.au/assets/responsive/case-gym-480.avif 480w, https://mifogen4.com.au/assets/responsive/case-gym-768.avif 768w, https://mifogen4.com.au/assets/responsive/case-gym-1280.avif 1280w, https://mifogen4.com.au/assets/responsive/case-gym-1536.avif 1536w",
		webp: "https://mifogen4.com.au/assets/responsive/case-gym-96.webp 96w, https://mifogen4.com.au/assets/responsive/case-gym-240.webp 240w, https://mifogen4.com.au/assets/responsive/case-gym-480.webp 480w, https://mifogen4.com.au/assets/responsive/case-gym-768.webp 768w, https://mifogen4.com.au/assets/responsive/case-gym-1280.webp 1280w, https://mifogen4.com.au/assets/responsive/case-gym-1536.webp 1536w"
	},
	"https://mifogen4.com.au/assets/case-lifestyle.webp": {
		width: 1536,
		height: 1024,
		avif: "https://mifogen4.com.au/assets/responsive/case-lifestyle-96.avif 96w, https://mifogen4.com.au/assets/responsive/case-lifestyle-240.avif 240w, https://mifogen4.com.au/assets/responsive/case-lifestyle-480.avif 480w, https://mifogen4.com.au/assets/responsive/case-lifestyle-768.avif 768w, https://mifogen4.com.au/assets/responsive/case-lifestyle-1280.avif 1280w, https://mifogen4.com.au/assets/responsive/case-lifestyle-1536.avif 1536w",
		webp: "https://mifogen4.com.au/assets/responsive/case-lifestyle-96.webp 96w, https://mifogen4.com.au/assets/responsive/case-lifestyle-240.webp 240w, https://mifogen4.com.au/assets/responsive/case-lifestyle-480.webp 480w, https://mifogen4.com.au/assets/responsive/case-lifestyle-768.webp 768w, https://mifogen4.com.au/assets/responsive/case-lifestyle-1280.webp 1280w, https://mifogen4.com.au/assets/responsive/case-lifestyle-1536.webp 1536w"
	},
	"https://mifogen4.com.au/assets/case-open.webp": {
		width: 1600,
		height: 900,
		avif: "https://mifogen4.com.au/assets/responsive/case-open-96.avif 96w, https://mifogen4.com.au/assets/responsive/case-open-240.avif 240w, https://mifogen4.com.au/assets/responsive/case-open-480.avif 480w, https://mifogen4.com.au/assets/responsive/case-open-768.avif 768w, https://mifogen4.com.au/assets/responsive/case-open-1280.avif 1280w, https://mifogen4.com.au/assets/responsive/case-open-1600.avif 1600w",
		webp: "https://mifogen4.com.au/assets/responsive/case-open-96.webp 96w, https://mifogen4.com.au/assets/responsive/case-open-240.webp 240w, https://mifogen4.com.au/assets/responsive/case-open-480.webp 480w, https://mifogen4.com.au/assets/responsive/case-open-768.webp 768w, https://mifogen4.com.au/assets/responsive/case-open-1280.webp 1280w, https://mifogen4.com.au/assets/responsive/case-open-1600.webp 1600w"
	},
	"https://mifogen4.com.au/assets/case-ride.webp": {
		width: 1536,
		height: 1024,
		avif: "https://mifogen4.com.au/assets/responsive/case-ride-96.avif 96w, https://mifogen4.com.au/assets/responsive/case-ride-240.avif 240w, https://mifogen4.com.au/assets/responsive/case-ride-480.avif 480w, https://mifogen4.com.au/assets/responsive/case-ride-768.avif 768w, https://mifogen4.com.au/assets/responsive/case-ride-1280.avif 1280w, https://mifogen4.com.au/assets/responsive/case-ride-1536.avif 1536w",
		webp: "https://mifogen4.com.au/assets/responsive/case-ride-96.webp 96w, https://mifogen4.com.au/assets/responsive/case-ride-240.webp 240w, https://mifogen4.com.au/assets/responsive/case-ride-480.webp 480w, https://mifogen4.com.au/assets/responsive/case-ride-768.webp 768w, https://mifogen4.com.au/assets/responsive/case-ride-1280.webp 1280w, https://mifogen4.com.au/assets/responsive/case-ride-1536.webp 1536w"
	},
	"https://mifogen4.com.au/assets/cyclist-black.webp": {
		width: 1536,
		height: 1024,
		avif: "https://mifogen4.com.au/assets/responsive/cyclist-black-96.avif 96w, https://mifogen4.com.au/assets/responsive/cyclist-black-240.avif 240w, https://mifogen4.com.au/assets/responsive/cyclist-black-480.avif 480w, https://mifogen4.com.au/assets/responsive/cyclist-black-768.avif 768w, https://mifogen4.com.au/assets/responsive/cyclist-black-1280.avif 1280w, https://mifogen4.com.au/assets/responsive/cyclist-black-1536.avif 1536w",
		webp: "https://mifogen4.com.au/assets/responsive/cyclist-black-96.webp 96w, https://mifogen4.com.au/assets/responsive/cyclist-black-240.webp 240w, https://mifogen4.com.au/assets/responsive/cyclist-black-480.webp 480w, https://mifogen4.com.au/assets/responsive/cyclist-black-768.webp 768w, https://mifogen4.com.au/assets/responsive/cyclist-black-1280.webp 1280w, https://mifogen4.com.au/assets/responsive/cyclist-black-1536.webp 1536w"
	},
	"https://mifogen4.com.au/assets/fit-lab-v3.webp": {
		width: 1536,
		height: 1024,
		avif: "https://mifogen4.com.au/assets/responsive/fit-lab-v3-96.avif 96w, https://mifogen4.com.au/assets/responsive/fit-lab-v3-240.avif 240w, https://mifogen4.com.au/assets/responsive/fit-lab-v3-480.avif 480w, https://mifogen4.com.au/assets/responsive/fit-lab-v3-768.avif 768w, https://mifogen4.com.au/assets/responsive/fit-lab-v3-1280.avif 1280w, https://mifogen4.com.au/assets/responsive/fit-lab-v3-1536.avif 1536w",
		webp: "https://mifogen4.com.au/assets/responsive/fit-lab-v3-96.webp 96w, https://mifogen4.com.au/assets/responsive/fit-lab-v3-240.webp 240w, https://mifogen4.com.au/assets/responsive/fit-lab-v3-480.webp 480w, https://mifogen4.com.au/assets/responsive/fit-lab-v3-768.webp 768w, https://mifogen4.com.au/assets/responsive/fit-lab-v3-1280.webp 1280w, https://mifogen4.com.au/assets/responsive/fit-lab-v3-1536.webp 1536w"
	},
	"https://mifogen4.com.au/assets/gallery-case-scale.webp": {
		width: 960,
		height: 960,
		avif: "https://mifogen4.com.au/assets/responsive/gallery-case-scale-96.avif 96w, https://mifogen4.com.au/assets/responsive/gallery-case-scale-240.avif 240w, https://mifogen4.com.au/assets/responsive/gallery-case-scale-480.avif 480w, https://mifogen4.com.au/assets/responsive/gallery-case-scale-768.avif 768w, https://mifogen4.com.au/assets/responsive/gallery-case-scale-960.avif 960w",
		webp: "https://mifogen4.com.au/assets/responsive/gallery-case-scale-96.webp 96w, https://mifogen4.com.au/assets/responsive/gallery-case-scale-240.webp 240w, https://mifogen4.com.au/assets/responsive/gallery-case-scale-480.webp 480w, https://mifogen4.com.au/assets/responsive/gallery-case-scale-768.webp 768w, https://mifogen4.com.au/assets/responsive/gallery-case-scale-960.webp 960w"
	},
	"https://mifogen4.com.au/assets/gallery-gym-palm.webp": {
		width: 960,
		height: 960,
		avif: "https://mifogen4.com.au/assets/responsive/gallery-gym-palm-96.avif 96w, https://mifogen4.com.au/assets/responsive/gallery-gym-palm-240.avif 240w, https://mifogen4.com.au/assets/responsive/gallery-gym-palm-480.avif 480w, https://mifogen4.com.au/assets/responsive/gallery-gym-palm-768.avif 768w, https://mifogen4.com.au/assets/responsive/gallery-gym-palm-960.avif 960w",
		webp: "https://mifogen4.com.au/assets/responsive/gallery-gym-palm-96.webp 96w, https://mifogen4.com.au/assets/responsive/gallery-gym-palm-240.webp 240w, https://mifogen4.com.au/assets/responsive/gallery-gym-palm-480.webp 480w, https://mifogen4.com.au/assets/responsive/gallery-gym-palm-768.webp 768w, https://mifogen4.com.au/assets/responsive/gallery-gym-palm-960.webp 960w"
	},
	"https://mifogen4.com.au/assets/gallery-indoor-cycle.webp": {
		width: 960,
		height: 960,
		avif: "https://mifogen4.com.au/assets/responsive/gallery-indoor-cycle-96.avif 96w, https://mifogen4.com.au/assets/responsive/gallery-indoor-cycle-240.avif 240w, https://mifogen4.com.au/assets/responsive/gallery-indoor-cycle-480.avif 480w, https://mifogen4.com.au/assets/responsive/gallery-indoor-cycle-768.avif 768w, https://mifogen4.com.au/assets/responsive/gallery-indoor-cycle-960.avif 960w",
		webp: "https://mifogen4.com.au/assets/responsive/gallery-indoor-cycle-96.webp 96w, https://mifogen4.com.au/assets/responsive/gallery-indoor-cycle-240.webp 240w, https://mifogen4.com.au/assets/responsive/gallery-indoor-cycle-480.webp 480w, https://mifogen4.com.au/assets/responsive/gallery-indoor-cycle-768.webp 768w, https://mifogen4.com.au/assets/responsive/gallery-indoor-cycle-960.webp 960w"
	},
	"https://mifogen4.com.au/assets/gallery-training-kit.webp": {
		width: 960,
		height: 960,
		avif: "https://mifogen4.com.au/assets/responsive/gallery-training-kit-96.avif 96w, https://mifogen4.com.au/assets/responsive/gallery-training-kit-240.avif 240w, https://mifogen4.com.au/assets/responsive/gallery-training-kit-480.avif 480w, https://mifogen4.com.au/assets/responsive/gallery-training-kit-768.avif 768w, https://mifogen4.com.au/assets/responsive/gallery-training-kit-960.avif 960w",
		webp: "https://mifogen4.com.au/assets/responsive/gallery-training-kit-96.webp 96w, https://mifogen4.com.au/assets/responsive/gallery-training-kit-240.webp 240w, https://mifogen4.com.au/assets/responsive/gallery-training-kit-480.webp 480w, https://mifogen4.com.au/assets/responsive/gallery-training-kit-768.webp 768w, https://mifogen4.com.au/assets/responsive/gallery-training-kit-960.webp 960w"
	},
	"https://mifogen4.com.au/assets/gen4-hires-graphite-angle.webp": {
		width: 1400,
		height: 1400,
		avif: "https://mifogen4.com.au/assets/responsive/gen4-hires-graphite-angle-96.avif 96w, https://mifogen4.com.au/assets/responsive/gen4-hires-graphite-angle-240.avif 240w, https://mifogen4.com.au/assets/responsive/gen4-hires-graphite-angle-480.avif 480w, https://mifogen4.com.au/assets/responsive/gen4-hires-graphite-angle-768.avif 768w, https://mifogen4.com.au/assets/responsive/gen4-hires-graphite-angle-1280.avif 1280w, https://mifogen4.com.au/assets/responsive/gen4-hires-graphite-angle-1400.avif 1400w",
		webp: "https://mifogen4.com.au/assets/responsive/gen4-hires-graphite-angle-96.webp 96w, https://mifogen4.com.au/assets/responsive/gen4-hires-graphite-angle-240.webp 240w, https://mifogen4.com.au/assets/responsive/gen4-hires-graphite-angle-480.webp 480w, https://mifogen4.com.au/assets/responsive/gen4-hires-graphite-angle-768.webp 768w, https://mifogen4.com.au/assets/responsive/gen4-hires-graphite-angle-1280.webp 1280w, https://mifogen4.com.au/assets/responsive/gen4-hires-graphite-angle-1400.webp 1400w"
	},
	"https://mifogen4.com.au/assets/gen4-hires-graphite-buds.webp": {
		width: 1e3,
		height: 1e3,
		avif: "https://mifogen4.com.au/assets/responsive/gen4-hires-graphite-buds-96.avif 96w, https://mifogen4.com.au/assets/responsive/gen4-hires-graphite-buds-240.avif 240w, https://mifogen4.com.au/assets/responsive/gen4-hires-graphite-buds-480.avif 480w, https://mifogen4.com.au/assets/responsive/gen4-hires-graphite-buds-768.avif 768w, https://mifogen4.com.au/assets/responsive/gen4-hires-graphite-buds-1000.avif 1000w",
		webp: "https://mifogen4.com.au/assets/responsive/gen4-hires-graphite-buds-96.webp 96w, https://mifogen4.com.au/assets/responsive/gen4-hires-graphite-buds-240.webp 240w, https://mifogen4.com.au/assets/responsive/gen4-hires-graphite-buds-480.webp 480w, https://mifogen4.com.au/assets/responsive/gen4-hires-graphite-buds-768.webp 768w, https://mifogen4.com.au/assets/responsive/gen4-hires-graphite-buds-1000.webp 1000w"
	},
	"https://mifogen4.com.au/assets/gen4-hires-graphite-open.webp": {
		width: 1400,
		height: 1400,
		avif: "https://mifogen4.com.au/assets/responsive/gen4-hires-graphite-open-96.avif 96w, https://mifogen4.com.au/assets/responsive/gen4-hires-graphite-open-240.avif 240w, https://mifogen4.com.au/assets/responsive/gen4-hires-graphite-open-480.avif 480w, https://mifogen4.com.au/assets/responsive/gen4-hires-graphite-open-768.avif 768w, https://mifogen4.com.au/assets/responsive/gen4-hires-graphite-open-1280.avif 1280w, https://mifogen4.com.au/assets/responsive/gen4-hires-graphite-open-1400.avif 1400w",
		webp: "https://mifogen4.com.au/assets/responsive/gen4-hires-graphite-open-96.webp 96w, https://mifogen4.com.au/assets/responsive/gen4-hires-graphite-open-240.webp 240w, https://mifogen4.com.au/assets/responsive/gen4-hires-graphite-open-480.webp 480w, https://mifogen4.com.au/assets/responsive/gen4-hires-graphite-open-768.webp 768w, https://mifogen4.com.au/assets/responsive/gen4-hires-graphite-open-1280.webp 1280w, https://mifogen4.com.au/assets/responsive/gen4-hires-graphite-open-1400.webp 1400w"
	},
	"https://mifogen4.com.au/assets/gen4-hires-graphite-system.webp": {
		width: 1800,
		height: 1800,
		avif: "https://mifogen4.com.au/assets/responsive/gen4-hires-graphite-system-96.avif 96w, https://mifogen4.com.au/assets/responsive/gen4-hires-graphite-system-240.avif 240w, https://mifogen4.com.au/assets/responsive/gen4-hires-graphite-system-480.avif 480w, https://mifogen4.com.au/assets/responsive/gen4-hires-graphite-system-768.avif 768w, https://mifogen4.com.au/assets/responsive/gen4-hires-graphite-system-1280.avif 1280w, https://mifogen4.com.au/assets/responsive/gen4-hires-graphite-system-1800.avif 1800w",
		webp: "https://mifogen4.com.au/assets/responsive/gen4-hires-graphite-system-96.webp 96w, https://mifogen4.com.au/assets/responsive/gen4-hires-graphite-system-240.webp 240w, https://mifogen4.com.au/assets/responsive/gen4-hires-graphite-system-480.webp 480w, https://mifogen4.com.au/assets/responsive/gen4-hires-graphite-system-768.webp 768w, https://mifogen4.com.au/assets/responsive/gen4-hires-graphite-system-1280.webp 1280w, https://mifogen4.com.au/assets/responsive/gen4-hires-graphite-system-1800.webp 1800w"
	},
	"https://mifogen4.com.au/assets/gen4-hires-matte-black-angle.webp": {
		width: 1400,
		height: 1221,
		avif: "https://mifogen4.com.au/assets/responsive/gen4-hires-matte-black-angle-96.avif 96w, https://mifogen4.com.au/assets/responsive/gen4-hires-matte-black-angle-240.avif 240w, https://mifogen4.com.au/assets/responsive/gen4-hires-matte-black-angle-480.avif 480w, https://mifogen4.com.au/assets/responsive/gen4-hires-matte-black-angle-768.avif 768w, https://mifogen4.com.au/assets/responsive/gen4-hires-matte-black-angle-1280.avif 1280w, https://mifogen4.com.au/assets/responsive/gen4-hires-matte-black-angle-1400.avif 1400w",
		webp: "https://mifogen4.com.au/assets/responsive/gen4-hires-matte-black-angle-96.webp 96w, https://mifogen4.com.au/assets/responsive/gen4-hires-matte-black-angle-240.webp 240w, https://mifogen4.com.au/assets/responsive/gen4-hires-matte-black-angle-480.webp 480w, https://mifogen4.com.au/assets/responsive/gen4-hires-matte-black-angle-768.webp 768w, https://mifogen4.com.au/assets/responsive/gen4-hires-matte-black-angle-1280.webp 1280w, https://mifogen4.com.au/assets/responsive/gen4-hires-matte-black-angle-1400.webp 1400w"
	},
	"https://mifogen4.com.au/assets/gen4-hires-matte-black-buds.webp": {
		width: 1e3,
		height: 1e3,
		avif: "https://mifogen4.com.au/assets/responsive/gen4-hires-matte-black-buds-96.avif 96w, https://mifogen4.com.au/assets/responsive/gen4-hires-matte-black-buds-240.avif 240w, https://mifogen4.com.au/assets/responsive/gen4-hires-matte-black-buds-480.avif 480w, https://mifogen4.com.au/assets/responsive/gen4-hires-matte-black-buds-768.avif 768w, https://mifogen4.com.au/assets/responsive/gen4-hires-matte-black-buds-1000.avif 1000w",
		webp: "https://mifogen4.com.au/assets/responsive/gen4-hires-matte-black-buds-96.webp 96w, https://mifogen4.com.au/assets/responsive/gen4-hires-matte-black-buds-240.webp 240w, https://mifogen4.com.au/assets/responsive/gen4-hires-matte-black-buds-480.webp 480w, https://mifogen4.com.au/assets/responsive/gen4-hires-matte-black-buds-768.webp 768w, https://mifogen4.com.au/assets/responsive/gen4-hires-matte-black-buds-1000.webp 1000w"
	},
	"https://mifogen4.com.au/assets/gen4-hires-matte-black-open.webp": {
		width: 1400,
		height: 1400,
		avif: "https://mifogen4.com.au/assets/responsive/gen4-hires-matte-black-open-96.avif 96w, https://mifogen4.com.au/assets/responsive/gen4-hires-matte-black-open-240.avif 240w, https://mifogen4.com.au/assets/responsive/gen4-hires-matte-black-open-480.avif 480w, https://mifogen4.com.au/assets/responsive/gen4-hires-matte-black-open-768.avif 768w, https://mifogen4.com.au/assets/responsive/gen4-hires-matte-black-open-1280.avif 1280w, https://mifogen4.com.au/assets/responsive/gen4-hires-matte-black-open-1400.avif 1400w",
		webp: "https://mifogen4.com.au/assets/responsive/gen4-hires-matte-black-open-96.webp 96w, https://mifogen4.com.au/assets/responsive/gen4-hires-matte-black-open-240.webp 240w, https://mifogen4.com.au/assets/responsive/gen4-hires-matte-black-open-480.webp 480w, https://mifogen4.com.au/assets/responsive/gen4-hires-matte-black-open-768.webp 768w, https://mifogen4.com.au/assets/responsive/gen4-hires-matte-black-open-1280.webp 1280w, https://mifogen4.com.au/assets/responsive/gen4-hires-matte-black-open-1400.webp 1400w"
	},
	"https://mifogen4.com.au/assets/gen4-hires-matte-black-system.webp": {
		width: 1800,
		height: 1800,
		avif: "https://mifogen4.com.au/assets/responsive/gen4-hires-matte-black-system-96.avif 96w, https://mifogen4.com.au/assets/responsive/gen4-hires-matte-black-system-240.avif 240w, https://mifogen4.com.au/assets/responsive/gen4-hires-matte-black-system-480.avif 480w, https://mifogen4.com.au/assets/responsive/gen4-hires-matte-black-system-768.avif 768w, https://mifogen4.com.au/assets/responsive/gen4-hires-matte-black-system-1280.avif 1280w, https://mifogen4.com.au/assets/responsive/gen4-hires-matte-black-system-1800.avif 1800w",
		webp: "https://mifogen4.com.au/assets/responsive/gen4-hires-matte-black-system-96.webp 96w, https://mifogen4.com.au/assets/responsive/gen4-hires-matte-black-system-240.webp 240w, https://mifogen4.com.au/assets/responsive/gen4-hires-matte-black-system-480.webp 480w, https://mifogen4.com.au/assets/responsive/gen4-hires-matte-black-system-768.webp 768w, https://mifogen4.com.au/assets/responsive/gen4-hires-matte-black-system-1280.webp 1280w, https://mifogen4.com.au/assets/responsive/gen4-hires-matte-black-system-1800.webp 1800w"
	},
	"https://mifogen4.com.au/assets/gen4-hires-rose-gold-angle.webp": {
		width: 1400,
		height: 1400,
		avif: "https://mifogen4.com.au/assets/responsive/gen4-hires-rose-gold-angle-96.avif 96w, https://mifogen4.com.au/assets/responsive/gen4-hires-rose-gold-angle-240.avif 240w, https://mifogen4.com.au/assets/responsive/gen4-hires-rose-gold-angle-480.avif 480w, https://mifogen4.com.au/assets/responsive/gen4-hires-rose-gold-angle-768.avif 768w, https://mifogen4.com.au/assets/responsive/gen4-hires-rose-gold-angle-1280.avif 1280w, https://mifogen4.com.au/assets/responsive/gen4-hires-rose-gold-angle-1400.avif 1400w",
		webp: "https://mifogen4.com.au/assets/responsive/gen4-hires-rose-gold-angle-96.webp 96w, https://mifogen4.com.au/assets/responsive/gen4-hires-rose-gold-angle-240.webp 240w, https://mifogen4.com.au/assets/responsive/gen4-hires-rose-gold-angle-480.webp 480w, https://mifogen4.com.au/assets/responsive/gen4-hires-rose-gold-angle-768.webp 768w, https://mifogen4.com.au/assets/responsive/gen4-hires-rose-gold-angle-1280.webp 1280w, https://mifogen4.com.au/assets/responsive/gen4-hires-rose-gold-angle-1400.webp 1400w"
	},
	"https://mifogen4.com.au/assets/gen4-hires-rose-gold-buds.webp": {
		width: 1e3,
		height: 1e3,
		avif: "https://mifogen4.com.au/assets/responsive/gen4-hires-rose-gold-buds-96.avif 96w, https://mifogen4.com.au/assets/responsive/gen4-hires-rose-gold-buds-240.avif 240w, https://mifogen4.com.au/assets/responsive/gen4-hires-rose-gold-buds-480.avif 480w, https://mifogen4.com.au/assets/responsive/gen4-hires-rose-gold-buds-768.avif 768w, https://mifogen4.com.au/assets/responsive/gen4-hires-rose-gold-buds-1000.avif 1000w",
		webp: "https://mifogen4.com.au/assets/responsive/gen4-hires-rose-gold-buds-96.webp 96w, https://mifogen4.com.au/assets/responsive/gen4-hires-rose-gold-buds-240.webp 240w, https://mifogen4.com.au/assets/responsive/gen4-hires-rose-gold-buds-480.webp 480w, https://mifogen4.com.au/assets/responsive/gen4-hires-rose-gold-buds-768.webp 768w, https://mifogen4.com.au/assets/responsive/gen4-hires-rose-gold-buds-1000.webp 1000w"
	},
	"https://mifogen4.com.au/assets/gen4-hires-rose-gold-open.webp": {
		width: 1400,
		height: 1400,
		avif: "https://mifogen4.com.au/assets/responsive/gen4-hires-rose-gold-open-96.avif 96w, https://mifogen4.com.au/assets/responsive/gen4-hires-rose-gold-open-240.avif 240w, https://mifogen4.com.au/assets/responsive/gen4-hires-rose-gold-open-480.avif 480w, https://mifogen4.com.au/assets/responsive/gen4-hires-rose-gold-open-768.avif 768w, https://mifogen4.com.au/assets/responsive/gen4-hires-rose-gold-open-1280.avif 1280w, https://mifogen4.com.au/assets/responsive/gen4-hires-rose-gold-open-1400.avif 1400w",
		webp: "https://mifogen4.com.au/assets/responsive/gen4-hires-rose-gold-open-96.webp 96w, https://mifogen4.com.au/assets/responsive/gen4-hires-rose-gold-open-240.webp 240w, https://mifogen4.com.au/assets/responsive/gen4-hires-rose-gold-open-480.webp 480w, https://mifogen4.com.au/assets/responsive/gen4-hires-rose-gold-open-768.webp 768w, https://mifogen4.com.au/assets/responsive/gen4-hires-rose-gold-open-1280.webp 1280w, https://mifogen4.com.au/assets/responsive/gen4-hires-rose-gold-open-1400.webp 1400w"
	},
	"https://mifogen4.com.au/assets/gen4-hires-rose-gold-system.webp": {
		width: 1800,
		height: 1800,
		avif: "https://mifogen4.com.au/assets/responsive/gen4-hires-rose-gold-system-96.avif 96w, https://mifogen4.com.au/assets/responsive/gen4-hires-rose-gold-system-240.avif 240w, https://mifogen4.com.au/assets/responsive/gen4-hires-rose-gold-system-480.avif 480w, https://mifogen4.com.au/assets/responsive/gen4-hires-rose-gold-system-768.avif 768w, https://mifogen4.com.au/assets/responsive/gen4-hires-rose-gold-system-1280.avif 1280w, https://mifogen4.com.au/assets/responsive/gen4-hires-rose-gold-system-1800.avif 1800w",
		webp: "https://mifogen4.com.au/assets/responsive/gen4-hires-rose-gold-system-96.webp 96w, https://mifogen4.com.au/assets/responsive/gen4-hires-rose-gold-system-240.webp 240w, https://mifogen4.com.au/assets/responsive/gen4-hires-rose-gold-system-480.webp 480w, https://mifogen4.com.au/assets/responsive/gen4-hires-rose-gold-system-768.webp 768w, https://mifogen4.com.au/assets/responsive/gen4-hires-rose-gold-system-1280.webp 1280w, https://mifogen4.com.au/assets/responsive/gen4-hires-rose-gold-system-1800.webp 1800w"
	},
	"https://mifogen4.com.au/assets/gen4-powerbank-phone-v4.webp": {
		width: 1254,
		height: 1254,
		avif: "https://mifogen4.com.au/assets/responsive/gen4-powerbank-phone-v4-96.avif 96w, https://mifogen4.com.au/assets/responsive/gen4-powerbank-phone-v4-240.avif 240w, https://mifogen4.com.au/assets/responsive/gen4-powerbank-phone-v4-480.avif 480w, https://mifogen4.com.au/assets/responsive/gen4-powerbank-phone-v4-768.avif 768w, https://mifogen4.com.au/assets/responsive/gen4-powerbank-phone-v4-1254.avif 1254w",
		webp: "https://mifogen4.com.au/assets/responsive/gen4-powerbank-phone-v4-96.webp 96w, https://mifogen4.com.au/assets/responsive/gen4-powerbank-phone-v4-240.webp 240w, https://mifogen4.com.au/assets/responsive/gen4-powerbank-phone-v4-480.webp 480w, https://mifogen4.com.au/assets/responsive/gen4-powerbank-phone-v4-768.webp 768w, https://mifogen4.com.au/assets/responsive/gen4-powerbank-phone-v4-1254.webp 1254w"
	},
	"https://mifogen4.com.au/assets/gigabeat-cover.webp": {
		width: 768,
		height: 1024,
		avif: "https://mifogen4.com.au/assets/responsive/gigabeat-cover-96.avif 96w, https://mifogen4.com.au/assets/responsive/gigabeat-cover-240.avif 240w, https://mifogen4.com.au/assets/responsive/gigabeat-cover-480.avif 480w, https://mifogen4.com.au/assets/responsive/gigabeat-cover-768.avif 768w",
		webp: "https://mifogen4.com.au/assets/responsive/gigabeat-cover-96.webp 96w, https://mifogen4.com.au/assets/responsive/gigabeat-cover-240.webp 240w, https://mifogen4.com.au/assets/responsive/gigabeat-cover-480.webp 480w, https://mifogen4.com.au/assets/responsive/gigabeat-cover-768.webp 768w"
	},
	"https://mifogen4.com.au/assets/google-play-badge.png": {
		width: 646,
		height: 250,
		avif: "https://mifogen4.com.au/assets/responsive/google-play-badge-96.avif 96w, https://mifogen4.com.au/assets/responsive/google-play-badge-240.avif 240w, https://mifogen4.com.au/assets/responsive/google-play-badge-480.avif 480w, https://mifogen4.com.au/assets/responsive/google-play-badge-646.avif 646w",
		webp: "https://mifogen4.com.au/assets/responsive/google-play-badge-96.webp 96w, https://mifogen4.com.au/assets/responsive/google-play-badge-240.webp 240w, https://mifogen4.com.au/assets/responsive/google-play-badge-480.webp 480w, https://mifogen4.com.au/assets/responsive/google-play-badge-646.webp 646w"
	},
	"https://mifogen4.com.au/assets/gym-rose-gold.webp": {
		width: 1536,
		height: 1024,
		avif: "https://mifogen4.com.au/assets/responsive/gym-rose-gold-96.avif 96w, https://mifogen4.com.au/assets/responsive/gym-rose-gold-240.avif 240w, https://mifogen4.com.au/assets/responsive/gym-rose-gold-480.avif 480w, https://mifogen4.com.au/assets/responsive/gym-rose-gold-768.avif 768w, https://mifogen4.com.au/assets/responsive/gym-rose-gold-1280.avif 1280w, https://mifogen4.com.au/assets/responsive/gym-rose-gold-1536.avif 1536w",
		webp: "https://mifogen4.com.au/assets/responsive/gym-rose-gold-96.webp 96w, https://mifogen4.com.au/assets/responsive/gym-rose-gold-240.webp 240w, https://mifogen4.com.au/assets/responsive/gym-rose-gold-480.webp 480w, https://mifogen4.com.au/assets/responsive/gym-rose-gold-768.webp 768w, https://mifogen4.com.au/assets/responsive/gym-rose-gold-1280.webp 1280w, https://mifogen4.com.au/assets/responsive/gym-rose-gold-1536.webp 1536w"
	},
	"https://mifogen4.com.au/assets/mifo-logo-mark.png": {
		width: 512,
		height: 512,
		avif: "https://mifogen4.com.au/assets/responsive/mifo-logo-mark-96.avif 96w, https://mifogen4.com.au/assets/responsive/mifo-logo-mark-240.avif 240w, https://mifogen4.com.au/assets/responsive/mifo-logo-mark-480.avif 480w, https://mifogen4.com.au/assets/responsive/mifo-logo-mark-512.avif 512w",
		webp: "https://mifogen4.com.au/assets/responsive/mifo-logo-mark-96.webp 96w, https://mifogen4.com.au/assets/responsive/mifo-logo-mark-240.webp 240w, https://mifogen4.com.au/assets/responsive/mifo-logo-mark-480.webp 480w, https://mifogen4.com.au/assets/responsive/mifo-logo-mark-512.webp 512w"
	},
	"https://mifogen4.com.au/assets/o5-extreme-trail.webp": {
		width: 1920,
		height: 1201,
		avif: "https://mifogen4.com.au/assets/responsive/o5-extreme-trail-96.avif 96w, https://mifogen4.com.au/assets/responsive/o5-extreme-trail-240.avif 240w, https://mifogen4.com.au/assets/responsive/o5-extreme-trail-480.avif 480w, https://mifogen4.com.au/assets/responsive/o5-extreme-trail-768.avif 768w, https://mifogen4.com.au/assets/responsive/o5-extreme-trail-1280.avif 1280w, https://mifogen4.com.au/assets/responsive/o5-extreme-trail-1920.avif 1920w",
		webp: "https://mifogen4.com.au/assets/responsive/o5-extreme-trail-96.webp 96w, https://mifogen4.com.au/assets/responsive/o5-extreme-trail-240.webp 240w, https://mifogen4.com.au/assets/responsive/o5-extreme-trail-480.webp 480w, https://mifogen4.com.au/assets/responsive/o5-extreme-trail-768.webp 768w, https://mifogen4.com.au/assets/responsive/o5-extreme-trail-1280.webp 1280w, https://mifogen4.com.au/assets/responsive/o5-extreme-trail-1920.webp 1920w"
	},
	"https://mifogen4.com.au/assets/runner-coastal.webp": {
		width: 960,
		height: 1200,
		avif: "https://mifogen4.com.au/assets/responsive/runner-coastal-96.avif 96w, https://mifogen4.com.au/assets/responsive/runner-coastal-240.avif 240w, https://mifogen4.com.au/assets/responsive/runner-coastal-480.avif 480w, https://mifogen4.com.au/assets/responsive/runner-coastal-768.avif 768w, https://mifogen4.com.au/assets/responsive/runner-coastal-960.avif 960w",
		webp: "https://mifogen4.com.au/assets/responsive/runner-coastal-96.webp 96w, https://mifogen4.com.au/assets/responsive/runner-coastal-240.webp 240w, https://mifogen4.com.au/assets/responsive/runner-coastal-480.webp 480w, https://mifogen4.com.au/assets/responsive/runner-coastal-768.webp 768w, https://mifogen4.com.au/assets/responsive/runner-coastal-960.webp 960w"
	},
	"https://mifogen4.com.au/assets/runner-v2.webp": {
		width: 1536,
		height: 1024,
		avif: "https://mifogen4.com.au/assets/responsive/runner-v2-96.avif 96w, https://mifogen4.com.au/assets/responsive/runner-v2-240.avif 240w, https://mifogen4.com.au/assets/responsive/runner-v2-480.avif 480w, https://mifogen4.com.au/assets/responsive/runner-v2-768.avif 768w, https://mifogen4.com.au/assets/responsive/runner-v2-1280.avif 1280w, https://mifogen4.com.au/assets/responsive/runner-v2-1536.avif 1536w",
		webp: "https://mifogen4.com.au/assets/responsive/runner-v2-96.webp 96w, https://mifogen4.com.au/assets/responsive/runner-v2-240.webp 240w, https://mifogen4.com.au/assets/responsive/runner-v2-480.webp 480w, https://mifogen4.com.au/assets/responsive/runner-v2-768.webp 768w, https://mifogen4.com.au/assets/responsive/runner-v2-1280.webp 1280w, https://mifogen4.com.au/assets/responsive/runner-v2-1536.webp 1536w"
	},
	"https://mifogen4.com.au/assets/runner-world-cover.webp": {
		width: 768,
		height: 1024,
		avif: "https://mifogen4.com.au/assets/responsive/runner-world-cover-96.avif 96w, https://mifogen4.com.au/assets/responsive/runner-world-cover-240.avif 240w, https://mifogen4.com.au/assets/responsive/runner-world-cover-480.avif 480w, https://mifogen4.com.au/assets/responsive/runner-world-cover-768.avif 768w",
		webp: "https://mifogen4.com.au/assets/responsive/runner-world-cover-96.webp 96w, https://mifogen4.com.au/assets/responsive/runner-world-cover-240.webp 240w, https://mifogen4.com.au/assets/responsive/runner-world-cover-480.webp 480w, https://mifogen4.com.au/assets/responsive/runner-world-cover-768.webp 768w"
	},
	"https://mifogen4.com.au/assets/techbest-cover.webp": {
		width: 768,
		height: 1024,
		avif: "https://mifogen4.com.au/assets/responsive/techbest-cover-96.avif 96w, https://mifogen4.com.au/assets/responsive/techbest-cover-240.avif 240w, https://mifogen4.com.au/assets/responsive/techbest-cover-480.avif 480w, https://mifogen4.com.au/assets/responsive/techbest-cover-768.avif 768w",
		webp: "https://mifogen4.com.au/assets/responsive/techbest-cover-96.webp 96w, https://mifogen4.com.au/assets/responsive/techbest-cover-240.webp 240w, https://mifogen4.com.au/assets/responsive/techbest-cover-480.webp 480w, https://mifogen4.com.au/assets/responsive/techbest-cover-768.webp 768w"
	},
	"https://mifogen4.com.au/assets/gen4-packaging-contents.webp": {
		width: 1280,
		height: 1280,
		avif: "https://mifogen4.com.au/assets/responsive/gen4-packaging-contents-96.avif 96w, https://mifogen4.com.au/assets/responsive/gen4-packaging-contents-240.avif 240w, https://mifogen4.com.au/assets/responsive/gen4-packaging-contents-480.avif 480w, https://mifogen4.com.au/assets/responsive/gen4-packaging-contents-768.avif 768w, https://mifogen4.com.au/assets/responsive/gen4-packaging-contents-1280.avif 1280w",
		webp: "https://mifogen4.com.au/assets/responsive/gen4-packaging-contents-96.webp 96w, https://mifogen4.com.au/assets/responsive/gen4-packaging-contents-240.webp 240w, https://mifogen4.com.au/assets/responsive/gen4-packaging-contents-480.webp 480w, https://mifogen4.com.au/assets/responsive/gen4-packaging-contents-768.webp 768w, https://mifogen4.com.au/assets/responsive/gen4-packaging-contents-1280.webp 1280w"
	},
	"https://mifogen4.com.au/assets/gen4-packaging-open.webp": {
		width: 1600,
		height: 900,
		avif: "https://mifogen4.com.au/assets/responsive/gen4-packaging-open-96.avif 96w, https://mifogen4.com.au/assets/responsive/gen4-packaging-open-240.avif 240w, https://mifogen4.com.au/assets/responsive/gen4-packaging-open-480.avif 480w, https://mifogen4.com.au/assets/responsive/gen4-packaging-open-768.avif 768w, https://mifogen4.com.au/assets/responsive/gen4-packaging-open-1280.avif 1280w, https://mifogen4.com.au/assets/responsive/gen4-packaging-open-1600.avif 1600w",
		webp: "https://mifogen4.com.au/assets/responsive/gen4-packaging-open-96.webp 96w, https://mifogen4.com.au/assets/responsive/gen4-packaging-open-240.webp 240w, https://mifogen4.com.au/assets/responsive/gen4-packaging-open-480.webp 480w, https://mifogen4.com.au/assets/responsive/gen4-packaging-open-768.webp 768w, https://mifogen4.com.au/assets/responsive/gen4-packaging-open-1280.webp 1280w, https://mifogen4.com.au/assets/responsive/gen4-packaging-open-1600.webp 1600w"
	},
	"https://mifogen4.com.au/assets/mifo-app-icon.webp": {
		width: 512,
		height: 512,
		avif: "https://mifogen4.com.au/assets/responsive/mifo-app-icon-96.avif 96w, https://mifogen4.com.au/assets/responsive/mifo-app-icon-240.avif 240w, https://mifogen4.com.au/assets/responsive/mifo-app-icon-480.avif 480w, https://mifogen4.com.au/assets/responsive/mifo-app-icon-512.avif 512w",
		webp: "https://mifogen4.com.au/assets/responsive/mifo-app-icon-96.webp 96w, https://mifogen4.com.au/assets/responsive/mifo-app-icon-240.webp 240w, https://mifogen4.com.au/assets/responsive/mifo-app-icon-480.webp 480w, https://mifogen4.com.au/assets/responsive/mifo-app-icon-512.webp 512w"
	},
	"https://mifogen4.com.au/assets/gallery-case-scale-v2.webp": {
		width: 960,
		height: 960,
		avif: "https://mifogen4.com.au/assets/responsive/gallery-case-scale-v2-96.avif 96w, https://mifogen4.com.au/assets/responsive/gallery-case-scale-v2-240.avif 240w, https://mifogen4.com.au/assets/responsive/gallery-case-scale-v2-480.avif 480w, https://mifogen4.com.au/assets/responsive/gallery-case-scale-v2-768.avif 768w, https://mifogen4.com.au/assets/responsive/gallery-case-scale-v2-960.avif 960w",
		webp: "https://mifogen4.com.au/assets/responsive/gallery-case-scale-v2-96.webp 96w, https://mifogen4.com.au/assets/responsive/gallery-case-scale-v2-240.webp 240w, https://mifogen4.com.au/assets/responsive/gallery-case-scale-v2-480.webp 480w, https://mifogen4.com.au/assets/responsive/gallery-case-scale-v2-768.webp 768w, https://mifogen4.com.au/assets/responsive/gallery-case-scale-v2-960.webp 960w"
	},
	"https://mifogen4.com.au/assets/gallery-gym-palm-v2.webp": {
		width: 960,
		height: 960,
		avif: "https://mifogen4.com.au/assets/responsive/gallery-gym-palm-v2-96.avif 96w, https://mifogen4.com.au/assets/responsive/gallery-gym-palm-v2-240.avif 240w, https://mifogen4.com.au/assets/responsive/gallery-gym-palm-v2-480.avif 480w, https://mifogen4.com.au/assets/responsive/gallery-gym-palm-v2-768.avif 768w, https://mifogen4.com.au/assets/responsive/gallery-gym-palm-v2-960.avif 960w",
		webp: "https://mifogen4.com.au/assets/responsive/gallery-gym-palm-v2-96.webp 96w, https://mifogen4.com.au/assets/responsive/gallery-gym-palm-v2-240.webp 240w, https://mifogen4.com.au/assets/responsive/gallery-gym-palm-v2-480.webp 480w, https://mifogen4.com.au/assets/responsive/gallery-gym-palm-v2-768.webp 768w, https://mifogen4.com.au/assets/responsive/gallery-gym-palm-v2-960.webp 960w"
	}
}, ft = /* @__PURE__ */ o(((e) => {
	var t = Symbol.for("react.transitional.element"), n = Symbol.for("react.fragment");
	function r(e, n, r) {
		var i = null;
		if (r !== void 0 && (i = "" + r), n.key !== void 0 && (i = "" + n.key), "key" in n) for (var a in r = {}, n) a !== "key" && (r[a] = n[a]);
		else r = n;
		return n = r.ref, {
			$$typeof: t,
			type: e,
			key: i,
			ref: n === void 0 ? null : n,
			props: r
		};
	}
	e.Fragment = n, e.jsx = r, e.jsxs = r;
})), j = (/* @__PURE__ */ o(((e, t) => {
	t.exports = ft();
})))();
function M({ src: e, sizes: t = "100vw", srcSet: n, ...r }) {
	let i = dt[e];
	return i ? /* @__PURE__ */ (0, j.jsxs)("picture", {
		style: { display: "contents" },
		children: [/* @__PURE__ */ (0, j.jsx)("source", {
			style: { display: "none" },
			type: "image/avif",
			srcSet: i.avif,
			sizes: t
		}), /* @__PURE__ */ (0, j.jsx)("img", {
			decoding: "async",
			width: i.width,
			height: i.height,
			...r,
			src: e,
			srcSet: i.webp,
			sizes: t
		})]
	}) : /* @__PURE__ */ (0, j.jsx)("img", {
		src: e,
		srcSet: n,
		sizes: n ? t : void 0,
		...r
	});
}
//#endregion
//#region outputs/regional-reviews-nz-20261018/nz/athletics-src/PackagingSection.jsx
var pt = [{
	file: "gen4-packaging-contents.webp",
	label: "The full kit",
	alt: "Mifo Gen 4 retail box and charging case with five pairs of silicone ear tips and a USB-C cable",
	caption: "Fit, power and your next playlist. All in the box."
}, {
	file: "gen4-packaging-open.webp",
	label: "Open the box",
	alt: "Silver Mifo Gen 4 retail packaging beside the open lime presentation box and aluminium charging case",
	caption: "Silver on the outside. Signature Mifo lime within."
}], mt = [
	{
		icon: _e,
		title: "O5 Gen 4 earbuds",
		text: "One pair in your chosen colour. Low-profile sound for the track, gym and everything after."
	},
	{
		icon: se,
		title: "Aluminium charging case",
		text: "Recharge between sessions. Up to 120 hours of total listening with case recharges."
	},
	{
		icon: me,
		title: "Five pairs of silicone ear tips",
		text: "Find your comfortable seal before the first warm-up. A better fit starts with the right tips."
	},
	{
		icon: O,
		title: "USB-C charging cable",
		text: "Plug in, top up and get your kit ready for the next training day."
	}
];
function ht({ onExploreCase: e }) {
	let [t, n] = (0, S.useState)(0), r = (0, S.useRef)(null), i = (e) => n((t) => (t + e + pt.length) % pt.length), a = pt[t];
	return /* @__PURE__ */ (0, j.jsx)("section", {
		className: "packaging-section",
		id: "in-the-box",
		"aria-labelledby": "packaging-title",
		children: /* @__PURE__ */ (0, j.jsxs)("div", {
			className: "packaging-inner",
			children: [
				/* @__PURE__ */ (0, j.jsxs)("div", {
					className: "packaging-heading",
					children: [/* @__PURE__ */ (0, j.jsxs)("div", { children: [/* @__PURE__ */ (0, j.jsxs)("p", {
						className: "eyebrow",
						children: [/* @__PURE__ */ (0, j.jsx)(Te, {
							size: 19,
							"aria-hidden": "true"
						}), " WHAT'S IN THE BOX"]
					}), /* @__PURE__ */ (0, j.jsxs)("h2", {
						id: "packaging-title",
						children: [
							"Unbox your next",
							/* @__PURE__ */ (0, j.jsx)("br", {}),
							"training partner."
						]
					})] }), /* @__PURE__ */ (0, j.jsx)("p", { children: "From the first unboxing to your first session. Your earbuds, charging case and fit essentials, together in signature Mifo packaging." })]
				}),
				/* @__PURE__ */ (0, j.jsxs)("div", {
					className: "packaging-layout",
					children: [/* @__PURE__ */ (0, j.jsxs)("div", {
						className: "packaging-gallery",
						role: "region",
						"aria-label": "Gen 4 packaging gallery",
						"aria-roledescription": "carousel",
						children: [/* @__PURE__ */ (0, j.jsxs)("figure", { children: [/* @__PURE__ */ (0, j.jsx)("div", {
							className: "packaging-stage",
							onTouchStart: (e) => {
								r.current = {
									x: e.touches[0].clientX,
									y: e.touches[0].clientY
								};
							},
							onTouchCancel: () => {
								r.current = null;
							},
							onTouchEnd: (e) => {
								if (!r.current) return;
								let t = r.current.x - e.changedTouches[0].clientX, n = r.current.y - e.changedTouches[0].clientY;
								Math.abs(t) > 40 && Math.abs(t) > Math.abs(n) && i(t > 0 ? 1 : -1), r.current = null;
							},
							children: /* @__PURE__ */ (0, j.jsx)(M, {
								src: `https://mifogen4.com.au/assets/${a.file}`,
								alt: a.alt,
								sizes: "(max-width: 800px) 92vw, (max-width: 1440px) 50vw, 700px",
								loading: "lazy"
							})
						}), /* @__PURE__ */ (0, j.jsx)("figcaption", {
							"aria-live": "polite",
							children: a.caption
						})] }), /* @__PURE__ */ (0, j.jsxs)("div", {
							className: "packaging-controls",
							children: [
								/* @__PURE__ */ (0, j.jsx)("button", {
									className: "icon-button",
									onClick: () => i(-1),
									"aria-label": "Previous packaging image",
									title: "Previous packaging image",
									children: /* @__PURE__ */ (0, j.jsx)(de, { size: 20 })
								}),
								/* @__PURE__ */ (0, j.jsx)("div", {
									className: "packaging-thumbnails",
									role: "group",
									"aria-label": "Choose packaging view",
									children: pt.map((e, r) => /* @__PURE__ */ (0, j.jsxs)("button", {
										onClick: () => n(r),
										"aria-pressed": t === r,
										"aria-label": e.label,
										title: e.label,
										children: [/* @__PURE__ */ (0, j.jsx)(M, {
											src: `https://mifogen4.com.au/assets/${e.file}`,
											alt: "",
											sizes: "56px",
											loading: "lazy"
										}), /* @__PURE__ */ (0, j.jsx)("span", { children: e.label })]
									}, e.file))
								}),
								/* @__PURE__ */ (0, j.jsx)("button", {
									className: "icon-button",
									onClick: () => i(1),
									"aria-label": "Next packaging image",
									title: "Next packaging image",
									children: /* @__PURE__ */ (0, j.jsx)(fe, { size: 20 })
								})
							]
						})]
					}), /* @__PURE__ */ (0, j.jsxs)("div", {
						className: "packaging-details",
						children: [
							/* @__PURE__ */ (0, j.jsx)("p", {
								className: "packaging-included",
								children: "INCLUDED WITH EVERY GEN 4"
							}),
							/* @__PURE__ */ (0, j.jsx)("ul", {
								className: "packaging-list",
								children: mt.map(({ icon: e, title: t, text: n }, r) => /* @__PURE__ */ (0, j.jsxs)("li", { children: [
									/* @__PURE__ */ (0, j.jsx)(e, {
										size: 23,
										"aria-hidden": "true"
									}),
									/* @__PURE__ */ (0, j.jsxs)("div", { children: [/* @__PURE__ */ (0, j.jsx)("h3", { children: t }), /* @__PURE__ */ (0, j.jsx)("p", { children: n })] }),
									/* @__PURE__ */ (0, j.jsxs)("span", {
										className: "packaging-index",
										"aria-hidden": "true",
										children: ["0", r + 1]
									})
								] }, t))
							}),
							/* @__PURE__ */ (0, j.jsxs)("a", {
								className: "button button-lime",
								href: "#shop",
								children: ["Choose your colour ", /* @__PURE__ */ (0, j.jsx)(T, { size: 18 })]
							}),
							/* @__PURE__ */ (0, j.jsx)("small", { children: "Graphite shown. Earbuds and charging case come in your selected colour." })
						]
					})]
				}),
				/* @__PURE__ */ (0, j.jsxs)("div", {
					className: "packaging-bonus",
					children: [
						/* @__PURE__ */ (0, j.jsx)(ge, {
							size: 27,
							"aria-hidden": "true"
						}),
						/* @__PURE__ */ (0, j.jsxs)("div", { children: [/* @__PURE__ */ (0, j.jsx)("strong", { children: "And a little extra for your kit bag." }), /* @__PURE__ */ (0, j.jsx)("p", { children: "Your free Airfome hard-shell carrying case is added separately, one per pair. A limited-time bonus, not the charging case." })] }),
						/* @__PURE__ */ (0, j.jsxs)("button", {
							className: "text-link",
							onClick: e,
							children: ["Explore your free case ", /* @__PURE__ */ (0, j.jsx)(T, { size: 18 })]
						})
					]
				})
			]
		})
	});
}
//#endregion
//#region outputs/regional-reviews-nz-20261018/nz/athletics-src/comparison.mjs
var gt = "18 August 2026", _t = [
	{
		id: "apple",
		brand: "Apple",
		model: "AirPods Pro 3",
		price: 42900,
		priceType: "RRP",
		source: "https://www.apple.com/au/airpods-pro/specs/",
		priceSource: "https://www.apple.com/au/shop/buy-airpods/airpods-pro-3"
	},
	{
		id: "sony",
		brand: "Sony",
		model: "WF-1000XM5",
		price: 34995,
		priceType: "Listed price",
		source: "https://www.sony.com.au/headphones/products/wf-1000xm5",
		priceSource: "https://store.sony.com.au/headphones-noisecancelling/WF1000XM5B.html"
	},
	{
		id: "bose",
		brand: "Bose",
		model: "QC Ultra Earbuds 2",
		price: 45e3,
		priceType: "Launch price",
		source: "https://www.bose.com.au/pressroom/bose-announces-the-quietcomfort-ultra-earbuds-2nd-gen"
	},
	{
		id: "samsung",
		brand: "Samsung",
		model: "Galaxy Buds4 Pro",
		price: 39900,
		priceType: "RRP",
		source: "https://www.samsung.com/au/audio-sound/galaxy-buds/galaxy-buds4-pro-black-sm-r640nzkaxsa/"
	}
], vt = [
	{
		id: "battery",
		label: "Listening with the case",
		icon: "battery",
		values: [
			["Up to 120 hours", "Includes case recharges"],
			["Up to 24 hours", "ANC on"],
			["Up to 24 hours", "ANC on"],
			["Up to 24 hours", "Immersive Audio off"],
			["Up to 30 hours", "ANC off"]
		]
	},
	{
		id: "power",
		label: "Charge your phone",
		icon: "power",
		values: [
			["USB-C power bank", "Built into the charging case"],
			["Not listed", "No device-charging feature listed"],
			["Not listed", "No device-charging feature listed"],
			["Not listed", "No device-charging feature listed"],
			["Not listed", "No device-charging feature listed"]
		]
	},
	{
		id: "noise",
		label: "Find your focus",
		icon: "noise",
		values: [
			["Hybrid ANC", "Plus transparency mode"],
			["ANC + Adaptive Audio", "Plus transparency mode"],
			["Noise cancelling", "Plus Ambient Sound"],
			["Adaptive ANC", "Plus Aware Mode"],
			["Adaptive ANC", "Plus ambient sound"]
		]
	},
	{
		id: "app",
		label: "Tune your workout",
		icon: "app",
		values: [
			["Mifo app EQ", "iOS + Android"],
			["Adaptive EQ", "Apple system controls"],
			["Sound Connect EQ", "iOS + Android app"],
			["Bose app EQ", "iOS + Android app"],
			["Galaxy controls", "Compatible Android devices"]
		]
	},
	{
		id: "switch",
		label: "Switch devices",
		icon: "switch",
		values: [
			["Multipoint", "Two compatible devices"],
			["Automatic switching", "Apple ecosystem"],
			["Multipoint", "Two compatible devices"],
			["Multipoint", "Two compatible devices"],
			["Auto Switch", "Galaxy ecosystem"]
		]
	},
	{
		id: "audio",
		label: "Audio technology",
		icon: "noise",
		extra: !0,
		values: [
			["LDAC", "High-resolution playback"],
			["H2 chip", "Adaptive EQ"],
			["LDAC + LC3", "8.4 mm driver"],
			["aptX Adaptive", "Compatible Snapdragon Sound devices"],
			["24-bit / 96 kHz", "Compatible Galaxy devices"]
		]
	},
	{
		id: "wireless",
		label: "Wireless connection",
		icon: "switch",
		extra: !0,
		values: [
			["Bluetooth 6.0", "BR / EDR / BLE"],
			["Bluetooth 5.3", ""],
			["Bluetooth 5.3", ""],
			["Bluetooth 5.3", ""],
			["LE Audio + Auracast", "Compatible devices required"]
		]
	},
	{
		id: "latency",
		label: "Low-latency mode",
		icon: "latency",
		extra: !0,
		values: [
			["60 ms", "With SBC or AAC"],
			["Not quantified", "No public latency figure"],
			["Not quantified", "No public latency figure"],
			["aptX Adaptive", "Includes low-latency operation"],
			["Not quantified", "No public latency figure"]
		]
	}
], yt = {
	battery: se,
	power: Fe,
	noise: ae,
	app: Pe,
	switch: D,
	latency: Be
};
function bt({ colour: e, colourName: t }) {
	let [n, r] = (0, S.useState)("apple"), [i, a] = (0, S.useState)(!1), o = (e) => `compare-rival${e === n ? " is-selected" : ""}`;
	return /* @__PURE__ */ (0, j.jsx)("section", {
		className: "comparison-section",
		id: "compare",
		"aria-labelledby": "compare-title",
		children: /* @__PURE__ */ (0, j.jsxs)("div", {
			className: "comparison-inner",
			children: [
				/* @__PURE__ */ (0, j.jsxs)("div", {
					className: "comparison-heading",
					children: [/* @__PURE__ */ (0, j.jsxs)("div", { children: [
						/* @__PURE__ */ (0, j.jsx)("p", {
							className: "eyebrow",
							children: "COMPARE TO MIFO"
						}),
						/* @__PURE__ */ (0, j.jsxs)("h2", {
							id: "compare-title",
							children: [
								"Built for training.",
								/* @__PURE__ */ (0, j.jsx)("br", {}),
								/* @__PURE__ */ (0, j.jsx)("span", { children: "Compare your kit." })
							]
						}),
						/* @__PURE__ */ (0, j.jsxs)("p", {
							className: "comparison-lead",
							children: [
								"More power for your training. More left for the rest of your kit. Get 120-hour total listening, hybrid ANC and a USB-C power bank for NZ",
								A(He),
								"."
							]
						})
					] }), /* @__PURE__ */ (0, j.jsx)("div", {
						className: "comparison-product",
						children: /* @__PURE__ */ (0, j.jsx)(M, {
							src: `https://mifogen4.com.au/assets/gen4-hires-${e}-system.webp`,
							alt: `${t} Mifo O5 Gen 4 earbuds and aluminium charging case`,
							sizes: "(max-width: 800px) 1px, 340px",
							loading: "lazy"
						})
					})]
				}),
				/* @__PURE__ */ (0, j.jsxs)("label", {
					className: "comparison-picker",
					htmlFor: "compare-brand",
					children: ["Compare Mifo with", /* @__PURE__ */ (0, j.jsxs)("span", { children: [/* @__PURE__ */ (0, j.jsx)("select", {
						id: "compare-brand",
						value: n,
						onChange: (e) => r(e.target.value),
						children: _t.map((e) => /* @__PURE__ */ (0, j.jsxs)("option", {
							value: e.id,
							children: [
								e.brand,
								" ",
								e.model
							]
						}, e.id))
					}), /* @__PURE__ */ (0, j.jsx)(ue, {
						size: 18,
						"aria-hidden": "true"
					})] })]
				}),
				/* @__PURE__ */ (0, j.jsx)("div", {
					className: "comparison-table-wrap",
					children: /* @__PURE__ */ (0, j.jsxs)("table", {
						className: "comparison-table",
						"aria-describedby": "comparison-method",
						children: [
							/* @__PURE__ */ (0, j.jsxs)("caption", {
								className: "sr-only",
								children: [
									"Mifo O5 Gen 4 and premium wireless earbuds. Feature reference checked ",
									gt,
									"."
								]
							}),
							/* @__PURE__ */ (0, j.jsx)("thead", { children: /* @__PURE__ */ (0, j.jsxs)("tr", { children: [
								/* @__PURE__ */ (0, j.jsx)("th", {
									scope: "col",
									className: "compare-feature",
									children: /* @__PURE__ */ (0, j.jsxs)("span", { children: [
										"YOUR KIT,",
										/* @__PURE__ */ (0, j.jsx)("br", {}),
										"COMPARED"
									] })
								}),
								/* @__PURE__ */ (0, j.jsxs)("th", {
									scope: "col",
									className: "compare-mifo",
									children: [
										/* @__PURE__ */ (0, j.jsxs)("span", {
											className: "compare-brand",
											children: ["MIFO ", /* @__PURE__ */ (0, j.jsx)(oe, {
												size: 17,
												"aria-hidden": "true"
											})]
										}),
										/* @__PURE__ */ (0, j.jsx)("strong", {
											className: "compare-model",
											children: "O5 Gen 4"
										}),
										/* @__PURE__ */ (0, j.jsxs)("span", {
											className: "compare-price",
											children: ["NZ", A(He)]
										}),
										/* @__PURE__ */ (0, j.jsx)("small", { children: "Current price" })
									]
								}),
								_t.map((e) => /* @__PURE__ */ (0, j.jsxs)("th", {
									scope: "col",
									className: o(e.id),
									children: [/* @__PURE__ */ (0, j.jsx)("span", {
										className: "compare-brand",
										children: e.brand
									}), /* @__PURE__ */ (0, j.jsx)("strong", {
										className: "compare-model",
										children: e.model
									})]
								}, e.id))
							] }) }),
							/* @__PURE__ */ (0, j.jsx)("tbody", {
								id: "comparison-values",
								children: vt.map((e) => {
									let t = yt[e.icon];
									return /* @__PURE__ */ (0, j.jsxs)("tr", {
										hidden: e.extra && !i,
										children: [/* @__PURE__ */ (0, j.jsxs)("th", {
											scope: "row",
											className: "compare-feature",
											children: [/* @__PURE__ */ (0, j.jsx)(t, {
												size: 18,
												"aria-hidden": "true"
											}), /* @__PURE__ */ (0, j.jsx)("span", { children: e.label })]
										}), e.values.map(([e, t], n) => /* @__PURE__ */ (0, j.jsxs)("td", {
											className: n === 0 ? "compare-mifo" : o(_t[n - 1].id),
											children: [/* @__PURE__ */ (0, j.jsx)("strong", { children: e }), t && /* @__PURE__ */ (0, j.jsx)("small", { children: t })]
										}, n))]
									}, e.id);
								})
							})
						]
					})
				}),
				/* @__PURE__ */ (0, j.jsxs)("div", {
					className: "comparison-actions",
					children: [/* @__PURE__ */ (0, j.jsxs)("button", {
						type: "button",
						className: "comparison-expand",
						"aria-expanded": i,
						"aria-controls": "comparison-values",
						onClick: () => a(!i),
						children: [i ? /* @__PURE__ */ (0, j.jsx)(Se, { size: 18 }) : /* @__PURE__ */ (0, j.jsx)(De, { size: 18 }), i ? "Fewer specifications" : "Audio, Bluetooth & latency"]
					}), /* @__PURE__ */ (0, j.jsxs)("a", {
						className: "button button-lime",
						href: "#shop",
						children: ["Choose your Gen 4 ", /* @__PURE__ */ (0, j.jsx)(T, { size: 18 })]
					})]
				}),
				/* @__PURE__ */ (0, j.jsxs)("div", {
					className: "comparison-footnotes",
					id: "comparison-method",
					children: [
						/* @__PURE__ */ (0, j.jsxs)("p", { children: [
							"Mifo is NZ$199.99 including GST, with one free Airfome carrying case per pair. NZ delivery is NZ$19.99, or free from NZ$299.99 after discounts. Competitor features were checked on ",
							gt,
							"; NZ retail prices vary."
						] }),
						/* @__PURE__ */ (0, j.jsx)("p", { children: "Battery figures include case recharges and use each manufacturer's published conditions, not identical laboratory tests. Gen 4 runtime varies with volume, ANC, codec and use. Advanced audio, switching and app features depend on compatible devices. Specifications are not a ranking of sound or ANC quality." }),
						/* @__PURE__ */ (0, j.jsxs)("details", { children: [
							/* @__PURE__ */ (0, j.jsxs)("summary", { children: ["Comparison notes & sources ", /* @__PURE__ */ (0, j.jsx)(ue, {
								size: 16,
								"aria-hidden": "true"
							})] }),
							/* @__PURE__ */ (0, j.jsx)("p", { children: "Mifo values are final Gen 4 specifications and platform features. Competitor features use the original comparison's dated reference. Manufacturer pages linked below describe their own products; a feature marked \"not listed\" is not confirmed by the published specification." }),
							/* @__PURE__ */ (0, j.jsx)("div", {
								className: "comparison-sources",
								children: _t.map((e) => /* @__PURE__ */ (0, j.jsxs)("a", {
									href: e.source,
									target: "_blank",
									rel: "noreferrer",
									children: [
										e.brand,
										" specifications ",
										/* @__PURE__ */ (0, j.jsx)(T, {
											size: 14,
											"aria-hidden": "true"
										})
									]
								}, e.id))
							})
						] })
					]
				})
			]
		})
	});
}
//#endregion
//#region outputs/regional-reviews-nz-20261018/nz/athletics-src/reviews.mjs
var xt = {
	shop: "mifo-com-au.myshopify.com",
	productId: "2295061217376",
	endpoint: "https://api.judge.me/reviews/reviews_for_widget"
}, St = {
	newest: ["created_at", "desc"],
	highest: ["rating", "desc"],
	lowest: ["rating", "asc"],
	photos: ["pictures_first", "desc"]
};
function Ct({ page: e = 1, rating: t = "", sort: n = "newest", search: r = "" } = {}) {
	let i = new URL(xt.endpoint), [a, o] = St[n] || St.newest, s = {
		shop_domain: xt.shop,
		platform: "shopify",
		product_id: xt.productId,
		page: String(Math.max(1, Math.floor(Number(e) || 1))),
		per_page: "10",
		sort_by: a,
		sort_dir: o
	};
	return /^[1-5]$/.test(String(t)) && (s.filter_rating = String(t)), r.trim() && (s.search = r.trim().slice(0, 200)), i.search = new URLSearchParams(s).toString(), i.href;
}
function wt(e) {
	try {
		let t = new URL(e);
		return t.protocol === "https:" && t.hostname === "review-images.judgeme.com" ? t.href : null;
	} catch {
		return null;
	}
}
function Tt(e) {
	let t = e.transparency_badges || [];
	return {
		verified: e.verified_buyer === !0,
		incentivised: t.some((e) => /earned|incentivi|reward|free_product/i.test(e)),
		invited: t.includes("review_collected_via_store_invitation")
	};
}
function Et(e) {
	if (String(e?.product_external_id) !== xt.productId || !Array.isArray(e?.reviews) || !Array.isArray(e?.histogram) || !e?.pagination || !Number.isFinite(Number(e.average_rating))) throw Error("The review service returned an unexpected response.");
	return e;
}
async function Dt(e, { signal: t, fetcher: n = fetch } = {}) {
	let r = await n(Ct(e), {
		signal: t,
		credentials: "omit",
		headers: { Accept: "application/json" }
	});
	if (!r.ok) throw Error("Reviews are temporarily unavailable.");
	return Et(await r.json());
}
//#endregion
//#region outputs/regional-reviews-nz-20261018/nz/athletics-src/ReviewsExplorer.jsx
function Ot(e) {
	let t = new DOMParser().parseFromString(String(e || ""), "text/html");
	return t.querySelectorAll("script, style, iframe, object").forEach((e) => e.remove()), t.querySelectorAll("br").forEach((e) => e.replaceWith("\n")), t.querySelectorAll("p").forEach((e) => e.append("\n")), t.body.textContent.trim();
}
function kt({ rating: e }) {
	return /* @__PURE__ */ (0, j.jsx)("span", {
		className: "explorer-stars",
		role: "img",
		"aria-label": `${e} out of 5 stars`,
		children: [
			1,
			2,
			3,
			4,
			5
		].map((t) => /* @__PURE__ */ (0, j.jsxs)("span", { children: [/* @__PURE__ */ (0, j.jsx)(Ie, {}), /* @__PURE__ */ (0, j.jsx)("span", {
			style: { width: `${Math.min(1, Math.max(0, e - t + 1)) * 100}%` },
			children: /* @__PURE__ */ (0, j.jsx)(Ie, {})
		})] }, t))
	});
}
function At(e) {
	if (e.key !== "Tab") return;
	let t = [...e.currentTarget.querySelectorAll("button:not(:disabled), input, select, [tabindex='0']")].filter((e) => e.getClientRects().length && !e.closest("[hidden]")), n = t[0], r = t.at(-1);
	e.shiftKey && document.activeElement === n ? (e.preventDefault(), r?.focus()) : !e.shiftKey && document.activeElement === r && (e.preventDefault(), n?.focus());
}
function jt({ review: e, onPhoto: t }) {
	let [n, r] = (0, S.useState)(!1), i = Ot(e.body_html), a = Tt(e), o = (e.pictures_urls || []).map((e) => ({
		original: wt(e.original),
		small: wt(e.small)
	})).filter((e) => e.original && e.small), s = e.is_anonymous_reviewer ? "Anonymous" : Ot(e.reviewer_name || "Mifo customer");
	return /* @__PURE__ */ (0, j.jsxs)("article", {
		className: "explorer-review",
		children: [
			/* @__PURE__ */ (0, j.jsx)("div", {
				className: "explorer-review-top",
				children: /* @__PURE__ */ (0, j.jsx)(kt, { rating: e.rating })
			}),
			/* @__PURE__ */ (0, j.jsx)("h3", { children: Ot(e.title) }),
			/* @__PURE__ */ (0, j.jsx)("p", {
				className: "explorer-body",
				children: !n && i.length > 500 ? `${i.slice(0, 500)}…` : i
			}),
			i.length > 500 && /* @__PURE__ */ (0, j.jsx)("button", {
				className: "explorer-text-button",
				"aria-expanded": n,
				onClick: () => r(!n),
				children: n ? "Read less" : "Read full review"
			}),
			o.length > 0 && /* @__PURE__ */ (0, j.jsx)("div", {
				className: "explorer-photos",
				children: o.map((e, n) => /* @__PURE__ */ (0, j.jsx)("button", {
					onClick: () => t({
						...e,
						alt: `${s}'s review photo ${n + 1}`
					}),
					"aria-label": `Enlarge ${s}'s review photo ${n + 1}`,
					children: /* @__PURE__ */ (0, j.jsx)("img", {
						src: e.small,
						alt: `${s}'s review photo ${n + 1}`,
						width: "80",
						height: "80",
						loading: "lazy"
					})
				}, e.original))
			}),
			/* @__PURE__ */ (0, j.jsxs)("div", {
				className: "explorer-author",
				children: [/* @__PURE__ */ (0, j.jsx)("strong", { children: s }), a.verified && /* @__PURE__ */ (0, j.jsxs)("span", { children: [/* @__PURE__ */ (0, j.jsx)(pe, { size: 14 }), " Verified buyer"] })]
			}),
			e.reply_content && /* @__PURE__ */ (0, j.jsxs)("div", {
				className: "explorer-reply",
				children: [/* @__PURE__ */ (0, j.jsx)("strong", { children: Ot(e.shop_reply_name || "Mifo Customer Support") }), /* @__PURE__ */ (0, j.jsx)("p", { children: Ot(e.reply_content) })]
			})
		]
	});
}
function Mt({ onClose: e, onShop: t, price: n }) {
	let [r, i] = (0, S.useState)({
		page: 1,
		rating: "",
		sort: "newest",
		search: ""
	}), [a, o] = (0, S.useState)(""), [s, c] = (0, S.useState)(null), [l, u] = (0, S.useState)(!0), [d, f] = (0, S.useState)(""), [p, m] = (0, S.useState)(0), [h, g] = (0, S.useState)(null), _ = (0, S.useRef)(null), v = (0, S.useRef)(null), y = (0, S.useRef)(null), b = (0, S.useRef)(!1), x = (0, S.useRef)(null), ee = (0, S.useRef)(null);
	(0, S.useEffect)(() => {
		let e = new AbortController(), t = setTimeout(() => e.abort(), 15e3), n = !0;
		return u(!0), f(""), Dt(r, { signal: e.signal }).then((e) => {
			n && (c(e), y.current ||= e);
		}).catch(() => {
			n && f("We couldn't load reviews just now. Please try again.");
		}).finally(() => {
			clearTimeout(t), n && u(!1);
		}), () => {
			n = !1, clearTimeout(t), e.abort();
		};
	}, [r, p]), (0, S.useEffect)(() => {
		!l && !d && b.current && (_.current?.scrollTo({ top: v.current.offsetTop - _.current.offsetTop - 16 }), v.current?.focus({ preventScroll: !0 }), b.current = !1);
	}, [l, d]), (0, S.useEffect)(() => {
		h && ee.current?.focus();
	}, [h]);
	function C(e) {
		i((t) => ({
			...t,
			...e,
			page: 1
		}));
	}
	function te() {
		o(""), i({
			page: 1,
			rating: "",
			sort: "newest",
			search: ""
		});
	}
	function ne() {
		g(null), requestAnimationFrame(() => x.current?.focus());
	}
	let w = y.current || s, re = r.rating || r.search, E = w?.number_of_reviews, ae = Math.max(1, Number(s?.pagination?.total_pages) || 1);
	return /* @__PURE__ */ (0, j.jsxs)("div", {
		className: "reviews-explorer",
		onKeyDown: At,
		children: [
			/* @__PURE__ */ (0, j.jsxs)("div", {
				className: "dialog-heading explorer-heading",
				children: [/* @__PURE__ */ (0, j.jsxs)("div", { children: [/* @__PURE__ */ (0, j.jsx)("span", {
					className: "eyebrow",
					children: "THE MIFO COMMUNITY"
				}), /* @__PURE__ */ (0, j.jsx)("h2", { children: "Mifo, in your words." })] }), /* @__PURE__ */ (0, j.jsx)("button", {
					className: "icon-button",
					"aria-label": "Close reviews",
					title: "Close reviews",
					onClick: e,
					autoFocus: !0,
					children: /* @__PURE__ */ (0, j.jsx)(ze, {})
				})]
			}),
			/* @__PURE__ */ (0, j.jsxs)("div", {
				className: "explorer-scroll",
				ref: _,
				hidden: !!h,
				children: [
					/* @__PURE__ */ (0, j.jsxs)("div", {
						className: "explorer-overview",
						children: [/* @__PURE__ */ (0, j.jsxs)("div", {
							className: "explorer-score",
							children: [
								/* @__PURE__ */ (0, j.jsxs)("strong", { children: [w ? Number(w.average_rating).toFixed(1) : "4.7", /* @__PURE__ */ (0, j.jsx)("small", { children: "/5" })] }),
								/* @__PURE__ */ (0, j.jsx)(kt, { rating: w ? Number(w.average_rating) : 4.7 }),
								/* @__PURE__ */ (0, j.jsxs)("span", { children: [E ? E.toLocaleString("en-AU") : "6,140", " O5 family reviews"] }),
								/* @__PURE__ */ (0, j.jsx)("img", {
									src: "https://mifogen4.com.au/assets/judgeme-logo.svg",
									alt: "Reviews collected by Judge.me",
									width: "125",
									height: "24"
								})
							]
						}), /* @__PURE__ */ (0, j.jsx)("div", {
							className: "explorer-histogram",
							"aria-label": "Filter reviews by star rating",
							children: (w?.histogram || [
								5,
								4,
								3,
								2,
								1
							].map((e) => ({
								rating: e,
								frequency: 0
							}))).map((e) => /* @__PURE__ */ (0, j.jsxs)("button", {
								"aria-label": `Filter ${e.rating} star reviews`,
								"aria-pressed": String(e.rating) === r.rating,
								disabled: !w,
								onClick: () => C({ rating: String(e.rating) === r.rating ? "" : String(e.rating) }),
								children: [
									/* @__PURE__ */ (0, j.jsxs)("span", { children: [
										e.rating,
										" ",
										/* @__PURE__ */ (0, j.jsx)(Ie, {
											size: 13,
											fill: "currentColor"
										})
									] }),
									/* @__PURE__ */ (0, j.jsx)("span", {
										className: "histogram-track",
										children: /* @__PURE__ */ (0, j.jsx)("span", { style: { width: `${E ? e.frequency / E * 100 : 0}%` } })
									}),
									/* @__PURE__ */ (0, j.jsx)("span", { children: w ? e.frequency.toLocaleString("en-AU") : "—" })
								]
							}, e.rating))
						})]
					}),
					/* @__PURE__ */ (0, j.jsxs)("form", {
						className: "explorer-filters",
						onSubmit: (e) => {
							e.preventDefault(), C({ search: a.trim() });
						},
						children: [
							/* @__PURE__ */ (0, j.jsxs)("label", {
								className: "explorer-search",
								children: [/* @__PURE__ */ (0, j.jsx)("span", { children: "Search reviews" }), /* @__PURE__ */ (0, j.jsxs)("div", { children: [/* @__PURE__ */ (0, j.jsx)("input", {
									type: "search",
									"aria-label": "Search reviews",
									placeholder: "Fit, running, battery…",
									maxLength: 200,
									value: a,
									onChange: (e) => o(e.target.value)
								}), /* @__PURE__ */ (0, j.jsx)("button", {
									type: "submit",
									"aria-label": "Search reviews",
									title: "Search reviews",
									children: /* @__PURE__ */ (0, j.jsx)(je, { size: 19 })
								})] })]
							}),
							/* @__PURE__ */ (0, j.jsxs)("label", { children: [/* @__PURE__ */ (0, j.jsx)("span", { children: "Rating" }), /* @__PURE__ */ (0, j.jsxs)("select", {
								value: r.rating,
								onChange: (e) => C({ rating: e.target.value }),
								children: [/* @__PURE__ */ (0, j.jsx)("option", {
									value: "",
									children: "All ratings"
								}), [
									5,
									4,
									3,
									2,
									1
								].map((e) => /* @__PURE__ */ (0, j.jsxs)("option", {
									value: e,
									children: [
										e,
										" ",
										e === 1 ? "star" : "stars"
									]
								}, e))]
							})] }),
							/* @__PURE__ */ (0, j.jsxs)("label", { children: [/* @__PURE__ */ (0, j.jsx)("span", { children: "Sort by" }), /* @__PURE__ */ (0, j.jsxs)("select", {
								value: r.sort,
								onChange: (e) => C({ sort: e.target.value }),
								children: [
									/* @__PURE__ */ (0, j.jsx)("option", {
										value: "newest",
										children: "Most recent"
									}),
									/* @__PURE__ */ (0, j.jsx)("option", {
										value: "highest",
										children: "Highest rating"
									}),
									/* @__PURE__ */ (0, j.jsx)("option", {
										value: "lowest",
										children: "Lowest rating"
									}),
									/* @__PURE__ */ (0, j.jsx)("option", {
										value: "photos",
										children: "Photos first"
									})
								]
							})] })
						]
					}),
					/* @__PURE__ */ (0, j.jsxs)("div", {
						className: "explorer-results-meta",
						children: [/* @__PURE__ */ (0, j.jsx)("span", {
							role: "status",
							"aria-live": "polite",
							children: l ? "Loading reviews…" : d ? "Reviews unavailable" : `${s?.reviews.length || 0} reviews on this page${r.rating ? ` · ${r.rating} stars` : ""}${r.search ? ` · “${r.search}”` : ""}`
						}), re && /* @__PURE__ */ (0, j.jsxs)("button", {
							className: "explorer-text-button",
							onClick: te,
							children: ["Clear filters ", /* @__PURE__ */ (0, j.jsx)(ze, { size: 13 })]
						})]
					}),
					/* @__PURE__ */ (0, j.jsx)("div", {
						ref: v,
						className: "explorer-results",
						tabIndex: -1,
						"aria-label": "Review results",
						"aria-busy": l,
						children: l ? /* @__PURE__ */ (0, j.jsxs)("div", {
							className: "explorer-loading",
							children: [/* @__PURE__ */ (0, j.jsx)(ve, {
								className: "review-spinner",
								size: 25
							}), /* @__PURE__ */ (0, j.jsx)("p", { children: "Loading from Judge.me" })]
						}) : d ? /* @__PURE__ */ (0, j.jsxs)("div", {
							className: "explorer-empty",
							role: "alert",
							children: [/* @__PURE__ */ (0, j.jsx)("p", { children: d }), /* @__PURE__ */ (0, j.jsxs)("button", {
								className: "button button-dark",
								onClick: () => m((e) => e + 1),
								children: [/* @__PURE__ */ (0, j.jsx)(Oe, { size: 17 }), " Try again"]
							})]
						}) : s.reviews.length ? s.reviews.map((e) => /* @__PURE__ */ (0, j.jsx)(jt, {
							review: e,
							onPhoto: (e) => {
								x.current = document.activeElement, g(e);
							}
						}, e.uuid)) : /* @__PURE__ */ (0, j.jsxs)("div", {
							className: "explorer-empty",
							children: [
								/* @__PURE__ */ (0, j.jsx)("h3", { children: "No matching reviews" }),
								/* @__PURE__ */ (0, j.jsx)("p", { children: "Try another word or choose a different rating." }),
								/* @__PURE__ */ (0, j.jsx)("button", {
									className: "explorer-text-button",
									onClick: te,
									children: "Clear filters"
								})
							]
						})
					}),
					!l && !d && s?.reviews.length > 0 && /* @__PURE__ */ (0, j.jsxs)("nav", {
						className: "explorer-pagination",
						"aria-label": "Review pages",
						children: [
							/* @__PURE__ */ (0, j.jsx)("button", {
								className: "icon-button",
								title: "Previous review page",
								"aria-label": "Previous review page",
								disabled: r.page <= 1,
								onClick: () => {
									b.current = !0, i((e) => ({
										...e,
										page: e.page - 1
									}));
								},
								children: /* @__PURE__ */ (0, j.jsx)(de, {})
							}),
							/* @__PURE__ */ (0, j.jsxs)("span", { children: [
								"Page ",
								r.page,
								" of ",
								ae
							] }),
							/* @__PURE__ */ (0, j.jsx)("button", {
								className: "icon-button",
								title: "Next review page",
								"aria-label": "Next review page",
								disabled: r.page >= ae,
								onClick: () => {
									b.current = !0, i((e) => ({
										...e,
										page: e.page + 1
									}));
								},
								children: /* @__PURE__ */ (0, j.jsx)(fe, {})
							})
						]
					})
				]
			}),
			h && /* @__PURE__ */ (0, j.jsxs)("div", {
				className: "explorer-photo-view",
				children: [
					/* @__PURE__ */ (0, j.jsxs)("button", {
						ref: ee,
						className: "explorer-text-button",
						onClick: ne,
						children: [/* @__PURE__ */ (0, j.jsx)(ie, { size: 18 }), " Back to reviews"]
					}),
					/* @__PURE__ */ (0, j.jsx)("img", {
						src: h.original,
						alt: h.alt
					}),
					/* @__PURE__ */ (0, j.jsx)("p", { children: h.alt })
				]
			}),
			/* @__PURE__ */ (0, j.jsxs)("div", {
				className: "explorer-footer",
				children: [/* @__PURE__ */ (0, j.jsxs)("span", { children: [/* @__PURE__ */ (0, j.jsx)("strong", { children: "Your next training partner." }), /* @__PURE__ */ (0, j.jsxs)("small", { children: [n, " · Free case included"] })] }), /* @__PURE__ */ (0, j.jsxs)("button", {
					className: "button button-dark",
					onClick: t,
					children: ["Shop Gen 4 ", /* @__PURE__ */ (0, j.jsx)(T, { size: 17 })]
				})]
			})
		]
	});
}
//#endregion
//#region outputs/regional-reviews-nz-20261018/nz/athletics-src/NoiseControlSection.jsx
var Nt = [{
	id: "anc",
	label: "Noise cancelling",
	icon: Re,
	image: "gallery-indoor-cycle.webp",
	alt: "Athlete wearing a matte-black Mifo earbud during an indoor cycling session",
	caption: "YOUR SESSION. YOUR SOUNDTRACK.",
	name: "HYBRID ACTIVE NOISE CANCELLING",
	heading: "Less background. More beat.",
	description: "Turn down the distractions and get into your session. Hybrid ANC reduces unwanted background noise, giving your playlist more room when you train indoors, travel or unwind.",
	features: [
		["Two ways to tackle noise", "Feedforward and feedback noise control work together to reduce the sound you don't want in your listening."],
		["Made for your focus time", "From solo gym sets to indoor intervals, keep your attention on the music that moves you."],
		["Start with a good seal", "Choose a snug, comfortable fit from the included silicone ear tips to help noise reduction and bass performance."]
	],
	note: "ANC reduces noise; it does not remove every sound. Performance varies with fit and surroundings."
}, {
	id: "transparency",
	label: "Transparency",
	icon: me,
	image: "runner-coastal.webp",
	alt: "Runner wearing a graphite Mifo earbud on a coastal path",
	caption: "YOUR MUSIC. MORE OF YOUR WORLD.",
	name: "TRANSPARENCY MODE",
	heading: "Let the outside in.",
	description: "Keep your earbuds in and bring more of your surroundings into your listening. Transparency mode lets ambient sound through alongside your music, for the moments when you don't want to shut the world out.",
	features: [
		["Hear beyond the playlist", "Let voices and everyday sounds into your listening without taking your earbuds out."],
		["Between sets and on the move", "Hear a training partner between sets or more of the space around you on your post-workout walk."],
		["You choose the balance", "Switch listening modes in the Mifo app, and keep your music at a comfortable volume."]
	],
	note: "Stay attentive outdoors. Transparency is not hearing protection and does not guarantee you will hear traffic or other hazards."
}];
function Pt() {
	let [e, t] = (0, S.useState)(0), n = (0, S.useRef)([]);
	function r(e, r) {
		let i = e.key === "ArrowRight" ? (r + 1) % Nt.length : e.key === "ArrowLeft" ? (r + Nt.length - 1) % Nt.length : e.key === "Home" ? 0 : e.key === "End" ? Nt.length - 1 : null;
		i !== null && (e.preventDefault(), t(i), n.current[i]?.focus());
	}
	return /* @__PURE__ */ (0, j.jsx)("section", {
		className: "noise-control",
		id: "noise-control",
		"aria-labelledby": "noise-title",
		children: /* @__PURE__ */ (0, j.jsxs)("div", {
			className: "noise-inner",
			children: [
				/* @__PURE__ */ (0, j.jsxs)("div", {
					className: "noise-heading",
					children: [/* @__PURE__ */ (0, j.jsxs)("div", { children: [/* @__PURE__ */ (0, j.jsxs)("p", {
						className: "eyebrow",
						children: [/* @__PURE__ */ (0, j.jsx)(ae, {
							size: 18,
							"aria-hidden": "true"
						}), " SOUND ON YOUR TERMS"]
					}), /* @__PURE__ */ (0, j.jsxs)("h2", {
						id: "noise-title",
						children: [
							"Find your focus.",
							/* @__PURE__ */ (0, j.jsx)("br", {}),
							"Let life back in."
						]
					})] }), /* @__PURE__ */ (0, j.jsx)("p", { children: "Active noise cancelling for your own space. Transparency for the world around you. Two listening modes, ready for different parts of your day." })]
				}),
				/* @__PURE__ */ (0, j.jsx)("div", {
					className: "noise-tabs",
					role: "tablist",
					"aria-label": "Explore listening modes",
					children: Nt.map((i, a) => /* @__PURE__ */ (0, j.jsxs)("button", {
						ref: (e) => {
							n.current[a] = e;
						},
						role: "tab",
						id: `noise-tab-${i.id}`,
						"aria-selected": e === a,
						"aria-controls": `noise-panel-${i.id}`,
						tabIndex: e === a ? 0 : -1,
						onClick: () => t(a),
						onKeyDown: (e) => r(e, a),
						children: [/* @__PURE__ */ (0, j.jsx)(i.icon, {
							size: 20,
							"aria-hidden": "true"
						}), /* @__PURE__ */ (0, j.jsx)("span", { children: i.label })]
					}, i.id))
				}),
				Nt.map((t, n) => /* @__PURE__ */ (0, j.jsxs)("div", {
					className: "noise-panel",
					role: "tabpanel",
					id: `noise-panel-${t.id}`,
					"aria-labelledby": `noise-tab-${t.id}`,
					hidden: e !== n,
					tabIndex: 0,
					children: [/* @__PURE__ */ (0, j.jsxs)("figure", {
						className: `noise-image noise-image-${t.id}`,
						children: [e === n && /* @__PURE__ */ (0, j.jsx)(M, {
							src: `https://mifogen4.com.au/assets/${t.image}`,
							alt: t.alt,
							sizes: "(max-width: 700px) 92vw, (max-width: 1440px) 44vw, 600px",
							loading: "lazy"
						}), /* @__PURE__ */ (0, j.jsxs)("figcaption", { children: [/* @__PURE__ */ (0, j.jsx)(t.icon, {
							size: 18,
							"aria-hidden": "true"
						}), t.caption] })]
					}), /* @__PURE__ */ (0, j.jsxs)("div", {
						className: "noise-copy",
						children: [
							/* @__PURE__ */ (0, j.jsx)("p", {
								className: "noise-mode-name",
								children: t.name
							}),
							/* @__PURE__ */ (0, j.jsx)("h3", { children: t.heading }),
							/* @__PURE__ */ (0, j.jsx)("p", {
								className: "noise-description",
								children: t.description
							}),
							/* @__PURE__ */ (0, j.jsx)("dl", {
								className: "noise-features",
								children: t.features.map(([e, t]) => /* @__PURE__ */ (0, j.jsxs)("div", { children: [/* @__PURE__ */ (0, j.jsx)("dt", { children: e }), /* @__PURE__ */ (0, j.jsx)("dd", { children: t })] }, e))
							}),
							/* @__PURE__ */ (0, j.jsx)("p", {
								className: "noise-note",
								children: t.note
							})
						]
					})]
				}, t.id)),
				/* @__PURE__ */ (0, j.jsxs)("div", {
					className: "noise-actions",
					children: [/* @__PURE__ */ (0, j.jsxs)("a", {
						className: "noise-app-link",
						href: "#mifo-app",
						children: [/* @__PURE__ */ (0, j.jsx)(Pe, {
							size: 21,
							"aria-hidden": "true"
						}), /* @__PURE__ */ (0, j.jsxs)("span", { children: ["Make it yours in the free Mifo app", /* @__PURE__ */ (0, j.jsxs)("strong", { children: ["Explore app controls ", /* @__PURE__ */ (0, j.jsx)(T, {
							size: 15,
							"aria-hidden": "true"
						})] })] })]
					}), /* @__PURE__ */ (0, j.jsxs)("a", {
						className: "button button-lime",
						href: "#shop",
						children: ["Choose your Gen 4 ", /* @__PURE__ */ (0, j.jsx)(T, {
							size: 18,
							"aria-hidden": "true"
						})]
					})]
				})
			]
		})
	});
}
//#endregion
//#region outputs/regional-reviews-nz-20261018/nz/athletics-src/main.jsx
var Ft = "https://mifogen4.com.au/assets/", It = (e) => Ue.find((t) => t.id === e) || Ue[0], Lt = (e, t = "system") => `${Ft}gen4-hires-${e}-${t}.webp`, Rt = [
	{
		shot: "system",
		label: "Earbuds & charging case"
	},
	{
		file: "gallery-training-kit.webp",
		label: "Graphite, ready for your run",
		responsive: !0
	},
	{
		shot: "open",
		label: "Inside the charging case"
	},
	{
		file: "gallery-indoor-cycle.webp",
		label: "Matte black, indoor training",
		responsive: !0
	},
	{
		file: "gallery-gym-palm-v2.webp",
		label: "Rose gold, up close",
		responsive: !0
	},
	{
		file: "gallery-case-scale-v2.webp",
		label: "Your palm-sized free Airfome case",
		responsive: !0
	},
	{
		file: "gen4-packaging-contents.webp",
		label: "What's in the box",
		responsive: !0
	}
], zt = [
	{
		file: "case-lifestyle.webp",
		label: "Trackside",
		alt: "Compact Airfome case holding the charging case beside a runner's kit",
		control: "case in use"
	},
	{
		file: "case-open.webp",
		label: "Inside the case",
		alt: "Open Airfome carrying case showing the mesh pocket and fitted lower compartment",
		control: "open case"
	},
	{
		file: "case-closed.webp",
		label: "Hard-shell protection",
		alt: "Closed Airfome carrying case with round clip and ribbed protective panel",
		control: "closed case"
	},
	{
		file: "case-ride.webp",
		label: "Post-ride, palm-sized",
		alt: "Small Airfome carrying case in a cyclist's palm beside a road bike",
		control: "case after a ride"
	},
	{
		file: "case-gym.webp",
		label: "Packed for the gym",
		alt: "Charging case nested snugly inside the compact Airfome case on a gym bench",
		control: "case at the gym"
	}
], Bt = [
	{
		id: "running",
		label: "Running",
		icon: he,
		image: "runner-v2.webp",
		alt: "Runner wearing a low-profile graphite Mifo earbud on an athletics track",
		panelImage: "runner-coastal.webp",
		panelAlt: "Runner in an off-white singlet wearing a graphite Mifo earbud on a coastal path",
		eyebrow: "01 / FIND YOUR STRIDE",
		title: "Less adjusting.\nMore running.",
		copy: "Your rhythm is hard-earned. Keep it. The low-profile O5 shape sits close to your ear, so your earbuds feel like part of your kit, not something to keep checking.",
		features: [
			["A fit with a head start", "Shaped from research across 2,000+ ears. Find your seal with the included ear tips."],
			["Hear more of the world", "Switch to transparency mode when you want ambient sound alongside your playlist."],
			["Make the long run yours", "App EQ lets you dial in the soundtrack, from steady kilometres to the final push."]
		],
		note: "Stay aware outdoors. Transparency mode does not replace attention to traffic and your surroundings."
	},
	{
		id: "gym",
		label: "Gym",
		icon: k,
		image: "gym-rose-gold.webp",
		alt: "Gym-goer wearing a small rose-gold Mifo earbud during a dumbbell split squat",
		eyebrow: "02 / GET IN YOUR ZONE",
		title: "Big bass.\nBigger intention.",
		copy: "The warm-up. The working set. The last rep you nearly skipped. Bring powerful O5 sound and hybrid noise cancellation to the session you came to do.",
		features: [
			["Turn down the gym noise", "Hybrid ANC reduces background noise so you can focus on your music."],
			["Your sound. Your controls.", "Set your EQ and touch gestures in the Mifo app. Less time reaching for your phone."],
			["No stems. Less in the way.", "A compact in-ear shape for lifting, floor work and moving between stations."]
		],
		note: "Choose an ear-tip size that feels secure before training. Listen at a comfortable volume."
	},
	{
		id: "cycling",
		label: "Cycling",
		icon: ce,
		image: "cyclist-black.webp",
		alt: "Helmeted cyclist wearing a low-profile matte-black Mifo earbud on a coastal training circuit",
		eyebrow: "03 / FIND YOUR CADENCE",
		title: "Settle into the ride.\nStay in your rhythm.",
		copy: "From the indoor trainer to your next closed-course session, bring your soundtrack along without bulky stems getting in the way of your helmet straps.",
		features: [
			["Low profile. Less fuss.", "A compact shape sits close to the ear. Check the fit with your helmet before your session."],
			["Sound for your cadence", "Customise the EQ in the Mifo app for the playlist that gets you through the next interval."],
			["Power for the long week", "Up to 120 hours of total listening with case recharges, ready for the next training day."]
		],
		note: "Keep your surroundings audible. Use only where safe and permitted; transparency mode is not a substitute for road awareness."
	},
	{
		id: "beyond",
		label: "Beyond the session",
		icon: Ce,
		image: "o5-extreme-trail.webp",
		alt: "Athlete moving across a coastal trail",
		eyebrow: "04 / KEEP THE DAY MOVING",
		title: "Finish the session.\nNot the soundtrack.",
		copy: "From the training ground to the rest of your day, Gen 4 brings long-lasting power and easy connections. One pair, with plenty left to give.",
		features: [
			["120 hours, with the case", "Top up between sessions for up to 120 hours of total listening."],
			["Switch without the shuffle", "Multipoint connects two compatible devices. Move from a training video to a phone call."],
			["A backup for your phone", "The metal charging case doubles as a USB-C power bank for compatible devices."]
		],
		note: "Battery life varies with volume, ANC, codec and use. Total time includes recharges from the case."
	}
], Vt = [
	["Are these suitable for running and gym training?", "Gen 4 has a compact, low-profile fit designed for active use. Try the included ear tips to find a secure, comfortable seal before your first session. Fit varies by person. Use transparency when you need ambient sound and stay attentive outdoors."],
	["How does active noise cancelling work?", "Gen 4 uses hybrid feedforward and feedback active noise cancelling (ANC) to reduce unwanted background noise. It is useful for focused listening during indoor training, travel or downtime. Choose a snug ear-tip fit and select noise cancelling in the Mifo app. ANC does not eliminate all sound; its effect varies with fit and surroundings."],
	["What is transparency mode, and when should I use it?", "Transparency mode lets ambient sound through alongside your music, so you can hear more of the world without removing your earbuds. Switch to it in the Mifo app when you want to hear a training partner or your surroundings. Keep the volume comfortable and stay attentive: transparency does not guarantee you will hear traffic or other hazards."],
	["What exactly is included for NZ$199.99?", "A pair of Mifo O5 Gen 4 earbuds in your chosen colour, the aluminium charging case, five pairs of silicone ear tips and a USB-C charging cable. For a limited time, you also receive one free Airfome hard-shell carrying case per pair. New Zealand delivery is NZ$19.99, or free on orders of NZ$299.99 or more."],
	["Is the free case different from the charging case?", "Yes. The aluminium charging case powers your earbuds and works as a USB-C power bank. The free Airfome case is a separate zip-up protective carrying case that holds your charging case and keeps small accessories together. It does not charge devices."],
	["Does 120 hours mean one continuous charge?", "No. Up to 120 hours is the combined listening time of the earbuds and the recharges provided by the charging case. Actual runtime depends on volume, ANC, codec, calls and other settings."],
	["Does it work with iPhone and Android?", "Yes. Bluetooth pairing works with compatible devices. The Mifo app is available for iOS and Android for EQ, listening modes, touch controls, battery monitoring and firmware updates. LDAC high-resolution playback requires a compatible source; it is not supported by iPhone."],
	["When will my order ship?", "New Zealand delivery is NZ$19.99 on orders below NZ$299.99, and free on orders of NZ$299.99 or more after discounts. Tracking is emailed when your order ships. Delivery time depends on your location. See our shipping policy for details."],
	["Where do the reviews and recommendations come from?", "The 4.7/5 rating and customer quotes come from earlier Mifo O5 models, collected through Judge.me. They reflect the O5 family's track record, not Gen 4-specific reviews. The editorial recommendations also recognise earlier O5 models."],
	["What about warranty and returns?", "Your order is sold and supported by Mifo New Zealand. Contact our team for warranty and returns assistance, and read the terms of service linked in the footer before purchasing."]
];
function Ht({ score: e = 4.7 }) {
	return /* @__PURE__ */ (0, j.jsx)("span", {
		className: "stars",
		role: "img",
		"aria-label": `${e} out of 5 stars`,
		children: [
			0,
			1,
			2,
			3,
			4
		].map((t) => /* @__PURE__ */ (0, j.jsxs)("span", {
			className: "star",
			children: [/* @__PURE__ */ (0, j.jsx)(Ie, {}), /* @__PURE__ */ (0, j.jsx)("span", {
				style: { width: `${Math.max(0, Math.min(1, e - t)) * 100}%` },
				children: /* @__PURE__ */ (0, j.jsx)(Ie, {})
			})]
		}, t))
	});
}
function Ut() {
	return /* @__PURE__ */ (0, j.jsxs)("div", {
		className: "store-links",
		children: [/* @__PURE__ */ (0, j.jsx)("a", {
			href: "https://apps.apple.com/nz/app/mifo/id6762269812",
			target: "_blank",
			rel: "noreferrer",
			"aria-label": "Mifo for iOS on the App Store",
			children: /* @__PURE__ */ (0, j.jsx)(M, {
				src: "https://mifogen4.com.au/assets/app-store-badge.svg",
				alt: "Download on the App Store",
				width: "120",
				height: "40",
				loading: "lazy"
			})
		}), /* @__PURE__ */ (0, j.jsx)("a", {
			href: "https://play.google.com/store/apps/details?id=com.smartware.mifo",
			target: "_blank",
			rel: "noreferrer",
			"aria-label": "Mifo for Android on Google Play",
			children: /* @__PURE__ */ (0, j.jsx)(M, {
				src: "https://mifogen4.com.au/assets/google-play-badge.png",
				sizes: "142px",
				className: "google-play-badge",
				alt: "Get it on Google Play",
				width: "646",
				height: "250",
				loading: "lazy"
			})
		})]
	});
}
function Wt({ value: e, onChange: t, label: n = "Quantity" }) {
	return /* @__PURE__ */ (0, j.jsxs)("div", {
		className: "quantity",
		"aria-label": n,
		children: [
			/* @__PURE__ */ (0, j.jsx)("button", {
				"aria-label": `Decrease ${n.toLowerCase()}`,
				title: "Decrease quantity",
				disabled: e <= 1,
				onClick: () => t(e - 1),
				children: /* @__PURE__ */ (0, j.jsx)(Se, { size: 15 })
			}),
			/* @__PURE__ */ (0, j.jsx)("output", {
				"aria-label": n,
				children: e
			}),
			/* @__PURE__ */ (0, j.jsx)("button", {
				"aria-label": `Increase ${n.toLowerCase()}`,
				title: "Increase quantity",
				disabled: e >= 10,
				onClick: () => t(e + 1),
				children: /* @__PURE__ */ (0, j.jsx)(De, { size: 15 })
			})
		]
	});
}
function Gt({ slide: e, onSlide: t, modal: n = !1 }) {
	let r = (0, S.useRef)(null), i = zt[e], a = (n) => t((e + n + zt.length) % zt.length);
	return /* @__PURE__ */ (0, j.jsxs)("div", {
		className: `case-gallery ${n ? "in-dialog" : "on-page"}`,
		role: "region",
		"aria-label": n ? "Case detail gallery" : "Free case gallery",
		"aria-roledescription": "carousel",
		children: [
			/* @__PURE__ */ (0, j.jsx)("div", {
				className: "case-gallery-image",
				tabIndex: 0,
				"aria-label": i.alt,
				onKeyDown: (e) => {
					(e.key === "ArrowLeft" || e.key === "ArrowRight") && (e.preventDefault(), a(e.key === "ArrowRight" ? 1 : -1));
				},
				onTouchStart: (e) => {
					r.current = {
						x: e.touches[0].clientX,
						y: e.touches[0].clientY
					};
				},
				onTouchCancel: () => {
					r.current = null;
				},
				onTouchEnd: (e) => {
					if (!r.current) return;
					let t = r.current.x - e.changedTouches[0].clientX, n = r.current.y - e.changedTouches[0].clientY;
					Math.abs(t) > 40 && Math.abs(t) > Math.abs(n) && a(t > 0 ? 1 : -1), r.current = null;
				},
				children: /* @__PURE__ */ (0, j.jsx)(M, {
					src: Ft + i.file,
					sizes: n ? "(max-width: 600px) 92vw, 560px" : "(max-width: 800px) 100vw, 55vw",
					alt: i.alt,
					width: "1536",
					height: "1024",
					loading: n ? "eager" : "lazy",
					decoding: "async"
				})
			}),
			/* @__PURE__ */ (0, j.jsxs)("div", {
				className: "case-gallery-controls",
				children: [
					/* @__PURE__ */ (0, j.jsx)("button", {
						className: "icon-button",
						title: "Previous case image",
						"aria-label": n ? "Previous case detail image" : "Previous case image",
						onClick: () => a(-1),
						children: /* @__PURE__ */ (0, j.jsx)(de, { size: 20 })
					}),
					/* @__PURE__ */ (0, j.jsxs)("p", {
						"aria-live": "polite",
						children: [/* @__PURE__ */ (0, j.jsx)("strong", { children: i.label }), /* @__PURE__ */ (0, j.jsxs)("span", { children: [
							e + 1,
							" / ",
							zt.length
						] })]
					}),
					/* @__PURE__ */ (0, j.jsx)("button", {
						className: "icon-button",
						title: "Next case image",
						"aria-label": n ? "Next case detail image" : "Next case image",
						onClick: () => a(1),
						children: /* @__PURE__ */ (0, j.jsx)(fe, { size: 20 })
					})
				]
			}),
			/* @__PURE__ */ (0, j.jsx)("div", {
				className: "case-thumbnails",
				children: zt.map((r, i) => /* @__PURE__ */ (0, j.jsx)("button", {
					"aria-label": `${n ? "View" : "Show"} ${r.control}`,
					title: r.label,
					"aria-pressed": e === i,
					onClick: () => t(i),
					children: /* @__PURE__ */ (0, j.jsx)(M, {
						src: Ft + r.file,
						sizes: "64px",
						alt: "",
						width: "160",
						height: "107",
						loading: "lazy",
						decoding: "async"
					})
				}, r.file))
			})
		]
	});
}
function Kt({ open: e, onClose: t, title: n, className: r = "", children: i }) {
	let a = (0, S.useRef)(null);
	return (0, S.useEffect)(() => {
		let t = a.current;
		return e ? (t.showModal(), document.body.classList.add("modal-open")) : t.open && t.close(), () => document.body.classList.remove("modal-open");
	}, [e]), /* @__PURE__ */ (0, j.jsx)("dialog", {
		ref: a,
		className: r,
		"aria-label": n,
		onCancel: (e) => {
			e.preventDefault(), t();
		},
		onClick: (e) => {
			e.target === a.current && t();
		},
		children: e && /* @__PURE__ */ (0, j.jsx)("div", {
			className: "dialog-inner",
			children: i
		})
	});
}
function qt() {
	let [e, t] = (0, S.useState)("graphite"), [n, r] = (0, S.useState)(1), [i, a] = (0, S.useState)(0), [o, s] = (0, S.useState)(0), [c, l] = (0, S.useState)([]), [u, d] = (0, S.useState)(!1);
	(0, S.useEffect)(() => {
		et("view_item", [{
			item_id: "mifo-gen4",
			item_name: "Mifo O5 Gen 4",
			price: He / 100,
			quantity: 1
		}], He / 100);
		let e = new URLSearchParams(window.location.search).get("colour");
		Ue.some((t) => t.id === e) && t(e);
		try {
			l(We(JSON.parse(localStorage.getItem("mifo-nz-athletics-cart-v1") || "[]")));
		} catch {}
		d(!0);
	}, []);
	let [f, p] = (0, S.useState)(!1), [m, h] = (0, S.useState)(!1), [g, _] = (0, S.useState)(!1), [v, y] = (0, S.useState)(0), [b, x] = (0, S.useState)(!1), [ee, C] = (0, S.useState)(""), te = (0, S.useRef)(!1), ne = (0, S.useRef)(0), [w, ie] = (0, S.useState)(!1), [oe, ce] = (0, S.useState)(!1), [O, k] = (0, S.useState)(""), [he, _e] = (0, S.useState)(!1), ve = (0, S.useRef)(null), Se = (0, S.useRef)(null), Ce = (0, S.useRef)(null), we = (0, S.useRef)(!1), Te = Je(c), Oe = It(e), je = Bt[o];
	(0, S.useEffect)(() => {
		if (u) try {
			localStorage.setItem("mifo-nz-athletics-cart-v1", JSON.stringify(c));
		} catch {}
	}, [c, u]), (0, S.useEffect)(() => {
		let e = () => {
			let e = Se.current.getBoundingClientRect(), t = window.matchMedia("(max-width: 700px)").matches;
			_e(t ? e.top < 56 || e.bottom > window.innerHeight : e.bottom <= 56);
		}, t = new IntersectionObserver(e, {
			rootMargin: "-56px 0px 0px 0px",
			threshold: [0, 1]
		});
		return t.observe(Se.current), window.addEventListener("resize", e), () => {
			t.disconnect(), window.removeEventListener("resize", e);
		};
	}, []), (0, S.useEffect)(() => {
		let e = (e) => {
			e.key === "Escape" && (ce(!1), document.querySelector(".menu-button")?.focus());
		};
		return oe && window.addEventListener("keydown", e), () => window.removeEventListener("keydown", e);
	}, [oe]);
	function Ie() {
		l((t) => Ge(t, e, n)), et("add_to_cart", [{
			item_id: Oe.variantId,
			item_name: "Mifo O5 Gen 4",
			item_variant: Oe.name,
			price: He / 100,
			quantity: n
		}], He * n / 100), x(!1), C(""), p(!0), k(`${n} ${Oe.name} ${n === 1 ? "pair" : "pairs"} and ${n} free ${n === 1 ? "case" : "cases"} added to your bag.`);
	}
	function Re() {
		ce(!1), p(!0);
	}
	function Be() {
		ne.current += 1, te.current = !1, x(!1), p(!1);
	}
	async function Ve() {
		if (te.current) return;
		te.current = !0;
		let e = ++ne.current;
		x(!0), C("");
		try {
			let t = await Qe(), n = await lt(c, { attribution: t });
			if (e !== ne.current) return;
			window.location.assign(n.checkoutUrl);
		} catch (t) {
			if (e !== ne.current) return;
			C(t.message || "Checkout is unavailable. Please try again."), x(!1), te.current = !1;
		}
	}
	(0, S.useEffect)(() => {
		let e = () => {
			x(!1), te.current = !1;
		};
		return window.addEventListener("pageshow", e), () => window.removeEventListener("pageshow", e);
	}, []);
	function Ye(e) {
		t(e), a(0);
		let n = new URL(window.location.href);
		n.searchParams.set("colour", e), window.history.replaceState(null, "", n);
	}
	function Xe(e) {
		a((t) => (t + e + Rt.length) % Rt.length);
	}
	let Ze = Rt[i].shot ? Lt(e, Rt[i].shot) : Ft + Rt[i].file;
	return /* @__PURE__ */ (0, j.jsxs)(j.Fragment, { children: [
		/* @__PURE__ */ (0, j.jsx)("a", {
			className: "skip-link",
			href: "#main",
			children: "Skip to content"
		}),
		/* @__PURE__ */ (0, j.jsxs)("div", {
			className: "promo",
			children: [
				/* @__PURE__ */ (0, j.jsx)(ge, { size: 15 }),
				/* @__PURE__ */ (0, j.jsx)("span", { children: "FREE AIRFOME CASE WITH EVERY PAIR" }),
				/* @__PURE__ */ (0, j.jsxs)("a", {
					href: "#free-case",
					children: ["Meet your bonus ", /* @__PURE__ */ (0, j.jsx)(E, { size: 13 })]
				})
			]
		}),
		/* @__PURE__ */ (0, j.jsxs)("header", {
			className: "header",
			children: [
				/* @__PURE__ */ (0, j.jsxs)("a", {
					href: "#",
					"aria-label": "Mifo home - Made for movement",
					className: "brand",
					children: [/* @__PURE__ */ (0, j.jsx)(M, {
						src: "https://mifogen4.com.au/assets/mifo-logo-mark.png",
						width: "65",
						height: "38",
						sizes: "65px",
						alt: "Mifo"
					}), /* @__PURE__ */ (0, j.jsx)("span", { children: "MADE FOR MOVEMENT" })]
				}),
				/* @__PURE__ */ (0, j.jsxs)("nav", {
					id: "main-nav",
					"aria-label": "Main navigation",
					className: oe ? "nav is-open" : "nav",
					children: [/* @__PURE__ */ (0, j.jsxs)("a", {
						className: "mobile-shop-link",
						href: "#shop",
						onClick: () => ce(!1),
						children: ["Shop O5 Gen 4 ", /* @__PURE__ */ (0, j.jsx)(T, { size: 18 })]
					}), [
						["#performance", "Built for sport"],
						["#fit", "The fit"],
						["#technology", "The technology"],
						["#compare", "Compare"],
						["#in-the-box", "In the box"],
						["#free-case", "Your free case"],
						["#reviews", "Reviews"]
					].map(([e, t]) => /* @__PURE__ */ (0, j.jsx)("a", {
						href: e,
						onClick: () => ce(!1),
						children: t
					}, e))]
				}),
				/* @__PURE__ */ (0, j.jsxs)("div", {
					className: "header-actions",
					children: [
						/* @__PURE__ */ (0, j.jsx)("span", {
							className: "region",
							children: "NZ / NZD"
						}),
						/* @__PURE__ */ (0, j.jsxs)("button", {
							className: "icon-button cart-trigger",
							"aria-label": `Open bag, ${Te.quantity} items`,
							title: "Your bag",
							onClick: Re,
							children: [/* @__PURE__ */ (0, j.jsx)(Ne, { size: 21 }), Te.quantity > 0 && /* @__PURE__ */ (0, j.jsx)("span", { children: Te.quantity })]
						}),
						/* @__PURE__ */ (0, j.jsx)("button", {
							className: "icon-button menu-button",
							"aria-label": oe ? "Close menu" : "Open menu",
							title: "Menu",
							"aria-expanded": oe,
							"aria-controls": "main-nav",
							onClick: () => ce(!oe),
							children: oe ? /* @__PURE__ */ (0, j.jsx)(ze, {}) : /* @__PURE__ */ (0, j.jsx)(xe, {})
						})
					]
				})
			]
		}),
		/* @__PURE__ */ (0, j.jsxs)("main", {
			id: "main",
			children: [
				/* @__PURE__ */ (0, j.jsxs)("section", {
					className: "hero",
					"aria-labelledby": "hero-title",
					children: [
						/* @__PURE__ */ (0, j.jsx)(M, {
							className: "hero-photo",
							src: "https://mifogen4.com.au/assets/runner-v2.webp",
							alt: "Campaign athlete sprinting on the track wearing a graphite Mifo earbud",
							width: "1536",
							height: "827",
							sizes: "(max-width: 700px) 1px, 100vw",
							fetchPriority: "high"
						}),
						/* @__PURE__ */ (0, j.jsx)("div", { className: "hero-shade" }),
						/* @__PURE__ */ (0, j.jsxs)("div", {
							className: "hero-copy",
							children: [
								/* @__PURE__ */ (0, j.jsx)("p", {
									className: "eyebrow light",
									children: "YOUR SOUNDTRACK. YOUR NEXT PERSONAL BEST."
								}),
								/* @__PURE__ */ (0, j.jsxs)("h1", {
									id: "hero-title",
									children: [
										"Mifo O5",
										" ",
										/* @__PURE__ */ (0, j.jsx)("br", {}),
										"Gen 4."
									]
								}),
								/* @__PURE__ */ (0, j.jsx)("p", {
									className: "hero-line",
									children: "All in. Every session."
								}),
								/* @__PURE__ */ (0, j.jsx)("p", {
									className: "mobile-product-type",
									children: "Wireless earbuds for running & gym"
								}),
								/* @__PURE__ */ (0, j.jsx)("p", {
									className: "hero-description",
									children: "Big sound. A low-profile fit. Built to move from the first kilometre to the last rep."
								}),
								/* @__PURE__ */ (0, j.jsxs)("a", {
									className: "hero-link",
									href: "#performance",
									children: ["Find your training edge ", /* @__PURE__ */ (0, j.jsx)(Jt, {})]
								})
							]
						}),
						/* @__PURE__ */ (0, j.jsx)("span", {
							className: "hero-caption",
							children: "O5 GEN 4 / PERFORMANCE AUDIO"
						})
					]
				}),
				/* @__PURE__ */ (0, j.jsx)("section", {
					className: "purchase-band",
					id: "shop",
					ref: ve,
					"aria-label": "Choose your Mifo O5 Gen 4",
					children: /* @__PURE__ */ (0, j.jsxs)("div", {
						className: "purchase-inner",
						children: [
							/* @__PURE__ */ (0, j.jsxs)("div", {
								className: "buy-gallery",
								children: [/* @__PURE__ */ (0, j.jsxs)("button", {
									className: "gallery-main " + (Rt[i].shot ? "product-slide" : "lifestyle-slide"),
									"aria-label": `Enlarge ${Rt[i].label}`,
									onClick: () => {
										we.current || ie(!0), we.current = !1;
									},
									onTouchStart: (e) => {
										we.current = !1, Ce.current = {
											x: e.touches[0].clientX,
											y: e.touches[0].clientY
										};
									},
									onTouchCancel: () => {
										Ce.current = null, we.current = !1;
									},
									onTouchEnd: (e) => {
										if (Ce.current !== null) {
											let t = Ce.current.x - e.changedTouches[0].clientX, n = Ce.current.y - e.changedTouches[0].clientY;
											we.current = Math.max(Math.abs(t), Math.abs(n)) > 12, Math.abs(t) > 40 && Math.abs(t) > Math.abs(n) * 1.25 && Xe(t > 0 ? 1 : -1), Ce.current = null;
										}
									},
									children: [/* @__PURE__ */ (0, j.jsx)(M, {
										src: Ze,
										sizes: "(max-width: 700px) 94vw, (max-width: 800px) 150px, 210px",
										fetchPriority: i === 0 ? "high" : "auto",
										alt: `${Rt[i].shot ? Oe.name + " " : ""}${Rt[i].label}`,
										width: "1800",
										height: "1800"
									}), /* @__PURE__ */ (0, j.jsx)("span", {
										className: "zoom-icon",
										children: /* @__PURE__ */ (0, j.jsx)(ke, { size: 16 })
									})]
								}), /* @__PURE__ */ (0, j.jsxs)("div", {
									className: "gallery-controls",
									children: [
										/* @__PURE__ */ (0, j.jsx)("button", {
											className: "icon-button",
											title: "Previous image",
											"aria-label": "Previous product image",
											onClick: () => Xe(-1),
											children: /* @__PURE__ */ (0, j.jsx)(de, { size: 17 })
										}),
										/* @__PURE__ */ (0, j.jsx)("div", {
											className: "gallery-dots",
											children: Rt.map((e, t) => /* @__PURE__ */ (0, j.jsx)("button", {
												title: e.label,
												"aria-label": `Show ${e.label}`,
												"aria-pressed": i === t,
												onClick: () => a(t)
											}, e.label))
										}),
										/* @__PURE__ */ (0, j.jsxs)("span", {
											className: "gallery-count",
											role: "status",
											"aria-label": `Product image ${i + 1} of ${Rt.length}`,
											children: [
												i + 1,
												" / ",
												Rt.length
											]
										}),
										/* @__PURE__ */ (0, j.jsx)("button", {
											className: "icon-button",
											title: "Next image",
											"aria-label": "Next product image",
											onClick: () => Xe(1),
											children: /* @__PURE__ */ (0, j.jsx)(fe, { size: 17 })
										})
									]
								})]
							}),
							/* @__PURE__ */ (0, j.jsxs)("div", {
								className: "buy-summary",
								children: [
									/* @__PURE__ */ (0, j.jsxs)("span", {
										className: "stock",
										children: [/* @__PURE__ */ (0, j.jsx)("span", {}), " Available to order."]
									}),
									/* @__PURE__ */ (0, j.jsx)("h2", { children: "Your next training partner." }),
									/* @__PURE__ */ (0, j.jsxs)("button", {
										type: "button",
										className: "rating-link",
										"aria-haspopup": "dialog",
										onClick: () => _(!0),
										children: [
											/* @__PURE__ */ (0, j.jsx)(Ht, {}),
											/* @__PURE__ */ (0, j.jsx)("strong", { children: "4.7/5" }),
											/* @__PURE__ */ (0, j.jsx)("span", {
												className: "read-reviews-label",
												children: "Read reviews"
											})
										]
									}),
									/* @__PURE__ */ (0, j.jsx)("span", {
										className: "review-context",
										children: "Verified by Judge.me"
									}),
									/* @__PURE__ */ (0, j.jsxs)("div", {
										className: "price",
										children: [/* @__PURE__ */ (0, j.jsxs)("strong", { children: ["NZ", A(He)] }), /* @__PURE__ */ (0, j.jsx)("span", { children: "incl. GST" })]
									}),
									/* @__PURE__ */ (0, j.jsxs)("p", {
										className: "shipping-note",
										children: [/* @__PURE__ */ (0, j.jsx)(Le, { size: 15 }), " NZ delivery $19.99. Free from NZ$299.99."]
									})
								]
							}),
							/* @__PURE__ */ (0, j.jsxs)("div", {
								className: "buy-controls",
								children: [
									/* @__PURE__ */ (0, j.jsxs)("div", {
										className: "choose-row",
										children: [/* @__PURE__ */ (0, j.jsxs)("fieldset", { children: [/* @__PURE__ */ (0, j.jsxs)("legend", { children: ["Colour: ", /* @__PURE__ */ (0, j.jsx)("strong", { children: Oe.name })] }), /* @__PURE__ */ (0, j.jsx)("div", {
											className: "swatches",
											children: Ue.map((t) => /* @__PURE__ */ (0, j.jsx)("button", {
												"aria-label": `Select ${t.name}`,
												title: t.name,
												"aria-pressed": e === t.id,
												style: { "--swatch": t.hex },
												onClick: () => Ye(t.id),
												children: e === t.id && /* @__PURE__ */ (0, j.jsx)(le, { size: 15 })
											}, t.id))
										})] }), /* @__PURE__ */ (0, j.jsxs)("div", {
											className: "quantity-field",
											children: [/* @__PURE__ */ (0, j.jsx)("span", { children: "Pairs" }), /* @__PURE__ */ (0, j.jsx)(Wt, {
												value: n,
												onChange: r
											})]
										})]
									}),
									/* @__PURE__ */ (0, j.jsxs)("button", {
										ref: Se,
										className: "button button-lime add-main",
										onClick: Ie,
										children: [
											"Add to bag",
											" ",
											/* @__PURE__ */ (0, j.jsxs)("span", { children: [
												"NZ",
												A(He * n),
												" ",
												/* @__PURE__ */ (0, j.jsx)(T, { size: 18 })
											] })
										]
									}),
									/* @__PURE__ */ (0, j.jsxs)("button", {
										className: "gift-note",
										onClick: () => h(!0),
										children: [
											/* @__PURE__ */ (0, j.jsx)(ge, { size: 18 }),
											/* @__PURE__ */ (0, j.jsxs)("span", { children: [/* @__PURE__ */ (0, j.jsx)("strong", { children: "Your free Airfome case is included." }), " One protective case for every pair."] }),
											/* @__PURE__ */ (0, j.jsx)(E, { size: 17 })
										]
									})
								]
							})
						]
					})
				}),
				/* @__PURE__ */ (0, j.jsxs)("nav", {
					className: "mobile-shortcuts",
					"aria-label": "Explore Gen 4",
					children: [
						/* @__PURE__ */ (0, j.jsxs)("a", {
							href: "#performance",
							children: ["Features ", /* @__PURE__ */ (0, j.jsx)(ue, { size: 14 })]
						}),
						/* @__PURE__ */ (0, j.jsxs)("a", {
							href: "#compare",
							children: ["Compare ", /* @__PURE__ */ (0, j.jsx)(ue, { size: 14 })]
						}),
						/* @__PURE__ */ (0, j.jsxs)("a", {
							href: "#free-case",
							children: ["Free case ", /* @__PURE__ */ (0, j.jsx)(ue, { size: 14 })]
						}),
						/* @__PURE__ */ (0, j.jsxs)("a", {
							href: "#reviews",
							children: ["Reviews ", /* @__PURE__ */ (0, j.jsx)(ue, { size: 14 })]
						})
					]
				}),
				/* @__PURE__ */ (0, j.jsxs)("div", {
					className: "benefit-strip",
					children: [
						/* @__PURE__ */ (0, j.jsxs)("span", { children: [/* @__PURE__ */ (0, j.jsx)(me, {}), "Low-profile, stay-put design"] }),
						/* @__PURE__ */ (0, j.jsxs)("span", { children: [/* @__PURE__ */ (0, j.jsx)(se, {}), "Up to 120 hours with case"] }),
						/* @__PURE__ */ (0, j.jsx)("span", { children: /* @__PURE__ */ (0, j.jsxs)("a", {
							className: "noise-shortcut",
							href: "#noise-control",
							children: [/* @__PURE__ */ (0, j.jsx)(ae, {}), "ANC + transparency"]
						}) }),
						/* @__PURE__ */ (0, j.jsxs)("span", { children: [/* @__PURE__ */ (0, j.jsx)(Me, {}), "Aircraft-grade aluminium"] })
					]
				}),
				/* @__PURE__ */ (0, j.jsxs)("button", {
					type: "button",
					className: "review-proof-band",
					"aria-haspopup": "dialog",
					onClick: () => _(!0),
					children: [
						/* @__PURE__ */ (0, j.jsx)(Ht, {}),
						/* @__PURE__ */ (0, j.jsxs)("strong", { children: ["4.7", /* @__PURE__ */ (0, j.jsx)("span", { children: "/5" })] }),
						/* @__PURE__ */ (0, j.jsxs)("span", {
							className: "proof-copy",
							children: [/* @__PURE__ */ (0, j.jsx)("b", { children: "6,140 reviews. A well-loved O5 heritage." }), /* @__PURE__ */ (0, j.jsx)("small", { children: "Mifo O5 customer reviews on Judge.me" })]
						}),
						/* @__PURE__ */ (0, j.jsxs)("span", {
							className: "proof-link",
							children: ["Read reviews ", /* @__PURE__ */ (0, j.jsx)(T, { size: 18 })]
						})
					]
				}),
				/* @__PURE__ */ (0, j.jsxs)("section", {
					className: "training section-pad",
					id: "performance",
					children: [/* @__PURE__ */ (0, j.jsxs)("div", {
						className: "section-heading",
						children: [/* @__PURE__ */ (0, j.jsxs)("div", { children: [/* @__PURE__ */ (0, j.jsx)("p", {
							className: "eyebrow",
							children: "LESS FRICTION. MORE FORWARD."
						}), /* @__PURE__ */ (0, j.jsxs)("h2", { children: [
							"For the work",
							/* @__PURE__ */ (0, j.jsx)("br", {}),
							"you put in."
						] })] }), /* @__PURE__ */ (0, j.jsx)("div", {
							className: "mode-tabs",
							role: "tablist",
							"aria-label": "Your training style",
							children: Bt.map((e, t) => /* @__PURE__ */ (0, j.jsxs)("button", {
								role: "tab",
								id: `tab-${e.id}`,
								"aria-selected": o === t,
								"aria-controls": "training-panel",
								onClick: () => s(t),
								children: [/* @__PURE__ */ (0, j.jsx)(e.icon, { size: 17 }), e.label]
							}, e.id))
						})]
					}), /* @__PURE__ */ (0, j.jsxs)("div", {
						id: "training-panel",
						className: "training-layout",
						role: "tabpanel",
						"aria-labelledby": `tab-${je.id}`,
						children: [/* @__PURE__ */ (0, j.jsxs)("div", {
							className: `training-image${je.panelImage ? " training-image--portrait" : ""}`,
							children: [/* @__PURE__ */ (0, j.jsx)(M, {
								src: Ft + (je.panelImage || je.image),
								sizes: "(max-width: 800px) 90vw, 48vw",
								alt: je.panelAlt || je.alt,
								width: je.panelImage ? "960" : "1536",
								height: je.panelImage ? "1200" : "1024",
								loading: "lazy"
							}), /* @__PURE__ */ (0, j.jsx)("span", { children: je.eyebrow })]
						}), /* @__PURE__ */ (0, j.jsxs)("div", {
							className: "training-copy",
							children: [
								/* @__PURE__ */ (0, j.jsx)("h3", { children: je.title.split("\n").map((e, t) => /* @__PURE__ */ (0, j.jsxs)(S.Fragment, { children: [t > 0 && /* @__PURE__ */ (0, j.jsx)("br", {}), e] }, e)) }),
								/* @__PURE__ */ (0, j.jsx)("p", { children: je.copy }),
								/* @__PURE__ */ (0, j.jsx)("ol", {
									className: "feature-list",
									children: je.features.map(([e, t], n) => /* @__PURE__ */ (0, j.jsxs)("li", { children: [/* @__PURE__ */ (0, j.jsxs)("span", { children: ["0", n + 1] }), /* @__PURE__ */ (0, j.jsxs)("div", { children: [/* @__PURE__ */ (0, j.jsx)("h4", { children: e }), /* @__PURE__ */ (0, j.jsx)("p", { children: t })] })] }, e))
								}),
								/* @__PURE__ */ (0, j.jsx)("small", { children: je.note }),
								/* @__PURE__ */ (0, j.jsxs)("a", {
									className: "text-link",
									href: "#shop",
									children: ["Find your colour ", /* @__PURE__ */ (0, j.jsx)(E, { size: 17 })]
								})
							]
						})]
					})]
				}),
				/* @__PURE__ */ (0, j.jsxs)("section", {
					className: "fit-section section-pad",
					id: "fit",
					children: [
						/* @__PURE__ */ (0, j.jsxs)("div", {
							className: "section-heading",
							children: [/* @__PURE__ */ (0, j.jsxs)("div", { children: [/* @__PURE__ */ (0, j.jsx)("p", {
								className: "eyebrow",
								children: "THE SCIENCE OF STAYING PUT"
							}), /* @__PURE__ */ (0, j.jsxs)("h2", { children: [
								"2,000+ ear shapes.",
								/* @__PURE__ */ (0, j.jsx)("br", {}),
								"One stay-put obsession."
							] })] }), /* @__PURE__ */ (0, j.jsxs)("p", { children: [
								"Less adjusting.",
								/* @__PURE__ */ (0, j.jsx)("br", {}),
								"More of what moves you."
							] })]
						}),
						/* @__PURE__ */ (0, j.jsxs)("figure", {
							className: "fit-lab-visual",
							children: [/* @__PURE__ */ (0, j.jsx)(M, {
								src: "https://mifogen4.com.au/assets/fit-lab-v3.webp",
								sizes: "(max-width: 800px) 90vw, 52vw",
								alt: "Digital ear-shape renderings and contour illustrations beside a large graphite Mifo earbud close-up",
								width: "1536",
								height: "1024",
								loading: "lazy",
								decoding: "async"
							}), /* @__PURE__ */ (0, j.jsx)("figcaption", { children: "Ear-shape study and earbud fit visualisation." })]
						}),
						/* @__PURE__ */ (0, j.jsxs)("div", {
							className: "fit-story",
							children: [/* @__PURE__ */ (0, j.jsxs)("div", { children: [
								/* @__PURE__ */ (0, j.jsxs)("h3", { children: [
									"Built around ears.",
									/* @__PURE__ */ (0, j.jsx)("br", {}),
									"Not guesswork."
								] }),
								/* @__PURE__ */ (0, j.jsx)("p", { children: "We studied more than 2,000 different ear shapes to refine the O5 fit. The result is a low-profile contour designed to stay secure through sprints, gym sets and long training sessions." }),
								/* @__PURE__ */ (0, j.jsx)("small", { children: "A secure fit starts with the right ear tips. Individual fit varies." })
							] }), /* @__PURE__ */ (0, j.jsxs)("details", {
								className: "fit-process",
								children: [/* @__PURE__ */ (0, j.jsxs)("summary", { children: ["How we build a secure fit ", /* @__PURE__ */ (0, j.jsx)(De, { size: 18 })] }), /* @__PURE__ */ (0, j.jsxs)("ol", {
									className: "fit-steps",
									children: [
										/* @__PURE__ */ (0, j.jsxs)("li", { children: [/* @__PURE__ */ (0, j.jsx)(Ae, {}), /* @__PURE__ */ (0, j.jsxs)("div", { children: [/* @__PURE__ */ (0, j.jsx)("h4", { children: "Study the shape" }), /* @__PURE__ */ (0, j.jsx)("p", { children: "Understand the curves and differences that make every ear unique." })] })] }),
										/* @__PURE__ */ (0, j.jsxs)("li", { children: [/* @__PURE__ */ (0, j.jsx)(me, {}), /* @__PURE__ */ (0, j.jsxs)("div", { children: [/* @__PURE__ */ (0, j.jsx)("h4", { children: "Keep it close" }), /* @__PURE__ */ (0, j.jsx)("p", { children: "A sculpted, stemless housing sits low in the ear, with less bulk outside it." })] })] }),
										/* @__PURE__ */ (0, j.jsxs)("li", { children: [/* @__PURE__ */ (0, j.jsx)(re, {}), /* @__PURE__ */ (0, j.jsxs)("div", { children: [/* @__PURE__ */ (0, j.jsx)("h4", { children: "Make it your fit" }), /* @__PURE__ */ (0, j.jsx)("p", { children: "Choose the ear tips that give you a snug seal before you turn up the effort." })] })] })
									]
								})]
							})]
						})
					]
				}),
				/* @__PURE__ */ (0, j.jsxs)("section", {
					className: "athlete-heritage section-pad",
					children: [
						/* @__PURE__ */ (0, j.jsxs)("div", {
							className: "section-heading",
							children: [/* @__PURE__ */ (0, j.jsxs)("div", { children: [/* @__PURE__ */ (0, j.jsx)("p", {
								className: "eyebrow",
								children: "O5 PERFORMANCE HERITAGE"
							}), /* @__PURE__ */ (0, j.jsxs)("h2", { children: [
								"Battle-tested.",
								/* @__PURE__ */ (0, j.jsx)("br", {}),
								"Far beyond the finish line."
							] })] }), /* @__PURE__ */ (0, j.jsx)("p", { children: "From professional athletes and Olympians to sporting enthusiasts around the world, the O5 family has been part of the effort. Gen 4 carries that active-use heritage into your next session." })]
						}),
						/* @__PURE__ */ (0, j.jsx)("div", {
							className: "athlete-grid",
							role: "region",
							"aria-label": "Athlete stories",
							tabIndex: 0,
							children: [
								Bt[0],
								Bt[2],
								Bt[1]
							].map((e) => /* @__PURE__ */ (0, j.jsxs)("a", {
								href: "#performance",
								onClick: () => s(Bt.findIndex((t) => t.id === e.id)),
								children: [/* @__PURE__ */ (0, j.jsx)(M, {
									src: Ft + e.image,
									sizes: "(max-width: 800px) 90vw, 30vw",
									alt: e.alt,
									width: "1536",
									height: "1024",
									loading: "lazy",
									decoding: "async"
								}), /* @__PURE__ */ (0, j.jsxs)("span", { children: [
									/* @__PURE__ */ (0, j.jsx)(e.icon, { size: 21 }),
									/* @__PURE__ */ (0, j.jsx)("strong", { children: e.label === "Gym" ? "Gym-goers" : e.label === "Running" ? "Runners" : "Cyclists" }),
									/* @__PURE__ */ (0, j.jsx)(E, { size: 20 })
								] })]
							}, e.id))
						}),
						/* @__PURE__ */ (0, j.jsxs)("p", {
							className: "heritage-note",
							children: [
								/* @__PURE__ */ (0, j.jsx)(be, { size: 17 }),
								" Built on Mifo's O5 athlete heritage.",
								" ",
								/* @__PURE__ */ (0, j.jsxs)("a", {
									href: "/products/mifo-gen-4-wireless-earbuds",
									target: "_blank",
									rel: "noreferrer",
									children: ["Explore the Mifo story ", /* @__PURE__ */ (0, j.jsx)(E, { size: 13 })]
								})
							]
						})
					]
				}),
				/* @__PURE__ */ (0, j.jsxs)("section", {
					className: "technology section-pad",
					id: "technology",
					children: [
						/* @__PURE__ */ (0, j.jsxs)("div", {
							className: "section-heading",
							children: [/* @__PURE__ */ (0, j.jsxs)("div", { children: [/* @__PURE__ */ (0, j.jsx)("p", {
								className: "eyebrow",
								children: "YOUR KIT JUST LEVELLED UP"
							}), /* @__PURE__ */ (0, j.jsxs)("h2", { children: [
								"Serious technology.",
								/* @__PURE__ */ (0, j.jsx)("br", {}),
								"Everyday advantage."
							] })] }), /* @__PURE__ */ (0, j.jsxs)("p", { children: [
								"Engineered for your session.",
								/* @__PURE__ */ (0, j.jsx)("br", {}),
								"Ready for everything after."
							] })]
						}),
						/* @__PURE__ */ (0, j.jsxs)("div", {
							className: "tech-grid",
							children: [
								/* @__PURE__ */ (0, j.jsxs)("article", {
									className: "battery-feature",
									children: [
										/* @__PURE__ */ (0, j.jsxs)("span", {
											className: "tech-label",
											children: [/* @__PURE__ */ (0, j.jsx)(se, { size: 19 }), " ENDURANCE"]
										}),
										/* @__PURE__ */ (0, j.jsxs)("h3", { children: ["120", /* @__PURE__ */ (0, j.jsx)("span", { children: "hrs" })] }),
										/* @__PURE__ */ (0, j.jsx)("strong", { children: "Less charging. More showing up." }),
										/* @__PURE__ */ (0, j.jsx)("p", { children: "Up to 120 hours of total listening with the charging case. Refuel your earbuds between workouts." }),
										/* @__PURE__ */ (0, j.jsx)("small", { children: "Total includes case recharges. Runtime varies with settings and use." })
									]
								}),
								/* @__PURE__ */ (0, j.jsxs)("article", {
									className: "sound-feature",
									children: [
										/* @__PURE__ */ (0, j.jsxs)("span", {
											className: "tech-label",
											children: [/* @__PURE__ */ (0, j.jsx)(ae, { size: 19 }), " SOUND & FOCUS"]
										}),
										/* @__PURE__ */ (0, j.jsxs)("h3", { children: [
											"Feel the beat.",
											/* @__PURE__ */ (0, j.jsx)("br", {}),
											"Find your zone."
										] }),
										/* @__PURE__ */ (0, j.jsx)(M, {
											src: Lt("graphite", "buds"),
											sizes: "(max-width: 800px) 90vw, 36vw",
											width: "1000",
											height: "1000",
											alt: "Close-up of graphite O5 Gen 4 earbuds",
											loading: "lazy"
										}),
										/* @__PURE__ */ (0, j.jsx)("p", { children: "Powerful bass meets LDAC high-resolution playback and hybrid ANC. Go deeper into your playlist, then switch to transparency when you need the world." }),
										/* @__PURE__ */ (0, j.jsxs)("a", {
											className: "noise-detail-link",
											href: "#noise-control",
											children: ["Explore both listening modes ", /* @__PURE__ */ (0, j.jsx)(T, { size: 16 })]
										})
									]
								}),
								/* @__PURE__ */ (0, j.jsxs)("article", { children: [
									/* @__PURE__ */ (0, j.jsxs)("span", {
										className: "tech-label",
										children: [/* @__PURE__ */ (0, j.jsx)(D, { size: 19 }), " CONNECTION"]
									}),
									/* @__PURE__ */ (0, j.jsxs)("h3", { children: [
										"Two devices.",
										/* @__PURE__ */ (0, j.jsx)("br", {}),
										"One less interruption."
									] }),
									/* @__PURE__ */ (0, j.jsx)("p", { children: "Bluetooth 6.0 and multipoint keep compatible devices connected. A 60 ms low-latency mode helps training videos stay in step." }),
									/* @__PURE__ */ (0, j.jsxs)("span", {
										className: "mini-spec",
										children: [
											"BLUETOOTH 6.0 ",
											/* @__PURE__ */ (0, j.jsx)("span", { children: "/" }),
											" MULTIPOINT"
										]
									})
								] }),
								/* @__PURE__ */ (0, j.jsxs)("article", { children: [
									/* @__PURE__ */ (0, j.jsxs)("span", {
										className: "tech-label",
										children: [/* @__PURE__ */ (0, j.jsx)(Me, { size: 19 }), " CONSTRUCTION"]
									}),
									/* @__PURE__ */ (0, j.jsxs)("h3", { children: [
										"Metal. Not",
										/* @__PURE__ */ (0, j.jsx)("br", {}),
										"more plastic."
									] }),
									/* @__PURE__ */ (0, j.jsx)("p", { children: "Precision-machined, recyclable aircraft-grade aluminium outer bodies and charging case. A considered finish for kit you reach for every day." }),
									/* @__PURE__ */ (0, j.jsx)("span", {
										className: "mini-spec",
										children: "AIRCRAFT-GRADE ALUMINIUM"
									})
								] })
							]
						}),
						/* @__PURE__ */ (0, j.jsxs)("details", {
							className: "spec-details",
							children: [/* @__PURE__ */ (0, j.jsxs)("summary", { children: ["Explore the full Gen 4 specification ", /* @__PURE__ */ (0, j.jsx)(De, { size: 18 })] }), /* @__PURE__ */ (0, j.jsx)("dl", { children: [
								["Sound", "LDAC high-resolution playback; stereo DAC with 104 dB SNR. Compatible source required."],
								["Noise control", "Hybrid feedforward and feedback ANC, transparency mode."],
								["Calls", "Three microphone inputs, 102 dB ADC and AI beamforming."],
								["Wireless", "Bluetooth 6.0, multipoint; 60 ms low-latency mode with SBC/AAC."],
								["App", "iOS and Android: EQ, listening modes, touch controls, battery monitoring and firmware updates."],
								["Power", "Up to 120 hours total with the charging case; USB-C device-charging capability. Phone recharge varies by battery capacity and charging conditions."],
								["Fit and materials", "Low-profile shape informed by 2,000+ ear shapes; recyclable aircraft-grade aluminium outer earbud and charging-case bodies."]
							].map(([e, t]) => /* @__PURE__ */ (0, j.jsxs)("div", { children: [/* @__PURE__ */ (0, j.jsx)("dt", { children: e }), /* @__PURE__ */ (0, j.jsx)("dd", { children: t })] }, e)) })]
						})
					]
				}),
				/* @__PURE__ */ (0, j.jsx)(Pt, {}),
				/* @__PURE__ */ (0, j.jsx)("section", {
					className: "listening-app",
					id: "mifo-app",
					"aria-labelledby": "listening-app-title",
					children: /* @__PURE__ */ (0, j.jsxs)("div", {
						className: "listening-app-inner",
						children: [/* @__PURE__ */ (0, j.jsxs)("div", {
							className: "listening-app-intro",
							children: [
								/* @__PURE__ */ (0, j.jsxs)("div", {
									className: "listening-app-identity",
									children: [/* @__PURE__ */ (0, j.jsx)(M, {
										src: "https://mifogen4.com.au/assets/mifo-app-icon.webp",
										sizes: "72px",
										width: "512",
										height: "512",
										alt: "Mifo app icon",
										loading: "lazy"
									}), /* @__PURE__ */ (0, j.jsxs)("div", { children: [/* @__PURE__ */ (0, j.jsx)("p", {
										className: "eyebrow",
										children: "THE FREE MIFO APP"
									}), /* @__PURE__ */ (0, j.jsxs)("h2", {
										id: "listening-app-title",
										children: [
											/* @__PURE__ */ (0, j.jsx)("span", { children: "Your workout." }),
											" ",
											/* @__PURE__ */ (0, j.jsx)("span", { children: "Your sound." })
										]
									})] })]
								}),
								/* @__PURE__ */ (0, j.jsx)("p", { children: "More bass for your next set. A balanced mix for your long run. Make every playlist your own, on iPhone or Android." }),
								/* @__PURE__ */ (0, j.jsx)(Ut, {})
							]
						}), /* @__PURE__ */ (0, j.jsxs)("ul", {
							className: "listening-app-features",
							children: [
								/* @__PURE__ */ (0, j.jsxs)("li", { children: [/* @__PURE__ */ (0, j.jsx)(Pe, {
									size: 23,
									"aria-hidden": "true"
								}), /* @__PURE__ */ (0, j.jsxs)("div", { children: [/* @__PURE__ */ (0, j.jsx)("h3", { children: "Fine-tune your EQ" }), /* @__PURE__ */ (0, j.jsx)("p", { children: "Dial in the bass, balance and detail you love." })] })] }),
								/* @__PURE__ */ (0, j.jsxs)("li", { children: [/* @__PURE__ */ (0, j.jsx)(ae, {
									size: 23,
									"aria-hidden": "true"
								}), /* @__PURE__ */ (0, j.jsxs)("div", { children: [/* @__PURE__ */ (0, j.jsx)("h3", { children: "Choose your listening mode" }), /* @__PURE__ */ (0, j.jsx)("p", { children: "Switch between noise cancellation and transparency." })] })] }),
								/* @__PURE__ */ (0, j.jsxs)("li", { children: [/* @__PURE__ */ (0, j.jsx)(Fe, {
									size: 23,
									"aria-hidden": "true"
								}), /* @__PURE__ */ (0, j.jsxs)("div", { children: [/* @__PURE__ */ (0, j.jsx)("h3", { children: "Make the controls yours" }), /* @__PURE__ */ (0, j.jsx)("p", { children: "Set your earbud tap controls and check your battery." })] })] })
							]
						})]
					})
				}),
				/* @__PURE__ */ (0, j.jsx)(ht, { onExploreCase: () => h(!0) }),
				/* @__PURE__ */ (0, j.jsxs)("section", {
					className: "case-section",
					id: "free-case",
					children: [/* @__PURE__ */ (0, j.jsxs)("div", {
						className: "case-story",
						children: [/* @__PURE__ */ (0, j.jsxs)("div", {
							className: "case-copy",
							children: [
								/* @__PURE__ */ (0, j.jsxs)("p", {
									className: "eyebrow",
									children: [/* @__PURE__ */ (0, j.jsx)(ge, { size: 18 }), " A LITTLE EXTRA. A LOT OF USE."]
								}),
								/* @__PURE__ */ (0, j.jsxs)("h2", { children: [
									"Your kit.",
									/* @__PURE__ */ (0, j.jsx)("br", {}),
									"All together."
								] }),
								/* @__PURE__ */ (0, j.jsxs)("p", {
									className: "case-lead",
									children: [
										"A free Airfome hard-shell case.",
										/* @__PURE__ */ (0, j.jsx)("br", {}),
										"With every pair. For a limited time."
									]
								}),
								/* @__PURE__ */ (0, j.jsx)("p", { children: "From your gym bag to race weekend, keep your charging case and small essentials in one neat, protected place." }),
								/* @__PURE__ */ (0, j.jsxs)("div", {
									className: "case-points",
									children: [
										/* @__PURE__ */ (0, j.jsxs)("span", { children: [/* @__PURE__ */ (0, j.jsx)(le, {}), "Protective hard shell"] }),
										/* @__PURE__ */ (0, j.jsxs)("span", { children: [/* @__PURE__ */ (0, j.jsx)(le, {}), "Zip closure & mesh pocket"] }),
										/* @__PURE__ */ (0, j.jsxs)("span", { children: [/* @__PURE__ */ (0, j.jsx)(le, {}), "Compact, easy-carry design"] })
									]
								}),
								/* @__PURE__ */ (0, j.jsxs)("button", {
									className: "button button-dark",
									onClick: () => h(!0),
									children: ["Take a closer look ", /* @__PURE__ */ (0, j.jsx)(E, { size: 18 })]
								}),
								/* @__PURE__ */ (0, j.jsx)("small", { children: "Automatically included. No code. One carrying case per pair." })
							]
						}), /* @__PURE__ */ (0, j.jsx)(Gt, {
							slide: v,
							onSlide: y
						})]
					}), /* @__PURE__ */ (0, j.jsxs)("div", {
						className: "case-bottom",
						children: [
							/* @__PURE__ */ (0, j.jsx)(M, {
								src: "https://mifogen4.com.au/assets/case-closed.webp",
								sizes: "180px",
								width: "1600",
								height: "900",
								alt: "Closed Airfome carrying case",
								loading: "lazy"
							}),
							/* @__PURE__ */ (0, j.jsxs)("p", { children: [/* @__PURE__ */ (0, j.jsx)("strong", { children: "Two cases. Two different jobs." }), " Your aluminium case keeps you charged. Your free Airfome case keeps your kit together."] }),
							/* @__PURE__ */ (0, j.jsxs)("button", {
								onClick: () => h(!0),
								className: "text-link",
								children: ["Explore the case ", /* @__PURE__ */ (0, j.jsx)(T, { size: 17 })]
							})
						]
					})]
				}),
				/* @__PURE__ */ (0, j.jsxs)("section", {
					className: "app-section section-pad",
					id: "power-on-the-go",
					children: [/* @__PURE__ */ (0, j.jsx)("div", {
						className: "app-image",
						children: /* @__PURE__ */ (0, j.jsx)(M, {
							src: "https://mifogen4.com.au/assets/gen4-powerbank-phone-v4.webp",
							sizes: "(max-width: 800px) 90vw, 50vw",
							width: "1254",
							height: "1254",
							alt: "Mifo charging case connected to a smartphone by USB-C",
							loading: "lazy"
						})
					}), /* @__PURE__ */ (0, j.jsxs)("div", {
						className: "app-copy",
						children: [
							/* @__PURE__ */ (0, j.jsx)("p", {
								className: "eyebrow",
								children: "FROM WARM-UP TO WIND-DOWN"
							}),
							/* @__PURE__ */ (0, j.jsxs)("h2", { children: [
								"More power",
								/* @__PURE__ */ (0, j.jsx)("br", {}),
								"in your corner."
							] }),
							/* @__PURE__ */ (0, j.jsx)("p", { children: "The charging case doubles as a USB-C power bank. A useful backup when your phone needs a top-up after a long day out." }),
							/* @__PURE__ */ (0, j.jsx)("small", { children: "Phone charging depends on battery capacity and conditions." })
						]
					})]
				}),
				/* @__PURE__ */ (0, j.jsx)(bt, {
					colour: e,
					colourName: Oe.name
				}),
				/* @__PURE__ */ (0, j.jsxs)("section", {
					className: "reviews section-pad",
					id: "reviews",
					children: [
						/* @__PURE__ */ (0, j.jsxs)("div", {
							className: "section-heading",
							children: [/* @__PURE__ */ (0, j.jsxs)("div", { children: [/* @__PURE__ */ (0, j.jsx)("p", {
								className: "eyebrow",
								children: "A FIT PEOPLE COME BACK TO"
							}), /* @__PURE__ */ (0, j.jsxs)("h2", { children: [
								"Thousands of ears.",
								/* @__PURE__ */ (0, j.jsx)("br", {}),
								"Plenty of love."
							] })] }), /* @__PURE__ */ (0, j.jsxs)("div", {
								className: "review-summary",
								children: [
									/* @__PURE__ */ (0, j.jsxs)("div", { children: [/* @__PURE__ */ (0, j.jsxs)("strong", { children: ["4.7", /* @__PURE__ */ (0, j.jsx)("span", { children: "/5" })] }), /* @__PURE__ */ (0, j.jsx)(Ht, {})] }),
									/* @__PURE__ */ (0, j.jsx)("p", { children: "6,140 Mifo customer reviews" }),
									/* @__PURE__ */ (0, j.jsx)("small", { children: "From the Mifo O5 family." }),
									/* @__PURE__ */ (0, j.jsxs)("button", {
										className: "button button-dark review-explore-action",
										"aria-haspopup": "dialog",
										onClick: () => _(!0),
										children: ["Read all reviews ", /* @__PURE__ */ (0, j.jsx)(T, { size: 18 })]
									})
								]
							})]
						}),
						/* @__PURE__ */ (0, j.jsxs)("div", {
							className: "review-grid",
							role: "region",
							"aria-label": "Customer reviews",
							tabIndex: 0,
							children: [
								/* @__PURE__ */ (0, j.jsxs)("article", { children: [
									/* @__PURE__ */ (0, j.jsx)(Ht, { score: 5 }),
									/* @__PURE__ */ (0, j.jsx)("h3", { children: "Small ears. Good fit." }),
									/* @__PURE__ */ (0, j.jsx)("blockquote", { children: "\"I have really small ears and they fit me.\"" }),
									/* @__PURE__ */ (0, j.jsxs)("footer", { children: ["Anonymous ", /* @__PURE__ */ (0, j.jsx)("span", { children: "Mifo customer · Incentivised review" })] })
								] }),
								/* @__PURE__ */ (0, j.jsxs)("article", { children: [
									/* @__PURE__ */ (0, j.jsx)(Ht, { score: 5 }),
									/* @__PURE__ */ (0, j.jsx)("h3", { children: "Fit. Sound. Build." }),
									/* @__PURE__ */ (0, j.jsx)("blockquote", { children: "\"Amazing fit, great sound and build quality.\"" }),
									/* @__PURE__ */ (0, j.jsxs)("footer", { children: ["Matt ", /* @__PURE__ */ (0, j.jsx)("span", { children: "Mifo customer" })] })
								] }),
								/* @__PURE__ */ (0, j.jsxs)("article", { children: [
									/* @__PURE__ */ (0, j.jsx)(Ht, { score: 5 }),
									/* @__PURE__ */ (0, j.jsx)("h3", { children: "Back for another pair." }),
									/* @__PURE__ */ (0, j.jsx)("blockquote", { children: "\"Just purchased my third pair\"" }),
									/* @__PURE__ */ (0, j.jsxs)("footer", { children: ["Benjamin ", /* @__PURE__ */ (0, j.jsx)("span", { children: "Mifo customer · Incentivised review" })] })
								] })
							]
						}),
						/* @__PURE__ */ (0, j.jsxs)("div", {
							className: "review-verification",
							children: [/* @__PURE__ */ (0, j.jsx)("span", { children: "Verified by" }), /* @__PURE__ */ (0, j.jsx)(M, {
								src: "https://mifogen4.com.au/assets/judgeme-logo.svg",
								alt: "Judge.me",
								width: "125",
								height: "24",
								loading: "lazy",
								decoding: "async"
							})]
						}),
						/* @__PURE__ */ (0, j.jsxs)("div", {
							className: "editorial",
							role: "region",
							"aria-label": "Publication recognition",
							tabIndex: 0,
							children: [
								/* @__PURE__ */ (0, j.jsxs)("article", {
									className: "editorial-pick",
									"aria-label": "Runner World editorial recognition",
									children: [
										/* @__PURE__ */ (0, j.jsx)("div", {
											className: "publication-cover",
											children: /* @__PURE__ */ (0, j.jsx)(M, {
												src: "https://mifogen4.com.au/assets/runner-world-cover.webp",
												srcSet: `${Ft}runner-world-cover-384.webp 384w, ${Ft}runner-world-cover.webp 768w`,
												sizes: "(max-width: 600px) 42vw, (max-width: 1100px) 27vw, 330px",
												alt: "Runner World magazine-style cover concept featuring a runner",
												width: "768",
												height: "1024",
												loading: "lazy",
												decoding: "async"
											})
										}),
										/* @__PURE__ */ (0, j.jsx)("strong", { children: "Best Earbuds For Runners" }),
										/* @__PURE__ */ (0, j.jsx)("span", { children: "Runner World" })
									]
								}),
								/* @__PURE__ */ (0, j.jsxs)("article", {
									className: "editorial-pick",
									"aria-label": "Techbest editorial recognition",
									children: [
										/* @__PURE__ */ (0, j.jsx)("div", {
											className: "publication-cover",
											children: /* @__PURE__ */ (0, j.jsx)(M, {
												src: "https://mifogen4.com.au/assets/techbest-cover.webp",
												srcSet: `${Ft}techbest-cover-384.webp 384w, ${Ft}techbest-cover.webp 768w`,
												sizes: "(max-width: 600px) 42vw, (max-width: 1100px) 27vw, 330px",
												alt: "Techbest magazine-style cover concept featuring graphite Mifo earbuds",
												width: "768",
												height: "1024",
												loading: "lazy",
												decoding: "async"
											})
										}),
										/* @__PURE__ */ (0, j.jsx)("strong", { children: "Earbuds Of The Year" }),
										/* @__PURE__ */ (0, j.jsx)("span", { children: "Techbest" })
									]
								}),
								/* @__PURE__ */ (0, j.jsxs)("article", {
									className: "editorial-pick",
									"aria-label": "Gigabeat editorial recognition",
									children: [
										/* @__PURE__ */ (0, j.jsx)("div", {
											className: "publication-cover",
											children: /* @__PURE__ */ (0, j.jsx)(M, {
												src: "https://mifogen4.com.au/assets/gigabeat-cover.webp",
												srcSet: `${Ft}gigabeat-cover-384.webp 384w, ${Ft}gigabeat-cover.webp 768w`,
												sizes: "(max-width: 600px) 42vw, (max-width: 1100px) 27vw, 330px",
												alt: "Gigabeat magazine-style cover concept featuring rose-gold Mifo earbuds",
												width: "768",
												height: "1024",
												loading: "lazy",
												decoding: "async"
											})
										}),
										/* @__PURE__ */ (0, j.jsx)("strong", { children: "Editor's choice" }),
										/* @__PURE__ */ (0, j.jsx)("span", { children: "Gigabeat" })
									]
								})
							]
						})
					]
				}),
				/* @__PURE__ */ (0, j.jsxs)("section", {
					className: "faq-section section-pad",
					id: "faq",
					children: [/* @__PURE__ */ (0, j.jsxs)("div", { children: [
						/* @__PURE__ */ (0, j.jsx)("p", {
							className: "eyebrow",
							children: "BEFORE YOUR NEXT MOVE"
						}),
						/* @__PURE__ */ (0, j.jsxs)("h2", { children: [
							"Good questions.",
							/* @__PURE__ */ (0, j.jsx)("br", {}),
							"Straight answers."
						] }),
						/* @__PURE__ */ (0, j.jsx)("p", { children: "Everything you need to get going." }),
						/* @__PURE__ */ (0, j.jsxs)("a", {
							href: "/pages/contact",
							className: "text-link",
							children: ["Talk to Mifo ", /* @__PURE__ */ (0, j.jsx)(E, { size: 16 })]
						})
					] }), /* @__PURE__ */ (0, j.jsx)("div", {
						className: "faq-list",
						children: Vt.map(([e, t]) => /* @__PURE__ */ (0, j.jsxs)("details", { children: [/* @__PURE__ */ (0, j.jsxs)("summary", { children: [e, /* @__PURE__ */ (0, j.jsx)(De, { size: 19 })] }), /* @__PURE__ */ (0, j.jsx)("p", { children: t })] }, e))
					})]
				}),
				/* @__PURE__ */ (0, j.jsxs)("section", {
					className: "finish-section",
					children: [/* @__PURE__ */ (0, j.jsxs)("div", { children: [
						/* @__PURE__ */ (0, j.jsx)("p", {
							className: "eyebrow",
							children: "ONE PAIR. EVERY PART OF YOUR DAY."
						}),
						/* @__PURE__ */ (0, j.jsxs)("h2", { children: [
							"Make your",
							/* @__PURE__ */ (0, j.jsx)("br", {}),
							"next move."
						] }),
						/* @__PURE__ */ (0, j.jsxs)("p", { children: [
							"Mifo O5 Gen 4. NZ$199.99.",
							/* @__PURE__ */ (0, j.jsx)("br", {}),
							"Free Airfome case. Free NZ delivery from NZ$299.99."
						] }),
						/* @__PURE__ */ (0, j.jsxs)("a", {
							className: "button button-lime",
							href: "#shop",
							children: ["Choose your pair ", /* @__PURE__ */ (0, j.jsx)(T, { size: 18 })]
						})
					] }), /* @__PURE__ */ (0, j.jsx)(M, {
						src: Lt("rose-gold"),
						sizes: "(max-width: 800px) 90vw, 45vw",
						width: "1800",
						height: "1800",
						alt: "Rose gold Gen 4 earbuds and matching charging case",
						loading: "lazy"
					})]
				})
			]
		}),
		/* @__PURE__ */ (0, j.jsxs)("footer", {
			className: "footer",
			children: [
				/* @__PURE__ */ (0, j.jsxs)("div", {
					className: "footer-main",
					children: [
						/* @__PURE__ */ (0, j.jsx)("a", {
							href: "#",
							className: "brand",
							"aria-label": "Mifo home",
							children: /* @__PURE__ */ (0, j.jsx)(M, {
								src: "https://mifogen4.com.au/assets/mifo-logo-mark.png",
								sizes: "65px",
								alt: "Mifo",
								width: "65",
								height: "38"
							})
						}),
						/* @__PURE__ */ (0, j.jsxs)("p", { children: [
							"Made for movement.",
							/* @__PURE__ */ (0, j.jsx)("br", {}),
							"Mifo New Zealand."
						] }),
						/* @__PURE__ */ (0, j.jsx)("nav", {
							"aria-label": "Footer navigation",
							children: ut.map((e) => /* @__PURE__ */ (0, j.jsx)("a", {
								href: e.url,
								children: e.label
							}, e.slug))
						})
					]
				}),
				/* @__PURE__ */ (0, j.jsxs)("div", {
					className: "footer-bottom",
					children: [/* @__PURE__ */ (0, j.jsx)("span", { children: "© 2026 Mifo New Zealand. All prices NZD, including GST." }), /* @__PURE__ */ (0, j.jsx)("span", { children: "Secure checkout and support by Mifo New Zealand." })]
				}),
				/* @__PURE__ */ (0, j.jsx)("p", {
					className: "image-note",
					children: "Athletic lifestyle scenes are AI-generated campaign imagery, not athlete endorsements."
				})
			]
		}),
		he && !f && !m && !w && !oe && /* @__PURE__ */ (0, j.jsxs)("div", {
			className: "sticky-buy",
			children: [
				/* @__PURE__ */ (0, j.jsxs)("a", {
					className: "sticky-product",
					href: "#shop",
					"aria-label": `Change colour or quantity, ${n} ${Oe.name} ${n === 1 ? "pair" : "pairs"} selected`,
					children: [
						/* @__PURE__ */ (0, j.jsx)("strong", { children: "Mifo O5 Gen 4" }),
						/* @__PURE__ */ (0, j.jsxs)("span", {
							className: "sticky-price",
							children: [
								"NZ",
								A(19999 * n),
								" ",
								/* @__PURE__ */ (0, j.jsx)("i", { children: "+ free case" })
							]
						}),
						/* @__PURE__ */ (0, j.jsxs)("span", {
							className: "sticky-selection",
							children: [
								n > 1 ? `${n} × ` : "",
								Oe.name,
								" ",
								/* @__PURE__ */ (0, j.jsx)(ue, { size: 12 })
							]
						})
					]
				}),
				/* @__PURE__ */ (0, j.jsxs)("button", {
					className: "sticky-proof",
					"aria-haspopup": "dialog",
					onClick: () => _(!0),
					"aria-label": "Read reviews: 4.7 out of 5, Mifo O5 customer reviews on Judge.me",
					children: [/* @__PURE__ */ (0, j.jsxs)("span", {
						className: "sticky-rating",
						children: [/* @__PURE__ */ (0, j.jsx)(Ht, {}), /* @__PURE__ */ (0, j.jsx)("strong", { children: "4.7/5" })]
					}), /* @__PURE__ */ (0, j.jsxs)("span", {
						className: "sticky-verification",
						children: ["Verified by ", /* @__PURE__ */ (0, j.jsx)(M, {
							src: "https://mifogen4.com.au/assets/judgeme-logo.svg",
							alt: "Judge.me",
							width: "100",
							height: "24"
						})]
					})]
				}),
				/* @__PURE__ */ (0, j.jsxs)("button", {
					className: "button button-lime",
					onClick: Ie,
					"aria-label": `Add ${n} ${Oe.name} ${n === 1 ? "pair" : "pairs"} to bag`,
					children: ["Add to bag ", /* @__PURE__ */ (0, j.jsx)(Ne, { size: 18 })]
				})
			]
		}),
		/* @__PURE__ */ (0, j.jsx)("div", {
			className: "sr-only",
			"aria-live": "polite",
			children: O
		}),
		/* @__PURE__ */ (0, j.jsx)(Kt, {
			open: g,
			onClose: () => _(!1),
			title: "Mifo customer reviews",
			className: "reviews-dialog",
			children: /* @__PURE__ */ (0, j.jsx)(Mt, {
				price: `NZ${A(He)}`,
				onClose: () => _(!1),
				onShop: () => {
					_(!1), requestAnimationFrame(() => {
						Se.current?.focus({ preventScroll: !0 }), document.getElementById("shop").scrollIntoView({ behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth" });
					});
				}
			})
		}),
		/* @__PURE__ */ (0, j.jsxs)(Kt, {
			open: f,
			onClose: Be,
			title: "Your bag",
			className: "cart-dialog",
			children: [
				/* @__PURE__ */ (0, j.jsxs)("div", {
					className: "dialog-heading",
					children: [/* @__PURE__ */ (0, j.jsxs)("div", { children: [/* @__PURE__ */ (0, j.jsx)("span", {
						className: "eyebrow",
						children: b ? "SECURE CHECKOUT" : "GOOD CHOICE"
					}), /* @__PURE__ */ (0, j.jsxs)("h2", { children: ["Your bag ", /* @__PURE__ */ (0, j.jsxs)("span", { children: [
						"(",
						Te.quantity,
						")"
					] })] })] }), /* @__PURE__ */ (0, j.jsx)("button", {
						className: "icon-button",
						title: "Close bag",
						"aria-label": "Close bag",
						onClick: Be,
						children: /* @__PURE__ */ (0, j.jsx)(ze, {})
					})]
				}),
				/* @__PURE__ */ (0, j.jsx)("div", {
					className: "cart-body",
					children: c.length === 0 ? /* @__PURE__ */ (0, j.jsxs)("div", {
						className: "empty-bag",
						children: [
							/* @__PURE__ */ (0, j.jsx)(Ne, { size: 42 }),
							/* @__PURE__ */ (0, j.jsx)("h3", { children: "Your next move starts here." }),
							/* @__PURE__ */ (0, j.jsx)("p", { children: "Pick your colour. We'll include the free case." }),
							/* @__PURE__ */ (0, j.jsxs)("button", {
								className: "button button-dark",
								onClick: () => {
									p(!1), document.getElementById("shop").scrollIntoView({ behavior: "smooth" });
								},
								children: ["Choose your pair ", /* @__PURE__ */ (0, j.jsx)(T, { size: 17 })]
							})
						]
					}) : /* @__PURE__ */ (0, j.jsxs)(j.Fragment, { children: [
						c.map((e) => /* @__PURE__ */ (0, j.jsxs)("article", {
							className: "cart-item",
							children: [/* @__PURE__ */ (0, j.jsx)(M, {
								src: Lt(e.colour, "buds"),
								sizes: "80px",
								width: "1000",
								height: "1000",
								alt: `${It(e.colour).name} Gen 4 earbuds`
							}), /* @__PURE__ */ (0, j.jsxs)("div", { children: [
								/* @__PURE__ */ (0, j.jsxs)("div", {
									className: "cart-item-title",
									children: [/* @__PURE__ */ (0, j.jsx)("h3", { children: "Mifo O5 Gen 4" }), /* @__PURE__ */ (0, j.jsx)("strong", { children: A(He * e.quantity) })]
								}),
								/* @__PURE__ */ (0, j.jsxs)("label", { children: ["Colour", /* @__PURE__ */ (0, j.jsxs)("span", {
									className: "cart-colour-select",
									children: [/* @__PURE__ */ (0, j.jsx)("select", {
										"aria-label": `Colour for ${It(e.colour).name} pair`,
										value: e.colour,
										disabled: b,
										onChange: (t) => l((n) => qe(n, e.colour, t.target.value)),
										children: Ue.map((e) => /* @__PURE__ */ (0, j.jsx)("option", {
											value: e.id,
											children: e.name
										}, e.id))
									}), /* @__PURE__ */ (0, j.jsx)(ue, {
										size: 16,
										"aria-hidden": "true"
									})]
								})] }),
								/* @__PURE__ */ (0, j.jsx)("div", {
									className: "cart-item-actions",
									children: b ? /* @__PURE__ */ (0, j.jsxs)("span", { children: ["Quantity: ", e.quantity] }) : /* @__PURE__ */ (0, j.jsxs)(j.Fragment, { children: [/* @__PURE__ */ (0, j.jsx)(Wt, {
										label: `${It(e.colour).name} pairs`,
										value: e.quantity,
										onChange: (t) => l((n) => Ke(n, e.colour, t))
									}), /* @__PURE__ */ (0, j.jsx)("button", {
										className: "remove",
										onClick: () => l((t) => Ke(t, e.colour, 0)),
										children: "Remove"
									})] })
								})
							] })]
						}, e.colour)),
						/* @__PURE__ */ (0, j.jsxs)("div", {
							className: "cart-gift",
							children: [
								/* @__PURE__ */ (0, j.jsx)(M, {
									src: "https://mifogen4.com.au/assets/case-closed.webp",
									sizes: "70px",
									width: "1600",
									height: "900",
									alt: "Airfome carrying case"
								}),
								/* @__PURE__ */ (0, j.jsxs)("div", { children: [/* @__PURE__ */ (0, j.jsxs)("strong", { children: ["Airfome hard-shell case × ", Te.freeCases] }), /* @__PURE__ */ (0, j.jsx)("span", { children: "Your limited-time gift" })] }),
								/* @__PURE__ */ (0, j.jsx)("strong", { children: "FREE" })
							]
						}),
						!b && /* @__PURE__ */ (0, j.jsxs)("button", {
							className: "another-pair",
							onClick: () => {
								p(!1), document.getElementById("shop").scrollIntoView({ behavior: "smooth" });
							},
							children: [
								/* @__PURE__ */ (0, j.jsx)("span", { children: /* @__PURE__ */ (0, j.jsx)(De, { size: 20 }) }),
								/* @__PURE__ */ (0, j.jsxs)("div", { children: [/* @__PURE__ */ (0, j.jsx)("strong", { children: "Add another pair" }), /* @__PURE__ */ (0, j.jsx)("small", { children: "Another colour. Another free case." })] }),
								/* @__PURE__ */ (0, j.jsx)(E, { size: 19 })
							]
						}),
						/* @__PURE__ */ (0, j.jsxs)("div", {
							className: "cart-trust",
							children: [/* @__PURE__ */ (0, j.jsxs)("span", { children: [/* @__PURE__ */ (0, j.jsx)(Le, { size: 17 }), Te.subtotal >= 29999 ? "Free New Zealand delivery" : "New Zealand delivery: NZ$19.99"] }), /* @__PURE__ */ (0, j.jsxs)("span", { children: [/* @__PURE__ */ (0, j.jsx)(Ee, { size: 17 }), "Tracking emailed on dispatch."] })]
						})
					] })
				}),
				c.length > 0 && /* @__PURE__ */ (0, j.jsxs)("div", {
					className: "cart-footer",
					children: [
						/* @__PURE__ */ (0, j.jsxs)("div", { children: [/* @__PURE__ */ (0, j.jsxs)("span", { children: ["Subtotal ", /* @__PURE__ */ (0, j.jsx)("small", { children: "incl. GST" })] }), /* @__PURE__ */ (0, j.jsxs)("strong", { children: ["NZ", A(Te.subtotal)] })] }),
						/* @__PURE__ */ (0, j.jsxs)("p", { children: [
							Te.freeCases,
							" free ",
							Te.freeCases === 1 ? "case" : "cases",
							" included.",
							Te.subtotal < 29999 ? " Free NZ delivery from NZ$299.99 after discounts." : " Free NZ delivery included before any further discounts."
						] }),
						ee && /* @__PURE__ */ (0, j.jsx)("p", {
							className: "checkout-error",
							role: "alert",
							children: ee
						}),
						/* @__PURE__ */ (0, j.jsxs)("button", {
							className: "button button-lime",
							onClick: Ve,
							disabled: b,
							"aria-busy": b,
							children: [
								/* @__PURE__ */ (0, j.jsx)(ye, { size: 18 }),
								b ? "Opening checkout..." : "Continue to checkout",
								/* @__PURE__ */ (0, j.jsx)(T, { size: 18 })
							]
						}),
						/* @__PURE__ */ (0, j.jsx)("small", { children: "Secure payment with Mifo New Zealand. No code needed." })
					]
				})
			]
		}),
		/* @__PURE__ */ (0, j.jsxs)(Kt, {
			open: m,
			onClose: () => h(!1),
			title: "Explore your free Airfome case",
			className: "case-dialog",
			children: [/* @__PURE__ */ (0, j.jsxs)("div", {
				className: "dialog-heading",
				children: [/* @__PURE__ */ (0, j.jsxs)("div", { children: [/* @__PURE__ */ (0, j.jsx)("span", {
					className: "eyebrow",
					children: "INCLUDED WITH EVERY PAIR"
				}), /* @__PURE__ */ (0, j.jsx)("h2", { children: "Meet your Airfome case." })] }), /* @__PURE__ */ (0, j.jsx)("button", {
					className: "icon-button",
					"aria-label": "Close case details",
					title: "Close",
					onClick: () => h(!1),
					children: /* @__PURE__ */ (0, j.jsx)(ze, {})
				})]
			}), /* @__PURE__ */ (0, j.jsxs)("div", {
				className: "case-dialog-content",
				children: [/* @__PURE__ */ (0, j.jsx)(Gt, {
					slide: v,
					onSlide: y,
					modal: !0
				}), /* @__PURE__ */ (0, j.jsxs)("div", {
					className: "case-detail-copy",
					children: [
						/* @__PURE__ */ (0, j.jsx)("span", {
							className: "offer-label",
							children: "YOUR BONUS / FREE"
						}),
						/* @__PURE__ */ (0, j.jsxs)("h3", { children: [
							"Pack it.",
							/* @__PURE__ */ (0, j.jsx)("br", {}),
							"Zip it. Go."
						] }),
						/* @__PURE__ */ (0, j.jsx)("p", { children: "A protective home for your Mifo charging case, whether it's in your gym bag, weekend luggage or everyday kit." }),
						/* @__PURE__ */ (0, j.jsxs)("ul", { children: [
							/* @__PURE__ */ (0, j.jsxs)("li", { children: [/* @__PURE__ */ (0, j.jsx)(Me, {}), "Hard-shell outer for everyday protection"] }),
							/* @__PURE__ */ (0, j.jsxs)("li", { children: [/* @__PURE__ */ (0, j.jsx)(Ee, {}), "Internal mesh pocket for small accessories"] }),
							/* @__PURE__ */ (0, j.jsxs)("li", { children: [/* @__PURE__ */ (0, j.jsx)(pe, {}), "Zip closure and carry attachment"] })
						] }),
						/* @__PURE__ */ (0, j.jsx)("p", {
							className: "small-print",
							children: "Separate from the aluminium charging case. The Airfome carrying case has no battery and does not charge devices."
						}),
						/* @__PURE__ */ (0, j.jsxs)("button", {
							className: "button button-dark",
							onClick: () => {
								h(!1), document.getElementById("shop").scrollIntoView({ behavior: "smooth" });
							},
							children: ["Choose your Gen 4 ", /* @__PURE__ */ (0, j.jsx)(T, { size: 18 })]
						}),
						/* @__PURE__ */ (0, j.jsx)("small", { children: "One free case for each eligible pair. No code needed." })
					]
				})]
			})]
		}),
		/* @__PURE__ */ (0, j.jsxs)(Kt, {
			open: w,
			onClose: () => ie(!1),
			title: Rt[i].label,
			className: "zoom-dialog",
			children: [
				/* @__PURE__ */ (0, j.jsxs)("div", {
					className: "dialog-heading",
					children: [/* @__PURE__ */ (0, j.jsx)("h2", { children: Rt[i].label }), /* @__PURE__ */ (0, j.jsx)("button", {
						className: "icon-button",
						"aria-label": "Close image",
						title: "Close",
						onClick: () => ie(!1),
						children: /* @__PURE__ */ (0, j.jsx)(ze, {})
					})]
				}),
				/* @__PURE__ */ (0, j.jsx)(M, {
					className: "zoom-image",
					src: Ze,
					sizes: "(max-width: 960px) 92vw, 900px",
					alt: `${Rt[i].shot ? Oe.name + " " : ""}${Rt[i].label}`
				}),
				/* @__PURE__ */ (0, j.jsxs)("div", {
					className: "zoom-controls",
					children: [
						/* @__PURE__ */ (0, j.jsx)("button", {
							className: "icon-button",
							"aria-label": "Previous enlarged image",
							title: "Previous",
							onClick: () => Xe(-1),
							children: /* @__PURE__ */ (0, j.jsx)(de, {})
						}),
						/* @__PURE__ */ (0, j.jsxs)("span", { children: [
							i + 1,
							" / ",
							Rt.length
						] }),
						/* @__PURE__ */ (0, j.jsx)("button", {
							className: "icon-button",
							"aria-label": "Next enlarged image",
							title: "Next",
							onClick: () => Xe(1),
							children: /* @__PURE__ */ (0, j.jsx)(fe, {})
						})
					]
				})
			]
		})
	] });
}
function Jt() {
	return /* @__PURE__ */ (0, j.jsx)(we, {
		size: 17,
		style: { transform: "rotate(90deg)" }
	});
}
//#endregion
//#region outputs/regional-reviews-nz-20261018/nz/athletics-src/entry-client.jsx
var Yt = document.getElementById("root");
Yt.hasChildNodes() ? (0, Ve.hydrateRoot)(Yt, /* @__PURE__ */ (0, j.jsx)(qt, {})) : (0, Ve.createRoot)(Yt).render(/* @__PURE__ */ (0, j.jsx)(qt, {}));
//#endregion
